
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("hRcC4", function(module, exports) {
/* EditorForgeConfigHelperRenderer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $0125f7cacb851b02$var$hideIframe = null;
const $0125f7cacb851b02$var$bodiedExtensionHelper = {
    setRenderer: ()=>{}
}; /**
    * A component that allows us to render Forge UI Extensions directly in the editor
    * Normally, they are rendered as part of the extension manifest's render function,
    * but that function is not called for bodied extensions, so we need to render them separately.
    */ 
const $0125f7cacb851b02$export$d78837c9c32f5ea5 = ()=>{
    const [renderer, setRenderer] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(null);
    $0125f7cacb851b02$var$bodiedExtensionHelper.setRenderer = (renderer_0)=>setRenderer(// We wrap the renderer function here, otherwise setState thinks we're passing a state mutation function
        ()=>renderer_0);
    return renderer ? renderer() : null;
};
const $0125f7cacb851b02$export$893920e86f275cd9 = async ({ extension: extension, forgeExtensionNode: forgeExtensionNode, hasCustomConfig: hasCustomConfig, isInitialInsertion: isInitialInsertion, createRenderFunction: createRenderFunction, onSubmit: onSubmit, onValidate: onValidate })=>{
    let gqlExtension = extension;
    let customEditContext;
    if (hasCustomConfig) {
        gqlExtension = {
            ...extension,
            properties: {
                ...extension.properties,
                // Preserve other properties like resourceUploadId, environmentId, etc.
                resource: extension.properties?.config?.resource,
                render: extension.properties?.config?.render,
                resolvedResourceEntry: extension.properties?.config?.resolvedResourceEntry,
                title: extension.properties?.config?.title,
                viewportSize: extension.properties?.config?.viewportSize
            }
        };
        const onModalClose = ()=>$0125f7cacb851b02$var$bodiedExtensionHelper.setRenderer(null);
        customEditContext = {
            isInserting: isInitialInsertion,
            bridge: {
                close: onModalClose,
                submit: ({ data: data })=>{
                    // This can throw and propagate exceptions back down to the app
                    const payload = onValidate(data); // This can throw and propagate exceptions back down to the app
                    onSubmit(payload);
                    if (!payload.keepEditing) onModalClose();
                    return true;
                }
            },
            modalExtension: {
                type: 'macroConfig',
                title: extension.properties?.config?.title,
                closeModalExtension: onModalClose,
                modalWidth: extension.properties?.config?.viewportSize,
                shouldCloseOnOverlayClick: true,
                shouldCloseOnEscapePress: true
            }
        };
    }
    const renderFunction = await createRenderFunction(gqlExtension, customEditContext); // The Forge Doc config iframe should be hidden and resolve the config in the background
    // The loading component for custom config is unaffected as it is rendered in a Portal
    $0125f7cacb851b02$var$bodiedExtensionHelper.setRenderer(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_3iDTPbYbGa"
            ])
        }, renderFunction({
            node: forgeExtensionNode
        })));
};
const $0125f7cacb851b02$export$7d20cbfd94f605c9 = async ({ extension: extension, forgeExtensionNode: forgeExtensionNode, createRenderFunction: createRenderFunction })=>{
    const renderFunction = await createRenderFunction(extension);
    $0125f7cacb851b02$var$bodiedExtensionHelper.setRenderer(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_3iDTPbYbGa"
            ])
        }, renderFunction({
            node: forgeExtensionNode
        })));
};
module.exports["EditorForgeExtensionConfigHelperRenderer"] = $0125f7cacb851b02$export$d78837c9c32f5ea5;
module.exports["renderConfigHelper"] = $0125f7cacb851b02$export$893920e86f275cd9;
module.exports["renderBodiedExtensionIframe"] = $0125f7cacb851b02$export$7d20cbfd94f605c9;

});

parcelRegister("eYo03", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $695181131995162d$export$29d561579c798129 = 'com.atlassian.confluence.macro.core';
const $695181131995162d$export$e400f4d17a615c24 = 'agent-managed-block';
const $695181131995162d$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('agentManagedExtensionPlugin');
module.exports["AGENT_MANAGED_EXTENSION_TYPE_DEFAULT"] = $695181131995162d$export$29d561579c798129;
module.exports["AGENT_MANAGED_EXTENSION_KEY"] = $695181131995162d$export$e400f4d17a615c24;
module.exports["pluginKey"] = $695181131995162d$export$18d4026d1ea86bb1;

});

parcelRegister("fPsyy", function(module, exports) {

var $7fDQr = parcelRequire("7fDQr");


const $9e907e6c94f6a3f7$export$fc997db2c0ab195 = async ({ intl: intl, editorActions: editorActions, extensionHandlers: extensionHandlers, createAnalyticsEvent: createAnalyticsEvent, externalToolbarItems: externalToolbarItems })=>{
    const { buildManifest: buildManifest } = await (parcelRequire("4Ih7W"));
    return buildManifest({
        intl: intl,
        editorActions: editorActions,
        parseNumber: $7fDQr.parseNumber,
        extensionHandlerWithReference: extensionHandlers,
        createAnalyticsEvent: createAnalyticsEvent,
        externalToolbarItems: externalToolbarItems || []
    });
};
module.exports["createChartsExtension"] = $9e907e6c94f6a3f7$export$fc997db2c0ab195;

});

parcelRegister("7fDQr", function(module, exports) {
const $0ce40a2f1d4c3720$export$6bf0e8cf8e1d780d = (numStr)=>{
    numStr = numStr.replace(/[,$%]/g, '');
    const num = Number(numStr);
    if (!Number.isNaN(num)) return num;
    return null;
};
module.exports["parseNumber"] = $0ce40a2f1d4c3720$export$6bf0e8cf8e1d780d;

});

parcelRegister("4Ih7W", function(module, exports) {

let $36e88e8c54bae5c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $36e88e8c54bae5c9$var$load("kccW9"),
    $36e88e8c54bae5c9$var$load("6wr18"),
    $36e88e8c54bae5c9$var$load("8R7DY"),
    $36e88e8c54bae5c9$var$load("c6nMJ"),
    $36e88e8c54bae5c9$var$load("hMfq4"),
    $36e88e8c54bae5c9$var$load("ffEVr"),
    $36e88e8c54bae5c9$var$load("027MC")
]).then(()=>parcelRequire('2iclA'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("gkua4", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
var $a2797acc385bb070$export$eeab3cae4ffcf74a = /*#__PURE__*/ function(ADFReferenceTypes) {
    ADFReferenceTypes["TABLE"] = "table-adf";
    return ADFReferenceTypes;
}({});
var $a2797acc385bb070$export$5cb1f459478c70e = /*#__PURE__*/ function(MEASURE_NAME) {
    MEASURE_NAME["INITIALISE_FRAGMENT_MARKS"] = "initialiseFragmentMarks";
    MEASURE_NAME["CONNECT_NODES"] = "connectNodes";
    MEASURE_NAME["UPDATE_SOURCE"] = "updateSource";
    MEASURE_NAME["DISCONNECT_SOURCE"] = "disconnectSource";
    MEASURE_NAME["UPDATE_TARGET"] = "updateTarget";
    MEASURE_NAME["DISCONNECT_TARGET"] = "disconnectTarget";
    MEASURE_NAME["UPDATE_FRAGMENT_MARK_NAME"] = "updateFragmentMarkName";
    MEASURE_NAME["GET_CONNECTIONS"] = "getConnections";
    return MEASURE_NAME;
}({});
module.exports["ADFReferenceTypes"] = $a2797acc385bb070$export$eeab3cae4ffcf74a;
module.exports["MEASURE_NAME"] = $a2797acc385bb070$export$5cb1f459478c70e;

});

parcelRegister("3CKU8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dOBRD = parcelRequire("dOBRD");


var $gkua4 = parcelRequire("gkua4");

// Getting all nodes mapping (LocalId => ADNode)
const $3080fa76f8962476$var$getAllNodes = (nodes = [])=>{
    let allNodes = new Map();
    nodes.forEach((node)=>{
        const existingFragmentMark = node.marks?.find((m)=>m.type === 'fragment');
        const fragmentLocalId = existingFragmentMark?.attrs?.localId;
        if (fragmentLocalId) allNodes.set(fragmentLocalId, node);
        if (node.attrs?.localId) allNodes.set(node.attrs.localId, node);
        if (node.content) allNodes = new Map([
            ...allNodes,
            ...$3080fa76f8962476$var$getAllNodes(node.content)
        ]);
    });
    return allNodes;
};
const $3080fa76f8962476$var$memoGetAllNodes = (0, $dOBRD.default)((adf)=>$3080fa76f8962476$var$getAllNodes(adf.content));
const $3080fa76f8962476$export$cd3f7ccaa044b456 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { adf: adf, extensionParams: extensionParams, dataSourceProvider: dataSourceProvider } = t0;
    let allADFNodes;
    let t1;
    if ($[0] !== adf || $[1] !== extensionParams.localId) {
        allADFNodes = $3080fa76f8962476$var$memoGetAllNodes(adf);
        const activeNodeFromADF = allADFNodes.get(extensionParams.localId);
        t1 = activeNodeFromADF?.marks?.find($3080fa76f8962476$var$_temp)?.attrs?.sources?.[0];
        $[0] = adf;
        $[1] = extensionParams.localId;
        $[2] = allADFNodes;
        $[3] = t1;
    } else {
        allADFNodes = $[2];
        t1 = $[3];
    }
    const dataSourceId = t1;
    let t2;
    if ($[4] !== allADFNodes || $[5] !== dataSourceId) {
        t2 = ()=>{
            const dataSourceNode = allADFNodes.get(dataSourceId);
            if (dataSourceNode?.type === "table") return {
                [(0, $gkua4.ADFReferenceTypes).TABLE]: dataSourceNode
            };
        };
        $[4] = allADFNodes;
        $[5] = dataSourceId;
        $[6] = t2;
    } else t2 = $[6];
    const [reference, setReference] = (0, $cozmU.useState)(t2);
    let t3;
    let t4;
    if ($[7] !== dataSourceId || $[8] !== dataSourceProvider) {
        t3 = ()=>{
            if (!dataSourceId) return;
            dataSourceProvider?.subscribe(dataSourceId, setReference);
            return ()=>dataSourceProvider?.unsubscribe(dataSourceId, setReference);
        };
        t4 = [
            dataSourceProvider,
            dataSourceId
        ];
        $[7] = dataSourceId;
        $[8] = dataSourceProvider;
        $[9] = t3;
        $[10] = t4;
    } else {
        t3 = $[9];
        t4 = $[10];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[11] !== reference) {
        t5 = {
            references: reference ? [
                reference
            ] : []
        };
        $[11] = reference;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ adf: adf, extensionParams: extensionParams, dataSourceProvider: dataSourceProvider })=>{
    const allADFNodes = $3080fa76f8962476$var$memoGetAllNodes(adf);
    const activeNodeFromADF = allADFNodes.get(extensionParams.localId);
    // At the moment we support only one data consumer
    const dataSourceId = activeNodeFromADF?.marks?.find((mark)=>mark.type === 'dataConsumer')?.attrs?.sources?.[0];
    const [reference, setReference] = (0, $cozmU.useState)(()=>{
        const dataSourceNode = allADFNodes.get(dataSourceId);
        // At the momment only table nodes as a source are supported
        if (dataSourceNode?.type === 'table') return {
            [(0, $gkua4.ADFReferenceTypes).TABLE]: dataSourceNode
        };
    });
    (0, $cozmU.useEffect)(()=>{
        if (!dataSourceId) return;
        dataSourceProvider?.subscribe(dataSourceId, setReference);
        return ()=>dataSourceProvider?.unsubscribe(dataSourceId, setReference);
    }, [
        dataSourceProvider,
        dataSourceId
    ]);
    return {
        references: reference ? [
            reference
        ] : []
    };
};
function $3080fa76f8962476$var$_temp(mark) {
    return mark.type === "dataConsumer";
}
module.exports["useReference"] = $3080fa76f8962476$export$cd3f7ccaa044b456;

});

parcelRegister("gH8jv", function(module, exports) {

var $hjUDQ = parcelRequire("hjUDQ");


var $6Rsxa = parcelRequire("6Rsxa");


var $bm134 = parcelRequire("bm134");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $cbvYp = parcelRequire("cbvYp");


const $d29a7626179a8a1f$var$cardsExtensionProviderLoader = async (props)=>{
    const module = await (parcelRequire("lMywb"));
    return module.cardsExtensionProvider(props);
};

const $d29a7626179a8a1f$var$carouselExtensionProviderLoader = async (props)=>{
    const module = await (parcelRequire("5q8Sb"));
    return module.carouselExtensionProvider(props);
};

const $d29a7626179a8a1f$var$platformSearchExtensionProviderLoader = async (props)=>{
    const module = await (parcelRequire("kv7Kg"));
    return module.searchExtensionProvider(props);
};

const $d29a7626179a8a1f$var$platformSpotlightExtensionProviderLoader = async (props)=>{
    const module = await (parcelRequire("33G0S"));
    return module.spotlightExtensionProvider(props);
};

const $d29a7626179a8a1f$var$platformLinksMenuExtensionProviderLoader = async (props)=>{
    const module = await (parcelRequire("219yw"));
    return module.linksMenuExtensionProvider(props);
};

const $d29a7626179a8a1f$var$platformSectionExtensionProviderLoader = async (props)=>{
    const module = await (parcelRequire("guwVF"));
    return module.sectionExtensionProvider(props);
};
const $d29a7626179a8a1f$export$5cf5e33faff4fd37 = async (props)=>{
    const extensionProviders = $d29a7626179a8a1f$var$listPremiumExtensionProviders(props.contentId, props.allowCompanyHubExclusiveExtensions);
    const premiumExtensions = [];
    for (const provider of extensionProviders)try {
        const instance = await provider(props);
        const manifests = await instance.getExtensions();
        premiumExtensions.push(...manifests);
    } catch (error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        });
    }
    return premiumExtensions;
};
function $d29a7626179a8a1f$var$listPremiumExtensionProviders(contentId, allowCompanyHubExclusiveExtensions) {
    const extensionProviders = [];
    extensionProviders.push(async (providerProps)=>(await $d29a7626179a8a1f$var$platformSpotlightExtensionProviderLoader({
            contentId: contentId,
            mode: (0, $hjUDQ.ExtensionMode).EDITOR,
            propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
        }))(providerProps));
    extensionProviders.push(async (providerProps)=>(await $d29a7626179a8a1f$var$carouselExtensionProviderLoader({
            contentId: contentId,
            propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
        }))(providerProps));
    extensionProviders.push(async (providerProps)=>(await $d29a7626179a8a1f$var$cardsExtensionProviderLoader({
            contentId: contentId,
            mode: (0, $hjUDQ.ExtensionMode).EDITOR,
            propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
        }))(providerProps));
    if (allowCompanyHubExclusiveExtensions) {
        extensionProviders.push(async (providerProps)=>(await $d29a7626179a8a1f$var$platformLinksMenuExtensionProviderLoader({
                contentId: contentId,
                mode: (0, $hjUDQ.ExtensionMode).EDITOR,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            }))(providerProps));
        extensionProviders.push(async (providerProps)=>(await $d29a7626179a8a1f$var$platformSectionExtensionProviderLoader({
                contentId: contentId,
                mode: (0, $hjUDQ.ExtensionMode).EDITOR,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider),
                getSectionExtensionContents: $bm134.getSectionExtensionContents
            }))(providerProps));
        extensionProviders.push((0, $6Rsxa.hubElementPlaceholderExtensionProvider));
        extensionProviders.push(async (providerProps)=>(await $d29a7626179a8a1f$var$platformSearchExtensionProviderLoader({
                contentId: contentId,
                mode: (0, $hjUDQ.ExtensionMode).EDITOR,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            }))(providerProps));
    }
    return extensionProviders;
}
module.exports["createPremiumExtensionManifests"] = $d29a7626179a8a1f$export$5cf5e33faff4fd37;

});

parcelRegister("6Rsxa", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $bdpeX = parcelRequire("bdpeX");


var $9MYUp = parcelRequire("9MYUp");


var $kSwu1 = parcelRequire("kSwu1");

const $08933e50c02dd85b$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    title: {
        id: "company-hub.hub-element-placeholder.manifest.extension-title",
        defaultMessage: "Hub element placeholder"
    }
});



const $3a20790997032cac$var$HubElementPlaceholderExtension = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "xUz9t",
    name: "HubElementPlaceholderExtension",
    loader: async ()=>(await (parcelRequire("irKqF"))).HubElementPlaceholderExtension,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
});

const $3a20790997032cac$export$48207f1a9fb5511d = async ({ contentId: contentId, editorActions: editorActions, openConfigPanel: openConfigPanel, intl: intl })=>{
    const type = (0, $9MYUp.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE);
    const title = intl.formatMessage((0, $08933e50c02dd85b$export$a7357cdd1f0b0168).title);
    const icons = {
        '48': ()=>Promise.resolve((parcelRequire("jo8MM"))).then(({ default: PremiumIcon })=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PremiumIcon, {
                        color: "var(--ds-icon-subtle, #505258)",
                        label: "",
                        spacing: "spacious"
                    }))
    };
    const update = async ()=>{
        const selectedNode = editorActions?.getSelectedNode()?.toJSON();
        const selectedLocalId = selectedNode?.attrs?.localId;
        if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
    };
    const render = async ()=>({ node: node })=>{
            // Only render the extension if we are in the editor
            return editorActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3a20790997032cac$var$HubElementPlaceholderExtension, {
                openConfigPanel: openConfigPanel,
                editorActions: editorActions,
                extensionNode: node,
                contentId: contentId
            }) : null;
        };
    return new (0, $bdpeX.default)([
        {
            key: (0, $9MYUp.HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY),
            icons: icons,
            title: title,
            type: type,
            description: '',
            modules: {
                nodes: {
                    default: {
                        type: 'extension',
                        render: render,
                        update: update
                    }
                }
            }
        }
    ]);
};
module.exports["hubElementPlaceholderExtensionProvider"] = $3a20790997032cac$export$48207f1a9fb5511d;

});

parcelRegister("irKqF", function(module, exports) {

let $d6dec37146254315$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d6dec37146254315$var$load("6UOty"),
    $d6dec37146254315$var$load("9Nopc"),
    $d6dec37146254315$var$load("nllca"),
    $d6dec37146254315$var$load("1olsN"),
    $d6dec37146254315$var$load("cyDpt"),
    $d6dec37146254315$var$load("iEsP0"),
    $d6dec37146254315$var$load("fR7a0"),
    $d6dec37146254315$var$load("hUbK8"),
    $d6dec37146254315$var$load("fqJr7"),
    $d6dec37146254315$var$load("7H1j2"),
    $d6dec37146254315$var$load("25adb"),
    $d6dec37146254315$var$load("glcJK"),
    $d6dec37146254315$var$load("5SpB1"),
    $d6dec37146254315$var$load("1Gr4q"),
    $d6dec37146254315$var$load("dChty"),
    $d6dec37146254315$var$load("jmTCk"),
    $d6dec37146254315$var$load("VXbA1"),
    $d6dec37146254315$var$load("ca0UP"),
    $d6dec37146254315$var$load("a92TB"),
    $d6dec37146254315$var$load("c7nj5"),
    $d6dec37146254315$var$load("1yIye"),
    $d6dec37146254315$var$load("7EorR"),
    $d6dec37146254315$var$load("Wowvf"),
    $d6dec37146254315$var$load("e3Gt5"),
    $d6dec37146254315$var$load("cvcNg"),
    $d6dec37146254315$var$load("4zz48"),
    $d6dec37146254315$var$load("jXM1T"),
    $d6dec37146254315$var$load("39XCn"),
    $d6dec37146254315$var$load("jw3lv"),
    $d6dec37146254315$var$load("7rqWx"),
    $d6dec37146254315$var$load("3Cky6"),
    $d6dec37146254315$var$load("kG5Ju"),
    $d6dec37146254315$var$load("il8bj"),
    $d6dec37146254315$var$load("6wr18"),
    $d6dec37146254315$var$load("aFLSJ"),
    $d6dec37146254315$var$load("ffEVr"),
    $d6dec37146254315$var$load("6bjEk"),
    $d6dec37146254315$var$load("jfSwd"),
    $d6dec37146254315$var$load("9vDBp"),
    $d6dec37146254315$var$load("96rwC"),
    $d6dec37146254315$var$load("RI3SR"),
    $d6dec37146254315$var$load("hhss7"),
    $d6dec37146254315$var$load("4YkJj"),
    $d6dec37146254315$var$load("sefUQ")
]).then(()=>parcelRequire('g54Qs'));

});

parcelRegister("bm134", function(module, exports) {

var $9MYUp = parcelRequire("9MYUp");

const $4f0e6cc68907f482$export$993dca3597b448e8 = ({ header: header, subHeader: subHeader, placeholderTitle: placeholderTitle })=>[
        {
            type: 'extensionFrame',
            content: [
                {
                    type: 'heading',
                    attrs: {
                        level: 1,
                        localId: null
                    },
                    content: [
                        {
                            type: 'text',
                            text: `${header}`
                        }
                    ]
                },
                {
                    type: 'paragraph',
                    attrs: {
                        localId: null
                    },
                    content: [
                        {
                            type: 'text',
                            text: `${subHeader}`
                        }
                    ]
                },
                {
                    type: 'paragraph',
                    attrs: {
                        localId: null
                    }
                },
                {
                    type: 'extension',
                    attrs: {
                        extensionKey: (0, $9MYUp.HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY),
                        extensionType: (0, $9MYUp.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE),
                        parameters: {
                            extensionTitle: placeholderTitle
                        },
                        text: null,
                        layout: 'default',
                        localId: null
                    }
                }
            ]
        }
    ];
module.exports["getSectionExtensionContents"] = $4f0e6cc68907f482$export$993dca3597b448e8;

});

parcelRegister("lMywb", function(module, exports) {

let $fdb8db379c235d15$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fdb8db379c235d15$var$load("nllca"),
    $fdb8db379c235d15$var$load("8ikac"),
    $fdb8db379c235d15$var$load("58WtS"),
    $fdb8db379c235d15$var$load("1olsN"),
    $fdb8db379c235d15$var$load("cyDpt"),
    $fdb8db379c235d15$var$load("hUbK8"),
    $fdb8db379c235d15$var$load("gkVge"),
    $fdb8db379c235d15$var$load("7H1j2"),
    $fdb8db379c235d15$var$load("25adb"),
    $fdb8db379c235d15$var$load("9Nopc"),
    $fdb8db379c235d15$var$load("dgmjH"),
    $fdb8db379c235d15$var$load("6UOty"),
    $fdb8db379c235d15$var$load("glcJK"),
    $fdb8db379c235d15$var$load("5SpB1"),
    $fdb8db379c235d15$var$load("71yo9"),
    $fdb8db379c235d15$var$load("kpdr7"),
    $fdb8db379c235d15$var$load("hZsD1"),
    $fdb8db379c235d15$var$load("1Gr4q"),
    $fdb8db379c235d15$var$load("bxj2D"),
    $fdb8db379c235d15$var$load("dChty"),
    $fdb8db379c235d15$var$load("ariuh"),
    $fdb8db379c235d15$var$load("eUsnQ"),
    $fdb8db379c235d15$var$load("6C7Vr"),
    $fdb8db379c235d15$var$load("jmTCk"),
    $fdb8db379c235d15$var$load("VXbA1"),
    $fdb8db379c235d15$var$load("4YkJj"),
    $fdb8db379c235d15$var$load("7EorR"),
    $fdb8db379c235d15$var$load("Wowvf"),
    $fdb8db379c235d15$var$load("hhss7"),
    $fdb8db379c235d15$var$load("e3Gt5"),
    $fdb8db379c235d15$var$load("cvcNg"),
    $fdb8db379c235d15$var$load("jXM1T"),
    $fdb8db379c235d15$var$load("gNPMO"),
    $fdb8db379c235d15$var$load("jfSwd"),
    $fdb8db379c235d15$var$load("1dC87"),
    $fdb8db379c235d15$var$load("3fvOY"),
    $fdb8db379c235d15$var$load("9vDBp"),
    $fdb8db379c235d15$var$load("ca0UP"),
    $fdb8db379c235d15$var$load("a92TB"),
    $fdb8db379c235d15$var$load("c7nj5"),
    $fdb8db379c235d15$var$load("1yIye"),
    $fdb8db379c235d15$var$load("4zz48"),
    $fdb8db379c235d15$var$load("39XCn"),
    $fdb8db379c235d15$var$load("jw3lv"),
    $fdb8db379c235d15$var$load("7rqWx"),
    $fdb8db379c235d15$var$load("aIze1"),
    $fdb8db379c235d15$var$load("3Cky6"),
    $fdb8db379c235d15$var$load("kG5Ju"),
    $fdb8db379c235d15$var$load("il8bj"),
    $fdb8db379c235d15$var$load("6wr18"),
    $fdb8db379c235d15$var$load("ffEVr"),
    $fdb8db379c235d15$var$load("aFLSJ"),
    $fdb8db379c235d15$var$load("6bjEk"),
    $fdb8db379c235d15$var$load("iYZAq"),
    $fdb8db379c235d15$var$load("bru8i")
]).then(()=>parcelRequire('eKNXi'));

});

parcelRegister("5q8Sb", function(module, exports) {

let $3f26436aeba3c765$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3f26436aeba3c765$var$load("nllca"),
    $3f26436aeba3c765$var$load("8ikac"),
    $3f26436aeba3c765$var$load("58WtS"),
    $3f26436aeba3c765$var$load("1olsN"),
    $3f26436aeba3c765$var$load("cyDpt"),
    $3f26436aeba3c765$var$load("hUbK8"),
    $3f26436aeba3c765$var$load("aQPuI"),
    $3f26436aeba3c765$var$load("7i9SF"),
    $3f26436aeba3c765$var$load("7H1j2"),
    $3f26436aeba3c765$var$load("25adb"),
    $3f26436aeba3c765$var$load("9Nopc"),
    $3f26436aeba3c765$var$load("jfSwd"),
    $3f26436aeba3c765$var$load("1dC87"),
    $3f26436aeba3c765$var$load("6UOty"),
    $3f26436aeba3c765$var$load("3fvOY"),
    $3f26436aeba3c765$var$load("glcJK"),
    $3f26436aeba3c765$var$load("5SpB1"),
    $3f26436aeba3c765$var$load("hS8gF"),
    $3f26436aeba3c765$var$load("g8A75"),
    $3f26436aeba3c765$var$load("7G12e"),
    $3f26436aeba3c765$var$load("1Gr4q"),
    $3f26436aeba3c765$var$load("bxj2D"),
    $3f26436aeba3c765$var$load("dChty"),
    $3f26436aeba3c765$var$load("jgaRb"),
    $3f26436aeba3c765$var$load("9vDBp"),
    $3f26436aeba3c765$var$load("RI3SR"),
    $3f26436aeba3c765$var$load("hhss7"),
    $3f26436aeba3c765$var$load("jmTCk"),
    $3f26436aeba3c765$var$load("VXbA1"),
    $3f26436aeba3c765$var$load("ca0UP"),
    $3f26436aeba3c765$var$load("a92TB"),
    $3f26436aeba3c765$var$load("c7nj5"),
    $3f26436aeba3c765$var$load("1yIye"),
    $3f26436aeba3c765$var$load("6fJCf"),
    $3f26436aeba3c765$var$load("4YkJj"),
    $3f26436aeba3c765$var$load("7EorR"),
    $3f26436aeba3c765$var$load("Wowvf"),
    $3f26436aeba3c765$var$load("e3Gt5"),
    $3f26436aeba3c765$var$load("cvcNg"),
    $3f26436aeba3c765$var$load("iZR3N"),
    $3f26436aeba3c765$var$load("4zz48"),
    $3f26436aeba3c765$var$load("jXM1T"),
    $3f26436aeba3c765$var$load("39XCn"),
    $3f26436aeba3c765$var$load("jw3lv"),
    $3f26436aeba3c765$var$load("7rqWx"),
    $3f26436aeba3c765$var$load("aIze1"),
    $3f26436aeba3c765$var$load("3Cky6"),
    $3f26436aeba3c765$var$load("kG5Ju"),
    $3f26436aeba3c765$var$load("il8bj"),
    $3f26436aeba3c765$var$load("4N1MY"),
    $3f26436aeba3c765$var$load("6wr18"),
    $3f26436aeba3c765$var$load("aFLSJ"),
    $3f26436aeba3c765$var$load("ffEVr"),
    $3f26436aeba3c765$var$load("6bjEk"),
    $3f26436aeba3c765$var$load("bQzWg")
]).then(()=>parcelRequire('2zngr'));

});

parcelRegister("kv7Kg", function(module, exports) {

let $eeccb5ed2c5c03b5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $eeccb5ed2c5c03b5$var$load("gkVge"),
    $eeccb5ed2c5c03b5$var$load("cvcNg"),
    $eeccb5ed2c5c03b5$var$load("6wr18"),
    $eeccb5ed2c5c03b5$var$load("gNPMO"),
    $eeccb5ed2c5c03b5$var$load("glcJK"),
    $eeccb5ed2c5c03b5$var$load("5SpB1"),
    $eeccb5ed2c5c03b5$var$load("kpdr7"),
    $eeccb5ed2c5c03b5$var$load("hZsD1"),
    $eeccb5ed2c5c03b5$var$load("9w623"),
    $eeccb5ed2c5c03b5$var$load("1aqfs"),
    $eeccb5ed2c5c03b5$var$load("7G12e"),
    $eeccb5ed2c5c03b5$var$load("dChty"),
    $eeccb5ed2c5c03b5$var$load("eUsnQ"),
    $eeccb5ed2c5c03b5$var$load("6C7Vr"),
    $eeccb5ed2c5c03b5$var$load("4YkJj"),
    $eeccb5ed2c5c03b5$var$load("Wowvf"),
    $eeccb5ed2c5c03b5$var$load("hhss7"),
    $eeccb5ed2c5c03b5$var$load("ffEVr"),
    $eeccb5ed2c5c03b5$var$load("4lu2a")
]).then(()=>parcelRequire('42CfU'));

});

parcelRegister("33G0S", function(module, exports) {

let $23a23dd7b11bb1c0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $23a23dd7b11bb1c0$var$load("9Nopc"),
    $23a23dd7b11bb1c0$var$load("nllca"),
    $23a23dd7b11bb1c0$var$load("1olsN"),
    $23a23dd7b11bb1c0$var$load("cyDpt"),
    $23a23dd7b11bb1c0$var$load("iEsP0"),
    $23a23dd7b11bb1c0$var$load("fR7a0"),
    $23a23dd7b11bb1c0$var$load("hUbK8"),
    $23a23dd7b11bb1c0$var$load("fqJr7"),
    $23a23dd7b11bb1c0$var$load("7H1j2"),
    $23a23dd7b11bb1c0$var$load("25adb"),
    $23a23dd7b11bb1c0$var$load("glcJK"),
    $23a23dd7b11bb1c0$var$load("5SpB1"),
    $23a23dd7b11bb1c0$var$load("1Gr4q"),
    $23a23dd7b11bb1c0$var$load("dChty"),
    $23a23dd7b11bb1c0$var$load("hhss7"),
    $23a23dd7b11bb1c0$var$load("jmTCk"),
    $23a23dd7b11bb1c0$var$load("VXbA1"),
    $23a23dd7b11bb1c0$var$load("ca0UP"),
    $23a23dd7b11bb1c0$var$load("a92TB"),
    $23a23dd7b11bb1c0$var$load("c7nj5"),
    $23a23dd7b11bb1c0$var$load("1yIye"),
    $23a23dd7b11bb1c0$var$load("4YkJj"),
    $23a23dd7b11bb1c0$var$load("7EorR"),
    $23a23dd7b11bb1c0$var$load("Wowvf"),
    $23a23dd7b11bb1c0$var$load("e3Gt5"),
    $23a23dd7b11bb1c0$var$load("cvcNg"),
    $23a23dd7b11bb1c0$var$load("4zz48"),
    $23a23dd7b11bb1c0$var$load("jXM1T"),
    $23a23dd7b11bb1c0$var$load("39XCn"),
    $23a23dd7b11bb1c0$var$load("jw3lv"),
    $23a23dd7b11bb1c0$var$load("7rqWx"),
    $23a23dd7b11bb1c0$var$load("3Cky6"),
    $23a23dd7b11bb1c0$var$load("kG5Ju"),
    $23a23dd7b11bb1c0$var$load("il8bj"),
    $23a23dd7b11bb1c0$var$load("6wr18"),
    $23a23dd7b11bb1c0$var$load("aFLSJ"),
    $23a23dd7b11bb1c0$var$load("ffEVr"),
    $23a23dd7b11bb1c0$var$load("6bjEk"),
    $23a23dd7b11bb1c0$var$load("jfSwd"),
    $23a23dd7b11bb1c0$var$load("9vDBp"),
    $23a23dd7b11bb1c0$var$load("96rwC")
]).then(()=>parcelRequire('bZm0X'));

});

parcelRegister("219yw", function(module, exports) {

let $17831656c445e998$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $17831656c445e998$var$load("hUbK8"),
    $17831656c445e998$var$load("eOFeQ"),
    $17831656c445e998$var$load("25adb"),
    $17831656c445e998$var$load("glcJK"),
    $17831656c445e998$var$load("5SpB1"),
    $17831656c445e998$var$load("6vAHn"),
    $17831656c445e998$var$load("do5z1"),
    $17831656c445e998$var$load("hS8gF"),
    $17831656c445e998$var$load("g8A75"),
    $17831656c445e998$var$load("7G12e"),
    $17831656c445e998$var$load("1Gr4q"),
    $17831656c445e998$var$load("dChty"),
    $17831656c445e998$var$load("hhss7"),
    $17831656c445e998$var$load("5pK3l"),
    $17831656c445e998$var$load("jmTCk"),
    $17831656c445e998$var$load("4YkJj"),
    $17831656c445e998$var$load("7EorR"),
    $17831656c445e998$var$load("Wowvf"),
    $17831656c445e998$var$load("cvcNg"),
    $17831656c445e998$var$load("iZR3N"),
    $17831656c445e998$var$load("jXM1T"),
    $17831656c445e998$var$load("aIze1"),
    $17831656c445e998$var$load("6wr18"),
    $17831656c445e998$var$load("ffEVr"),
    $17831656c445e998$var$load("4N1MY"),
    $17831656c445e998$var$load("c70Sh")
]).then(()=>parcelRequire('cn3r4'));

});

parcelRegister("guwVF", function(module, exports) {

let $c018fdb4f223e05e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c018fdb4f223e05e$var$load("6wr18"),
    $c018fdb4f223e05e$var$load("dgPly"),
    $c018fdb4f223e05e$var$load("glcJK"),
    $c018fdb4f223e05e$var$load("5SpB1"),
    $c018fdb4f223e05e$var$load("5NX6D"),
    $c018fdb4f223e05e$var$load("ffEVr"),
    $c018fdb4f223e05e$var$load("4YkJj"),
    $c018fdb4f223e05e$var$load("dmi8r")
]).then(()=>parcelRequire('h0VGA'));

});

parcelRegister("bfil7", function(module, exports) {
/* eslint-disable prefer-const */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bdpeX = parcelRequire("bdpeX");


var $i1t43 = parcelRequire("i1t43");


var $4aRua = parcelRequire("4aRua");





var $eYo03 = parcelRequire("eYo03");











var $jHZ78 = parcelRequire("jHZ78");


var $uia0q = parcelRequire("uia0q");


var $5lo82 = parcelRequire("5lo82");





var $5ZtfK = parcelRequire("5ZtfK");




/* AutoUpdateIntervalMenu.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $hekY6 = parcelRequire("hekY6");


var $cJrqk = parcelRequire("cJrqk");


var $lJQKj = parcelRequire("lJQKj");

const $a912ef196b518420$export$3ece9240b892cee0 = (config, updateInterval)=>({
        desiredUpdateFrequency: (0, $lJQKj.getDesiredUpdateFrequencyForInterval)(updateInterval),
        goal: config.goal ?? undefined,
        goalOperations: config.goalOperations ?? undefined,
        prompt: config.prompt ?? null,
        sources: config.sources?.map((source)=>({
                app: source.app,
                ...source.url ? {
                    url: source.url
                } : {}
            })) ?? undefined
    });






var $89DwQ = parcelRequire("89DwQ");


var $cvhuh = parcelRequire("cvhuh");

var $4HMJH = parcelRequire("4HMJH");

const $287531c088127560$var$getSelectedAiManagedObject = (editorView)=>{
    const found = (0, $5lo82.findAgentManagedExtension)(editorView.state);
    const attrs = found?.node.attrs;
    const aimoId = (0, $5lo82.getNodeAiManagedObject)(attrs)?.id;
    return {
        aimoId: aimoId,
        cachedAimo: aimoId ? (0, $89DwQ.getCachedAiManagedObject)(editorView, aimoId) : undefined,
        localId: found?.node.attrs.localId
    };
};
const $287531c088127560$var$dispatchOpenAutoUpdateInterval = (editorView, selected)=>{
    const currentTarget = (0, $4HMJH.getAutoUpdateIntervalTargetFromState)(editorView.state);
    const isCurrentTargetOpen = currentTarget.isOpen && currentTarget.localId === selected.localId;
    if (isCurrentTargetOpen) return false;
    editorView.dispatch((0, $4HMJH.setMeta)(editorView.state.tr, {
        localId: selected.localId,
        type: 'OPEN_AUTO_UPDATE_INTERVAL'
    }));
    return true;
};
const $287531c088127560$var$getAiManagedObjectSelectionByLocalId = (editorView, localId)=>{
    const selected = $287531c088127560$var$getSelectedAiManagedObject(editorView);
    if (selected.localId === localId) return selected;
    const found = (0, $5lo82.findAgentManagedExtensionByLocalId)(editorView.state, localId);
    const attrs = found?.node.attrs;
    const aimoId = (0, $5lo82.getNodeAiManagedObject)(attrs)?.id;
    return {
        aimoId: aimoId,
        cachedAimo: aimoId ? (0, $89DwQ.getCachedAiManagedObject)(editorView, aimoId) : undefined,
        localId: localId
    };
};
const $287531c088127560$var$hydrateSelectionFromEditorView = async (editorView, selected)=>{
    if (!selected.aimoId) return;
    await (0, $89DwQ.getAiManagedObjectWithCache)({
        aimoId: selected.aimoId,
        cachedAimo: selected.cachedAimo,
        editorView: editorView,
        localId: selected.localId
    });
};
const $287531c088127560$var$persistUpdateInterval = async (editorView, updateInterval)=>{
    const target = (0, $4HMJH.getAutoUpdateIntervalTargetFromState)(editorView.state);
    const selected = target.localId ? $287531c088127560$var$getAiManagedObjectSelectionByLocalId(editorView, target.localId) : $287531c088127560$var$getSelectedAiManagedObject(editorView);
    if (!selected.aimoId) return;
    const aimo = await (0, $89DwQ.getAiManagedObjectWithCache)({
        aimoId: selected.aimoId,
        cachedAimo: selected.cachedAimo,
        editorView: editorView,
        localId: selected.localId
    });
    if (!aimo) return;
    const getCloseAutoUpdateIntervalMeta = ()=>{
        const latestTarget = (0, $4HMJH.getAutoUpdateIntervalTargetFromState)(editorView.state);
        if (!latestTarget.isOpen || latestTarget.localId !== selected.localId) return undefined;
        return {
            type: 'CLOSE_AUTO_UPDATE_INTERVAL'
        };
    };
    await (0, $89DwQ.updateAiManagedObjectWithCache)(editorView, {
        id: aimo.id,
        config: (0, $a912ef196b518420$export$3ece9240b892cee0)(aimo.config, updateInterval)
    }, selected.localId, getCloseAutoUpdateIntervalMeta);
};
const $287531c088127560$var$dispatchCloseAutoUpdateInterval = (editorView)=>{
    if (editorView.isDestroyed) return;
    editorView.dispatch((0, $4HMJH.setMeta)(editorView.state.tr, {
        type: 'CLOSE_AUTO_UPDATE_INTERVAL'
    }));
};
const $287531c088127560$export$c9858b5eac4f4374 = (option)=>(_state, _dispatch, editorView)=>{
        if (!editorView) return false;
        $287531c088127560$var$persistUpdateInterval(editorView, option === 'none' ? undefined : option).catch(()=>{
            $287531c088127560$var$dispatchCloseAutoUpdateInterval(editorView);
        });
        return true;
    };
const $287531c088127560$export$16d859ececa782c6 = ()=>(_state, _dispatch, editorView)=>{
        if (!editorView) return false;
        const selected = $287531c088127560$var$getSelectedAiManagedObject(editorView);
        const currentTarget = (0, $4HMJH.getAutoUpdateIntervalTargetFromState)(editorView.state);
        const isCurrentTargetOpen = currentTarget.isOpen && currentTarget.localId === selected.localId;
        if (isCurrentTargetOpen) {
            const loadStatus = (0, $cvhuh.getAiManagedObjectLoadStatusFromState)(editorView.state, selected.aimoId);
            return loadStatus === 'failed' || loadStatus === 'loading';
        }
        const isOpening = $287531c088127560$var$dispatchOpenAutoUpdateInterval(editorView, selected);
        if (isOpening) $287531c088127560$var$hydrateSelectionFromEditorView(editorView, selected).catch(()=>undefined);
        return isOpening;
    };
const $287531c088127560$export$9abf2c64b91508e9 = ()=>(_state, _dispatch, editorView)=>{
        if (!editorView) return false;
        const target = (0, $4HMJH.getAutoUpdateIntervalTargetFromState)(editorView.state);
        const selected = target.localId ? $287531c088127560$var$getAiManagedObjectSelectionByLocalId(editorView, target.localId) : $287531c088127560$var$getSelectedAiManagedObject(editorView);
        $287531c088127560$var$hydrateSelectionFromEditorView(editorView, selected).catch(()=>undefined);
        return true;
    };









const $a1e359a458cb210f$var$StatusWorkflowStoppedIcon = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("3og17")));

const $a1e359a458cb210f$var$SpeedometerRightDownIcon = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("dq7fL")));

const $a1e359a458cb210f$var$SpeedometerUpIcon = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("ez9s8")));

const $a1e359a458cb210f$var$SpeedometerLeftDownIcon = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("aenax")));
const $a1e359a458cb210f$export$b0059aa98a63be1e = (intl)=>[
        {
            Icon: $a1e359a458cb210f$var$StatusWorkflowStoppedIcon,
            id: 'agent-managed-extension-auto-update-interval-none',
            label: intl.formatMessage((0, $uia0q.messages).noAutoUpdate),
            option: 'none'
        },
        {
            Icon: $a1e359a458cb210f$var$SpeedometerRightDownIcon,
            id: 'agent-managed-extension-auto-update-interval-short',
            label: intl.formatMessage((0, $uia0q.messages).updateIntervalShort),
            option: 'short'
        },
        {
            Icon: $a1e359a458cb210f$var$SpeedometerUpIcon,
            id: 'agent-managed-extension-auto-update-interval-medium',
            label: intl.formatMessage((0, $uia0q.messages).updateIntervalMedium),
            option: 'medium'
        },
        {
            Icon: $a1e359a458cb210f$var$SpeedometerLeftDownIcon,
            id: 'agent-managed-extension-auto-update-interval-long',
            label: intl.formatMessage((0, $uia0q.messages).updateIntervalLong),
            option: 'long'
        }
    ];



var $3k5Tv = parcelRequire("3k5Tv");







const $d3e762a6d5d79caa$var$sharedStateSelector = ({ agentManagedExtensionState: agentManagedExtensionState })=>agentManagedExtensionState;
const $d3e762a6d5d79caa$export$6d9e5db964b06d2c = (api)=>{
    const pluginState = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'agentManagedExtension'
    ], $d3e762a6d5d79caa$var$sharedStateSelector);
    const localId = pluginState?.isAutoUpdateIntervalOpen ? pluginState.autoUpdateIntervalLocalId : undefined;
    const aimo = (0, $cvhuh.getCachedAiManagedObjectByLocalIdFromPluginState)(pluginState, localId);
    const loadStatus = (0, $cvhuh.getAiManagedObjectLoadStatusByLocalIdFromPluginState)(pluginState, localId);
    return {
        isFailed: loadStatus === 'failed',
        isLoading: loadStatus === 'loading',
        selectedUpdateInterval: aimo ? (0, $lJQKj.getUpdateIntervalFromDesiredFrequency)(aimo.config.desiredUpdateFrequency) ?? 'none' : undefined
    };
};


const $003f7095f60757dd$var$menuStyles = null;
const $003f7095f60757dd$var$optionStyles = null;
const $003f7095f60757dd$var$selectedOptionStyles = null;
const $003f7095f60757dd$var$optionIconStyles = null;
const $003f7095f60757dd$var$optionIconFallbackStyles = null;
const $003f7095f60757dd$var$optionLabelStyles = null;
const $003f7095f60757dd$export$421ebf8d7aadbcf8 = ({ api: api, dispatchCommand: dispatchCommand, hide: hide, intl: intl, label: label })=>{
    const { isFailed: isFailed, isLoading: isLoading, selectedUpdateInterval: selectedUpdateInterval } = (0, $d3e762a6d5d79caa$export$6d9e5db964b06d2c)(api);
    if (isLoading) return /*#__PURE__*/ $cozmU.createElement("div", {
        "aria-label": label,
        className: (0, $hekY6.default)([
            "_4c065UgVvo _2Y7lL4gVvo _24h04i2Njc _39xV02N91d"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $cJrqk.AimoConfigurationLoadState), {
        status: "loading",
        testId: "agent-managed-extension-auto-update-interval-loading",
        variant: "menu"
    }));
    if (isFailed) return /*#__PURE__*/ $cozmU.createElement("div", {
        "aria-label": label,
        className: (0, $hekY6.default)([
            "_4c065UgVvo _2Y7lL4gVvo _24h04i2Njc _39xV02N91d"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $cJrqk.AimoConfigurationLoadState), {
        onRetry: ()=>dispatchCommand((0, $287531c088127560$export$9abf2c64b91508e9)()),
        status: "failed",
        testId: "agent-managed-extension-auto-update-interval-load-error",
        variant: "menu"
    }));
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "aria-label": label,
        role: "menu",
        className: (0, $hekY6.default)([
            "_4c065UgVvo _2Y7lL4gVvo _24h04i2Njc _39xV02N91d"
        ])
    }, (0, $a1e359a458cb210f$export$b0059aa98a63be1e)(intl).map((option)=>{
        const Icon = option.Icon;
        const isSelected = (selectedUpdateInterval ?? 'none') === option.option;
        return /*#__PURE__*/ $cozmU.createElement("button", {
            "aria-checked": isSelected,
            "data-testid": option.id,
            key: option.id,
            onClick: ()=>{
                dispatchCommand((0, $287531c088127560$export$c9858b5eac4f4374)(option.option));
                hide();
            },
            role: "menuitemcheckbox",
            type: "button",
            className: (0, $hekY6.default)([
                "_30huDKdnbC _0bjKvDKxmn _2mHwu82ADO _23rrnHyKLB _4c065UgVvo _2Y7lL42ADO _0hPCNLDIqT _0KLXrujOvk _24h04i2Njc _1UtDYzy7kJ _0wOv4Q7zJH _3iDTPbQ4SZ _4kiQYAnlTt _2fwxA5ecOK _39xV02N91d _1ubuxonXvL _34b3D2FQfX _1NDpvb6wH8 _2wtOC9vc3e _1eOmH6o126",
                isSelected && "_23rrnHyKLB _0KLXruY9q9 _1UtDYzjTy9 _1eOmH6sumd"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _3YEZNOdnbC"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
            fallback: /*#__PURE__*/ $cozmU.createElement("span", {
                className: (0, $hekY6.default)([
                    "_3iDTPbvbI6 _0jFU0VoWWg _39xV02oWWg"
                ])
            })
        }, /*#__PURE__*/ $cozmU.createElement(Icon, {
            label: ""
        }))), /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7"
            ])
        }, option.label));
    }));
};



const $eaa119ab10cc0efc$export$bdc2fc585e446e80 = (intl, api)=>{
    const label = intl.formatMessage((0, $uia0q.messages).autoUpdateInterval);
    const dropdownOptions = {
        height: 168,
        render: ({ dispatchCommand: dispatchCommand, hide: hide })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $003f7095f60757dd$export$421ebf8d7aadbcf8), {
                api: api,
                dispatchCommand: dispatchCommand,
                hide: hide,
                intl: intl,
                label: label
            }),
        width: 220
    };
    return {
        type: 'dropdown',
        id: 'agent-managed-extension-auto-update-interval',
        title: label,
        tooltip: label,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
            label: label
        }),
        dropdownWidth: 220,
        hideExpandIcon: true,
        onToggle: (0, $287531c088127560$export$16d859ececa782c6)(),
        showSelected: false,
        testId: 'agent-managed-extension-auto-update-interval-trigger',
        options: dropdownOptions
    };
};



const $a6abfd757fddb014$var$customizeIcon = ()=>Promise.resolve((parcelRequire("dPtk6"))).then((mod)=>mod.default);

const $a6abfd757fddb014$var$refreshIcon = ()=>Promise.resolve((parcelRequire("1WMy0"))).then((mod)=>mod.default);
const $a6abfd757fddb014$var$getAgentManagedExtensionAttributes = (node)=>node.attrs ?? {};
const $a6abfd757fddb014$var$getLocalId = (node)=>{
    const localId = $a6abfd757fddb014$var$getAgentManagedExtensionAttributes(node).localId;
    return typeof localId === 'string' ? localId : undefined;
};
const $a6abfd757fddb014$var$getAiManagedObjectId = (node)=>(0, $5lo82.getNodeAiManagedObject)($a6abfd757fddb014$var$getAgentManagedExtensionAttributes(node))?.id;
const $a6abfd757fddb014$var$hasAiManagedObject = (node, editorAPI)=>{
    const attrs = $a6abfd757fddb014$var$getAgentManagedExtensionAttributes(node);
    return Boolean((0, $5lo82.getNodeAiManagedObject)(attrs)) || Boolean(editorAPI?.agentManagedExtension?.actions?.hasAiManagedObject(attrs.localId));
};
const $a6abfd757fddb014$export$182fb6eec6871692 = ({ editorAPI: editorAPI, extensionType: extensionType = (0, $eYo03.AGENT_MANAGED_EXTENSION_TYPE_DEFAULT), intl: intl })=>{
    const autoUpdateIntervalItem = (0, $eaa119ab10cc0efc$export$bdc2fc585e446e80)(intl, editorAPI);
    const customizeItem = {
        key: 'agent-managed-extension-customize',
        label: intl.formatMessage((0, $uia0q.messages).customize),
        tooltip: intl.formatMessage((0, $uia0q.messages).customize),
        display: 'icon-and-label',
        icon: $a6abfd757fddb014$var$customizeIcon,
        action: ()=>{
            editorAPI?.agentManagedExtension?.actions?.toggleConfig();
            return Promise.resolve();
        }
    };
    const getToolbarItems = (contextNode)=>{
        const localId = $a6abfd757fddb014$var$getLocalId(contextNode);
        const aimoId = $a6abfd757fddb014$var$getAiManagedObjectId(contextNode);
        const pluginState = editorAPI?.agentManagedExtension?.sharedState.currentState();
        const isExecutionInProgress = (0, $jHZ78.isExecutingLifecycleState)(localId ? pluginState?.executionLifecycleByLocalId[localId]?.state : undefined);
        if (!$a6abfd757fddb014$var$hasAiManagedObject(contextNode, editorAPI)) return [
            customizeItem
        ];
        const regenerateItem = {
            key: 'agent-managed-extension-regenerate',
            label: intl.formatMessage((0, $uia0q.messages).regenerate),
            tooltip: intl.formatMessage((0, $uia0q.messages).regenerate),
            ariaLabel: intl.formatMessage((0, $uia0q.messages).regenerate),
            display: 'icon',
            icon: $a6abfd757fddb014$var$refreshIcon,
            disabled: isExecutionInProgress,
            action: ()=>{
                editorAPI?.agentManagedExtension?.actions?.regenerate({
                    aimoId: aimoId,
                    localId: localId
                });
                return Promise.resolve();
            }
        };
        return [
            customizeItem,
            autoUpdateIntervalItem,
            regenerateItem
        ];
    };
    const toolbar = {
        context: {
            type: 'extension',
            nodeType: 'bodiedExtension',
            extensionType: extensionType,
            extensionKey: (0, $eYo03.AGENT_MANAGED_EXTENSION_KEY)
        },
        toolbarItems: getToolbarItems
    };
    return [
        toolbar
    ];
};






/** Lazy-load the Rovo icon, sharing the chunk across all manifest icon entries. */ const $cffbca96dbcace4d$var$loadAgentManagedExtensionIcon = ()=>(parcelRequire("9vMEa"));



const $cffbca96dbcace4d$var$templateQuickInsertIconLoaders = {
    'decision-register': ()=>Promise.resolve((parcelRequire("dimUV"))),
    'executive-summary': ()=>Promise.resolve((parcelRequire("f0b2F"))),
    'meeting-recap': ()=>Promise.resolve((parcelRequire("ds2zu")))
};
const $cffbca96dbcace4d$export$69a33fa2796e9cf6 = (label, size = 'medium')=>()=>$cffbca96dbcace4d$var$loadAgentManagedExtensionIcon().then((mod)=>{
            const RovoIcon = mod.default;
            const IconForManifest = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RovoIcon, {
                    label: label,
                    size: size
                });
            IconForManifest.displayName = 'AgentManagedExtensionManifestIcon';
            return IconForManifest;
        });
const $cffbca96dbcace4d$export$f78933cf90535cd7 = (label, icon)=>()=>$cffbca96dbcace4d$var$templateQuickInsertIconLoaders[icon]().then((mod)=>{
            const TemplateIcon = mod.default;
            const IconForManifest = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(TemplateIcon, {
                    label: label,
                    color: "currentColor"
                });
            IconForManifest.displayName = 'AgentManagedExtensionTemplateQuickInsertIcon';
            return IconForManifest;
        });












/**
 * Build the ADF entity for a new agent-managed bodied extension.
 */ const $5b907044c393b4a7$var$buildBlockAdf = (extensionType, templateConfig)=>{
    const localId = (0, $5lo82.generateLocalId)();
    const attrs = {
        extensionKey: (0, $eYo03.AGENT_MANAGED_EXTENSION_KEY),
        extensionType: extensionType,
        parameters: templateConfig ? {
            macroParams: {
                templateConfig: {
                    value: JSON.stringify(templateConfig)
                }
            }
        } : {},
        layout: 'default',
        localId: localId
    };
    return {
        type: 'bodiedExtension',
        attrs: attrs,
        content: [
            {
                type: 'paragraph'
            }
        ]
    };
};
const $5b907044c393b4a7$var$templateQuickInsertModules = [
    {
        descriptionMessage: (0, $uia0q.messages).insertExecutiveSummaryDescription,
        icon: 'executive-summary',
        key: 'agent-managed-block-executive-summary',
        keywords: [
            'agent',
            'rovo',
            'block',
            'summary',
            'executive',
            'panel'
        ],
        priority: 699,
        templateConfig: {
            goal: 'executive-summary',
            outputFormat: 'panel',
            sourceMode: 'current-page'
        },
        titleMessage: (0, $uia0q.messages).insertExecutiveSummaryTitle
    },
    {
        descriptionMessage: (0, $uia0q.messages).insertMeetingRecapDescription,
        icon: 'meeting-recap',
        key: 'agent-managed-block-meeting-recap',
        keywords: [
            'agent',
            'rovo',
            'block',
            'meeting',
            'recap',
            'notes'
        ],
        priority: 698,
        templateConfig: {
            goal: 'meeting-recap',
            sourceMode: 'current-page'
        },
        titleMessage: (0, $uia0q.messages).insertMeetingRecapTitle
    },
    {
        descriptionMessage: (0, $uia0q.messages).insertDecisionRegisterDescription,
        icon: 'decision-register',
        key: 'agent-managed-block-decision-register',
        keywords: [
            'agent',
            'rovo',
            'block',
            'decision',
            'register',
            'table'
        ],
        priority: 697,
        templateConfig: {
            goal: 'decision-register',
            outputFormat: 'table',
            sourceMode: 'manual'
        },
        titleMessage: (0, $uia0q.messages).insertDecisionRegisterTitle
    }
];
const $5b907044c393b4a7$export$adf4394301cf8737 = ({ extensionType: extensionType = (0, $eYo03.AGENT_MANAGED_EXTENSION_TYPE_DEFAULT), intl: intl })=>{
    return [
        {
            key: 'agent-managed-block',
            title: intl.formatMessage((0, $uia0q.messages).insertTitle),
            description: intl.formatMessage((0, $uia0q.messages).insertDescription),
            keywords: [
                'agent',
                'rovo',
                'block',
                'manage',
                'prompt'
            ],
            priority: 700,
            icon: (0, $cffbca96dbcace4d$export$69a33fa2796e9cf6)('', 'small'),
            action: async ()=>{
                return $5b907044c393b4a7$var$buildBlockAdf(extensionType);
            }
        },
        ...$5b907044c393b4a7$var$templateQuickInsertModules.map(({ descriptionMessage: descriptionMessage, icon: icon, key: key, keywords: keywords, priority: priority, templateConfig: templateConfig, titleMessage: titleMessage })=>({
                key: key,
                title: intl.formatMessage(titleMessage),
                description: intl.formatMessage(descriptionMessage),
                keywords: keywords,
                priority: priority,
                icon: (0, $cffbca96dbcace4d$export$f78933cf90535cd7)(intl.formatMessage(titleMessage), icon),
                action: async ()=>{
                    return $5b907044c393b4a7$var$buildBlockAdf(extensionType, templateConfig);
                }
            }))
    ];
};



var $4bVKh = parcelRequire("4bVKh");

const $1c6759b0f11de312$var$TITLE = 'AI Block';
const $1c6759b0f11de312$var$DESCRIPTION = 'A block whose contents are kept up-to-date by AI using pre-configured criteria';
const $1c6759b0f11de312$export$622c71ff061f2d98 = ({ editorAPI: editorAPI, extensionType: extensionType = (0, $eYo03.AGENT_MANAGED_EXTENSION_TYPE_DEFAULT), intl: intl, providerFactory: providerFactory })=>({
        title: $1c6759b0f11de312$var$TITLE,
        description: $1c6759b0f11de312$var$DESCRIPTION,
        type: extensionType,
        key: (0, $eYo03.AGENT_MANAGED_EXTENSION_KEY),
        icons: {
            '48': (0, $cffbca96dbcace4d$export$69a33fa2796e9cf6)($1c6759b0f11de312$var$TITLE, 'medium')
        },
        modules: {
            quickInsert: (0, $5b907044c393b4a7$export$adf4394301cf8737)({
                extensionType: extensionType,
                intl: intl
            }),
            contextualToolbars: (0, $a6abfd757fddb014$export$182fb6eec6871692)({
                editorAPI: editorAPI,
                extensionType: extensionType,
                intl: intl
            }),
            nodes: {
                default: {
                    type: 'bodiedExtension',
                    render: ()=>Promise.resolve(({ node: node })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4bVKh.AgentManagedBodiedExtensionRenderer), {
                                node: node,
                                providerFactory: providerFactory,
                                readOnly: true
                            }))
                }
            }
        }
    });


const $a893e0ac7d00a494$export$39aa3cd1a722fe6a = ({ editorAPI: editorAPI, extensionType: extensionType = (0, $eYo03.AGENT_MANAGED_EXTENSION_TYPE_DEFAULT), intl: intl, providerFactory: providerFactory })=>new (0, $bdpeX.default)([
        (0, $1c6759b0f11de312$export$622c71ff061f2d98)({
            editorAPI: editorAPI,
            extensionType: extensionType,
            intl: intl,
            providerFactory: providerFactory
        })
    ]);



var $7rOWN = parcelRequire("7rOWN");


var $3ricL = parcelRequire("3ricL");


var $jH9cM = parcelRequire("jH9cM");





var $iDrrr = parcelRequire("iDrrr");


var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $7ZL6d = parcelRequire("7ZL6d");


var $320o0 = parcelRequire("320o0");

/* AIPanelRenderer.tsx generated by @compiled/babel-plugin v3.0.2 */ 












var $4XbfY = parcelRequire("4XbfY");


var $2lPWP = parcelRequire("2lPWP");


var $aPdNQ = parcelRequire("aPdNQ");





var $3BY7M = parcelRequire("3BY7M");


var $hRnS5 = parcelRequire("hRnS5");


var $6FNab = parcelRequire("6FNab");


var $1VhsF = parcelRequire("1VhsF");


var $IQ4Dz = parcelRequire("IQ4Dz");




parcelRequire("cozmU");


var $c5jT4 = parcelRequire("c5jT4");




const $809b1f0594c81346$export$82f46aa4e6535a45 = (content)=>{
    switch(content){
        case 'INPUT_EXCEEDS_TOKEN_LIMIT':
            return (0, $c5jT4.aiFailedStateMessages).tokenLimitExceeded;
        case 'INPUT_TOO_SHORT_TO_SUMMARIZE':
            return (0, $c5jT4.aiFailedStateMessages).inputTooShortError;
        case 'INPUT_TOO_SHORT_TO_PROCESS':
            return (0, $c5jT4.aiFailedStateMessages).inputTooShortError;
        case 'RATE_LIMIT':
            return (0, $c5jT4.aiFailedStateMessages).rateLimitEnforced;
        case 'OPENAI_RATE_LIMIT_USER_ABUSE':
            return (0, $c5jT4.aiFailedStateMessages).rateLimitEnforced;
        case 'NO_AGENT':
            return (0, $c5jT4.aiFailedStateMessages).internalServerError;
        case 'FEATURE_DISABLED_ON_SITE':
            return (0, $c5jT4.aiFailedStateMessages).internalServerError;
        case 'FEATURE_DISABLED':
            return (0, $c5jT4.aiFailedStateMessages).internalServerError;
        case 'INTERNAL_SERVER_ERROR':
            return (0, $c5jT4.aiFailedStateMessages).internalServerError;
        case 'PLUGIN_ERRORED':
            return (0, $c5jT4.aiFailedStateMessages).internalServerError;
        case 'HIPAA_CONTENT_DETECTED':
            return (0, $c5jT4.aiFailedStateMessages).hipaaContentError;
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return (0, $c5jT4.aiFailedStateMessages).tokenLimitExceeded;
        default:
            return (0, $c5jT4.aiFailedStateMessages).apiError;
    }
};
const $809b1f0594c81346$export$b3199784470a824d = (formatMessage)=>{
    return formatMessage((0, $c5jT4.aiFailedStateMessages).aupViolationMessage, {
        auplink: (chunks)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $i1t43.default), {
                href: "https://www.atlassian.com/legal/acceptable-use-policy",
                target: "_blank",
                children: chunks
            })
    });
};
const $809b1f0594c81346$export$3c9530b6fa51254f = (formatMessage)=>{
    return formatMessage((0, $c5jT4.aiFailedStateMessages).internalServerError, {
        link: (chunks)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $i1t43.default), {
                href: "https://status.atlassian.com/",
                target: "_blank",
                children: chunks
            })
    });
};
const $809b1f0594c81346$export$93f9f2a0033ee0e6 = (formatMessage)=>{
    return formatMessage((0, $c5jT4.aiFailedStateMessages).rateLimitEnforced, {
        link: (chunks)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $i1t43.default), {
                href: "https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/",
                target: "_blank",
                children: chunks
            })
    });
};






var $iTJtk = parcelRequire("iTJtk");


var $9DHhW = parcelRequire("9DHhW");


var $krYZG = parcelRequire("krYZG");

const $69a11806fd553684$export$25b5539498f7439e = ({ node: node })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const getNodeMarkCount = (content)=>{
            return content.reduce((accum, currentNode)=>{
                const { type: type, marks: marks } = currentNode;
                accum.nodes[type] = (accum.nodes[type] || 0) + 1;
                if (Array.isArray(marks)) marks.forEach(({ type: type })=>{
                    accum.marks[type] = (accum.marks[type] || 0) + 1;
                });
                return accum;
            }, {
                nodes: {},
                marks: {}
            });
        };
        const prepareAndSendAnalytics = ()=>{
            const nodeMarkCount = Array.isArray(node.content) ? getNodeMarkCount(node.content) : {};
            const event = {
                action: (0, $krYZG.ACTION).RENDERED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BODIED_EXTENSION,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_PANELS_BODIED_EXTENSION,
                eventType: (0, $krYZG.EVENT_TYPE).UI,
                attributes: {
                    platform: 'web',
                    extensionKey: node.extensionKey,
                    extensionType: node.extensionType,
                    localId: node.localId,
                    panelStatus: node.parameters?.macroMetadata?.status,
                    nodeMarkCount: nodeMarkCount
                }
            };
            if (createAnalyticsEvent) createAnalyticsEvent(event)?.fire((0, $iTJtk.FabricChannel).editor);
        };
        if ('requestIdleCallback' in window) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.requestIdleCallback(prepareAndSendAnalytics);
        else // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.requestAnimationFrame(prepareAndSendAnalytics);
    }, [
        createAnalyticsEvent,
        node.content,
        node.extensionKey,
        node.extensionType,
        node.localId,
        node.parameters?.macroMetadata?.status
    ]);
};


const $892969e22dc91d4e$var$jsonTransformer = new (0, $2lPWP.JSONTransformer)();
const $892969e22dc91d4e$var$prismBackground = null;
const $892969e22dc91d4e$var$prismBackgroundLight = null;
const $892969e22dc91d4e$var$prismBackgroundDark = null;
const $892969e22dc91d4e$var$aiPanel = null;
const $892969e22dc91d4e$var$aiPanelContainer = null;
const $892969e22dc91d4e$var$createNodesFromContent = (content, schema)=>{
    const nodes = [];
    for (const node of content){
        if (node?.type === 'text') {
            const textNode = schema.text(node.text ?? '');
            nodes.push(textNode);
        } else if (schema.nodes[node.type] && node.content) {
            const contentNodes = $892969e22dc91d4e$var$createNodesFromContent(node.content, schema);
            const newNode = schema.nodes[node.type].create(node.attrs, contentNodes);
            nodes.push(newNode);
        }
    }
    return nodes;
};
const $892969e22dc91d4e$export$e197b6fcca07a8f5 = ({ node: node, providerFactory: providerFactory })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const [errorMessage, setErrorMessage] = (0, $cozmU.useState)(undefined);
    const [theme, setTheme] = (0, $cozmU.useState)(undefined);
    (0, $cozmU.useEffect)(()=>{
        const status = node.parameters?.macroMetadata?.status;
        if (status === 'failed' || status === 'aup-violation') switch(node.parameters?.content){
            case 'ACCEPTABLE_USE_VIOLATIONS':
                const aupViolationMessage = (0, $809b1f0594c81346$export$b3199784470a824d)(formatMessage);
                setErrorMessage(aupViolationMessage);
                break;
            case 'NO_AGENT':
            case 'FEATURE_DISABLED_ON_SITE':
            case 'FEATURE_DISABLED':
            case 'INTERNAL_SERVER_ERROR':
            case 'PLUGIN_ERRORED':
                const internalServerError = (0, $809b1f0594c81346$export$3c9530b6fa51254f)(formatMessage);
                setErrorMessage(internalServerError);
                break;
            case 'RATE_LIMIT':
            case 'OPENAI_RATE_LIMIT_USER_ABUSE':
                const rateLimitErrorMessage = (0, $809b1f0594c81346$export$93f9f2a0033ee0e6)(formatMessage);
                setErrorMessage(rateLimitErrorMessage);
                break;
            default:
                const errorMessageDescriptor = (0, $809b1f0594c81346$export$82f46aa4e6535a45)(node.parameters?.content ?? 'API_FAILED');
                const errorMessage = formatMessage(errorMessageDescriptor);
                setErrorMessage(errorMessage);
                break;
        }
        setTheme(colorMode);
    }, [
        node.parameters?.macroMetadata?.status,
        node.parameters?.content,
        formatMessage,
        colorMode
    ]);
    (0, $69a11806fd553684$export$25b5539498f7439e)({
        node: node
    });
    const doc = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        if (!node?.content || errorMessage) return null;
        const adfEncoder = new (0, $6FNab.ADFEncoder)(()=>$892969e22dc91d4e$var$jsonTransformer);
        return adfEncoder.encode($892969e22dc91d4e$var$jsonTransformer.encode((0, $4XbfY.defaultSchema).nodes.doc.create({}, (0, $aPdNQ.Fragment).from($892969e22dc91d4e$var$createNodesFromContent(node.content, (0, $4XbfY.defaultSchema))))));
    }, [
        node.content,
        errorMessage
    ]);
    if (errorMessage) return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_0bjKvDT39v _0Of8r2NvrM _1ZnuxbNvrM _1wydGWNvrM _2Zuz6QNvrM",
            theme === 'light' ? "_2uo31fWDpu" : "_2uo31fOOcF"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $hekY6.default)([
                "_0bjKvDKxmn _0KLXruoI2d"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO"
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1VhsF.default), {
                    appearance: "error",
                    title: '',
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        as: "p",
                        children: errorMessage
                    })
                })
            })
        })
    });
    if (!doc) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_0bjKvDT39v _0Of8r2NvrM _1ZnuxbNvrM _1wydGWNvrM _2Zuz6QNvrM",
            theme === 'light' ? "_2uo31fWDpu" : "_2uo31fOOcF"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $hekY6.default)([
                "_0bjKvDKxmn _0KLXruoI2d"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO"
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hRnS5.RendererActionsContext), {
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3BY7M.default), {
                        document: doc,
                        appearance: "full-width",
                        dataProviders: providerFactory
                    })
                })
            })
        })
    });
};


const $7d49ca7d3833d1bc$var$buildActionItemsPanelManifest = ({ intl: intl, providerFactory: providerFactory })=>{
    return {
        title: intl.formatMessage((0, $7ZL6d.aiMessages).actionItemsPageTitle),
        type: 'com.atlassian.ai-blocks',
        key: 'ai-action-items-block',
        description: intl.formatMessage((0, $7ZL6d.aiMessages).actionItemsPageDescription),
        icons: {
            // Ignored via go/ees005
            // eslint-disable-next-line require-await
            '48': async ()=>()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($320o0))), {
                        label: intl.formatMessage((0, $7ZL6d.aiMessages).actionItemsPageTitle)
                    })
        },
        modules: {
            nodes: {
                aiActionItemsBodiedExtension: {
                    type: 'bodiedExtension',
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-await
                    render: // oxlint-disable-next-line require-await
                    async ()=>({ node: node })=>{
                            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $892969e22dc91d4e$export$e197b6fcca07a8f5), {
                                node: node,
                                providerFactory: providerFactory
                            });
                        }
                }
            }
        }
    };
};
var $7d49ca7d3833d1bc$export$2e2bcd8739ae039 = $7d49ca7d3833d1bc$var$buildActionItemsPanelManifest;





parcelRequire("cozmU");








const $9bd716aab0728d36$var$buildSummarisePagePanelManifest = ({ intl: intl, providerFactory: providerFactory })=>{
    return {
        title: intl.formatMessage((0, $7ZL6d.aiMessages).summarizePageTitle),
        type: 'com.atlassian.ai-blocks',
        key: 'ai-summary-block',
        description: intl.formatMessage((0, $7ZL6d.aiMessages).summarisePageDescription),
        icons: {
            // Ignored via go/ees005
            // eslint-disable-next-line require-await
            '48': async ()=>()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($320o0))), {
                        label: intl.formatMessage((0, $7ZL6d.aiMessages).summarizePageTitle)
                    })
        },
        modules: {
            nodes: {
                aiSummaryBodiedExtension: {
                    type: 'bodiedExtension',
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-await
                    render: // oxlint-disable-next-line require-await
                    async ()=>({ node: node })=>{
                            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $892969e22dc91d4e$export$e197b6fcca07a8f5), {
                                node: node,
                                providerFactory: providerFactory
                            });
                        }
                }
            }
        }
    };
};
var $9bd716aab0728d36$export$2e2bcd8739ae039 = $9bd716aab0728d36$var$buildSummarisePagePanelManifest;


const $5507a5178ad04a78$export$34ea67e5ccaac92 = ({ intl: intl, providerFactory: providerFactory })=>{
    const summarisePage = (0, $9bd716aab0728d36$export$2e2bcd8739ae039)({
        intl: intl,
        providerFactory: providerFactory
    });
    const findActionItems = (0, $7d49ca7d3833d1bc$export$2e2bcd8739ae039)({
        intl: intl,
        providerFactory: providerFactory
    });
    const extensions = [];
    /**
   * WARNING: Do not remove the isFedRamp check.
   * This is to ensure that AI functionality is not enabled in FedRamp environments.
   */ const isEnabled = (0, $iDrrr.fg)('use_frontend_feature_encoding_sdk_platform') ? (0, $3ricL.isFeatureEnabled)('rovo', 'rovo-editor-ai-panels') : !(0, $jH9cM.isFedRamp)();
    if (isEnabled) {
        extensions.push(summarisePage);
        extensions.push(findActionItems);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new (0, $bdpeX.default)(extensions);
};



var $8bRAb = parcelRequire("8bRAb");


var $fPsyy = parcelRequire("fPsyy");








var $9kbTQ = parcelRequire("9kbTQ");


var $lPJNC = parcelRequire("lPJNC");


var $7LGcP = parcelRequire("7LGcP");


var $2sp5n = parcelRequire("2sp5n");


var $lBKFk = parcelRequire("lBKFk");


var $foj7F = parcelRequire("foj7F");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $1NBp8 = parcelRequire("1NBp8");


var $jn9ek = parcelRequire("jn9ek");


var $irVI7 = parcelRequire("irVI7");


var $aJPUt = parcelRequire("aJPUt");


var $ge2sX = parcelRequire("ge2sX");


var $f7i8j = parcelRequire("f7i8j");


var $6s78L = parcelRequire("6s78L");

/**
 * @generated SignedSource<<b4de7216f1956b4f6d564d048c80f4fe>>
 * @relayHash d5b3b486626d032523668447f933702e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 354c0b2036d906d7ae2e966f47ff191e75d1623b0c463a838a7bb5cb00d40947
const $9aada210960f84b9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "createdInContentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "createdInContentId",
                            "variableName": "createdInContentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        },
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "database"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "createContentInline",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CreateContentInlineMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CreateContentInlineMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d5b3b486626d032523668447f933702e",
            "id": "354c0b2036d906d7ae2e966f47ff191e75d1623b0c463a838a7bb5cb00d40947",
            "metadata": {},
            "name": "CreateContentInlineMutation",
            "operationKind": "mutation",
            "text": "mutation CreateContentInlineMutation($createdInContentId:ID!,$spaceKey:String){createContentInline(input:{createdInContentId:$createdInContentId,spaceKey:$spaceKey,type:\"database\"}){id}}"
        }
    };
}();
$9aada210960f84b9$var$node.hash = "9d349e804d611298aa425de2f3bfd42a";
var $9aada210960f84b9$export$2e2bcd8739ae039 = $9aada210960f84b9$var$node;






var $jhwJP = parcelRequire("jhwJP");

const $7c2c9699294e7927$var$i18nBase = (0, $kSwu1.defineMessages)({
    manifestDescription: {
        id: "confluence-databases-extension.description",
        defaultMessage: "Create an empty database table"
    },
    manifestTitle: {
        id: "confluence-databases-extension.title",
        defaultMessage: "Database extension"
    },
    referenceDatabaseTitle: {
        id: "confluence-databases-extension.reference-database.title",
        defaultMessage: "Embed database"
    },
    referenceDatabaseDescription: {
        id: "confluence-databases-extension.reference-database.description",
        defaultMessage: "Display an existing database, entry, or value"
    },
    referenceDatabaseModalLabel: {
        id: "confluence-databases-extension.reference-database.modal-label",
        defaultMessage: "Reference database modal"
    },
    createDatabaseIconAltText: {
        id: "confluence-databases-extension.create-database.icon-alt-text",
        defaultMessage: "Create database icon"
    },
    referenceDatabaseIconAltText: {
        id: "confluence-databases-extension.reference-database.icon-alt-text",
        defaultMessage: "Reference database icon"
    },
    successFlagTitle: {
        id: "confluence-databases-extension.success-flag.title",
        defaultMessage: "Database added under this content "
    },
    successFlagAction: {
        id: "confluence-databases-extension.success-flag.action",
        defaultMessage: "Open database in new tab"
    },
    successFlagDescription: {
        id: "confluence-databases-extension.success-flag.description",
        defaultMessage: "To view this database in full and edit it with ease, open it in a new tab."
    },
    defaultErrorFlagTitle: {
        id: "confluence-databases-extension.error-flag.title",
        defaultMessage: "We\u2019re unable to create right now"
    },
    defaultErrorFlagDescription: {
        id: "confluence-databases-extension.error-flag.description",
        defaultMessage: "Refresh or wait a few minutes and try again. If this keeps happening, contact support."
    },
    parentPageMovedErrorTitle: {
        id: "confluence-databases-extension.error.parent-page-moved-error-title",
        defaultMessage: "The parent has moved"
    },
    parentPageMovedErrorDescription: {
        id: "confluence-databases-extension.error.parent-page-moved-error-description",
        defaultMessage: "Refresh to create in the new location."
    },
    permissionRemovedErrorTitle: {
        id: "confluence-databases-extension.error.permission-removed-error-title",
        defaultMessage: "We\u2019re unable to create this content"
    },
    permissionRemovedErrorDescription: {
        id: "confluence-databases-extension.error.permission-removed-error-description",
        defaultMessage: "You don\u2019t have permission to create here or the space has been recently deleted."
    },
    invalidParentErrorTitle: {
        id: "confluence-databases-extension.error.invalid-parent-error-title",
        defaultMessage: "We can\u2019t create a database"
    },
    invalidParentErrorDescription: {
        id: "confluence-databases-extension.error.invalid-parent-error-description",
        defaultMessage: "This page was deleted or archived. You can create a database on a different page."
    },
    databaseDefaultTitle: {
        id: "confluence-databases-extension.database-default.title",
        defaultMessage: "Database"
    },
    databaseDefaultDescription: {
        id: "confluence-databases-extension.database-default.description",
        defaultMessage: "Create a database to organize and sync info"
    },
    databaseDefaultIconAltText: {
        id: "confluence-databases-extension.database-default.icon-alt-text",
        defaultMessage: "Database icon"
    }
});
const $7c2c9699294e7927$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    invalidParentErrorDescription: {
        id: "confluence-databases-extension.error.invalid-parent-error-description.livedocs",
        defaultMessage: "This item was deleted or archived. You can create a database on a different page or live doc."
    }
});
const $7c2c9699294e7927$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($7c2c9699294e7927$var$i18nBase, $7c2c9699294e7927$var$i18nLiveDocs);


var $301fa4691cc72740$exports = {};
$301fa4691cc72740$exports = new URL("InlineEmbedIcon.eb3ad338.svg", import.meta.url).toString();






var $7aRdF = parcelRequire("7aRdF");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $aRGok = parcelRequire("aRGok");


var $bQm3c = parcelRequire("bQm3c");









var $fcaWu = parcelRequire("fcaWu");


var $7J5Uc = parcelRequire("7J5Uc");

const $e8cbe0a1e77b1d69$export$3f6d3dddadd0c944 = ()=>{
    const params = new URLSearchParams(window.location.search);
    const version = params.get('databases-frontend') || undefined;
    const [{ theme: theme }] = (0, $7J5Uc.useThemingState)();
    return (0, $cozmU.useMemo)(()=>{
        const url = new URL('/databases/standalone', window.location.origin);
        if (version) url.searchParams.set('bifrost-override', version);
        if (theme) {
            url.pathname = `${url.pathname}/${theme.colorMode === 'dark' ? 'index-dark.html' : 'index.html'}`;
            url.searchParams.set('themeState', encodeURIComponent((0, $fcaWu.themeObjectToString)(theme)));
        }
        url.searchParams.set('referencing', 'true');
        url.searchParams.set('parentProduct', 'smartLink');
        const finalUrlParts = [
            url.pathname
        ];
        if (Array.from(url.searchParams).length > 0) finalUrlParts.push(url.searchParams.toString());
        return finalUrlParts.join('?');
    }, [
        version,
        theme
    ]);
};


/**
 * @generated SignedSource<<2ee8713375fb79b28b48377dd2066673>>
 * @relayHash d74c02bb5f354ff3819d9b43f86431af
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e60df62ac017064af1e7d578c6fe1bed7115af17de2be761e182f801b2162514
const $005429b0440abbd3$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "kind": "ScalarField",
            "name": "isPrimary"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": v0 /*: any*/ 
                },
                {
                    "concreteType": "AtlassianUserEmail",
                    "kind": "LinkedField",
                    "name": "emails",
                    "plural": true,
                    "selections": v0 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "locale"
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "DatabaseReferenceModalCurrentUserQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "DatabaseReferenceModalCurrentUserQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d74c02bb5f354ff3819d9b43f86431af",
            "id": "e60df62ac017064af1e7d578c6fe1bed7115af17de2be761e182f801b2162514",
            "metadata": {},
            "name": "DatabaseReferenceModalCurrentUserQuery",
            "operationKind": "query",
            "text": "query DatabaseReferenceModalCurrentUserQuery{user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary},emails{value,isPrimary},locale}}"
        }
    };
}();
$005429b0440abbd3$var$node.hash = "da5e7e584d6c779f02f908f5482b3187";
var $005429b0440abbd3$export$2e2bcd8739ae039 = $005429b0440abbd3$var$node;


/* DatabaseReferenceModalSkeleton.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $a9aSv = parcelRequire("a9aSv");


var $dinVW = parcelRequire("dinVW");


var $1l0kj = parcelRequire("1l0kj");

const $c190662e98183b48$var$skeletonStyles = {
    embedReferenceContainer: "_4c065U2ADO _2Y7lL4NHnM",
    placeholderContainer: "_39xV02N91d _0jFU0V2nFc",
    placeholderText: "_39xV02N91d",
    footerContainer: "_1wydGWNHnM"
};
const $c190662e98183b48$export$c5d436bba21e5326 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $c190662e98183b48$var$skeletonStyles.embedReferenceContainer,
        space: "space.200",
        testId: "reference-database-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.150",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        isShimmering: true,
        width: 240,
        height: 40,
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        isShimmering: true,
        width: 240,
        height: 40,
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        isShimmering: true,
        width: 240,
        height: 40,
        borderRadius: "var(--ds-radius-small, 4px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignBlock: "center",
        alignInline: "center",
        space: "space.400",
        xcss: $c190662e98183b48$var$skeletonStyles.placeholderContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        isShimmering: true,
        width: 108,
        height: 108,
        borderRadius: "var(--ds-radius-full, 9999px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        isShimmering: true,
        width: 316,
        height: 14,
        borderRadius: "var(--ds-radius-full, 9999px)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignInline: "end",
        space: "space.100",
        xcss: $c190662e98183b48$var$skeletonStyles.footerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        isShimmering: true,
        width: 61,
        height: 32,
        borderRadius: "var(--ds-radius-small, 4px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        isShimmering: true,
        width: 61,
        height: 32,
        borderRadius: "var(--ds-radius-small, 4px)"
    })));
};



var $c0rhi = parcelRequire("c0rhi");

const $dc4f221a49e0d4ac$var$isDatabaseUrl = (value)=>/database\/\d+/.test(value);
const $dc4f221a49e0d4ac$export$8480276ebb3b339b = ({ onClose: onClose, intl: intl })=>{
    const iframeRef = (0, $cozmU.useRef)(null);
    const [identity, setIdentity] = (0, $cozmU.useState)(null);
    const { activationId: activationId, userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const initialUrl = (0, $e8cbe0a1e77b1d69$export$3f6d3dddadd0c944)();
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(true);
    (0, $cozmU.useEffect)(()=>{
        (0, $c0rhi.queryInterop)({
            query: (0, $005429b0440abbd3$export$2e2bcd8739ae039),
            __callerPackage__: "confluence-databases-extension"
        }).then(({ data: data })=>{
            setIdentity({
                accountId: data?.user?.id,
                nickname: data?.user?.displayName,
                picture: data?.user?.photos?.find((photo)=>photo?.isPrimary)?.value,
                email: data?.user?.emails?.find((email)=>email?.isPrimary)?.value,
                locale: data?.user?.locale
            });
        });
    }, []);
    const bridgeData = {
        cloudId: cloudId,
        activationId: activationId,
        userId: userId,
        identity: identity
    };
    const messageCallback = (0, $cozmU.useCallback)((event)=>{
        const isFromExpectedIframe = iframeRef.current && event.source === iframeRef.current.contentWindow;
        if (isFromExpectedIframe) try {
            const data = JSON.parse(event.data);
            if (data.finalDatabaseUrl && $dc4f221a49e0d4ac$var$isDatabaseUrl(data.finalDatabaseUrl)) onClose(data.finalDatabaseUrl);
            else if (data.cancelDatabaseReference) onClose(undefined);
            else if (data.databaseReferencingComponentLoaded) setIsLoading(false);
        } catch  {}
    }, [
        onClose,
        iframeRef
    ]);
    (0, $cozmU.useEffect)(()=>{
        window.addEventListener('message', messageCallback);
        return ()=>{
            window.removeEventListener('message', messageCallback);
        };
    }, [
        messageCallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        width: 1200,
        height: 592,
        onClose: ()=>onClose(undefined),
        testId: "reference-database-modal",
        label: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).referenceDatabaseModalLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).referenceDatabaseTitle))), isLoading || !identity ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c190662e98183b48$export$c5d436bba21e5326), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: '505px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            border: (0, $9wGTI.fg)('confluence_frontend_tokenize_border') ? "var(--ds-space-0, 0px)" : '0px',
            display: !isLoading && identity ? 'block' : 'none'
        },
        src: initialUrl,
        ...identity ? {
            'data-bridge-data': JSON.stringify(bridgeData)
        } : {},
        title: "reference-database-frame",
        ref: iframeRef
    })));
};






var $lfoFx = parcelRequire("lfoFx");








/**
 * @generated SignedSource<<b035fda6a872ab7331ba8bc85786fd7e>>
 * @relayHash 40826fc58666f6735d9c7867264a488a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 419c5723846b6b093ae72cf841f1af5f13d93a23b4eb82a119b57a7dfb9b71c4
const $3c3a42cef99017de$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "kind": "ScalarField",
            "name": "isPrimary"
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "referenceId"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": v2 /*: any*/ 
                },
                {
                    "concreteType": "AtlassianUserEmail",
                    "kind": "LinkedField",
                    "name": "emails",
                    "plural": true,
                    "selections": v2 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "locale"
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "DatabaseValueContainerContentUnifiedQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "DatabaseValueContainerContentUnifiedQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "40826fc58666f6735d9c7867264a488a",
            "id": "419c5723846b6b093ae72cf841f1af5f13d93a23b4eb82a119b57a7dfb9b71c4",
            "metadata": {},
            "name": "DatabaseValueContainerContentUnifiedQuery",
            "operationKind": "query",
            "text": "query DatabaseValueContainerContentUnifiedQuery($contentId:ID!){content(id:$contentId){nodes{id,referenceId,space{id,key,name}}},user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary},emails{value,isPrimary},locale}}"
        }
    };
}();
$3c3a42cef99017de$var$node.hash = "e6d282732f563a19f236b7e97e2dc95a";
var $3c3a42cef99017de$export$2e2bcd8739ae039 = $3c3a42cef99017de$var$node;





const $e75add8c1d946f03$export$df287bda027f951a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ contentId: contentId, entryId: entryId, fieldId: fieldId, isEdit: isEdit })=>{
    const iframeRef = (0, $cozmU.useRef)(null);
    const [content, setContent] = (0, $cozmU.useState)(null);
    const [dataLoaded, setDataLoaded] = (0, $cozmU.useState)(false);
    const [width, setWidth] = (0, $cozmU.useState)(0);
    const [height, setHeight] = (0, $cozmU.useState)(0);
    const databaseUrl = new URL((0, $e8cbe0a1e77b1d69$export$3f6d3dddadd0c944)(), window.location.origin);
    const [identity, setIdentity] = (0, $cozmU.useState)(null);
    const { activationId: activationId, userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    (0, $cozmU.useEffect)(()=>{
        (0, $c0rhi.queryInterop)({
            query: (0, $3c3a42cef99017de$export$2e2bcd8739ae039),
            variables: {
                contentId: contentId
            },
            __callerPackage__: "confluence-databases-extension"
        }).then(({ data: data })=>{
            setContent({
                contentReferenceId: data.content?.nodes?.[0]?.referenceId,
                spaceId: data.content?.nodes?.[0]?.space?.id,
                spaceKey: data.content?.nodes?.[0]?.space?.key,
                spaceName: data.content?.nodes?.[0]?.space?.name
            });
            setIdentity({
                accountId: data?.user?.id,
                nickname: data?.user?.displayName,
                picture: data?.user?.photos?.find((photo)=>photo?.isPrimary)?.value,
                email: data?.user?.emails?.find((email)=>email?.isPrimary)?.value,
                locale: data?.user?.locale
            });
            setDataLoaded(true);
        });
    }, [
        contentId
    ]);
    const bridgeData = {
        cloudId: cloudId,
        activationId: activationId,
        userId: userId,
        identity: identity,
        contentId: contentId,
        ...content ? {
            content: content
        } : {}
    };
    const messageCallback = (0, $cozmU.useCallback)((event)=>{
        const isFromExpectedIframe = iframeRef.current && event.source === iframeRef.current.contentWindow;
        if (isFromExpectedIframe) try {
            const data = JSON.parse(event.data);
            if (data.method === 'resize' && 'width' in data && 'height' in data) {
                setWidth(data.width);
                setHeight(data.height);
            }
        } catch  {}
    }, []);
    (0, $cozmU.useEffect)(()=>{
        window.addEventListener('message', messageCallback);
        return ()=>{
            window.removeEventListener('message', messageCallback);
        };
    }, [
        messageCallback
    ]);
    if (entryId && fieldId && contentId) {
        databaseUrl.searchParams.delete('referencing');
        databaseUrl.searchParams.set('contentId', contentId);
        databaseUrl.searchParams.set('entryId', entryId);
        databaseUrl.searchParams.set('fieldId', fieldId);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
            style: {
                width: `${width}px`,
                height: `${height}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                border: (0, $9wGTI.fg)('confluence_frontend_tokenize_border') ? "var(--ds-space-0, 0px)" : '0px',
                pointerEvents: isEdit ? 'none' : 'auto',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                verticalAlign: 'middle'
            },
            src: databaseUrl.toString(),
            ...dataLoaded ? {
                'data-bridge-data': JSON.stringify(bridgeData)
            } : {},
            title: "database-value-frame",
            ref: iframeRef
        }), width === 0 || height === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            testId: "database-value-spinner"
        }) : null);
    }
    return null;
});


const $dfcefa6efd7a826f$var$isParentPageMovedError = (error)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some((graphQLError)=>graphQLError.extensions.data.errors.some((nestedError)=>nestedError.message.key.includes('The parent space does not match the desired space')));
    return false;
};
const $dfcefa6efd7a826f$var$isInvalidParentError = (error)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some((graphQLError)=>graphQLError.extensions.data.errors.some((nestedError)=>nestedError.message.key.includes('Invalid potential parent passed')));
    return false;
};
const $dfcefa6efd7a826f$export$56cb25c20f68202b = (error)=>{
    if ($dfcefa6efd7a826f$var$isParentPageMovedError(error)) return {
        title: (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).parentPageMovedErrorTitle,
        description: (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).parentPageMovedErrorDescription
    };
    else if ($dfcefa6efd7a826f$var$isInvalidParentError(error)) return {
        title: (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).invalidParentErrorTitle,
        description: (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).invalidParentErrorDescription
    };
    else if ((0, $1uFM6.isUnauthorizedError)(error)) return {
        title: (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).permissionRemovedErrorTitle,
        description: (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).permissionRemovedErrorDescription
    };
    return null;
};
const $dfcefa6efd7a826f$var$fireFlagActionClickedAnalytics = ({ createAnalyticsEvent: createAnalyticsEvent })=>{
    createAnalyticsEvent?.({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'redirectToDatabase',
            source: 'editorComponent',
            attributes: {
                flow: 'inlineDatabaseCreation',
                contentType: 'database',
                collabService: 'canvas-relay'
            }
        }
    }).fire();
};
const $dfcefa6efd7a826f$export$c063c49e521623c3 = ({ pageId: pageId, spaceKey: spaceKey, spaceId: spaceId, experienceTracker: experienceTracker, createAnalyticsEvent: createAnalyticsEvent, flags: flags, pageTreeStateUpdater: pageTreeStateUpdater })=>{
    return async ()=>{
        try {
            experienceTracker?.start({
                name: (0, $irVI7.CREATE_DATABASE_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
                attributes: {
                    flow: 'inlinePageCreation'
                }
            });
            const mutationResult = await (0, $6s78L.mutateInterop)({
                mutation: (0, $9aada210960f84b9$export$2e2bcd8739ae039),
                variables: {
                    createdInContentId: pageId,
                    spaceKey: spaceKey
                },
                __callerPackage__: "confluence-databases-extension"
            });
            const contentId = mutationResult?.data?.createContentInline?.id ?? '';
            createAnalyticsEvent?.({
                type: 'sendTrackEvent',
                data: {
                    actionSubject: 'content',
                    action: 'createdByFlow',
                    objectId: contentId,
                    objectType: 'database',
                    containerId: spaceId,
                    containerType: 'space',
                    source: 'editorComponent',
                    attributes: {
                        flow: 'inlineDatabaseCreation',
                        contentType: 'database',
                        collabService: 'canvas-relay'
                    }
                }
            }).fire();
            const fullUrl = $dfcefa6efd7a826f$export$b51cf6ef6d0676bd(contentId, spaceKey);
            await flags?.showFlag({
                type: 'success-circle',
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).successFlagTitle),
                actions: [
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).successFlagAction),
                        href: fullUrl,
                        target: '_blank',
                        onClick: ()=>$dfcefa6efd7a826f$var$fireFlagActionClickedAnalytics({
                                createAnalyticsEvent: createAnalyticsEvent
                            })
                    }
                ],
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).successFlagDescription)
            });
            if (contentId && pageTreeStateUpdater) pageTreeStateUpdater.setForceFetchPageId(contentId);
            experienceTracker?.succeed({
                name: (0, $irVI7.CREATE_DATABASE_EXPERIENCE)
            });
            if ((0, $9wGTI.fg)('platform_native_embeds_rollout_non_maui_experience')) return {
                type: 'extension',
                attrs: {
                    extensionKey: `${0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY}:database`,
                    extensionType: (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE),
                    parameters: {
                        macroParams: {
                            url: {
                                value: fullUrl
                            },
                            alwaysShowTitle: {
                                value: 'true'
                            }
                        }
                    }
                }
            };
            return {
                type: 'embedCard',
                attrs: {
                    url: fullUrl
                }
            };
        } catch (error) {
            const cteTraceId = (0, $jn9ek.getTraceIdFromApolloError)(error);
            const expectedErrorMessage = $dfcefa6efd7a826f$export$56cb25c20f68202b(error);
            if (expectedErrorMessage) {
                experienceTracker?.succeed({
                    name: (0, $irVI7.CREATE_DATABASE_EXPERIENCE),
                    attributes: {
                        abortReason: 'expectedErrorMessage'
                    }
                });
                await flags?.showErrorFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), expectedErrorMessage.title),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), expectedErrorMessage.description)
                });
            } else {
                (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).DATABASES
                });
                experienceTracker?.stopOnError({
                    name: (0, $irVI7.CREATE_DATABASE_EXPERIENCE),
                    error: error,
                    attributes: {
                        cteTraceId: cteTraceId
                    }
                });
                await flags?.showErrorFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).defaultErrorFlagTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).defaultErrorFlagDescription)
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    };
};
const $dfcefa6efd7a826f$export$b51cf6ef6d0676bd = (contentId, spaceKey)=>{
    const databaseUrl = (0, $1NBp8.DATABASE_VIEW).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    return window.location.origin + databaseUrl;
};
const $dfcefa6efd7a826f$export$3fddcebfd1fcb0f5 = (intl)=>{
    return async ()=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const el = document.createElement('div');
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.body.appendChild(el);
        const sessionData = await (0, $ge2sX.getSessionData)();
        let result;
        try {
            result = await new Promise((resolve)=>{
                // eslint-disable-next-line react/no-deprecated
                (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7i8j.SessionDataContext).Provider, {
                    value: sessionData
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dc4f221a49e0d4ac$export$8480276ebb3b339b), {
                    onClose: async (result)=>{
                        resolve(result);
                    },
                    intl: intl
                })), el);
            });
        } finally{
            // eslint-disable-next-line react/no-deprecated
            (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).unmountComponentAtNode(el);
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            document.body.removeChild(el);
        }
        if (result) {
            if ((0, $9wGTI.fg)('platform_native_embeds_rollout_non_maui_experience')) return {
                type: 'extension',
                attrs: {
                    extensionKey: `${0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY}:database`,
                    extensionType: (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE),
                    parameters: {
                        macroParams: {
                            url: {
                                value: result
                            },
                            alwaysShowTitle: {
                                value: 'true'
                            }
                        }
                    }
                }
            };
            return {
                type: 'embedCard',
                attrs: {
                    url: result
                }
            };
        } else return;
    };
};
const $dfcefa6efd7a826f$var$getDatabaseIcon = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))), {
        label: ""
    });
};
const $dfcefa6efd7a826f$var$getQuickInsertItemsForPage = ({ pageId: pageId, spaceKey: spaceKey, spaceId: spaceId, experienceTracker: experienceTracker, createAnalyticsEvent: createAnalyticsEvent, intl: intl, flags: flags, pageTreeStateUpdater: pageTreeStateUpdater })=>{
    const items = [
        {
            key: 'create-database',
            title: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).databaseDefaultTitle),
            description: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).databaseDefaultDescription),
            preview: {
                image: {
                    dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVK2.png',
                    light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVM0.png'
                },
                attribution: {
                    name: intl.formatMessage((0, $lPJNC.messages).previewAttributionConfluence),
                    icon: (0, $7LGcP.ConfluenceAttributionIcon)
                }
            },
            ...(0, $6mKj3.isExperimentEnabled)('platform_editor_slash_command') ? {
                category: 'data-and-charts',
                priority: -1400
            } : {
                priority: -100
            },
            icon: async ()=>()=>$dfcefa6efd7a826f$var$getDatabaseIcon(),
            action: $dfcefa6efd7a826f$export$c063c49e521623c3({
                pageId: pageId,
                spaceKey: spaceKey,
                spaceId: spaceId,
                experienceTracker: experienceTracker,
                createAnalyticsEvent: createAnalyticsEvent,
                flags: flags,
                pageTreeStateUpdater: pageTreeStateUpdater
            }),
            featured: true
        }
    ];
    return items;
};
const $dfcefa6efd7a826f$export$f86f9e9c7cf6f650 = ({ pageId: pageId, spaceKey: spaceKey, spaceId: spaceId, intl: intl, flags: flags, experienceTracker: experienceTracker, createAnalyticsEvent: createAnalyticsEvent, contentType: contentType, allowDatabaseQuickInsert: allowDatabaseQuickInsert, isEdit: isEdit, pageTreeStateUpdater: pageTreeStateUpdater })=>{
    const quickInsert = [];
    if (contentType === 'page') quickInsert.push(...$dfcefa6efd7a826f$var$getQuickInsertItemsForPage({
        pageId: pageId,
        spaceKey: spaceKey,
        spaceId: spaceId,
        experienceTracker: experienceTracker,
        createAnalyticsEvent: createAnalyticsEvent,
        intl: intl,
        flags: flags,
        pageTreeStateUpdater: pageTreeStateUpdater
    }));
    quickInsert.push({
        key: 'reference-database',
        title: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).referenceDatabaseTitle),
        description: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).referenceDatabaseDescription),
        preview: {
            image: {
                dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHP.png',
                light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLI.png'
            },
            attribution: {
                name: intl.formatMessage((0, $lPJNC.messages).previewAttributionConfluence),
                icon: (0, $7LGcP.ConfluenceAttributionIcon)
            }
        },
        ...(0, $6mKj3.isExperimentEnabled)('platform_editor_slash_command') ? {
            category: 'data-and-charts',
            priority: -1300
        } : {},
        icon: async ()=>()=>(0, $6mKj3.isExperimentEnabled)('platform_editor_slash_command') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($foj7F))), {
                    label: ""
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($301fa4691cc72740$exports))),
                    alt: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).referenceDatabaseIconAltText)
                }),
        action: $dfcefa6efd7a826f$export$3fddcebfd1fcb0f5(intl)
    });
    return {
        title: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).manifestTitle),
        type: 'com.atlassian.confluence.macro.core',
        key: 'database-extension',
        icons: {
            '48': async ()=>()=>$dfcefa6efd7a826f$var$getDatabaseIcon()
        },
        modules: {
            quickInsert: allowDatabaseQuickInsert ? quickInsert : [],
            nodes: {
                default: {
                    type: 'inlineExtension',
                    render: async ()=>{
                        const sessionData = await (0, $ge2sX.getSessionData)();
                        return ({ node: node })=>{
                            const contentId = node.parameters?.macroParams?.contentId.value;
                            const entryId = node.parameters?.macroParams?.entryId.value;
                            const fieldId = node.parameters?.macroParams?.fieldId.value;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7i8j.SessionDataContext).Provider, {
                                value: sessionData
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e75add8c1d946f03$export$df287bda027f951a), {
                                contentId: contentId,
                                fieldId: fieldId,
                                entryId: entryId,
                                isEdit: isEdit
                            }));
                        };
                    }
                }
            }
        }
    };
};



var $iXzFq = parcelRequire("iXzFq");


var $yuLaV = parcelRequire("yuLaV");


var $gH8jv = parcelRequire("gH8jv");


var $202oG = parcelRequire("202oG");

















var $9KSWX = parcelRequire("9KSWX");








var $56j2k = parcelRequire("56j2k");


var $kIuhf = parcelRequire("kIuhf");


var $ixTN9 = parcelRequire("ixTN9");


var $lVgnR = parcelRequire("lVgnR");

const $aa48fa7acda1b956$var$i18n = (0, $kSwu1.defineMessages)({
    newLozenge: {
        id: "native-tabs.extension.new-lozenge",
        defaultMessage: "New"
    }
});

const $aa48fa7acda1b956$export$9939b6c8e50c59ac = (intl, { getCopyLinkBaseUrl: getCopyLinkBaseUrl, resolveElementByHash: resolveElementByHash, shouldEnableBlockTransform: shouldEnableBlockTransform = (0, $6mKj3.expVal)('confluence_native_tabs_m15', 'isEnabled', false) } = {})=>{
    const newLozengeLabel = intl.formatMessage($aa48fa7acda1b956$var$i18n.newLozenge);
    const { icon: NativeTabsIcon, manifest: base } = (0, $ixTN9.buildBaseManifest)(intl);
    return {
        ...base,
        modules: {
            quickInsert: [
                {
                    key: (0, $56j2k.EXTENSION_KEY),
                    preview: {
                        image: {
                            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVH0.png',
                            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKG.png'
                        },
                        attribution: {
                            name: intl.formatMessage((0, $lPJNC.messages).previewAttributionConfluence),
                            icon: (0, $7LGcP.ConfluenceAttributionIcon)
                        }
                    },
                    title: base.title,
                    description: base.description,
                    lozenge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
                        appearance: (0, $9wGTI.fg)('confluence_fronend_labels_categorization_migration') ? 'discovery' : 'new'
                    }, newLozengeLabel),
                    icon: async ()=>NativeTabsIcon,
                    action: async ()=>{
                        const { tabs: tabs, frames: frames } = (0, $kIuhf.buildDefaultParameters)();
                        return {
                            type: 'multiBodiedExtension',
                            attrs: {
                                extensionType: (0, $56j2k.EXTENSION_TYPE),
                                extensionKey: (0, $56j2k.EXTENSION_KEY),
                                parameters: {
                                    extensionTitle: base.title,
                                    tabs: tabs
                                }
                            },
                            content: frames
                        };
                    }
                }
            ],
            nodes: {
                default: {
                    type: 'multiBodiedExtension',
                    ...shouldEnableBlockTransform ? {
                        blockTransform: (0, $lVgnR.getNativeTabsBlockTransform)(intl)
                    } : {},
                    // @ts-expect-error — `__allowBodiedOverride` is recognised by the MBE plugin
                    // at runtime but isn't yet on `ExtensionModuleNode`. Remove when upstream types update.
                    __allowBodiedOverride: true,
                    // editor-core's MBE plugin mounts this with `{ node, actions, ... }` injected.
                    render: async ()=>{
                        const mod = await (parcelRequire("725X8"));
                        return (props)=>{
                            if (!props.actions) return null;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(mod.TabsEditor, {
                                ...props,
                                actions: props.actions,
                                getCopyLinkBaseUrl: getCopyLinkBaseUrl,
                                resolveElementByHash: resolveElementByHash
                            });
                        };
                    }
                }
            }
        }
    };
};









const $51b6dad63a2df526$export$fd653d4581226676 = (intl)=>{
    const { manifest: base } = (0, $ixTN9.buildBaseManifest)(intl);
    return {
        ...base,
        modules: {
            nodes: {
                default: {
                    type: 'multiBodiedExtension',
                    // @ts-expect-error — `__allowBodiedOverride` is recognised by the MBE plugin
                    // at runtime but isn't yet on `ExtensionModuleNode`. Remove when upstream types update.
                    __allowBodiedOverride: true,
                    // editor-core's MBE plugin mounts this with `{ node, actions, ... }` injected.
                    render: async ()=>{
                        const mod = await (parcelRequire("2fGKa"));
                        return (props)=>{
                            if (!props.actions) return null;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(mod.TabsRenderer, {
                                ...props,
                                actions: props.actions
                            });
                        };
                    }
                }
            }
        }
    };
};






var $9Cbhx = parcelRequire("9Cbhx");











var $b5sDq = parcelRequire("b5sDq");







var $8c7ae3b087cac808$exports = {};
$8c7ae3b087cac808$exports = new URL("whiteboard-icon.f6879358.svg", import.meta.url).toString();








const $fedaa3ee3f94e7ae$var$messagesBase = (0, $kSwu1.defineMessages)({
    whiteboardManifestDescription: {
        id: "whiteboard-extension.description",
        defaultMessage: "Create an empty whiteboard"
    },
    whiteboardManifestTitle: {
        id: "whiteboard-extension.title",
        defaultMessage: "Whiteboard extension"
    },
    createWhiteboardTitle: {
        id: "whiteboard-extension.create-whiteboard.title",
        defaultMessage: "Whiteboard"
    },
    createWhiteboardRetrospectiveTitle: {
        id: "whiteboard-extension.create-retrospective.title",
        defaultMessage: "Retrospective"
    },
    createWhiteboardDiagramTitle: {
        id: "whiteboard-extension.create-diagram.title",
        defaultMessage: "Diagram"
    },
    createWhiteboardFlowchartTitle: {
        id: "whiteboard-extension.create-flowchart.title",
        defaultMessage: "Flowchart"
    },
    createWhiteboardBrainstormingTitle: {
        id: "whiteboard-extension.create-brainstorming.title",
        defaultMessage: "Brainstorm session"
    },
    createWhiteboardRoadmapTitle: {
        id: "whiteboard-extension.create-roadmap.title",
        defaultMessage: "Roadmap"
    },
    createWhiteboardDescription: {
        id: "whiteboard-extension.create-whiteboard.description",
        defaultMessage: "Create a blank whiteboard"
    },
    createWhiteboardRetrospectiveDescription: {
        id: "whiteboard-extension.create-retrospective.description",
        defaultMessage: "Create a whiteboard using the simple retrospective template"
    },
    createWhiteboardDiagramDescription: {
        id: "whiteboard-extension.create-diagram.description",
        defaultMessage: "Create a whiteboard using the flowchart template"
    },
    createWhiteboardFlowchartDescription: {
        id: "whiteboard-extension.create-flowchart.description",
        defaultMessage: "Create a whiteboard using the flowchart template"
    },
    createWhiteboardBrainstormingDescription: {
        id: "whiteboard-extension.create-brainstorming.description",
        defaultMessage: "Create a whiteboard using the brainwriting template"
    },
    createWhiteboardRoadmapDescription: {
        id: "whiteboard-extension.create-roadmap.description",
        defaultMessage: "Create a whiteboard using the product roadmap template"
    },
    createWhiteboardIconAltText: {
        id: "whiteboard-extension.create-whiteboard.icon-alt-text",
        defaultMessage: "Create whiteboard icon"
    },
    successFlagTitle: {
        id: "whiteboard-extension.success-flag.title",
        defaultMessage: "Whiteboard added to content tree"
    },
    successFlagAction: {
        id: "whiteboard-extension.success-flag.action",
        defaultMessage: "Go to whiteboard"
    },
    successFlagDescription: {
        id: "whiteboard-extension.success-flag.description",
        defaultMessage: "The source whiteboard has been created in the tree. Go to the whiteboard to move its location or change its permissions."
    },
    whiteboardDefaultErrorFlagTitle: {
        id: "whiteboard-extension.error-flag.title",
        defaultMessage: "We\u2019re unable to create right now"
    },
    whiteboardDefaultErrorFlagDescription: {
        id: "whiteboard-extension.error-flag.description",
        defaultMessage: "Refresh or wait a few minutes and try again. If this keeps happening, contact support."
    },
    whiteboardParentPageMovedErrorTitle: {
        id: "whiteboard-extension.error.parent-page-moved-error-title",
        defaultMessage: "The parent has moved"
    },
    whiteboardParentPageMovedErrorDescription: {
        id: "whiteboard-extension.error.parent-page-moved-error-description",
        defaultMessage: "Refresh to create in the new location."
    },
    whiteboardPermissionRemovedErrorTitle: {
        id: "whiteboard-extension.error.permission-removed-error-title",
        defaultMessage: "We\u2019re unable to create this content"
    },
    whiteboardPermissionRemovedErrorDescription: {
        id: "whiteboard-extension.error.permission-removed-error-description",
        defaultMessage: "You don\u2019t have permission to create here or the space has been recently deleted."
    },
    whiteboardInvalidParentErrorTitle: {
        id: "whiteboard-extension.error.invalid-parent-error-title",
        defaultMessage: "We can\u2019t create a whiteboard"
    },
    whiteboardInvalidParentErrorDescription: {
        id: "whiteboard-extension.error.invalid-parent-error-description",
        defaultMessage: "This page was deleted or archived. You can create a whiteboard on a different page."
    },
    whiteboardFeaturedItemDescription: {
        id: "whiteboard-extension.featured.description",
        defaultMessage: "Use a whiteboard to add visuals to your page"
    }
});
const $fedaa3ee3f94e7ae$var$messagesLiveDocs = (0, $kSwu1.defineMessages)({
    whiteboardInvalidParentErrorDescription: {
        id: "whiteboard-extension.error.invalid-parent-error-description.livedocs",
        defaultMessage: "This item was deleted or archived. You can create a whiteboard on a different page."
    }
});
const $fedaa3ee3f94e7ae$export$defe85febe8b728c = (0, $jhwJP.mergeLiveDocI18n)($fedaa3ee3f94e7ae$var$messagesBase, $fedaa3ee3f94e7ae$var$messagesLiveDocs);

































var $hQnHK = parcelRequire("hQnHK");









const $e46ddd38893da75d$var$isParentPageMovedError = (error)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some((graphQLError)=>graphQLError.extensions.data.errors.some((nestedError)=>nestedError.message.key.includes('The parent space does not match the desired space')));
    return false;
};
const $e46ddd38893da75d$export$99d61d22bbf0a4ec = (error)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some((graphQLError)=>graphQLError.extensions.data.errors.some((nestedError)=>nestedError.message.key.includes('Invalid potential parent passed')));
    return false;
};
const $e46ddd38893da75d$export$56cb25c20f68202b = (error)=>{
    if ($e46ddd38893da75d$var$isParentPageMovedError(error)) return {
        title: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).whiteboardParentPageMovedErrorTitle,
        description: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).whiteboardParentPageMovedErrorDescription
    };
    else if ($e46ddd38893da75d$export$99d61d22bbf0a4ec(error)) return {
        title: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).whiteboardInvalidParentErrorTitle,
        description: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).whiteboardInvalidParentErrorDescription
    };
    else if ((0, $1uFM6.isUnauthorizedError)(error)) return {
        title: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).whiteboardPermissionRemovedErrorTitle,
        description: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).whiteboardPermissionRemovedErrorDescription
    };
    return null;
};





/**
 * @generated SignedSource<<151c9217a7e8ee52913fea6d5a2999a7>>
 * @relayHash 850ebfae14461f590dab32639d9975d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b46dcd216ada596b921f01749512ffaf9b266577b416b15e42b00ca2e3187836
const $778fd7f2ef2278d4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "createdInContentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "createdInContentId",
                            "variableName": "createdInContentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        },
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "whiteboard"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "createContentInline",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "WhiteboardExtensionCreateWhiteboardMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "WhiteboardExtensionCreateWhiteboardMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "850ebfae14461f590dab32639d9975d2",
            "id": "b46dcd216ada596b921f01749512ffaf9b266577b416b15e42b00ca2e3187836",
            "metadata": {},
            "name": "WhiteboardExtensionCreateWhiteboardMutation",
            "operationKind": "mutation",
            "text": "mutation WhiteboardExtensionCreateWhiteboardMutation($createdInContentId:ID!,$spaceKey:String){createContentInline(input:{createdInContentId:$createdInContentId,spaceKey:$spaceKey,type:\"whiteboard\"}){id}}"
        }
    };
}();
$778fd7f2ef2278d4$var$node.hash = "3d1403ce2fe2c2c31def65ef0ccedba0";
var $778fd7f2ef2278d4$export$2e2bcd8739ae039 = $778fd7f2ef2278d4$var$node;


const $e1ce81e18a8b72db$export$c38d501b92148141 = (0, $778fd7f2ef2278d4$export$2e2bcd8739ae039);



var $fhofE = parcelRequire("fhofE");

async function $d23d3820cfa9f1e7$export$233ac44b3eda1727(pageId, spaceId, spaceKey, templateKey, createAnalyticsEvent) {
    const mutationResult = await (0, $6s78L.mutateInterop)({
        mutation: (0, $e1ce81e18a8b72db$export$c38d501b92148141),
        variables: {
            createdInContentId: pageId,
            spaceKey: spaceKey
        },
        __callerPackage__: "whiteboard-extension"
    });
    const contentId = mutationResult.data?.createContentInline?.id;
    if (!contentId) throw Error('no content id present');
    // track event - whiteboard created inline
    const event = createAnalyticsEvent?.({
        type: 'sendTrackEvent',
        data: {
            action: 'createdByFlow',
            actionSubject: 'content',
            objectType: 'whiteboard',
            objectId: contentId,
            containerType: 'space',
            containerId: spaceId,
            source: 'createContentHandler',
            attributes: {
                flow: 'inlineWhiteboardCreation',
                contentType: 'whiteboard',
                collabService: 'canvas-relay',
                templateKey: templateKey
            }
        }
    });
    event?.fire();
    // return full URL so user can navigate
    return {
        contentId: contentId,
        fullUrl: (0, $fhofE.getFullWhiteboardUrl)(contentId, spaceKey)
    };
}


const $b90b80e740b78cf8$export$f15f03ee0d5fba0d = (pageId, spaceId, spaceKey, experienceTracker, createAnalyticsEvent, flags, templateKey, pageTreeStateUpdater)=>{
    return async ()=>{
        try {
            const instrumentedTemplateKey = templateKey ?? 'blank';
            experienceTracker?.start({
                name: (0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
                attributes: {
                    flow: 'inlinePageCreation',
                    template: instrumentedTemplateKey
                }
            });
            // call API to create whiteboard
            const { fullUrl: fullUrl, contentId: contentId } = await (0, $d23d3820cfa9f1e7$export$233ac44b3eda1727)(pageId, spaceId, spaceKey, instrumentedTemplateKey, createAnalyticsEvent);
            // allow user to navigate directly to whiteboard
            await flags?.showFlag({
                type: 'success-circle',
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).successFlagTitle),
                actions: [
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).successFlagAction),
                        href: fullUrl
                    }
                ],
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).successFlagDescription)
            });
            if (pageTreeStateUpdater && contentId) pageTreeStateUpdater.setForceFetchPageId(pageId);
            experienceTracker?.succeed({
                name: (0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE)
            });
            const url = new URL(fullUrl);
            const originatingUrl = (0, $1NBp8.EDIT_PAGE_V2).toUrl({
                contentType: 'pages',
                spaceKey: spaceKey,
                contentId: pageId
            });
            if (templateKey) // for applying a specific template once opened
            url.searchParams.set((0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM), templateKey);
            // for reconstructing the URL on the other side
            url.searchParams.set((0, $hQnHK.CREATED_FROM_SLUG), originatingUrl);
            window.open(url, '_blank', 'noreferrer, noopener');
            if ((0, $9wGTI.fg)('platform_native_embeds_rollout_non_maui_experience')) return {
                type: 'extension',
                attrs: {
                    extensionKey: `${0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY}:whiteboard`,
                    extensionType: (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE),
                    parameters: {
                        macroParams: {
                            url: {
                                value: fullUrl
                            }
                        }
                    }
                }
            };
            return {
                type: 'embedCard',
                attrs: {
                    url: fullUrl
                }
            };
        } catch (error) {
            const expectedErrorMessage = (0, $e46ddd38893da75d$export$56cb25c20f68202b)(error);
            if (expectedErrorMessage) {
                await flags?.showErrorFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), expectedErrorMessage.title),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), expectedErrorMessage.description)
                });
                experienceTracker?.succeed({
                    name: (0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE),
                    attributes: {
                        abortReason: 'expectedErrorMessage'
                    }
                });
            } else {
                const monitoringClient = (0, $5ZqQS.getMonitoringClient)();
                monitoringClient.submitError(error, {
                    attribution: (0, $3IBnw.Attribution).WHITEBOARDS
                });
                await flags?.showErrorFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).whiteboardDefaultErrorFlagTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).whiteboardDefaultErrorFlagDescription)
                });
                experienceTracker?.stopOnError({
                    name: (0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE),
                    error: error,
                    attributes: {
                        cteTraceId: (0, $jn9ek.getTraceIdFromApolloError)(error)
                    }
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    };
};



const $1ecba3309686f865$var$baseSlashCommands = [
    {
        key: 'whiteboard',
        title: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).createWhiteboardTitle,
        description: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).createWhiteboardDescription,
        preview: {
            image: {
                dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHX.png',
                light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLT.png'
            }
        }
    },
    {
        key: 'retrospective',
        title: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).createWhiteboardRetrospectiveTitle,
        description: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).createWhiteboardRetrospectiveDescription,
        templateKey: 'simple-retrospective',
        preview: {
            image: {
                dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVI3.png',
                light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLO.png'
            }
        }
    },
    {
        key: 'diagram',
        title: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).createWhiteboardDiagramTitle,
        description: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).createWhiteboardDiagramDescription,
        templateKey: 'flow-chart',
        preview: {
            image: {
                dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJZ.png',
                light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVNL.png'
            }
        }
    },
    {
        key: 'flowchart',
        title: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).createWhiteboardFlowchartTitle,
        description: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).createWhiteboardFlowchartDescription,
        templateKey: 'flow-chart',
        preview: {
            image: {
                dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIO.png',
                light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLQ.png'
            }
        }
    },
    {
        key: 'brainstorming',
        title: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).createWhiteboardBrainstormingTitle,
        description: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).createWhiteboardBrainstormingDescription,
        templateKey: 'brainwriting',
        preview: {
            image: {
                dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVI9.png',
                light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVMV.png'
            }
        }
    },
    {
        key: 'roadmap',
        title: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).createWhiteboardRoadmapTitle,
        description: (0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).createWhiteboardRoadmapDescription,
        templateKey: 'product-roadmap',
        preview: {
            image: {
                dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHW.png',
                light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLV.png'
            }
        }
    }
];
const $1ecba3309686f865$var$withPriorities = (priorities)=>$1ecba3309686f865$var$baseSlashCommands.map((command)=>({
            ...command,
            ...priorities[command.key] !== undefined ? {
                priority: priorities[command.key]
            } : {}
        }));
const $1ecba3309686f865$export$4b9aaaa6a56ab300 = $1ecba3309686f865$var$withPriorities({
    diagram: -200
});
const $1ecba3309686f865$export$6a8eaf1da3a38496 = $1ecba3309686f865$var$withPriorities({
    whiteboard: -1000,
    retrospective: -600,
    diagram: -900,
    flowchart: -800,
    brainstorming: -700,
    roadmap: -500
});



const $e34976de7a15a4c3$export$f5b268b2504551e9 = ({ pageId: pageId, spaceId: spaceId, spaceKey: spaceKey, intl: intl, flags: flags, experienceTracker: experienceTracker, createAnalyticsEvent: createAnalyticsEvent, contentType: contentType, allowWhiteboardQuickInsert: allowWhiteboardQuickInsert, pageTreeStateUpdater: pageTreeStateUpdater })=>{
    // empty extension if not on page
    if (contentType !== 'page') return {
        title: intl.formatMessage((0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).whiteboardManifestTitle),
        description: intl.formatMessage((0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).whiteboardManifestDescription),
        type: 'com.atlassian.confluence.macro.core',
        key: 'whiteboard-extension',
        icons: {
            // eslint-disable-next-line import/dynamic-import-chunkname
            '48': ()=>(parcelRequire("b4ALZ"))
        },
        modules: {
            quickInsert: []
        }
    };
    const icon = async ()=>()=>{
            if ((0, $9wGTI.fg)('cc_fd_wb_update_diagram_icon')) // Return new ADS icon when feature gate is enabled
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b5sDq))), {
                label: ""
            });
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($8c7ae3b087cac808$exports))),
                alt: ""
            });
        };
    const quickInsertCommands = ((0, $6mKj3.isExperimentEnabled)('platform_editor_slash_command') ? (0, $1ecba3309686f865$export$6a8eaf1da3a38496) : (0, $1ecba3309686f865$export$4b9aaaa6a56ab300)).map((command)=>({
            key: `create-${command.key}`,
            title: intl.formatMessage(command.title),
            description: intl.formatMessage(command.description),
            preview: {
                ...command.preview,
                attribution: {
                    name: intl.formatMessage((0, $lPJNC.messages).previewAttributionConfluence),
                    icon: (0, $7LGcP.ConfluenceAttributionIcon)
                }
            },
            ...(0, $6mKj3.isExperimentEnabled)('platform_editor_slash_command') ? {
                category: 'media'
            } : {},
            priority: command.priority,
            icon: icon,
            action: (0, $b90b80e740b78cf8$export$f15f03ee0d5fba0d)(pageId, spaceId, spaceKey, experienceTracker, createAnalyticsEvent, flags, command.templateKey, pageTreeStateUpdater),
            ...command.key === 'diagram' && {
                featured: true
            }
        }));
    return {
        title: intl.formatMessage((0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).whiteboardManifestTitle),
        description: intl.formatMessage((0, $fedaa3ee3f94e7ae$export$defe85febe8b728c).whiteboardManifestDescription),
        type: 'com.atlassian.confluence.macro.core',
        key: 'whiteboard-extension',
        icons: {
            '48': icon
        },
        modules: {
            quickInsert: allowWhiteboardQuickInsert ? quickInsertCommands : []
        }
    };
};



var $cOau5 = parcelRequire("cOau5");


var $jBnsv = parcelRequire("jBnsv");


var $Qcu7n = parcelRequire("Qcu7n");


var $3IXUB = parcelRequire("3IXUB");


var $6OgRG = parcelRequire("6OgRG");


var $6mEZ3 = parcelRequire("6mEZ3");


var $8pcS0 = parcelRequire("8pcS0");


var $cV0On = parcelRequire("cV0On");


var $aMlgD = parcelRequire("aMlgD");


var $fgbpl = parcelRequire("fgbpl");





function $7a29776dd6927980$export$eb802fdec29ee1cc(extensionHandlers) {
    return {
        title: 'Redacted Macro Placeholder',
        key: (0, $8pcS0.EXTENSION_KEY).REDACTED_MACRO_PLACEHOLDER,
        type: (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE,
        icons: {
            '48': async ()=>Promise.resolve((parcelRequire("4efpo")))
        },
        modules: {
            nodes: {
                default: {
                    type: 'extension',
                    render: async ()=>({ node: node })=>{
                            // We are already loading `RedactedPlaceholderExtensionHandler` for `extensionHandlers`
                            // and it also uses `@confluence/loadable` so loading it here asynchronously isn't useful
                            const handler = extensionHandlers[(0, $8pcS0.EXTENSION_TYPE).MACRO_CORE];
                            if (typeof handler === 'function') return handler(node, null);
                            return null;
                        }
                }
            }
        }
    };
}



var $9tVje = parcelRequire("9tVje");







const $2dcacd11913842b3$var$EmptyDiv = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-extension-key": "hide"
    });
const $2dcacd11913842b3$export$ec1e9c66266151e8 = {
    type: (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE,
    key: (0, $8pcS0.EXTENSION_KEY).HIDE,
    title: 'Hide',
    description: 'Legacy hide macro',
    // icon is left empty because this is only fixing behaviour for migrated content in renderer
    // this macro cannot be inserted in a normal flow via the editor
    icons: {
        '48': ()=>Promise.resolve({
                default: ()=>null
            })
    },
    modules: {
        nodes: {
            default: {
                type: 'bodiedExtension',
                render: async ()=>$2dcacd11913842b3$var$EmptyDiv
            }
        }
    }
};



const $fd320ef48aed12ed$export$8e57f4d7d2152080 = {
    type: 'com.atlassian.confluence.migration',
    key: 'nested-table',
    title: 'Nested tables',
    description: 'Allows you to nest tables within tables',
    icons: {
        '48': ()=>Promise.resolve((parcelRequire("k0CUL")))
    },
    modules: {}
};


var $8eaad4326dd1f025$export$c2e660b99d13fe1a = /*#__PURE__*/ function(MappedFieldTypes) {
    MappedFieldTypes["int"] = "number";
    MappedFieldTypes["percentage"] = "string";
    MappedFieldTypes["url"] = "string";
    MappedFieldTypes["cql"] = "dynamic-fieldset";
    MappedFieldTypes["relativedate"] = "string";
    MappedFieldTypes["group"] = "string";
    MappedFieldTypes["color"] = "string";
    return MappedFieldTypes;
}({});


const $2f69ce15c0bd4ea6$export$f977989607a3df34 = {
    label: {
        type: 'custom',
        label: 'Label',
        isMultiple: true,
        allowDuplicates: true,
        isRequired: true,
        options: {
            resolver: {
                type: 'label'
            }
        }
    },
    text: {
        type: 'string',
        op: '~',
        label: 'Including text'
    },
    contributor: {
        key: 'contributor',
        type: 'custom',
        label: 'Contributor',
        isMultiple: true,
        options: {
            resolver: {
                type: 'username'
            }
        }
    },
    creator: {
        key: 'creator',
        type: 'custom',
        label: 'Creator',
        isMultiple: true,
        options: {
            resolver: {
                type: 'username'
            }
        }
    },
    mention: {
        key: 'mention',
        type: 'custom',
        label: 'Mentioning',
        isMultiple: true,
        options: {
            resolver: {
                type: 'username'
            }
        }
    },
    parent: {
        type: 'custom',
        label: 'With parent',
        options: {
            resolver: {
                type: 'confluence-content-by-id'
            }
        }
    },
    ancestor: {
        type: 'custom',
        label: 'With ancestor',
        isMultiple: true,
        options: {
            resolver: {
                type: 'confluence-content-by-id'
            }
        }
    },
    space: {
        type: 'custom',
        label: 'In space',
        isMultiple: true,
        options: {
            resolver: {
                type: 'spacekey'
            }
        }
    },
    // TODO: https://product-fabric.atlassian.net/browse/ED-10532
    created: {
        type: 'string',
        op: '>=',
        label: 'Created after',
        description: 'Enter dates as YYYY-MM-DD, or use CQL functions like `now(-1d)` for yesterday.'
    },
    lastmodified: {
        type: 'string',
        op: '<=',
        label: 'Last modified',
        description: 'Enter dates as YYYY-MM-DD, or use CQL functions like `now(-1d)` for yesterday.'
    },
    title: {
        type: 'string',
        op: '~',
        label: 'With title'
    },
    type: {
        type: 'enum',
        label: 'Of type',
        isMultiple: false,
        style: 'select',
        items: [
            {
                value: 'page',
                label: 'Page'
            },
            {
                value: 'blogpost',
                label: 'Blog'
            },
            {
                value: 'comment',
                label: 'Comment'
            },
            {
                value: 'attachment',
                label: 'Attachment'
            }
        ]
    }
};
const $2f69ce15c0bd4ea6$export$9545db27234e21a8 = ()=>Object.keys($2f69ce15c0bd4ea6$export$f977989607a3df34).map((name)=>({
            name: name,
            ...$2f69ce15c0bd4ea6$export$f977989607a3df34[name]
        }));


/**
 * Confluence returns a namespace inside description and label when the field is empty.
 * To map it to the new extension api, we need to remove it or replace it depending on the case.
 *
 * The original code can be found at https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence/browse/confluence-plugins/confluence-editor-plugins/confluence-macro-browser/src/main/resources/js/macro-browser-editor.js#441
 * @param value
 * @param fallback
 * @param params
 * @param macroData
 * @param fieldType
 */ const $38eecb7cd02ce24e$var$safeGetBodyValue = (value, fallback, params, macroData, fieldType)=>{
    const { pluginKey: pluginKey, macroName: macroName } = macroData;
    if (value === [
        pluginKey,
        macroName,
        'param',
        params.name,
        fieldType
    ].join('.')) return fallback;
    return value;
};
const $38eecb7cd02ce24e$var$getBaseAttributes = (params, macroData)=>{
    const { displayName: displayName, name: name, description: description } = params;
    return {
        label: $38eecb7cd02ce24e$var$safeGetBodyValue(displayName, name, params, macroData, 'label'),
        name: params.name || 'defaultParameterValue',
        defaultValue: params.defaultValue,
        description: $38eecb7cd02ce24e$var$safeGetBodyValue(description ?? '', '', params, macroData, 'desc'),
        isMultiple: !!params.multiple,
        isRequired: !!params.required,
        isHidden: !!params.hidden
    };
};
const $38eecb7cd02ce24e$var$isNativeFieldType = (fieldType)=>{
    return /^(enum|string|number|boolean|date)$/.test(fieldType);
};
const $38eecb7cd02ce24e$export$f5f12fd2c8b33ce0 = (params, macroData)=>{
    const fieldType = $38eecb7cd02ce24e$var$transformFieldType(params.type.name);
    const baseAttributes = $38eecb7cd02ce24e$var$getBaseAttributes(params, macroData);
    if (fieldType === 'custom') {
        const customField = {
            ...baseAttributes,
            type: 'custom',
            options: {
                resolver: {
                    type: params.type.name
                }
            }
        };
        return customField;
    }
    if (params.type.name === 'cql') {
        let label = $38eecb7cd02ce24e$var$safeGetBodyValue(params.displayName, params.name, params, macroData, 'label');
        if (label === 'cql') label = 'CQL';
        const cqlField = {
            label: label,
            name: params.name || 'defaultParameterValue',
            fields: (0, $2f69ce15c0bd4ea6$export$9545db27234e21a8)(),
            type: 'fieldset',
            options: {
                isDynamic: true,
                transformer: {
                    type: params.type.name
                }
            }
        };
        return cqlField;
    }
    if (fieldType === 'enum') {
        const enumField = {
            ...baseAttributes,
            type: 'enum',
            style: 'select',
            defaultValue: baseAttributes.defaultValue ?? undefined,
            items: (params.enumValues || []).map((item)=>({
                    label: item,
                    value: item
                }))
        };
        return enumField;
    }
    // Transform default value of number from `null` -> `0`
    if (fieldType === 'number') {
        const numberField = {
            ...baseAttributes,
            type: 'number',
            defaultValue: baseAttributes.defaultValue ?? undefined
        };
        return numberField;
    }
    // Transform default value of number from `"false"` -> `false`
    if (fieldType === 'boolean') {
        const booleanField = {
            ...baseAttributes,
            type: 'boolean',
            isRequired: false,
            defaultValue: typeof baseAttributes.defaultValue === 'string' ? baseAttributes.defaultValue !== 'false' : !!baseAttributes.defaultValue
        };
        return booleanField;
    }
    const field = {
        ...baseAttributes,
        type: fieldType
    };
    return field;
};
const $38eecb7cd02ce24e$var$isMappedField = (fieldType)=>fieldType in (0, $8eaad4326dd1f025$export$c2e660b99d13fe1a);
const $38eecb7cd02ce24e$var$transformFieldType = (fieldType)=>{
    if ($38eecb7cd02ce24e$var$isMappedField(fieldType)) return (0, $8eaad4326dd1f025$export$c2e660b99d13fe1a)[fieldType];
    if ($38eecb7cd02ce24e$var$isNativeFieldType(fieldType)) return fieldType;
    return 'custom';
};



var $gaGUd = parcelRequire("gaGUd");


var $e7owm = parcelRequire("e7owm");


var $eQyFc = parcelRequire("eQyFc");


var $2E7zk = parcelRequire("2E7zk");


var $f7B1p = parcelRequire("f7B1p");

const $f5981546cd91a250$var$search = async (options)=>{
    const params = Object.entries(options).map(([key, value])=>Array.isArray(value) ? value.map((item)=>`${key}=${item}`) : `${key}=${value}`).flat().join('&');
    // /json/attachmentsearch.action?pageId=910426922&fileTypes=pdf&fileTypes=xls
    const res = await (0, $f7B1p.cfetch)(`/wiki/json/attachmentsearch.action?${params}`);
    const { attachments: attachments } = await res.json();
    if (attachments) return attachments.map(({ title: title })=>({
            label: title,
            value: title
        }));
    return [];
};
const $f5981546cd91a250$var$getAttachmentResolver = (options)=>async (searchTerm, selectedValue)=>{
        const searchers = [];
        searchers.push($f5981546cd91a250$var$search({
            ...options,
            title: searchTerm
        }));
        if (selectedValue) searchers.push(Promise.resolve((Array.isArray(selectedValue) ? selectedValue : [
            selectedValue
        ]).map((value)=>({
                label: value,
                value: value
            }))));
        return (await Promise.all(searchers)).flat();
    };
const $f5981546cd91a250$export$98306171982e2202 = (macro, pageContext)=>{
    const pageId = pageContext.contentId;
    // fileTypes were taken from
    // https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence/browse/confluence-plugins/confluence-bundled-plugins/officeconnector/Zen/src/main/resources/javascript/office-connector-macro-fields.js#125-128
    switch(macro.macroName){
        case 'viewpdf':
            return $f5981546cd91a250$var$getAttachmentResolver({
                pageId: pageId,
                fileTypes: [
                    'pdf'
                ]
            });
        case 'viewdoc':
            return $f5981546cd91a250$var$getAttachmentResolver({
                pageId: pageId,
                fileTypes: [
                    'doc',
                    'docx'
                ]
            });
        case 'viewxls':
            return $f5981546cd91a250$var$getAttachmentResolver({
                pageId: pageId,
                fileTypes: [
                    'xls',
                    'xlsx'
                ]
            });
        case 'viewppt':
            return $f5981546cd91a250$var$getAttachmentResolver({
                pageId: pageId,
                fileTypes: [
                    'ppt',
                    'pptx'
                ]
            });
        default:
            return $f5981546cd91a250$var$getAttachmentResolver({
                pageId: pageId
            });
    }
};





const $99dfcbe48c719a87$var$search = async (searchTerm)=>{
    const res = await (0, $f7B1p.cfetch)(`/wiki/rest/calendar-services/1.0/calendar/search/subcalendars.json?term=${searchTerm}&limit=25&showSubCalendarsInView=true`);
    const resp = await res.json();
    if (!resp.success) return [];
    return resp.payload.map(({ subCalendar: { name: name, spaceName: spaceName, id: id } })=>({
            label: name,
            description: spaceName,
            value: id
        }));
};
const $99dfcbe48c719a87$var$fromIds = async (uuids)=>{
    const res = await (0, $f7B1p.cfetch)(`/wiki/rest/calendar-services/1.0/calendar/util/format/subcalendar/ids.json?subCalendarIds=${uuids.join('%2C')}`);
    const resp = await res.json();
    return resp.map(({ name: name, id: id })=>({
            label: name,
            value: id
        }));
};
const $99dfcbe48c719a87$export$79a154fc3ca3f9ae = async (searchTerm, selectedValue)=>{
    const searchers = [];
    if (searchTerm) searchers.push($99dfcbe48c719a87$var$search(searchTerm));
    if (selectedValue) {
        if (Array.isArray(selectedValue)) searchers.push($99dfcbe48c719a87$var$fromIds(selectedValue));
        else searchers.push($99dfcbe48c719a87$var$fromIds([
            selectedValue
        ]));
    }
    return (await Promise.all(searchers)).flat();
};





const $6b5a09c45142de10$export$45b10814cc054894 = (maybeArray = [])=>[].concat(maybeArray);


const $24ca4725cd610b37$var$search = async (cql)=>{
    return (0, $f7B1p.cfetch)(`/wiki/rest/api/search?limit=10&expand=content.container.icon&cql=${cql}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((result)=>result.json()).then((response)=>response.results.map((result)=>({
                label: result.content.title,
                value: result.content.id,
                icon: `/wiki${result.content.container.icon.path}`,
                description: result.content.container.name
            })));
};
const $24ca4725cd610b37$export$a5caa672469ad596 = (contentIds)=>`id IN (${contentIds.join(',')})`;
const $24ca4725cd610b37$export$41173a2c419f6dfc = async (searchTerm, selectedValue, options)=>{
    const searchers = [];
    const type = options && options.type || 'page, blogpost';
    const selectedValues = (0, $6b5a09c45142de10$export$45b10814cc054894)(selectedValue);
    const conditionalCql = selectedValues.length ? `OR ${$24ca4725cd610b37$export$a5caa672469ad596(selectedValues)}` : '';
    if (searchTerm) searchers.push($24ca4725cd610b37$var$search(`type IN (${type}) AND title ~ "${searchTerm}*" ${conditionalCql}`));
    else searchers.push($24ca4725cd610b37$var$search(`type IN (${type}) AND id in recentlyViewedContent(5) ${conditionalCql}`));
    return (await Promise.all(searchers)).flat();
};


const $2fdd0370d00b842a$var$defaultPrefixSetting = {
    prefix: '',
    labelFunc: (val)=>val
};
const $2fdd0370d00b842a$export$4172796c9e33488c = ({ resolver: resolver, prefixSettings: prefixSettings })=>{
    // Returns a prefix if `val` starts with a prefix, or `undefined` otherwise.
    const getPrefixSetting = (val)=>{
        for (const setting of prefixSettings){
            if (val?.startsWith(setting.prefix)) return setting;
        }
        return undefined;
    };
    // Removes a prefix from `val` if it starts with one.
    const removePrefix = (val)=>{
        const prefix = getPrefixSetting(val)?.prefix;
        if (prefix) // Remove the `prefix` from `val`.
        return val.slice(prefix.length);
        return val;
    };
    // Known issue: If a value has a prefix when the page is loaded, it is stuck in the `selectedValue` array forever.
    // This makes it impossible to switch a value from one prefix to another, or to remove the prefix,
    // without removing the value, reloading the page, and adding it again.
    return async (searchTerm, selectedValue)=>{
        // Create a `preprocessedSelectedValue` array without prefixes so the resolver gives accurate reccommendations.
        let preprocessedSelectedValue = selectedValue;
        // A map from prefix-less labels to the PrefixSetting object that matches with the prefix they started with.
        const labelToPrefixSetting = {};
        // Depending on the resolver, `selectedValue` can be an array of strings, or just a string.  This handles both cases.
        if (Array.isArray(selectedValue)) {
            for (const selVal of selectedValue){
                const selValWithoutPrefix = removePrefix(selVal);
                labelToPrefixSetting[selValWithoutPrefix] = getPrefixSetting(selVal);
            }
            preprocessedSelectedValue = selectedValue.map(removePrefix);
        } else if (selectedValue) {
            const selValWithoutPrefix = removePrefix(selectedValue);
            labelToPrefixSetting[selValWithoutPrefix] = getPrefixSetting(selectedValue);
            preprocessedSelectedValue = selValWithoutPrefix;
        }
        // Remove the prefix from the searchTerm, and save the PrefixSetting corresponding with its prefix.
        const searchTermPrefixSetting = getPrefixSetting(searchTerm) ?? $2fdd0370d00b842a$var$defaultPrefixSetting;
        if (searchTerm) searchTerm = removePrefix(searchTerm);
        // Call the resolver with normal, prefix-less arguments.
        const results = await resolver(searchTerm, preprocessedSelectedValue);
        // Add prefixes back on to the results of the resolver.
        return results.map((result)=>{
            // Default to using no prefix.
            let prefixSetting = $2fdd0370d00b842a$var$defaultPrefixSetting;
            if (searchTerm) // If a search is happening, use the searchTerm's prefix.
            prefixSetting = searchTermPrefixSetting;
            else if (result.value in labelToPrefixSetting) // When no search is happening, use the prefixes from the selectedValue array.
            // This allows results to render correctly on initial load.
            prefixSetting = labelToPrefixSetting[result.value] ?? $2fdd0370d00b842a$var$defaultPrefixSetting;
            return {
                ...result,
                // Use the labelFunc to modify the result's label.
                // This displays prefixes in a more user-friendly way
                label: prefixSetting.labelFunc(removePrefix(result.label)),
                // Add the prefix back on to the result's value.
                value: `${prefixSetting.prefix}${result.value}`
            };
        });
    };
};


const $ca514041a0cedbe0$export$1766a89a46ff2e41 = ({ resolver: resolver, values: values })=>{
    const notSpecial = (val)=>values.indexOf(val) === -1;
    return async (searchTerm, selectedValue)=>{
        if (Array.isArray(selectedValue)) selectedValue = selectedValue.filter(notSpecial);
        else if (!notSpecial(selectedValue)) selectedValue = '';
        const results = await resolver(searchTerm, selectedValue);
        results.push(...values.map((value)=>({
                label: value,
                value: value
            })));
        return results;
    };
};



var $9fLxI = parcelRequire("9fLxI");

/**
 * @generated SignedSource<<602009188b815a0b2a6d042579f1d88f>>
 * @relayHash a6bf76d67b2d5f2f04c0fb717eb4852e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4955e9649932b1f87bb0c5a6cbd1c09263e51f14171d1b01f82e5a58964c4f3d
const $56e925227ded0880$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchTerm"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 25
        },
        {
            "kind": "Variable",
            "name": "searchText",
            "variableName": "searchTerm"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "label"
    }, v3 = [
        v2 /*: any*/ 
    ], v4 = [
        v2 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "labelResolverQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "LabelSearchResults",
                    "kind": "LinkedField",
                    "name": "labelSearch",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Label",
                            "kind": "LinkedField",
                            "name": "otherLabels",
                            "plural": true,
                            "selections": v3 /*: any*/ 
                        },
                        {
                            "concreteType": "Label",
                            "kind": "LinkedField",
                            "name": "suggestedLabels",
                            "plural": true,
                            "selections": v3 /*: any*/ 
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "labelResolverQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "LabelSearchResults",
                    "kind": "LinkedField",
                    "name": "labelSearch",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Label",
                            "kind": "LinkedField",
                            "name": "otherLabels",
                            "plural": true,
                            "selections": v4 /*: any*/ 
                        },
                        {
                            "concreteType": "Label",
                            "kind": "LinkedField",
                            "name": "suggestedLabels",
                            "plural": true,
                            "selections": v4 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "a6bf76d67b2d5f2f04c0fb717eb4852e",
            "id": "4955e9649932b1f87bb0c5a6cbd1c09263e51f14171d1b01f82e5a58964c4f3d",
            "metadata": {},
            "name": "labelResolverQuery",
            "operationKind": "query",
            "text": "query labelResolverQuery($searchTerm:String!){labelSearch(searchText:$searchTerm,limit:25){otherLabels{label,id},suggestedLabels{label,id}}}"
        }
    };
}();
$56e925227ded0880$var$node.hash = "f2ce1bb386f2b1a0933d20064c91e8f2";
var $56e925227ded0880$export$2e2bcd8739ae039 = $56e925227ded0880$var$node;





// eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming -- file name contains hyphens, incompatible with GraphQL naming
const $132842a839e22041$var$labelResolverQuery = (0, $56e925227ded0880$export$2e2bcd8739ae039);
const $132842a839e22041$var$isNonNullable = (value)=>value != null;
const $132842a839e22041$var$extractResults = (labelResults)=>labelResults.filter($132842a839e22041$var$isNonNullable).map((res)=>({
            label: res.label ?? '',
            value: res.label ?? ''
        }));
const $132842a839e22041$var$search = async (searchTerm)=>{
    const result = await (0, $c0rhi.queryInterop)({
        query: $132842a839e22041$var$labelResolverQuery,
        variables: {
            searchTerm: searchTerm ?? ''
        },
        __callerPackage__: "fabric-extension-lib"
    });
    const labelSearch = result?.data?.labelSearch;
    return [
        ...$132842a839e22041$var$extractResults(labelSearch?.suggestedLabels ?? []),
        ...$132842a839e22041$var$extractResults(labelSearch?.otherLabels ?? [])
    ];
};
const $132842a839e22041$export$a821dfb2c4620119 = async (searchTerm, selectedValue)=>{
    const searchers = [];
    if (searchTerm) searchers.push($132842a839e22041$var$search(searchTerm));
    if (selectedValue) {
        if (Array.isArray(selectedValue)) searchers.push(Promise.resolve(selectedValue.map((label)=>({
                label: label,
                value: label
            }))));
        else searchers.push(Promise.resolve([
            {
                label: selectedValue,
                value: selectedValue
            }
        ]));
    }
    return (await Promise.all(searchers)).flat();
};





/**
 * @generated SignedSource<<88919ecb8e7fce9c0723d3722185f3e6>>
 * @relayHash 5d07961fac73a5210773223b5cd893f7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID edfb299ffd5dd19387350c1ac7ec1ac207c0c61cc73a1e3a853b4c40d5f1cfbe
const $b772bfd267eb0550$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cql"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cql",
            "variableName": "cql"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 25
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "entityType"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "spacekeyResolverQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceSearchResponse",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "spacekeyResolverQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceSearchResponse",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "5d07961fac73a5210773223b5cd893f7",
            "id": "edfb299ffd5dd19387350c1ac7ec1ac207c0c61cc73a1e3a853b4c40d5f1cfbe",
            "metadata": {},
            "name": "spacekeyResolverQuery",
            "operationKind": "query",
            "text": "query spacekeyResolverQuery($cql:String!){search:confluence_search(cql:$cql,first:25){edges{node{entityType,title,space{key,icon{path},id}}}}}"
        }
    };
}();
$b772bfd267eb0550$var$node.hash = "c4344d7ac01abb756ffa63aecca5d833";
var $b772bfd267eb0550$export$2e2bcd8739ae039 = $b772bfd267eb0550$var$node;






// eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming -- file name contains hyphens, incompatible with GraphQL naming
const $0a9a42b243ec1ac9$var$spacekeyResolverQuery = (0, $b772bfd267eb0550$export$2e2bcd8739ae039);
const $0a9a42b243ec1ac9$var$search = async (cql)=>{
    const result = await (0, $c0rhi.queryInterop)({
        query: $0a9a42b243ec1ac9$var$spacekeyResolverQuery,
        variables: {
            cql: cql
        },
        __callerPackage__: "fabric-extension-lib"
    });
    return (result?.data?.search?.edges ?? []).map((edge)=>({
            label: edge?.node?.title ?? '',
            value: edge?.node?.space?.key ?? '',
            icon: `/wiki${edge?.node?.space?.icon?.path ?? ''}`
        }));
};
const $0a9a42b243ec1ac9$var$quoteString = (str)=>`"${str}"`;
const $0a9a42b243ec1ac9$export$e92c2756cc1b853b = (spaces)=>`space.key IN (${spaces.map($0a9a42b243ec1ac9$var$quoteString).join(',')})`;
const $0a9a42b243ec1ac9$var$searchByTitleOrSpaceKey = (searchTerm, selectedValues = [])=>$0a9a42b243ec1ac9$var$search(`type = space AND (space.title ~ "${searchTerm}*" OR ${$0a9a42b243ec1ac9$export$e92c2756cc1b853b(selectedValues.concat(searchTerm))})`);
const $0a9a42b243ec1ac9$export$534da981b85f5d27 = (supportsCurrentSpace)=>async (searchTerm, selectedValue)=>{
        const selectedValues = (0, $6b5a09c45142de10$export$45b10814cc054894)(selectedValue);
        const searchers = [];
        if (searchTerm) searchers.push($0a9a42b243ec1ac9$var$searchByTitleOrSpaceKey(searchTerm, selectedValues));
        else {
            if (supportsCurrentSpace) searchers.push(Promise.resolve([
                {
                    label: 'Current space',
                    value: 'currentSpace()'
                }
            ]));
            const conditionalCql = selectedValues.length ? ` OR ${$0a9a42b243ec1ac9$export$e92c2756cc1b853b(selectedValues)}` : '';
            searchers.push($0a9a42b243ec1ac9$var$search(`type = space AND (space in recentlyViewedSpaces(4) ${conditionalCql})`));
        }
        return (await Promise.all(searchers)).flat();
    };
const $0a9a42b243ec1ac9$export$bab0f33d6337c008 = (macro)=>{
    // create-from-template doesn't support CQL-style
    // `currentSpace()` values, so don't show that menu option
    //
    // likewise for pagetree
    if ([
        'create-from-template',
        'pagetree'
    ].indexOf(macro.macroName) > -1) return $0a9a42b243ec1ac9$export$534da981b85f5d27(false);
    else return $0a9a42b243ec1ac9$export$534da981b85f5d27(true);
};



const $7474bd4805c6fe29$export$4d47f6bf8ec8af17 = (resolver)=>async (searchTerm, selectedValue)=>{
        const options = await resolver(searchTerm, selectedValue);
        const memory = new Map();
        return options.filter(({ value: value })=>{
            const isKnownValue = memory.has(value);
            memory.set(value, true);
            return !isKnownValue;
        });
    };


const $10e93d065b18a316$var$spacekeyWithCurrentSpace = (0, $0a9a42b243ec1ac9$export$534da981b85f5d27)(true);
const $10e93d065b18a316$export$ed8020fd2c03836f = (0, $7474bd4805c6fe29$export$4d47f6bf8ec8af17)(async (searchTerm, selectedValue)=>{
    if (typeof selectedValue === 'string') selectedValue = selectedValue.split(',');
    let selectedSpaces;
    let selectedPages;
    if (selectedValue && selectedValue.length > 0) {
        selectedSpaces = selectedValue.filter((value)=>!(0, $2E7zk.isPageId)(value));
        selectedSpaces = selectedSpaces.length ? selectedSpaces : undefined;
        selectedPages = selectedValue.filter((0, $2E7zk.isPageId));
        selectedPages = selectedPages.length ? selectedPages : undefined;
    }
    const spaceResults = await $10e93d065b18a316$var$spacekeyWithCurrentSpace(searchTerm, selectedSpaces);
    // we don't want to find blogposts; this resolver is used for spaceAndPage field for task report macro which
    // does not support blog posts
    const contentResults = await (0, $24ca4725cd610b37$export$41173a2c419f6dfc)(searchTerm, selectedPages, {
        type: 'page, folder'
    });
    return [
        spaceResults,
        contentResults
    ].flat();
});






const $3b8b016da39bc505$var$search = async (query)=>{
    const type = 'page,blogpost';
    return (0, $f7B1p.cfetch)(`/wiki/rest/prototype/1/search/name.json?max-results=10&pageSize=10&type=${type}&query=${encodeURIComponent(query)}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((result)=>result.json()).then((response)=>{
        // two groups, one for pages and another for blogposts
        const res = [];
        response.group.forEach((groupResults)=>res.push(...groupResults.result.map((result)=>({
                    label: result.title,
                    value: `${result.space.key}:${result.title}`,
                    description: result.space.title
                }))));
        return res;
    });
};
const $3b8b016da39bc505$export$ddc3fcea26200983 = ()=>(0, $7474bd4805c6fe29$export$4d47f6bf8ec8af17)(async (searchTerm, selectedValue)=>{
        const searchers = [];
        if (searchTerm) searchers.push($3b8b016da39bc505$var$search(searchTerm));
        if (selectedValue) {
            if (typeof selectedValue === 'string' || Array.isArray(selectedValue)) {
                if (typeof selectedValue === 'string') selectedValue = selectedValue.split(',');
                selectedValue.forEach((selectedValue)=>{
                    const splitId = selectedValue.split(':');
                    const pageTitle = splitId[splitId.length - 1];
                    searchers.push($3b8b016da39bc505$var$search(pageTitle));
                });
            }
        }
        return (await Promise.all(searchers)).flat();
    });




var $gw2T1 = parcelRequire("gw2T1");

const $8540ddfe85cd4073$export$3f7da36354f8b724 = (resolver)=>async (searchTerm, selectedValue)=>{
        const options = await resolver(searchTerm, selectedValue);
        if (selectedValue) {
            const selectedValues = [].concat(selectedValue);
            return selectedValues.filter((v)=>!options.find(({ value: value })=>value === v)).map((v)=>({
                    label: v,
                    value: v
                })).concat(options);
        }
        return options;
    };


/**
 * @generated SignedSource<<fe47ef81438d9be0b74ad5b27b55dea7>>
 * @relayHash d64b36da2f901fa90653ae60fa1c0e96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4ef517be4e85b0d712fa26b3fee68eccc61afbdf5ec8c1c70f73e751b0ba0d1b
const $09c2e11ca00850c1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cql"
        }
    ], v1 = [
        {
            "alias": "searchUser",
            "args": [
                {
                    "kind": "Variable",
                    "name": "cql",
                    "variableName": "cql"
                },
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 25
                },
                {
                    "kind": "Literal",
                    "name": "sitePermissionTypeFilter",
                    "value": "all"
                }
            ],
            "concreteType": "ConfluenceSearchConnection",
            "kind": "LinkedField",
            "name": "confluence_searchUser",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceSearchResponseEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "user",
                                    "concreteType": "ConfluencePerson",
                                    "kind": "LinkedField",
                                    "name": "confluencePerson",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayName"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "accountId"
                                        },
                                        {
                                            "concreteType": "Icon",
                                            "kind": "LinkedField",
                                            "name": "profilePicture",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "path"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usernameResolverQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usernameResolverQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d64b36da2f901fa90653ae60fa1c0e96",
            "id": "4ef517be4e85b0d712fa26b3fee68eccc61afbdf5ec8c1c70f73e751b0ba0d1b",
            "metadata": {},
            "name": "usernameResolverQuery",
            "operationKind": "query",
            "text": "query usernameResolverQuery($cql:String!){searchUser:confluence_searchUser(cql:$cql,first:25,sitePermissionTypeFilter:\"all\"){edges{node{user:confluencePerson{displayName,accountId,profilePicture{path}}}}}}"
        }
    };
}();
$09c2e11ca00850c1$var$node.hash = "b3bcfd40385902ef428c9c3b9dc32d7a";
var $09c2e11ca00850c1$export$2e2bcd8739ae039 = $09c2e11ca00850c1$var$node;





var $1d06acb41b6c7038$exports = {};
/*
 * Generated by PEG.js 0.10.0.
 *
 * http://pegjs.org/
 */ "use strict";
function $1d06acb41b6c7038$var$peg$subclass(child, parent) {
    function ctor() {
        this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
}
function $1d06acb41b6c7038$var$peg$SyntaxError(message, expected, found, location) {
    this.message = message;
    this.expected = expected;
    this.found = found;
    this.location = location;
    this.name = "SyntaxError";
    if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, $1d06acb41b6c7038$var$peg$SyntaxError);
}
$1d06acb41b6c7038$var$peg$subclass($1d06acb41b6c7038$var$peg$SyntaxError, Error);
$1d06acb41b6c7038$var$peg$SyntaxError.buildMessage = function(expected, found) {
    var DESCRIBE_EXPECTATION_FNS = {
        literal: function(expectation) {
            return "\"" + literalEscape(expectation.text) + "\"";
        },
        "class": function(expectation) {
            var escapedParts = "", i;
            for(i = 0; i < expectation.parts.length; i++)escapedParts += expectation.parts[i] instanceof Array ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1]) : classEscape(expectation.parts[i]);
            return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
        },
        any: function(expectation) {
            return "any character";
        },
        end: function(expectation) {
            return "end of input";
        },
        other: function(expectation) {
            return expectation.description;
        }
    };
    function hex(ch) {
        return ch.charCodeAt(0).toString(16).toUpperCase();
    }
    function literalEscape(s) {
        return s.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function(ch) {
            return '\\x0' + hex(ch);
        }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
            return '\\x' + hex(ch);
        });
    }
    function classEscape(s) {
        return s.replace(/\\/g, '\\\\').replace(/\]/g, '\\]').replace(/\^/g, '\\^').replace(/-/g, '\\-').replace(/\0/g, '\\0').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/[\x00-\x0F]/g, function(ch) {
            return '\\x0' + hex(ch);
        }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
            return '\\x' + hex(ch);
        });
    }
    function describeExpectation(expectation) {
        return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
    }
    function describeExpected(expected) {
        var descriptions = new Array(expected.length), i, j;
        for(i = 0; i < expected.length; i++)descriptions[i] = describeExpectation(expected[i]);
        descriptions.sort();
        if (descriptions.length > 0) {
            for(i = 1, j = 1; i < descriptions.length; i++)if (descriptions[i - 1] !== descriptions[i]) {
                descriptions[j] = descriptions[i];
                j++;
            }
            descriptions.length = j;
        }
        switch(descriptions.length){
            case 1:
                return descriptions[0];
            case 2:
                return descriptions[0] + " or " + descriptions[1];
            default:
                return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
        }
    }
    function describeFound(found) {
        return found ? "\"" + literalEscape(found) + "\"" : "end of input";
    }
    return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
};
function $1d06acb41b6c7038$var$peg$parse(input, options) {
    options = options !== void 0 ? options : {};
    var peg$FAILED = {}, peg$startRuleIndices = {
        aqlStatement: 0
    }, peg$startRuleIndex = 0, peg$consts = [
        function(clause, orderby) {
            return {
                clause: clause,
                orderby: orderby
            };
        },
        function(orderby) {
            return orderby;
        },
        "order by",
        peg$literalExpectation("ORDER BY", true),
        function(primary, secondary) {
            return [
                primary,
                ...secondary
            ];
        },
        ",",
        peg$literalExpectation(",", false),
        function(clause) {
            return clause;
        },
        function(field, direction) {
            return {
                field: field,
                direction: direction
            };
        },
        "asc",
        peg$literalExpectation("ASC", true),
        "desc",
        peg$literalExpectation("DESC", true),
        function(clause, joined) {
            return {
                nodeType: 'clause',
                clauses: [
                    clause,
                    ...joined
                ],
                type: 'or'
            };
        },
        "or",
        peg$literalExpectation("OR", true),
        function(clause, joined) {
            return {
                nodeType: 'clause',
                clauses: [
                    clause,
                    ...joined
                ],
                type: 'and'
            };
        },
        "and",
        peg$literalExpectation("AND", true),
        function(haveNot, clause) {
            return {
                nodeType: 'clause',
                clause: clause,
                invert: !!haveNot
            };
        },
        function(expr) {
            return {
                nodeType: 'expr',
                ...expr
            };
        },
        "not ",
        peg$literalExpectation("NOT ", true),
        "!",
        peg$literalExpectation("!", false),
        function(field, op, value) {
            return {
                field: field,
                op: op,
                value: value
            };
        },
        function(field, op, value) {
            return {
                field: field,
                op: op,
                value: value
            };
        },
        "<",
        peg$literalExpectation("<", false),
        ">",
        peg$literalExpectation(">", false),
        "~",
        peg$literalExpectation("~", false),
        "!~",
        peg$literalExpectation("!~", false),
        "in",
        peg$literalExpectation("IN", true),
        function(haveNot) {
            return haveNot ? 'NOT IN' : 'IN';
        },
        "=",
        peg$literalExpectation("=", false),
        "!=",
        peg$literalExpectation("!=", false),
        function(v1, vremain) {
            return [
                v1,
                ...vremain
            ];
        },
        function(val) {
            return val;
        },
        ">=",
        peg$literalExpectation(">=", false),
        "<=",
        peg$literalExpectation("<=", false),
        function(n) {
            return Number.parseFloat(n);
        },
        "(",
        peg$literalExpectation("(", false),
        ")",
        peg$literalExpectation(")", false),
        function(funcName, params) {
            return `${funcName}(${(params || []).join(',')})`;
        },
        function(value, remaining) {
            return [
                value,
                ...remaining
            ];
        },
        function(value) {
            return value;
        },
        "'",
        peg$literalExpectation("'", false),
        "\\",
        peg$literalExpectation("\\", false),
        "\"",
        peg$literalExpectation("\"", false),
        ".",
        peg$literalExpectation(".", false),
        /^[^']/,
        peg$classExpectation([
            "'"
        ], true, false),
        function(val) {
            return val.join('');
        },
        /^[^"]/,
        peg$classExpectation([
            "\""
        ], true, false),
        function(val) {
            return val.join('.');
        },
        /^[0-9]/,
        peg$classExpectation([
            [
                "0",
                "9"
            ]
        ], false, false),
        /^[\\\-]/,
        peg$classExpectation([
            "\\",
            "-"
        ], false, false),
        function(rootIdentifier, indexedIdentifier) {
            return [
                rootIdentifier,
                ...indexedIdentifier
            ];
        },
        function(item) {
            return item;
        },
        /^[a-zA-Z_]/,
        peg$classExpectation([
            [
                "a",
                "z"
            ],
            [
                "A",
                "Z"
            ],
            "_"
        ], false, false),
        /^[a-zA-Z_0-9]/,
        peg$classExpectation([
            [
                "a",
                "z"
            ],
            [
                "A",
                "Z"
            ],
            "_",
            [
                "0",
                "9"
            ]
        ], false, false),
        function(firstLetter, remaining) {
            return firstLetter + remaining;
        },
        /^[eE]/,
        peg$classExpectation([
            "e",
            "E"
        ], false, false),
        /^[\-+]/,
        peg$classExpectation([
            "-",
            "+"
        ], false, false),
        /^[\t ]/,
        peg$classExpectation([
            "\t",
            " "
        ], false, false)
    ], peg$bytecode = [
        peg$decode("%;&/7#;!.\" &\"/)$8\": \"\"! )(\"'#&'#"),
        peg$decode("%;V/1#;\"/($8\":!\"! )(\"'#&'#"),
        peg$decode("%3\"\"\"5(7#/K#;V/B$;$/9$$;#0#*;#&/)$8$:$$\"! )($'#(#'#(\"'#&'#"),
        peg$decode("%2%\"\"6%7&/:#;W/1$;$/($8#:'#! )(#'#(\"'#&'#"),
        peg$decode("%;M/;#;V/2$;%/)$8#:(#\"\" )(#'#(\"'#&'#"),
        peg$decode("3)\"\"5#7*.) &3+\"\"5$7,"),
        peg$decode("%;(/9#$;'0#*;'&/)$8\":-\"\"! )(\"'#&'#"),
        peg$decode("%;V/I#3.\"\"5\"7//:$;V/1$;(/($8$:'$! )($'#(#'#(\"'#&'#"),
        peg$decode("%;+/9#$;)0#*;)&/)$8\":0\"\"! )(\"'#&'#"),
        peg$decode("%;V/I#31\"\"5#72/:$;V/1$;*/($8$:'$! )($'#(#'#(\"'#&'#"),
        peg$decode("%;,.\" &\"/2#;+/)$8\":3\"\"! )(\"'#&'#"),
        peg$decode("%;J/L#;W/C$;&/:$;W/1$;K/($8%:'%!\")(%'#($'#(#'#(\"'#&'#./ &%;-/' 8!:4!! )"),
        peg$decode("35\"\"5$76.) &27\"\"6778"),
        peg$decode(";..5 &;/./ &;1.) &;0.# &;2"),
        peg$decode("%;M/N#;W/E$;6/<$;W/3$;5/*$8%:9%#$\" )(%'#($'#(#'#(\"'#&'#"),
        peg$decode("%;M/N#;W/E$;7/<$;W/3$;9/*$8%:9%#$\" )(%'#($'#(#'#(\"'#&'#.X &%;M/N#;W/E$;8/<$;W/3$;=/*$8%:9%#$\" )(%'#($'#(#'#(\"'#&'#"),
        peg$decode("%;M/N#;W/E$;>/<$;W/3$;3/*$8%::%#$\" )(%'#($'#(#'#(\"'#&'#"),
        peg$decode("%;M/N#;W/E$;>/<$;W/3$;4/*$8%::%#$\" )(%'#($'#(#'#(\"'#&'#"),
        peg$decode("%;M/\\#2;\"\"6;7</M$;M/D$2=\"\"6=7>/5$;A/,$;@/#$+&)(&'#(%'#($'#(#'#(\"'#&'#"),
        peg$decode(";?.* &%;C/\"!&,)"),
        peg$decode("%;C/\"!&,).# &;B"),
        peg$decode(";M.# &;C"),
        peg$decode("2?\"\"6?7@.) &2A\"\"6A7B"),
        peg$decode("%;,.\" &\"/7#3C\"\"5\"7D/($8\":E\"!!)(\"'#&'#"),
        peg$decode("2F\"\"6F7G.) &2H\"\"6H7I"),
        peg$decode(";C.# &;:"),
        peg$decode("%;J/f#;W/]$;</T$;W/K$$;;0#*;;&/;$;W/2$;K/)$8':J'\"$\")(''#(&'#(%'#($'#(#'#(\"'#&'#"),
        peg$decode("%2%\"\"6%7&/J#$;V0#*;V&/:$;</1$;W/($8$:K$!!)($'#(#'#(\"'#&'#"),
        peg$decode(";C.# &;="),
        peg$decode(";C./ &;M.) &;P.# &;?"),
        peg$decode("2L\"\"6L7M.Y &2N\"\"6N7O.M &2=\"\"6=7>.A &2;\"\"6;7<.5 &2F\"\"6F7G.) &2H\"\"6H7I"),
        peg$decode("%;U/' 8!:P!! )"),
        peg$decode("%;7/:#;V.\" &\"/,$;9/#$+#)(#'#(\"'#&'#.\xB9 &%;8/:#;V.\" &\"/,$;=/#$+#)(#'#(\"'#&'#.\x92 &%;6/:#;V.\" &\"/,$;5/#$+#)(#'#(\"'#&'#.k &%;>/:#;V.\" &\"/,$;4/#$+#)(#'#(\"'#&'#.D &%;>/:#;V.\" &\"/,$;3/#$+#)(#'#(\"'#&'#"),
        peg$decode("%;I/,#;M/#$+\")(\"'#&'#"),
        peg$decode(";P.# &;M"),
        peg$decode("%;M/p#;W/g$2Q\"\"6Q7R/X$;W/O$;D.\" &\"/A$;W/8$2S\"\"6S7T/)$8':U'\"&\")(''#(&'#(%'#($'#(#'#(\"'#&'#"),
        peg$decode("%;=/9#$;E0#*;E&/)$8\":V\"\"! )(\"'#&'#"),
        peg$decode("%2%\"\"6%7&/:#;W/1$;=/($8#:W#! )(#'#(\"'#&'#"),
        peg$decode("2X\"\"6X7Y"),
        peg$decode("2Z\"\"6Z7["),
        peg$decode("2\\\"\"6\\7]"),
        peg$decode("2^\"\"6^7_"),
        peg$decode("2Q\"\"6Q7R"),
        peg$decode("2S\"\"6S7T"),
        peg$decode("%;G/,#;F/#$+\")(\"'#&'#.O &%;G/,#;G/#$+\")(\"'#&'#.6 &%;G/,#;H/#$+\")(\"'#&'#"),
        peg$decode("%;F/g#$%;L/\"!&,).) &4`\"\"5!7a06*%;L/\"!&,).) &4`\"\"5!7a&/1$;F/($8#:b#!!)(#'#(\"'#&'#.\x83 &%;H/g#$%;L/\"!&,).) &4c\"\"5!7d06*%;L/\"!&,).) &4c\"\"5!7d&/1$;H/($8#:b#!!)(#'#(\"'#&'#./ &%;Q/' 8!:e!! )"),
        peg$decode("4f\"\"5!7g"),
        peg$decode("%4h\"\"5!7i/\"!&,)"),
        peg$decode("%%;N/t#;N/k$;N/b$;N/Y$;O/P$;N/G$;N/>$;O/5$;N/,$;N/#$+*)(*'#()'#(('#(''#(&'#(%'#($'#(#'#(\"'#&'#/\"!&,)"),
        peg$decode("%;S/9#$;R0#*;R&/)$8\":j\"\"! )(\"'#&'#"),
        peg$decode("%;I/1#;S/($8\":k\"! )(\"'#&'#"),
        peg$decode("%4l\"\"5!7m/L#%$4n\"\"5!7o0)*4n\"\"5!7o&/\"!&,)/)$8\":p\"\"! )(\"'#&'#"),
        peg$decode("$4f\"\"5!7g/,#0)*4f\"\"5!7g&&&#"),
        peg$decode("%;T/\x98#%2^\"\"6^7_/?#$4f\"\"5!7g0)*4f\"\"5!7g&/#$+\")(\"'#&'#.\" &\"/^$%4q\"\"5!7r/@#4s\"\"5!7t.\" &\"/,$;T/#$+#)(#'#(\"'#&'#.\" &\"/#$+#)(#'#(\"'#&'#.} &%2^\"\"6^7_/g#;T/^$%4q\"\"5!7r/@#4s\"\"5!7t.\" &\"/,$;T/#$+#)(#'#(\"'#&'#.\" &\"/#$+#)(#'#(\"'#&'#.# &;T"),
        peg$decode("$4u\"\"5!7v/,#0)*4u\"\"5!7v&&&#"),
        peg$decode("$4u\"\"5!7v0)*4u\"\"5!7v&")
    ], peg$currPos = 0, peg$savedPos = 0, peg$posDetailsCache = [
        {
            line: 1,
            column: 1
        }
    ], peg$maxFailPos = 0, peg$maxFailExpected = [], peg$silentFails = 0, peg$result;
    if ("startRule" in options) {
        if (!(options.startRule in peg$startRuleIndices)) throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
        peg$startRuleIndex = peg$startRuleIndices[options.startRule];
    }
    function text() {
        return input.substring(peg$savedPos, peg$currPos);
    }
    function location() {
        return peg$computeLocation(peg$savedPos, peg$currPos);
    }
    function expected(description, location) {
        location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);
        throw peg$buildStructuredError([
            peg$otherExpectation(description)
        ], input.substring(peg$savedPos, peg$currPos), location);
    }
    function error(message, location) {
        location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);
        throw peg$buildSimpleError(message, location);
    }
    function peg$literalExpectation(text, ignoreCase) {
        return {
            type: "literal",
            text: text,
            ignoreCase: ignoreCase
        };
    }
    function peg$classExpectation(parts, inverted, ignoreCase) {
        return {
            type: "class",
            parts: parts,
            inverted: inverted,
            ignoreCase: ignoreCase
        };
    }
    function peg$anyExpectation() {
        return {
            type: "any"
        };
    }
    function peg$endExpectation() {
        return {
            type: "end"
        };
    }
    function peg$otherExpectation(description) {
        return {
            type: "other",
            description: description
        };
    }
    function peg$computePosDetails(pos) {
        var details = peg$posDetailsCache[pos], p;
        if (details) return details;
        else {
            p = pos - 1;
            while(!peg$posDetailsCache[p])p--;
            details = peg$posDetailsCache[p];
            details = {
                line: details.line,
                column: details.column
            };
            while(p < pos){
                if (input.charCodeAt(p) === 10) {
                    details.line++;
                    details.column = 1;
                } else details.column++;
                p++;
            }
            peg$posDetailsCache[pos] = details;
            return details;
        }
    }
    function peg$computeLocation(startPos, endPos) {
        var startPosDetails = peg$computePosDetails(startPos), endPosDetails = peg$computePosDetails(endPos);
        return {
            start: {
                offset: startPos,
                line: startPosDetails.line,
                column: startPosDetails.column
            },
            end: {
                offset: endPos,
                line: endPosDetails.line,
                column: endPosDetails.column
            }
        };
    }
    function peg$fail(expected) {
        if (peg$currPos < peg$maxFailPos) return;
        if (peg$currPos > peg$maxFailPos) {
            peg$maxFailPos = peg$currPos;
            peg$maxFailExpected = [];
        }
        peg$maxFailExpected.push(expected);
    }
    function peg$buildSimpleError(message, location) {
        return new $1d06acb41b6c7038$var$peg$SyntaxError(message, null, null, location);
    }
    function peg$buildStructuredError(expected, found, location) {
        return new $1d06acb41b6c7038$var$peg$SyntaxError($1d06acb41b6c7038$var$peg$SyntaxError.buildMessage(expected, found), expected, found, location);
    }
    function peg$decode(s) {
        var bc = new Array(s.length), i;
        for(i = 0; i < s.length; i++)bc[i] = s.charCodeAt(i) - 32;
        return bc;
    }
    function peg$parseRule(index) {
        var bc = peg$bytecode[index], ip = 0, ips = [], end = bc.length, ends = [], stack = [], params, i;
        while(true){
            while(ip < end)switch(bc[ip]){
                case 0:
                    stack.push(peg$consts[bc[ip + 1]]);
                    ip += 2;
                    break;
                case 1:
                    stack.push(void 0);
                    ip++;
                    break;
                case 2:
                    stack.push(null);
                    ip++;
                    break;
                case 3:
                    stack.push(peg$FAILED);
                    ip++;
                    break;
                case 4:
                    stack.push([]);
                    ip++;
                    break;
                case 5:
                    stack.push(peg$currPos);
                    ip++;
                    break;
                case 6:
                    stack.pop();
                    ip++;
                    break;
                case 7:
                    peg$currPos = stack.pop();
                    ip++;
                    break;
                case 8:
                    stack.length -= bc[ip + 1];
                    ip += 2;
                    break;
                case 9:
                    stack.splice(-2, 1);
                    ip++;
                    break;
                case 10:
                    stack[stack.length - 2].push(stack.pop());
                    ip++;
                    break;
                case 11:
                    stack.push(stack.splice(stack.length - bc[ip + 1], bc[ip + 1]));
                    ip += 2;
                    break;
                case 12:
                    stack.push(input.substring(stack.pop(), peg$currPos));
                    ip++;
                    break;
                case 13:
                    ends.push(end);
                    ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);
                    if (stack[stack.length - 1]) {
                        end = ip + 3 + bc[ip + 1];
                        ip += 3;
                    } else {
                        end = ip + 3 + bc[ip + 1] + bc[ip + 2];
                        ip += 3 + bc[ip + 1];
                    }
                    break;
                case 14:
                    ends.push(end);
                    ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);
                    if (stack[stack.length - 1] === peg$FAILED) {
                        end = ip + 3 + bc[ip + 1];
                        ip += 3;
                    } else {
                        end = ip + 3 + bc[ip + 1] + bc[ip + 2];
                        ip += 3 + bc[ip + 1];
                    }
                    break;
                case 15:
                    ends.push(end);
                    ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);
                    if (stack[stack.length - 1] !== peg$FAILED) {
                        end = ip + 3 + bc[ip + 1];
                        ip += 3;
                    } else {
                        end = ip + 3 + bc[ip + 1] + bc[ip + 2];
                        ip += 3 + bc[ip + 1];
                    }
                    break;
                case 16:
                    if (stack[stack.length - 1] !== peg$FAILED) {
                        ends.push(end);
                        ips.push(ip);
                        end = ip + 2 + bc[ip + 1];
                        ip += 2;
                    } else ip += 2 + bc[ip + 1];
                    break;
                case 17:
                    ends.push(end);
                    ips.push(ip + 3 + bc[ip + 1] + bc[ip + 2]);
                    if (input.length > peg$currPos) {
                        end = ip + 3 + bc[ip + 1];
                        ip += 3;
                    } else {
                        end = ip + 3 + bc[ip + 1] + bc[ip + 2];
                        ip += 3 + bc[ip + 1];
                    }
                    break;
                case 18:
                    ends.push(end);
                    ips.push(ip + 4 + bc[ip + 2] + bc[ip + 3]);
                    if (input.substr(peg$currPos, peg$consts[bc[ip + 1]].length) === peg$consts[bc[ip + 1]]) {
                        end = ip + 4 + bc[ip + 2];
                        ip += 4;
                    } else {
                        end = ip + 4 + bc[ip + 2] + bc[ip + 3];
                        ip += 4 + bc[ip + 2];
                    }
                    break;
                case 19:
                    ends.push(end);
                    ips.push(ip + 4 + bc[ip + 2] + bc[ip + 3]);
                    if (input.substr(peg$currPos, peg$consts[bc[ip + 1]].length).toLowerCase() === peg$consts[bc[ip + 1]]) {
                        end = ip + 4 + bc[ip + 2];
                        ip += 4;
                    } else {
                        end = ip + 4 + bc[ip + 2] + bc[ip + 3];
                        ip += 4 + bc[ip + 2];
                    }
                    break;
                case 20:
                    ends.push(end);
                    ips.push(ip + 4 + bc[ip + 2] + bc[ip + 3]);
                    if (peg$consts[bc[ip + 1]].test(input.charAt(peg$currPos))) {
                        end = ip + 4 + bc[ip + 2];
                        ip += 4;
                    } else {
                        end = ip + 4 + bc[ip + 2] + bc[ip + 3];
                        ip += 4 + bc[ip + 2];
                    }
                    break;
                case 21:
                    stack.push(input.substr(peg$currPos, bc[ip + 1]));
                    peg$currPos += bc[ip + 1];
                    ip += 2;
                    break;
                case 22:
                    stack.push(peg$consts[bc[ip + 1]]);
                    peg$currPos += peg$consts[bc[ip + 1]].length;
                    ip += 2;
                    break;
                case 23:
                    stack.push(peg$FAILED);
                    if (peg$silentFails === 0) peg$fail(peg$consts[bc[ip + 1]]);
                    ip += 2;
                    break;
                case 24:
                    peg$savedPos = stack[stack.length - 1 - bc[ip + 1]];
                    ip += 2;
                    break;
                case 25:
                    peg$savedPos = peg$currPos;
                    ip++;
                    break;
                case 26:
                    params = bc.slice(ip + 4, ip + 4 + bc[ip + 3]);
                    for(i = 0; i < bc[ip + 3]; i++)params[i] = stack[stack.length - 1 - params[i]];
                    stack.splice(stack.length - bc[ip + 2], bc[ip + 2], peg$consts[bc[ip + 1]].apply(null, params));
                    ip += 4 + bc[ip + 3];
                    break;
                case 27:
                    stack.push(peg$parseRule(bc[ip + 1]));
                    ip += 2;
                    break;
                case 28:
                    peg$silentFails++;
                    ip++;
                    break;
                case 29:
                    peg$silentFails--;
                    ip++;
                    break;
                default:
                    throw new Error("Invalid opcode: " + bc[ip] + ".");
            }
            if (ends.length > 0) {
                end = ends.pop();
                ip = ips.pop();
            } else break;
        }
        return stack[0];
    }
    peg$result = peg$parseRule(peg$startRuleIndex);
    if (peg$result !== peg$FAILED && peg$currPos === input.length) return peg$result;
    else {
        if (peg$result !== peg$FAILED && peg$currPos < input.length) peg$fail(peg$endExpectation());
        throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
    }
}
$1d06acb41b6c7038$exports = {
    SyntaxError: $1d06acb41b6c7038$var$peg$SyntaxError,
    parse: $1d06acb41b6c7038$var$peg$parse
};



const $be58797972986c91$export$96e6fc3a139b2555 = (text)=>text.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
const $be58797972986c91$export$2c4c4d2119dc396f = (value)=>value === 'currentSpace()' ? value : `"${$be58797972986c91$export$96e6fc3a139b2555(value.toString())}"`;
const $be58797972986c91$export$ac8a9eb5c5a129c4 = (content)=>{
    const exprs = [];
    // content is an object with key/value pairs
    // we first convert it array and filter out undefined/null
    // if content is array, we convert each object in array to tuple array of [key, value]
    const arr = Object.entries(content).filter((entry)=>entry[1]);
    exprs.push(...arr.map((entry)=>{
        // eslint-disable-next-line prefer-const
        let [key, value] = entry;
        const definition = (0, $2f69ce15c0bd4ea6$export$f977989607a3df34)[key];
        const cqlKey = definition.key || key;
        let cqlValue;
        let cqlOp = '=';
        // use a different operator for this field?
        // e.g. a text field might want to use ~
        if (definition && definition.op) cqlOp = definition.op;
        // flatten singular arrays to scalar
        if (Array.isArray(value) && value.length === 1) value = value[0];
        // construct the value expression
        if (Array.isArray(value)) {
            cqlValue = `(${value.map($be58797972986c91$export$2c4c4d2119dc396f).join(', ')})`;
            cqlOp = 'IN';
        } else if (typeof value === 'number') // we don't have any number cql fields as of yet, but just in case
        cqlValue = value.toString();
        else cqlValue = $be58797972986c91$export$2c4c4d2119dc396f(value.toString());
        return `${cqlKey} ${cqlOp} ${cqlValue}`;
    }));
    return exprs.join(' AND ');
};
// walks the parse tree and finds expressions
// it also ensures we only have AND queries
function* $be58797972986c91$var$collectExpr(node) {
    if (node.clause) yield* $be58797972986c91$var$collectExpr(node.clause);
    if (node.clauses) {
        if (node.type.toUpperCase() === 'OR' && node.clauses.length !== 1) throw new SyntaxError('cannot handle multiple OR clauses');
        for (const subclause of node.clauses)yield* $be58797972986c91$var$collectExpr(subclause);
    }
    if (node.nodeType === 'expr') yield node;
}
const $be58797972986c91$export$7b88d2983fb8d650 = (value)=>{
    if (value === null || typeof value === 'undefined') return {};
    // try to parse CQL and pull only expressions out of the AST
    const parsed = (0, $1d06acb41b6c7038$exports.parse)(value);
    const exprs = Array.from($be58797972986c91$var$collectExpr(parsed));
    // create an object from the set of expressions
    const deserializedCQL = {};
    exprs.forEach((expr)=>{
        deserializedCQL[expr.field] = expr.value;
    });
    return deserializedCQL;
};


// eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming -- file name contains hyphens, incompatible with GraphQL naming
const $c1e526d8b8327452$var$usernameResolverQuery = (0, $09c2e11ca00850c1$export$2e2bcd8739ae039);
const $c1e526d8b8327452$var$getQueryTerm = (term)=>{
    // query term looks like this: "type = user AND (user.fullname ~ \"bob*\" OR user = \"bob\")"
    return `type = user AND (user.fullname ~ "${term}*" OR user = "${term}")`;
};
const $c1e526d8b8327452$var$search = async (cql)=>{
    const result = await (0, $c0rhi.queryInterop)({
        query: $c1e526d8b8327452$var$usernameResolverQuery,
        variables: {
            cql: cql
        },
        __callerPackage__: "fabric-extension-lib"
    });
    return (result?.data?.searchUser?.edges ?? []).map((edge)=>({
            label: edge?.node?.user?.displayName ?? '',
            value: edge?.node?.user?.accountId ?? '',
            icon: edge?.node?.user?.profilePicture?.path ?? ''
        }));
};
const $c1e526d8b8327452$export$63f9bb9a5820f1bc = async (searchTerm, selectedValue)=>{
    const searchers = [];
    if (searchTerm) searchers.push($c1e526d8b8327452$var$search($c1e526d8b8327452$var$getQueryTerm(searchTerm)));
    if (selectedValue) {
        if (Array.isArray(selectedValue)) // if values are in array, concat the items into one search phrase
        // e.g if array is ["sponge", "bob"], query term is: "user IN ( \"sponge\", \"bob\")"
        searchers.push($c1e526d8b8327452$var$search(`user IN (${selectedValue.map((val)=>`"${(0, $be58797972986c91$export$96e6fc3a139b2555)(val)}"`).join(', ')})`));
        else // if not an array just pass in the term as selected val
        searchers.push($c1e526d8b8327452$var$search($c1e526d8b8327452$var$getQueryTerm(selectedValue)));
    }
    return (await Promise.all(searchers)).flat();
};



var $kTVK2 = parcelRequire("kTVK2");

const $6ec8fb0cb8d57c0c$export$1bb3f7145befbf14 = (intl)=>async (searchTerm, selectedValue)=>{
        const items = [
            {
                label: intl.formatMessage((0, $kTVK2.i18nWidth).fullLabel),
                value: '100%'
            },
            {
                label: intl.formatMessage((0, $kTVK2.i18nWidth).threeQuartersLabel),
                value: '75%'
            },
            {
                label: intl.formatMessage((0, $kTVK2.i18nWidth).halfLabel),
                value: '50%'
            },
            {
                label: intl.formatMessage((0, $kTVK2.i18nWidth).quarterLabel),
                value: '25%'
            }
        ];
        // Add the current input value if it is not one of the predefined options
        // This is necessary to allow values beyond the predefined ones. (i.e. "90%")
        if (selectedValue && typeof selectedValue === 'string' && !Object.values(items).map((item)=>item.value).includes(selectedValue)) items.push({
            label: selectedValue,
            value: selectedValue
        });
        if (searchTerm) return Promise.resolve(items.filter((item)=>item.value.indexOf(searchTerm) !== -1));
        return Promise.resolve(items);
    };



const $0772041b1b3e00cb$var$i18n = (0, $kSwu1.defineMessages)({
    deprecatedMacroDescription: {
        id: "fabric-extension-lib.deprecation.description",
        defaultMessage: "This macro has been deprecated. <alink>Find out more about this change</alink>"
    },
    configValuePrefixRequired: {
        id: "fabric-extension-lib.config-value-prefix.required",
        defaultMessage: "{fieldValue} (required)"
    },
    configValuePrefixExcluded: {
        id: "fabric-extension-lib.config-value-prefix.excluded",
        defaultMessage: "{fieldValue} (excluded)"
    }
});
const $0772041b1b3e00cb$var$PLUS_MINUS_PREFIX_SETTINGS = (intl)=>[
        {
            prefix: '+',
            labelFunc: (labelExcludingPrefix)=>intl.formatMessage($0772041b1b3e00cb$var$i18n.configValuePrefixRequired, {
                    fieldValue: labelExcludingPrefix
                })
        },
        {
            prefix: '-',
            labelFunc: (labelExcludingPrefix)=>intl.formatMessage($0772041b1b3e00cb$var$i18n.configValuePrefixExcluded, {
                    fieldValue: labelExcludingPrefix
                })
        }
    ];
// We downloaded the extension manifest
// earlier within query-preloaders
// the resulting manifest is cached
const $0772041b1b3e00cb$var$getMacroLegacyManifest = (0, $9fLxI.getExtensionManifest);
const $0772041b1b3e00cb$export$a3cca4b25908b904 = (macro)=>{
    // TODO: remove this code when cleaning up deprecating_low_usage_macros FG after macro removal on Sep 25 2025
    if ((0, $cV0On.DEPRECATED_MACROS).includes(macro.macroName)) return {
        isDeprecated: true,
        message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "medium"
        }, "\u26A0\uFE0F\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$0772041b1b3e00cb$var$i18n.deprecatedMacroDescription,
            values: {
                alink: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                        href: (0, $cV0On.MACRO_DEPRECATION_INFO_URL),
                        target: "_blank"
                    }, chunks)
            }
        }))
    };
    return undefined;
};
const $0772041b1b3e00cb$var$isFeatureEnabled = (feature)=>{
    return (0, $yuLaV.isContentTypeEnabledInCurrentEnv)(feature);
};
const $0772041b1b3e00cb$var$hijackQuestionsListConnectManifest = (modernManifests)=>{
    const nativeManifest = modernManifests.find((m)=>m.key === 'questionslist-macro-native');
    if (!nativeManifest) return modernManifests;
    // Keep native macro key for new insertion while rewriting legacy key lookups
    // to the same native implementation for existing documents. The legacy alias
    // must not register quick insert, otherwise both keys appear in the slash menu.
    const manifestsWithoutConnectKey = modernManifests.filter((m)=>m.key !== 'questionslist-macro');
    return [
        ...manifestsWithoutConnectKey,
        {
            ...nativeManifest,
            key: 'questionslist-macro',
            modules: {
                ...nativeManifest.modules,
                quickInsert: []
            }
        }
    ];
};
const $0772041b1b3e00cb$export$b65bd6188c54bfe2 = async (legacyMacros, pageContext, extensionHandlers, getMigrationExtensionManifest, openMacroBrowserToEditExistingMacro, openMacroBrowserForInitialConfiguration, editorAPI, intl, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage, flags, allowLegacyMacros = false)=>{
    const isAllowed = (0, $6OgRG.isAllowedWithFeatureFlags)();
    const externalContentAppMacroPriorities = (0, $6mKj3.isExperimentEnabled)('platform_editor_slash_command') ? new Map([
        ...legacyMacros
    ].filter((0, $2E7zk.isExternalContentAppMacro)).sort((first, second)=>first.title.localeCompare(second.title) || first.macroName.localeCompare(second.macroName)).map((macro, index)=>[
            macro.moduleKey,
            index
        ])) : undefined;
    return legacyMacros.map((macro)=>{
        const manifest = $0772041b1b3e00cb$export$42915e364448bf43((0, $8pcS0.EXTENSION_TYPE).MACRO_CORE, macro, pageContext, extensionHandlers, !isAllowed(macro), openMacroBrowserToEditExistingMacro, openMacroBrowserForInitialConfiguration, editorAPI, intl, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage, allowLegacyMacros, externalContentAppMacroPriorities?.get(macro.moduleKey));
        return manifest;
    }).concat(getMigrationExtensionManifest(pageContext.contentId, !!editorActions, intl, flags, createAnalyticsEvent));
};
const $0772041b1b3e00cb$export$42915e364448bf43 = (extensionType, macro, pageContext, extensionHandlers, readonly, openMacroBrowserToEditExistingMacro, openMacroBrowserForInitialConfiguration, editorAPI, intl, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage, allowLegacyMacros = false, externalContentAppMacroPriority)=>{
    const extensionKey = macro.macroName;
    let renderCache = null;
    const isEditor = !!editorActions;
    const { enabled: isConfigPanelEnabled, optedOut: excludedMacros } = pageContext.features.configPanel || {};
    const adfNodeType = (0, $eQyFc.getExtensionBodyType)(macro);
    // Override title & description in manifest for certain macros in Fabric editor only
    const macroOverrides = {
        title: (0, $aMlgD.getMacroTitleOverride)(extensionKey, intl) ?? macro.title,
        description: (0, $aMlgD.getMacroDescriptionOverride)(extensionKey, intl) ?? macro.description
    };
    macro = {
        ...macro,
        ...macroOverrides
    };
    const defaultNode = {
        type: adfNodeType,
        render: ()=>{
            const extensionHandler = extensionHandlers[extensionType];
            return Promise.resolve((extension)=>{
                // per backend restrictions, spaceKey and templateName are required in the extension's macroParams object in order for create-from-template macro to work for autogenerated blueprint index pages.
                if (extension.node.extensionKey === 'create-from-template') {
                    const macroParams = extension.node.parameters?.['macroParams'];
                    if (!macroParams?.spaceKey && !(0, $9wGTI.fg)('cft_macro_dont_force_spacekey')) macroParams.spaceKey = {
                        value: pageContext.spaceKey
                    };
                    if (!macroParams?.templateName) macroParams.templateName = macroParams.contentBlueprintId;
                }
                // if an override is provided for title, update the title for extension label lozenge component
                // This is necessary to update existing macros on a page after a title change rolls out
                if (isEditor && extension.node.parameters?.macroMetadata && macroOverrides?.title) extension.node.parameters.macroMetadata.title = macroOverrides.title;
                const showPlaceholder = (0, $eQyFc.shouldShowPlaceholder)(macro, excludedMacros, extension.node, isEditor);
                if ((isConfigPanelEnabled || !isEditor) && showPlaceholder) return (0, $9tVje.getMissingConfigPlaceholderComponent)(macro, extension.node, isEditor);
                if (isConfigPanelEnabled && isEditor && !(0, $eQyFc.canRenderInTheEditor)(macro)) return (0, $9tVje.getNonRenderablePlaceholderComponent)(macro, (0, $eQyFc.getExtensionBodyType)(macro), isLivePage);
                if (typeof extensionHandler === 'function') return extensionHandler(extension.node, {
                    references: extension.references,
                    actions: extension.actions,
                    isConnectMacro: macro.pluginKey === (0, $jBnsv.CONNECT_APP_PREFIX_KEY)
                });
                return extensionHandler.render(extension.node, {
                    references: extension.references,
                    actions: extension.actions,
                    isConnectMacro: macro.pluginKey === (0, $jBnsv.CONNECT_APP_PREFIX_KEY)
                });
            });
        },
        renderSync () {
            return renderCache;
        },
        async preloadRender () {
            // Extension provider's preload function will loop through all nodes and call this function
            // See platform/packages/editor/editor-common/src/extensions/default-extension-provider.ts
            renderCache = await this.render();
        }
    };
    const allowEdit = allowLegacyMacros || !readonly;
    if (allowEdit && ((0, $eQyFc.getVisibleParameters)(macro).length > 0 || (0, $eQyFc.shouldUseMacroBrowser)(macro, excludedMacros))) {
        const editInMacroBrowser = async (data, actions)=>{
            let selectedNode;
            /**
       * In API v1, we used to pass the whole `node` as `parameters`.
       * We fixed it in API v2 and now only passing `parameters`.
       * But Bodied Extensions inside Macro Browser still need the body for preview.
       * @see DEVHELP-6152
       */ if ((0, $fgbpl.isBodiedExtension)(adfNodeType)) // Currently, there's no other way to get selected node without using private API.
            selectedNode = (0, $2E7zk.getSelectedBodiedExtensionNode)(editorActions);
            const currentNode = await (0, $eQyFc.prepareMacro)({
                name: macro.macroName,
                params: (0, $6mEZ3.unwrapMacroParams)(data.macroParams)
            }, pageContext.contentId, selectedNode, intl);
            const defaultParameterValue = (0, $6mEZ3.getDefaultParamValue)(data.macroParams || {});
            if (defaultParameterValue) {
                const macroParams = currentNode.attrs?.parameters?.macroParams;
                if (macroParams) macroParams[''] = defaultParameterValue;
            }
            const macroFilter = undefined;
            const extensionAnalyticsInfo = {
                createAnalyticsEvent: createAnalyticsEvent,
                contentId: pageContext.contentId
            };
            const updateMacro = (newNode)=>{
                selectedNode = (0, $2E7zk.getSelectedBodiedExtensionNode)(editorActions);
                actions.doc.update(selectedNode?.attrs?.localId, ()=>({
                        attrs: newNode.attrs,
                        marks: newNode.marks,
                        content: newNode.content
                    }));
            };
            const newNode = await openMacroBrowserToEditExistingMacro(currentNode, macroBrowserConfig, macroFilter, extensionAnalyticsInfo, updateMacro, intl);
            // For bodiedExtension we should update the content
            if ((0, $fgbpl.isBodiedExtension)(adfNodeType) && actions?.doc?.update) {
                actions.doc.update(selectedNode?.attrs?.localId, ()=>({
                        attrs: newNode.attrs,
                        marks: newNode.marks,
                        content: newNode.content
                    }));
                return;
            }
            return newNode.attrs.parameters || {};
        };
        let params;
        if (!(0, $cV0On.isMacroDeprecated)(extensionKey)) defaultNode.update = async (data, actions)=>{
            // The adf parameters for macros look like:
            // {
            //    macroParams: {
            //        q: {value: 1},
            //        search: {value: 'my keyword'}
            //    },
            //    macroMetadata: {}
            // }
            // The only editable bit is what is inside the `macroParams`. This method unwraps the params and pass it to
            // the context panel for editing, and then wraps it back after saving.
            const transformBefore = (parameters)=>{
                params = (0, $6mEZ3.unwrapMacroParams)(parameters.macroParams);
                return (0, $e7owm.transformParams)('transformBefore', macro, params, pageContext, createAnalyticsEvent);
            };
            const transformAfter = async (initialParameters)=>{
                const parameters = (0, $e7owm.transformParams)('transformAfter', macro, initialParameters, pageContext, createAnalyticsEvent);
                if (macro.macroName === (0, $8pcS0.EXTENSION_KEY).TEAM_CALENDARS && (0, $6mKj3.expValEquals)('cc-engagement-team-calendar-macro-afm-migration', 'isEnabled', true)) {
                    const macroParams = (0, $6mEZ3.wrapMacroParams)((0, $gaGUd.normalizeNonLegacyCalendarMacroParams)(parameters));
                    return {
                        ...data,
                        macroParams: macroParams,
                        macroMetadata: {
                            ...data.macroMetadata,
                            macroId: data.macroMetadata?.macroId ?? {
                                value: (0, $9Cbhx.getMacroId)({
                                    macroParams: macroParams
                                })
                            }
                        }
                    };
                }
                // macros might have metadata changed based on macroParams so we need to fetch again. The rule changes on
                // each of them so we can't do it client side.
                const macroDefinition = {
                    name: macro.macroName,
                    params: parameters
                };
                const defaultParameterValue = (0, $6mEZ3.getDefaultParamValue)(parameters);
                if (defaultParameterValue) macroDefinition.defaultParameterValue = defaultParameterValue;
                const node = await (0, $eQyFc.prepareMacro)(macroDefinition, pageContext.contentId, null, intl);
                // add a new macroId if we don't already have one
                if (node.attrs.parameters) {
                    if (!node.attrs.parameters.macroMetadata) node.attrs.parameters.macroMetadata = {};
                    if (!node.attrs.parameters.macroMetadata['macroId']) node.attrs.parameters.macroMetadata['macroId'] = {
                        value: (0, $9Cbhx.getMacroId)(node.attrs.parameters)
                    };
                }
                return node.attrs.parameters || {};
            };
            if (!isConfigPanelEnabled || (0, $eQyFc.shouldUseMacroBrowser)(macro, excludedMacros)) return editInMacroBrowser(data, actions);
            return actions.editInContextPanel(transformBefore, transformAfter);
        };
        if ((0, $eQyFc.getVisibleParameters)(macro).length > 0) defaultNode.getFieldsDefinition = ()=>{
            const fields = macro.formDetails.parameters.map((params)=>(0, $38eecb7cd02ce24e$export$f5f12fd2c8b33ce0)(params, {
                    pluginKey: macro.pluginKey,
                    macroName: (0, $eQyFc.safeGetMacroName)(macro)
                }));
            return (0, $e7owm.remapCustomFields)(macro, fields, pageContext, intl, params, createAnalyticsEvent, isLivePage);
        };
    }
    let app;
    if ((0, $6mKj3.isExperimentEnabled)('platform_editor_slash_app_category_analytics') || (0, $6mKj3.isExperimentEnabled)('platform_editor_slash_command')) {
        const connectAppKey = (0, $2E7zk.getConnectAppKey)(macro.moduleKey);
        app = {
            key: connectAppKey || macro.pluginKey,
            source: connectAppKey ? 'ecosystem' : 'internal'
        };
    }
    return {
        ...app ? {
            app: app
        } : {},
        type: extensionType,
        key: extensionKey,
        title: macro.title,
        description: macro.description,
        deprecation: $0772041b1b3e00cb$export$a3cca4b25908b904(macro),
        icons: (0, $eQyFc.buildIconObject)(macro),
        documentationUrl: macro.formDetails.documentationUrl || undefined,
        modules: {
            quickInsert: !readonly && !(0, $cV0On.isMacroDeprecated)(extensionKey) && editorActions && (0, $Qcu7n.shouldIncludeMacroInQuickInsert)(extensionKey) ? (0, $2E7zk.createQuickInsertModule)(macro, pageContext, openMacroBrowserForInitialConfiguration, editorAPI, intl, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage, externalContentAppMacroPriority) : [],
            nodes: {
                default: defaultNode
            },
            fields: {
                custom: {
                    attachment: {
                        resolver: (0, $f5981546cd91a250$export$98306171982e2202)(macro, pageContext)
                    },
                    spacekey: {
                        resolver: (0, $0a9a42b243ec1ac9$export$bab0f33d6337c008)(macro)
                    },
                    username: {
                        resolver: (0, $c1e526d8b8327452$export$63f9bb9a5820f1bc)
                    },
                    label: {
                        resolver: (0, $132842a839e22041$export$a821dfb2c4620119)
                    },
                    labelWithPlusMinusPrefixes: {
                        resolver: (0, $2fdd0370d00b842a$export$4172796c9e33488c)({
                            resolver: (0, $132842a839e22041$export$a821dfb2c4620119),
                            prefixSettings: $0772041b1b3e00cb$var$PLUS_MINUS_PREFIX_SETTINGS(intl)
                        })
                    },
                    'confluence-content-by-id': {
                        resolver: (0, $24ca4725cd610b37$export$41173a2c419f6dfc)
                    },
                    'confluence-content': {
                        resolver: (0, $8540ddfe85cd4073$export$3f7da36354f8b724)((0, $3b8b016da39bc505$export$ddc3fcea26200983)())
                    },
                    spaceAndPage: {
                        resolver: (0, $10e93d065b18a316$export$ed8020fd2c03836f)
                    },
                    spaceKeyAndPageTitleContent: {
                        resolver: (0, $3b8b016da39bc505$export$ddc3fcea26200983)()
                    },
                    rootPage: {
                        resolver: (0, $ca514041a0cedbe0$export$1766a89a46ff2e41)({
                            resolver: (0, $3b8b016da39bc505$export$ddc3fcea26200983)(),
                            values: [
                                '@self',
                                '@home',
                                '@parent',
                                '@none'
                            ]
                        })
                    },
                    calendar: {
                        resolver: (0, $99dfcbe48c719a87$export$79a154fc3ca3f9ae)
                    },
                    template: {
                        resolver: (0, $gw2T1.getTemplateResolver)(pageContext)
                    },
                    blogRecentlyUpdatedSpace: {
                        resolver: (0, $ca514041a0cedbe0$export$1766a89a46ff2e41)({
                            /* recently updated macro doesn't support currentSpace() */ resolver: (0, $0a9a42b243ec1ac9$export$534da981b85f5d27)(false),
                            values: [
                                '@self',
                                '@personal',
                                '@global',
                                '@favorite',
                                '@favourite',
                                '@all',
                                '*'
                            ]
                        })
                    },
                    blogRecentlyUpdatedSpaceWithPlusMinusPrefixes: {
                        resolver: (0, $ca514041a0cedbe0$export$1766a89a46ff2e41)({
                            /* blog posts macro doesn't support currentSpace() */ resolver: (0, $2fdd0370d00b842a$export$4172796c9e33488c)({
                                /* blog posts macro needs support for requiring or excluding spaces with "+" or "-" prefixes.*/ resolver: (0, $0a9a42b243ec1ac9$export$534da981b85f5d27)(false),
                                prefixSettings: $0772041b1b3e00cb$var$PLUS_MINUS_PREFIX_SETTINGS(intl)
                            }),
                            values: [
                                '@self',
                                '@personal',
                                '@global',
                                '@favorite',
                                '@favourite',
                                '@all',
                                '*'
                            ]
                        })
                    },
                    contributorsSpaceParamResolver: {
                        resolver: (0, $ca514041a0cedbe0$export$1766a89a46ff2e41)({
                            resolver: (0, $0a9a42b243ec1ac9$export$534da981b85f5d27)(false),
                            values: [
                                '@personal',
                                '@global',
                                '@all'
                            ]
                        })
                    },
                    recentlyUpdatedDashboardSpaceKeyResolver: {
                        resolver: (0, $ca514041a0cedbe0$export$1766a89a46ff2e41)({
                            resolver: (0, $0a9a42b243ec1ac9$export$534da981b85f5d27)(false),
                            values: [
                                '*'
                            ]
                        })
                    },
                    widthPercentage: {
                        resolver: (0, $6ec8fb0cb8d57c0c$export$1bb3f7145befbf14)(intl)
                    }
                },
                fieldset: {
                    cql: {
                        serializer: (0, $be58797972986c91$export$ac8a9eb5c5a129c4),
                        deserializer: (0, $be58797972986c91$export$7b88d2983fb8d650)
                    }
                }
            }
        }
    };
};

const $0772041b1b3e00cb$export$1afad384655af93f = async (pageContext, extensionHandlers, editorAPI, editorActions, macroBrowserConfig, getMigrationExtensionManifest, openMacroBrowserToEditExistingMacro, openMacroBrowserForInitialConfiguration, intl, createAnalyticsEvent, onCompleteCallback, isLivePage, flags, experienceTracker, contentType, allowCreateDatabaseExtension = false, allowDatabaseQuickInsert = false, allowCreateWhiteboardExtension = false, rovoSkillsConfig, allowLegacyMacros = false, isCompanyHub, pageTreeStateUpdater, allowAgentManagedExtensionProvider = false, isLivePageViewMode)=>{
    const [legacyManifests, macroAutoConverters] = await Promise.all([
        $0772041b1b3e00cb$var$getMacroLegacyManifest(pageContext),
        (0, $3IXUB.getAutoConverter)(macroBrowserConfig)
    ]);
    // Block unsupported 1p macro insertion if we're in the Company Hub,
    // the company-hub-migration-prevent-1p-macro experiment is enabled,
    // and the company-hub-prevent-1p-macro-via-tap-trait gate returns false.
    // company-hub-prevent-1p-macro-via-tap-trait is controlled by a tap trait that checks if a tenant's company hub
    // has been published with unsupported 1p macros in the last 4 months,
    // in which case we will allow them to insert unsupported 1p macros.
    const hideMacrosOptions = {
        isLivePage: isLivePage,
        isCompanyHub: isCompanyHub && (0, $6mKj3.expVal)('company-hub-migration-prevent-1p-macro', 'isEnabled', false) && !(0, $9wGTI.fg)('company-hub-prevent-1p-macro-via-tap-trait')
    };
    const legacyManifestMacros = (0, $2E7zk.filterOutHiddenMacros)(legacyManifests.macros, hideMacrosOptions);
    let modernManifests = await $0772041b1b3e00cb$export$b65bd6188c54bfe2(legacyManifestMacros, pageContext, extensionHandlers, getMigrationExtensionManifest, openMacroBrowserToEditExistingMacro, openMacroBrowserForInitialConfiguration, editorAPI, intl, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage, flags, allowLegacyMacros);
    modernManifests = $0772041b1b3e00cb$var$hijackQuestionsListConnectManifest(modernManifests);
    modernManifests = modernManifests.filter((manifest)=>manifest.key !== 'toc');
    const macro = legacyManifestMacros.find((m)=>m.macroName === 'toc');
    const { tableOfContentsExtension: tableOfContentsExtension } = await (parcelRequire("lyokC"));
    const createTableOfContentsExtension = tableOfContentsExtension({
        macro: macro,
        pageContext: pageContext,
        extensionHandlers: extensionHandlers,
        editorAPI: editorAPI,
        openMacroBrowserForInitialConfiguration: openMacroBrowserForInitialConfiguration,
        macroBrowserConfig: macroBrowserConfig,
        editorActions: editorActions,
        createAnalyticsEvent: createAnalyticsEvent,
        intl: intl,
        onCompleteCallback: onCompleteCallback,
        isLivePage: isLivePage
    });
    modernManifests.push(createTableOfContentsExtension);
    modernManifests.push((0, $cOau5.createTourableRedactionExtension)({
        contentId: pageContext?.contentId
    }));
    modernManifests.push((0, $fd320ef48aed12ed$export$8e57f4d7d2152080));
    if ((0, $6mKj3.expVal)('confluence_native_tabs_experiment', 'isEnabled', false)) modernManifests.push(isLivePageViewMode ? (0, $51b6dad63a2df526$export$fd653d4581226676)(intl) : (0, $aa48fa7acda1b956$export$9939b6c8e50c59ac)(intl, {
        getCopyLinkBaseUrl: ()=>{
            if (!pageContext.contentId || !contentType || !pageContext.spaceKey) return null;
            return (0, $iXzFq.getUrlForContentType)({
                contentType: contentType,
                contentId: pageContext.contentId,
                spaceKey: pageContext.spaceKey,
                redirectToEditor: !isLivePage
            });
        },
        resolveElementByHash: (hashId)=>{
            const element = (0, $202oG.getHeadingIdsToElements)().get(hashId);
            return element instanceof HTMLElement ? element : null;
        }
    }));
    if (allowCreateDatabaseExtension && $0772041b1b3e00cb$var$isFeatureEnabled('database')) modernManifests.push((0, $dfcefa6efd7a826f$export$f86f9e9c7cf6f650)({
        pageId: pageContext.contentId,
        spaceKey: pageContext.spaceKey,
        spaceId: pageContext.spaceId,
        intl: intl,
        flags: flags,
        createAnalyticsEvent: createAnalyticsEvent,
        experienceTracker: experienceTracker,
        contentType: contentType,
        allowDatabaseQuickInsert: allowDatabaseQuickInsert && !(0, $9wGTI.fg)('confluence_frontend_databases_opt-out'),
        isEdit: true,
        pageTreeStateUpdater: pageTreeStateUpdater
    }));
    if (allowCreateWhiteboardExtension && pageContext.spaceId && pageContext.spaceKey && $0772041b1b3e00cb$var$isFeatureEnabled('whiteboard') && (0, $6mKj3.expVal)('create_whiteboard_via_slash_command', 'enabled', false)) modernManifests.push((0, $e34976de7a15a4c3$export$f5b268b2504551e9)({
        pageId: pageContext.contentId,
        spaceKey: pageContext.spaceKey,
        spaceId: pageContext.spaceId,
        intl: intl,
        flags: flags,
        experienceTracker: experienceTracker,
        createAnalyticsEvent: createAnalyticsEvent,
        contentType: contentType,
        allowWhiteboardQuickInsert: allowCreateWhiteboardExtension,
        pageTreeStateUpdater: pageTreeStateUpdater
    }));
    if (allowAgentManagedExtensionProvider && (0, $6mKj3.expVal)('agent-managed_blocks_mvp', 'isEnabled', false)) // `intl as any` mirrors the AI Panels provider call below — Confluence
    // uses `react-intl` while editor packages use `react-intl-next`.
    modernManifests.push(...await (0, $a893e0ac7d00a494$export$39aa3cd1a722fe6a)({
        intl: intl,
        editorAPI: editorAPI
    }).getExtensions());
    // Rovo Skills in insert menu (slash menu)
    if (rovoSkillsConfig?.enabled && rovoSkillsConfig?.cloudId) try {
        const skillsManifest = await (0, $8bRAb.createRovoSkillsExtensionManifest)(rovoSkillsConfig.cloudId, rovoSkillsConfig);
        modernManifests.push(skillsManifest);
    } catch  {
    // Silently fail — the insert menu will just not show skills
    }
    if ((0, $6mKj3.isExperimentEnabled)('platform_editor_slash_app_category_analytics') || (0, $6mKj3.isExperimentEnabled)('platform_editor_slash_command')) modernManifests = modernManifests.filter((manifest)=>Boolean(manifest)).map((manifest)=>({
            ...manifest,
            app: {
                ...manifest.app ?? {
                    key: manifest.key
                },
                source: manifest.app?.source ?? 'internal'
            }
        }));
    return new (0, $bdpeX.default)(modernManifests, [
        (link)=>{
            const result = macroAutoConverters(link);
            if (result) return result;
        }
    ]);
};
const $0772041b1b3e00cb$export$eeaf69e6b00b13ad = async (pageContext, extensionHandlers, getMigrationExtensionManifest, openMacroBrowserToEditExistingMacro, openMacroBrowserForInitialConfiguration, intl, createAnalyticsEvent, providerFactory)=>{
    const chartsExtensionPromise = (0, $fPsyy.createChartsExtension)({
        // TODO: use intl5 instead
        intl: intl,
        extensionHandlers: extensionHandlers[(0, $8pcS0.EXTENSION_TYPE).MACRO_WITH_REFERENCES],
        createAnalyticsEvent: createAnalyticsEvent
    });
    const legacyManifests = await $0772041b1b3e00cb$var$getMacroLegacyManifest(pageContext);
    let modernManifests = await $0772041b1b3e00cb$export$b65bd6188c54bfe2(legacyManifests.macros, pageContext, extensionHandlers, getMigrationExtensionManifest, openMacroBrowserToEditExistingMacro, openMacroBrowserForInitialConfiguration, // We don't have the `editorAPI` for the renderer
    undefined, intl, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    modernManifests.push((0, $7a29776dd6927980$export$eb802fdec29ee1cc)(extensionHandlers));
    if (chartsExtensionPromise) modernManifests.push(await chartsExtensionPromise);
    // We don't want to check for the aiOptInStatus as we want to show the rendered block
    // regardless of AI status so we don't lose content if people downgrade etc
    const aiBlockProvider = await (0, $5507a5178ad04a78$export$34ea67e5ccaac92)({
        intl: intl,
        providerFactory: providerFactory
    });
    modernManifests.push(...await aiBlockProvider.getExtensions());
    const { contentId: contentId } = pageContext;
    modernManifests.push(...await (0, $gH8jv.createPremiumExtensionManifests)({
        contentId: contentId,
        intl: intl,
        allowCompanyHubExclusiveExtensions: true
    }));
    if ($0772041b1b3e00cb$var$isFeatureEnabled('database')) modernManifests.push((0, $dfcefa6efd7a826f$export$f86f9e9c7cf6f650)({
        pageId: contentId,
        spaceKey: pageContext.spaceKey,
        spaceId: pageContext.spaceId,
        intl: intl,
        createAnalyticsEvent: createAnalyticsEvent,
        isEdit: false
    }));
    modernManifests.push((0, $cOau5.createTourableRedactionExtension)({
        contentId: contentId
    }));
    modernManifests.push((0, $fd320ef48aed12ed$export$8e57f4d7d2152080));
    if ((0, $6mKj3.expVal)('confluence_native_tabs_experiment', 'isEnabled', false)) modernManifests.push((0, $51b6dad63a2df526$export$fd653d4581226676)(intl));
    if ((0, $6mKj3.expVal)('agent-managed_blocks_mvp', 'isEnabled', false)) modernManifests.push(...await (0, $a893e0ac7d00a494$export$39aa3cd1a722fe6a)({
        intl: intl
    }).getExtensions());
    if ((0, $6mKj3.expVal)('platform_editor_hide_extension_renderer_support', 'isEnabled', false)) modernManifests.push((0, $2dcacd11913842b3$export$ec1e9c66266151e8));
    if ((0, $6mKj3.UNSAFE_expValNoExposure)('cc-maui-experiment', 'isEnabled', false) || (0, $9wGTI.fg)('platform_native_embeds_rollout_non_maui_experience')) {
        const nativeEmbedAnalyticsPageContext = {
            contentId: contentId,
            spaceId: pageContext.spaceId,
            // livePage set to false here since this is the rendered view only
            isLivePage: false,
            pageMode: 'view'
        };
        modernManifests.push((0, $7rOWN.createManifest)(true, undefined, undefined, undefined, nativeEmbedAnalyticsPageContext));
    }
    modernManifests = $0772041b1b3e00cb$var$hijackQuestionsListConnectManifest(modernManifests);
    return new (0, $bdpeX.default)(modernManifests);
};
module.exports["getConfluenceMacrosExtensionProviderForEditor"] = $0772041b1b3e00cb$export$1afad384655af93f;
module.exports["getConfluenceMacrosExtensionProviderForRenderer"] = $0772041b1b3e00cb$export$eeaf69e6b00b13ad;

});

parcelRegister("5lo82", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- uuid is used as a fallback for environments where crypto.randomUUID is unavailable

var $03RpJ = parcelRequire("03RpJ");


var $bjg0G = parcelRequire("bjg0G");


var $eYo03 = parcelRequire("eYo03");

const $f37cafbda0c5434c$export$972235505d9c823a = (value)=>{
    if (!value || typeof value !== 'object') return false;
    const maybeAiManagedObject = value;
    return typeof maybeAiManagedObject.id === 'string' && typeof maybeAiManagedObject.configVersion === 'string';
};
const $f37cafbda0c5434c$var$parseAiManagedObjectAttribute = (value)=>{
    if ($f37cafbda0c5434c$export$972235505d9c823a(value)) return value;
    if (typeof value !== 'string') return undefined;
    try {
        const parsed = JSON.parse(value);
        return $f37cafbda0c5434c$export$972235505d9c823a(parsed) ? parsed : undefined;
    } catch  {
        return undefined;
    }
};
const $f37cafbda0c5434c$export$82e3e9c83195e343 = (value)=>{
    if (!value || typeof value !== 'object') return false;
    const maybeTemplateConfig = value;
    const isSupportedGoal = maybeTemplateConfig.goal === 'decision-register' || maybeTemplateConfig.goal === 'executive-summary' || maybeTemplateConfig.goal === 'meeting-recap';
    const isSupportedSourceMode = maybeTemplateConfig.sourceMode === 'current-page' || maybeTemplateConfig.sourceMode === 'manual';
    const hasSupportedOutputFormat = maybeTemplateConfig.outputFormat === undefined || maybeTemplateConfig.outputFormat === 'panel' || maybeTemplateConfig.outputFormat === 'table' || maybeTemplateConfig.outputFormat === 'text';
    return isSupportedGoal && isSupportedSourceMode && hasSupportedOutputFormat;
};
const $f37cafbda0c5434c$var$parseTemplateConfig = (value)=>{
    if ($f37cafbda0c5434c$export$82e3e9c83195e343(value)) return value;
    if (typeof value !== 'string') return undefined;
    try {
        const parsed = JSON.parse(value);
        return $f37cafbda0c5434c$export$82e3e9c83195e343(parsed) ? parsed : undefined;
    } catch  {
        return undefined;
    }
};
const $f37cafbda0c5434c$export$e0b834a4687ac21d = (node)=>{
    if (!node || node.type.name !== 'bodiedExtension') return false;
    const { extensionKey: extensionKey } = node.attrs;
    return extensionKey === (0, $eYo03.AGENT_MANAGED_EXTENSION_KEY);
};
const $f37cafbda0c5434c$export$865e6dc91e7f3485 = (attrs)=>$f37cafbda0c5434c$var$parseAiManagedObjectAttribute(attrs?.parameters?.macroParams?.aiManagedObject?.value);
const $f37cafbda0c5434c$export$3c35bd50553f7b06 = (attrs)=>$f37cafbda0c5434c$var$parseTemplateConfig(attrs?.parameters?.macroParams?.templateConfig?.value);
const $f37cafbda0c5434c$export$960e9604201b140c = (state, selection)=>{
    const { bodiedExtension: bodiedExtension } = state.schema.nodes;
    if (!bodiedExtension) return undefined;
    const sel = selection || state.selection;
    const selected = (0, $bjg0G.findSelectedNodeOfType)(bodiedExtension)(sel);
    if (selected && $f37cafbda0c5434c$export$e0b834a4687ac21d(selected.node)) return {
        node: selected.node,
        pos: selected.pos
    };
    const parent = (0, $bjg0G.findParentNodeOfTypeClosestToPos)(sel.$from, bodiedExtension);
    if (parent && $f37cafbda0c5434c$export$e0b834a4687ac21d(parent.node)) return {
        node: parent.node,
        pos: parent.pos
    };
    return undefined;
};
const $f37cafbda0c5434c$export$7bdbde02e24177e8 = (state, localId)=>{
    if (!localId) return undefined;
    let found;
    state.doc.descendants((node, pos)=>{
        if ($f37cafbda0c5434c$export$e0b834a4687ac21d(node) && node.attrs.localId === localId) {
            found = {
                node: node,
                pos: pos
            };
            return false;
        }
        return true;
    });
    return found;
};
const $f37cafbda0c5434c$var$randomId = ()=>{
    if (globalThis?.crypto?.randomUUID) return globalThis.crypto.randomUUID();
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- uuid is used as a fallback for environments where crypto.randomUUID is unavailable
    return (0, $03RpJ.default)();
};
const $f37cafbda0c5434c$export$54a229a17ecd6798 = ()=>$f37cafbda0c5434c$var$randomId();
module.exports["isAgentManagedExtension"] = $f37cafbda0c5434c$export$e0b834a4687ac21d;
module.exports["getNodeAiManagedObject"] = $f37cafbda0c5434c$export$865e6dc91e7f3485;
module.exports["getNodeTemplateConfig"] = $f37cafbda0c5434c$export$3c35bd50553f7b06;
module.exports["findAgentManagedExtension"] = $f37cafbda0c5434c$export$960e9604201b140c;
module.exports["findAgentManagedExtensionByLocalId"] = $f37cafbda0c5434c$export$7bdbde02e24177e8;
module.exports["generateLocalId"] = $f37cafbda0c5434c$export$54a229a17ecd6798;

});

parcelRegister("cJrqk", function(module, exports) {
/* AimoConfigurationLoadState.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $hz2oZ = parcelRequire("hz2oZ");


var $4aRua = parcelRequire("4aRua");


var $9GVkD = parcelRequire("9GVkD");


var $uia0q = parcelRequire("uia0q");

const $821118ed851e0ab9$var$loadingStyles = null;
const $821118ed851e0ab9$var$panelLoadingStyles = null;
const $821118ed851e0ab9$var$loadingRowStyles = null;
const $821118ed851e0ab9$var$loadingShortRowStyles = null;
const $821118ed851e0ab9$var$loadingMediumRowStyles = null;
const $821118ed851e0ab9$var$loadingLongRowStyles = null;
const $821118ed851e0ab9$var$menuLoadingLongRowStyles = null;
const $821118ed851e0ab9$var$menuLoadingShortRowStyles = null;
const $821118ed851e0ab9$var$loadingFieldStyles = null;
const $821118ed851e0ab9$var$loadingTextAreaStyles = null;
const $821118ed851e0ab9$var$loadErrorStyles = null;
const $821118ed851e0ab9$var$panelLoadErrorStyles = null;
const $821118ed851e0ab9$var$AimoConfigurationLoadingState = ({ testId: testId, variant: variant })=>{
    const intl = (0, $kSwu1.useIntl)();
    if (variant === 'panel') return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        role: "status",
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _4c065U2ADO _2Y7lL42ADO _3iDTPbgBM8",
            "_2mHwu88HPE _4c065U2ADO _2Y7lL4dnbC"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, intl.formatMessage((0, $uia0q.messages).loadingConfiguration)), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _0KLXruGsB2 _0jFU0VxpxF",
            "_39xV02Lsv4"
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _0KLXruGsB2 _0jFU0VUF4f"
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _0KLXruGsB2 _0jFU0VxpxF",
            "_39xV02lIjS"
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _0KLXruGsB2 _0jFU0V5bvF"
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _0KLXruGsB2 _0jFU0VxpxF",
            "_39xV02N91d"
        ])
    }));
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        role: "status",
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _4c065U2ADO _2Y7lL42ADO _3iDTPbgBM8"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, intl.formatMessage((0, $uia0q.messages).loadingConfiguration)), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _0KLXruGsB2 _0jFU0VxpxF",
            "_39xV02E1Ft"
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _0KLXruGsB2 _0jFU0VxpxF",
            "_39xV02lIjS"
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _0KLXruGsB2 _0jFU0VxpxF",
            "_39xV02nQIZ"
        ])
    }));
};
const $821118ed851e0ab9$var$AimoConfigurationErrorState = ({ errorMessage: errorMessage, onRetry: onRetry, testId: testId, variant: variant })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        role: "alert",
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _4c065U2ADO _2Y7lL42ADO _0hPCNLDIqT _0GwItXDIqT _3iDTPbgBM8 _0pI6nMDIqT _4kiQYAT0NC _2fwxA5DIqT",
            variant === 'panel' && "_2Y7lL4dnbC"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.danger"
    }, errorMessage ?? intl.formatMessage((0, $uia0q.messages).failedToLoadConfiguration))), /*#__PURE__*/ $cozmU.createElement("div", null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "default",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($hz2oZ))),
        isDisabled: !onRetry,
        onClick: (event)=>{
            event.preventDefault();
            event.stopPropagation();
            onRetry?.();
        },
        onMouseDown: (event)=>{
            event.preventDefault();
            event.stopPropagation();
        },
        onMouseUp: (event)=>{
            event.preventDefault();
            event.stopPropagation();
        },
        spacing: "compact"
    }, intl.formatMessage((0, $uia0q.messages).retryConfigurationLoad))));
};
const $821118ed851e0ab9$export$5231ea4a0dd630a3 = ({ errorMessage: errorMessage, onRetry: onRetry, status: status, testId: testId, variant: variant })=>status === 'loading' ? /*#__PURE__*/ $cozmU.createElement($821118ed851e0ab9$var$AimoConfigurationLoadingState, {
        testId: testId,
        variant: variant
    }) : /*#__PURE__*/ $cozmU.createElement($821118ed851e0ab9$var$AimoConfigurationErrorState, {
        errorMessage: errorMessage,
        onRetry: onRetry,
        testId: testId,
        variant: variant
    });
module.exports["AimoConfigurationLoadState"] = $821118ed851e0ab9$export$5231ea4a0dd630a3;

});

parcelRegister("lJQKj", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");

const $fc243102b4fadb7e$export$8d61b4f7e7081403 = 'long';
const $fc243102b4fadb7e$var$UPDATE_INTERVAL_DYNAMIC_CONFIG = 'ai-managed-blocks-update-interval';
const $fc243102b4fadb7e$var$UPDATE_INTERVAL_FALLBACK_VALUES = {
    short: 'PT1H',
    medium: 'PT7H',
    long: 'P1D'
};
const $fc243102b4fadb7e$var$getUpdateIntervalValues = ()=>{
    const dynamicConfig = (0, $cXtTj.default).getExperiment($fc243102b4fadb7e$var$UPDATE_INTERVAL_DYNAMIC_CONFIG, {
        fireExperimentExposure: false
    }).value;
    const config = dynamicConfig.value ?? {};
    return {
        short: config.short ?? $fc243102b4fadb7e$var$UPDATE_INTERVAL_FALLBACK_VALUES.short,
        medium: config.medium ?? $fc243102b4fadb7e$var$UPDATE_INTERVAL_FALLBACK_VALUES.medium,
        long: config.long ?? $fc243102b4fadb7e$var$UPDATE_INTERVAL_FALLBACK_VALUES.long
    };
};
const $fc243102b4fadb7e$export$46669aa3fccf67a2 = (updateInterval)=>{
    const value = updateInterval ? $fc243102b4fadb7e$var$getUpdateIntervalValues()[updateInterval] : undefined;
    return value ? {
        type: 'INTERVAL',
        value: value
    } : undefined;
};
const $fc243102b4fadb7e$export$ffd2376fbb095b47 = (frequency)=>{
    if (!frequency) return undefined;
    if (frequency.type !== 'INTERVAL') return $fc243102b4fadb7e$export$8d61b4f7e7081403;
    const updateInterval = Object.entries($fc243102b4fadb7e$var$getUpdateIntervalValues()).find(([, value])=>value === frequency.value)?.[0];
    return updateInterval ?? $fc243102b4fadb7e$export$8d61b4f7e7081403;
};
module.exports["DEFAULT_UPDATE_INTERVAL"] = $fc243102b4fadb7e$export$8d61b4f7e7081403;
module.exports["getDesiredUpdateFrequencyForInterval"] = $fc243102b4fadb7e$export$46669aa3fccf67a2;
module.exports["getUpdateIntervalFromDesiredFrequency"] = $fc243102b4fadb7e$export$ffd2376fbb095b47;

});

parcelRegister("89DwQ", function(module, exports) {

var $jqItm = parcelRequire("jqItm");


var $4X6m9 = parcelRequire("4X6m9");


var $1tIRv = parcelRequire("1tIRv");


var $cvhuh = parcelRequire("cvhuh");

const $63607e2d21936292$export$b286a0c545213865 = (editorView, aimoId)=>(0, $cvhuh.getCachedAiManagedObjectFromState)(editorView.state, aimoId);
const $63607e2d21936292$export$e04cafc153b0e975 = (editorView, aimo, localId)=>{
    const tr = (0, $1tIRv.cacheAiManagedObject)(aimo, localId)({
        tr: editorView.state.tr
    });
    if (tr) editorView.dispatch(tr);
};
const $63607e2d21936292$var$isMetaActionArray = (meta)=>Array.isArray(meta);
const $63607e2d21936292$var$toMetaActions = (meta)=>{
    if (!meta) return undefined;
    return $63607e2d21936292$var$isMetaActionArray(meta) ? meta : [
        meta
    ];
};
const $63607e2d21936292$var$persistMutatedAiManagedObject = (editorView, aimo, localId, meta)=>{
    const tr = editorView.state.tr;
    (0, $4X6m9.setNodeAiManagedObject)(editorView.state, tr, aimo, localId);
    const metaActions = $63607e2d21936292$var$toMetaActions(typeof meta === 'function' ? meta() : meta);
    (0, $4X6m9.setAgentManagedExtensionMeta)(tr, metaActions ? [
        (0, $1tIRv.getCacheAiManagedObjectMeta)(aimo, localId),
        ...metaActions
    ] : (0, $1tIRv.getCacheAiManagedObjectMeta)(aimo, localId));
    editorView.dispatch(tr);
};
const $63607e2d21936292$var$dispatchAiManagedObjectLoadStarted = (editorView, aimoId, localId)=>{
    const tr = (0, $1tIRv.startAiManagedObjectLoad)(aimoId, localId)({
        tr: editorView.state.tr
    });
    if (tr) editorView.dispatch(tr);
};
const $63607e2d21936292$var$dispatchAiManagedObjectLoadFailed = (editorView, aimoId, localId)=>{
    const tr = (0, $1tIRv.failAiManagedObjectLoad)(aimoId, localId)({
        tr: editorView.state.tr
    });
    if (tr) editorView.dispatch(tr);
};
const $63607e2d21936292$export$58d6768cf50de495 = async ({ aimoId: aimoId, cachedAimo: cachedAimo, editorView: editorView, localId: localId })=>{
    const existingAimo = cachedAimo ?? $63607e2d21936292$export$b286a0c545213865(editorView, aimoId);
    if (existingAimo) {
        if (localId) $63607e2d21936292$export$e04cafc153b0e975(editorView, existingAimo, localId);
        return existingAimo;
    }
    $63607e2d21936292$var$dispatchAiManagedObjectLoadStarted(editorView, aimoId, localId);
    try {
        const fetchedAimo = await (0, $jqItm.fetchAiManagedObject)(aimoId);
        if (fetchedAimo) {
            $63607e2d21936292$export$e04cafc153b0e975(editorView, fetchedAimo, localId);
            return fetchedAimo;
        }
    } catch  {
        $63607e2d21936292$var$dispatchAiManagedObjectLoadFailed(editorView, aimoId, localId);
        throw new Error('Failed to load AI-managed object');
    }
    $63607e2d21936292$var$dispatchAiManagedObjectLoadFailed(editorView, aimoId, localId);
    return null;
};
const $63607e2d21936292$export$a7efd66c10a77728 = async (editorView, input, localId, meta)=>{
    const aimo = await (0, $jqItm.createAiManagedObject)(input);
    $63607e2d21936292$var$persistMutatedAiManagedObject(editorView, aimo, localId, meta);
    return aimo;
};
const $63607e2d21936292$export$3dea733dc530b401 = async (editorView, input, localId, meta)=>{
    const aimo = await (0, $jqItm.updateAiManagedObject)(input);
    $63607e2d21936292$var$persistMutatedAiManagedObject(editorView, aimo, localId, meta);
    return aimo;
};
const $63607e2d21936292$var$cacheAiManagedObjectStatus = (editorView, aimoId, status, localId)=>{
    const cachedAimo = $63607e2d21936292$export$b286a0c545213865(editorView, aimoId);
    if (!cachedAimo) return;
    // Archive/reactivate mutations return a boolean, so preserve the cached
    // object and only reflect the lifecycle status that changed on the backend.
    $63607e2d21936292$export$e04cafc153b0e975(editorView, {
        ...cachedAimo,
        status: status
    }, localId);
};
const $63607e2d21936292$export$be4561bb3b022c85 = async (editorView, aimoId, localId)=>{
    await (0, $jqItm.archiveAiManagedObject)(aimoId);
    $63607e2d21936292$var$cacheAiManagedObjectStatus(editorView, aimoId, 'ARCHIVED', localId);
};
const $63607e2d21936292$export$a3ddef0b8e9ecc7b = async (editorView, aimoId, localId)=>{
    await (0, $jqItm.reactivateAiManagedObject)(aimoId);
    $63607e2d21936292$var$cacheAiManagedObjectStatus(editorView, aimoId, 'ACTIVE', localId);
};
module.exports["getCachedAiManagedObject"] = $63607e2d21936292$export$b286a0c545213865;
module.exports["getAiManagedObjectWithCache"] = $63607e2d21936292$export$58d6768cf50de495;
module.exports["createAiManagedObjectWithCache"] = $63607e2d21936292$export$a7efd66c10a77728;
module.exports["updateAiManagedObjectWithCache"] = $63607e2d21936292$export$3dea733dc530b401;
module.exports["archiveAiManagedObjectWithCache"] = $63607e2d21936292$export$be4561bb3b022c85;
module.exports["reactivateAiManagedObjectWithCache"] = $63607e2d21936292$export$a3ddef0b8e9ecc7b;

});

parcelRegister("jqItm", function(module, exports) {
/**
 * Public API functions for creating, fetching, updating, and executing
 * AI-managed objects via the ai-managed-object-service.
 */ // oxlint-disable-next-line import/extensions
/**
 * Thin GraphQL client for the ai-managed-object-service, accessed
 * via the Atlassian GraphQL Gateway (AGG).
 *
 * This module is intentionally kept framework-agnostic (no React hooks)
 * so it can be called from both React components and editor plugin
 * imperative code paths.
 */ const $2fb101c0514a00ee$var$AGG_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $2fb101c0514a00ee$var$AGG_GRAPHQL_SLOW_ENDPOINT = `${$2fb101c0514a00ee$var$AGG_GRAPHQL_ENDPOINT}/slow`;
async function $2fb101c0514a00ee$export$c24d221fbbf75fb3(query, variables, options = {}) {
    const { slow: slow = false } = options;
    const endpoint = slow ? $2fb101c0514a00ee$var$AGG_GRAPHQL_SLOW_ENDPOINT : $2fb101c0514a00ee$var$AGG_GRAPHQL_ENDPOINT;
    const response = await fetch(endpoint, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify({
            query: query,
            variables: variables
        })
    });
    if (!response.ok) throw new $2fb101c0514a00ee$export$953a35594a2cb36(`Request failed with status ${response.status}`, response.status);
    return await response.json();
}
class $2fb101c0514a00ee$export$953a35594a2cb36 extends Error {
    constructor(message, statusCode){
        super(message);
        this.statusCode = void 0;
        this.name = 'AiManagedObjectApiError';
        this.statusCode = statusCode;
    }
}


// ---------------------------------------------------------------------------
// GraphQL fragments, queries, and mutations
// ---------------------------------------------------------------------------
const $ba65f7ed82d217f2$var$AI_MANAGED_OBJECT_FIELDS = `
  fragment AiManagedObjectFields on AiManagedObject {
    id
    lastModifiedBy
    lastExecutedAt
    lastExecutionStatus
    referenceObjectAri
    referenceProduct
    status
    type
    config {
      desiredUpdateFrequency {
        timezone
        type
        value
      }
      goal
      goalOperations
      prompt
      sources {
        app
        url
      }
      version
    }
  }
`;
const $ba65f7ed82d217f2$var$CREATE_AI_MANAGED_OBJECT = `
  mutation CreateAiManagedObject($cloudId: ID!, $input: AiManagedObjectCreateInput!) {
    aiManagedObject_createAiManagedObject(cloudId: $cloudId, input: $input) {
      ...AiManagedObjectFields
    }
  }
  ${$ba65f7ed82d217f2$var$AI_MANAGED_OBJECT_FIELDS}
`;
const $ba65f7ed82d217f2$var$UPDATE_AI_MANAGED_OBJECT = `
  mutation UpdateAiManagedObject($id: ID!, $input: AiManagedObjectUpdateInput!) {
    aiManagedObject_updateAiManagedObject(id: $id, input: $input) {
      ...AiManagedObjectFields
    }
  }
  ${$ba65f7ed82d217f2$var$AI_MANAGED_OBJECT_FIELDS}
`;
const $ba65f7ed82d217f2$var$GET_AI_MANAGED_OBJECT = `
  query GetAiManagedObject($id: ID!) {
    aiManagedObject_aiManagedObject(id: $id) {
      ...AiManagedObjectFields
    }
  }
  ${$ba65f7ed82d217f2$var$AI_MANAGED_OBJECT_FIELDS}
`;
const $ba65f7ed82d217f2$var$EXECUTE_AI_MANAGED_OBJECT = `
  mutation ExecuteAiManagedObject($id: ID!) {
    aiManagedObject_execute(id: $id) {
      aiManagedObject {
        ...AiManagedObjectFields
      }
      output
    }
  }
  ${$ba65f7ed82d217f2$var$AI_MANAGED_OBJECT_FIELDS}
`;
const $ba65f7ed82d217f2$var$ARCHIVE_AI_MANAGED_OBJECT = `
  mutation ArchiveAiManagedObject($id: ID!) {
    aiManagedObject_archiveAiManagedObject(id: $id)
  }
`;
const $ba65f7ed82d217f2$var$REACTIVATE_AI_MANAGED_OBJECT = `
  mutation ReactivateAiManagedObject($id: ID!) {
    aiManagedObject_reactivateAiManagedObject(id: $id)
  }
`;
async function $ba65f7ed82d217f2$export$9d05216757552374(input) {
    const { cloudId: cloudId, ...restInput } = input;
    const result = await (0, $2fb101c0514a00ee$export$c24d221fbbf75fb3)($ba65f7ed82d217f2$var$CREATE_AI_MANAGED_OBJECT, {
        cloudId: cloudId,
        input: restInput
    });
    if (result.errors?.length) throw new (0, $2fb101c0514a00ee$export$953a35594a2cb36)(result.errors.map((e)=>e.message).join('; '));
    const created = result.data?.aiManagedObject_createAiManagedObject;
    if (!created) throw new (0, $2fb101c0514a00ee$export$953a35594a2cb36)('No data returned from createAiManagedObject');
    return created;
}
async function $ba65f7ed82d217f2$export$63ee72a7ec567b23(input) {
    const { id: id, ...restInput } = input;
    const result = await (0, $2fb101c0514a00ee$export$c24d221fbbf75fb3)($ba65f7ed82d217f2$var$UPDATE_AI_MANAGED_OBJECT, {
        id: id,
        input: restInput
    });
    if (result.errors?.length) throw new (0, $2fb101c0514a00ee$export$953a35594a2cb36)(result.errors.map((e)=>e.message).join('; '));
    const updated = result.data?.aiManagedObject_updateAiManagedObject;
    if (!updated) throw new (0, $2fb101c0514a00ee$export$953a35594a2cb36)('No data returned from updateAiManagedObject');
    return updated;
}
async function $ba65f7ed82d217f2$export$6589e15d17afce0c(id) {
    const result = await (0, $2fb101c0514a00ee$export$c24d221fbbf75fb3)($ba65f7ed82d217f2$var$GET_AI_MANAGED_OBJECT, {
        id: id
    });
    if (result.errors?.length) {
        // Treat NOT_FOUND-style errors as null rather than throwing
        const isNotFound = result.errors.some((e)=>e.extensions?.statusCode === 404 || e.extensions?.classification === 'NOT_FOUND' || e.message?.toLowerCase().includes('not found'));
        if (isNotFound) return null;
        throw new (0, $2fb101c0514a00ee$export$953a35594a2cb36)(result.errors.map((e)=>e.message).join('; '));
    }
    return result.data?.aiManagedObject_aiManagedObject ?? null;
}
async function $ba65f7ed82d217f2$export$8235b51c7030883b(id) {
    const result = await (0, $2fb101c0514a00ee$export$c24d221fbbf75fb3)($ba65f7ed82d217f2$var$EXECUTE_AI_MANAGED_OBJECT, {
        id: id
    }, {
        slow: true
    });
    if (result.errors?.length) throw new (0, $2fb101c0514a00ee$export$953a35594a2cb36)(result.errors.map((e)=>e.message).join('; '));
    const executionResult = result.data?.aiManagedObject_execute;
    if (!executionResult) throw new (0, $2fb101c0514a00ee$export$953a35594a2cb36)('No data returned from executeAiManagedObject');
    return executionResult;
}
async function $ba65f7ed82d217f2$export$6818fc88487f401c(id) {
    const result = await (0, $2fb101c0514a00ee$export$c24d221fbbf75fb3)($ba65f7ed82d217f2$var$ARCHIVE_AI_MANAGED_OBJECT, {
        id: id
    });
    if (result.errors?.length) throw new (0, $2fb101c0514a00ee$export$953a35594a2cb36)(result.errors.map((e)=>e.message).join('; '));
    const archived = result.data?.aiManagedObject_archiveAiManagedObject;
    if (archived == null) throw new (0, $2fb101c0514a00ee$export$953a35594a2cb36)('No data returned from archiveAiManagedObject');
    if (!archived) throw new (0, $2fb101c0514a00ee$export$953a35594a2cb36)('archiveAiManagedObject returned false');
}
async function $ba65f7ed82d217f2$export$a20a57558acc0997(id) {
    const result = await (0, $2fb101c0514a00ee$export$c24d221fbbf75fb3)($ba65f7ed82d217f2$var$REACTIVATE_AI_MANAGED_OBJECT, {
        id: id
    });
    if (result.errors?.length) throw new (0, $2fb101c0514a00ee$export$953a35594a2cb36)(result.errors.map((e)=>e.message).join('; '));
    const reactivated = result.data?.aiManagedObject_reactivateAiManagedObject;
    if (reactivated == null) throw new (0, $2fb101c0514a00ee$export$953a35594a2cb36)('No data returned from reactivateAiManagedObject');
    if (!reactivated) throw new (0, $2fb101c0514a00ee$export$953a35594a2cb36)('reactivateAiManagedObject returned false');
}
module.exports["createAiManagedObject"] = $ba65f7ed82d217f2$export$9d05216757552374;
module.exports["updateAiManagedObject"] = $ba65f7ed82d217f2$export$63ee72a7ec567b23;
module.exports["fetchAiManagedObject"] = $ba65f7ed82d217f2$export$6589e15d17afce0c;
module.exports["executeAiManagedObject"] = $ba65f7ed82d217f2$export$8235b51c7030883b;
module.exports["archiveAiManagedObject"] = $ba65f7ed82d217f2$export$6818fc88487f401c;
module.exports["reactivateAiManagedObject"] = $ba65f7ed82d217f2$export$a20a57558acc0997;

});

parcelRegister("4X6m9", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $5lo82 = parcelRequire("5lo82");


var $4HMJH = parcelRequire("4HMJH");

const $cdf0fb09351d055e$export$243049e993020673 = ({ config: config, id: id })=>({
        configVersion: String(config.version ?? ''),
        id: id
    });
const $cdf0fb09351d055e$export$1d94409780da32d7 = (editorView, meta)=>{
    editorView.dispatch($cdf0fb09351d055e$export$f83837a9435c0146(editorView.state.tr, meta));
};
const $cdf0fb09351d055e$export$f83837a9435c0146 = (tr, meta)=>{
    (0, $4HMJH.setMeta)(tr, meta);
    tr.setMeta('addToHistory', false);
    return tr;
};
const $cdf0fb09351d055e$export$8954665daa104974 = (editorView, configLocalId)=>(configLocalId ? (0, $5lo82.findAgentManagedExtensionByLocalId)(editorView.state, configLocalId) : undefined) ?? (0, $5lo82.findAgentManagedExtension)(editorView.state);
const $cdf0fb09351d055e$export$7ed5f72e8921aca5 = (editorView, aimo, localId)=>{
    const tr = editorView.state.tr;
    if ($cdf0fb09351d055e$export$ec063d45d04777d0(editorView.state, tr, aimo, localId)) editorView.dispatch(tr);
};
const $cdf0fb09351d055e$export$ec063d45d04777d0 = (editorState, tr, aimo, localId)=>{
    const currentFound = (0, $5lo82.findAgentManagedExtensionByLocalId)(editorState, localId) ?? (0, $5lo82.findAgentManagedExtension)(editorState);
    if (!currentFound) return false;
    const { node: node, pos: pos } = currentFound;
    const existingAttrs = node.attrs;
    const existingAiManagedObject = (0, $5lo82.getNodeAiManagedObject)(existingAttrs);
    const aiManagedObject = $cdf0fb09351d055e$export$243049e993020673(aimo);
    if (existingAiManagedObject?.id === aiManagedObject.id && existingAiManagedObject.configVersion === aiManagedObject.configVersion) return false;
    const parameters = existingAttrs.parameters ?? {};
    tr.setNodeMarkup(pos, undefined, {
        ...node.attrs,
        parameters: {
            ...parameters,
            macroParams: {
                ...parameters.macroParams,
                aiManagedObject: {
                    // Confluence macro params persist scalar values reliably. Keep
                    // the public node metadata as an object by parsing on read.
                    value: JSON.stringify(aiManagedObject)
                }
            }
        }
    });
    tr.setMeta('addToHistory', false);
    return true;
};
const $cdf0fb09351d055e$var$isRecord = (value)=>Boolean(value) && typeof value === 'object' && !Array.isArray(value);
const $cdf0fb09351d055e$var$getParsedBodyAdf = (bodyAdf)=>{
    if (typeof bodyAdf !== 'string') return bodyAdf;
    try {
        return JSON.parse(bodyAdf);
    } catch  {
        return undefined;
    }
};
const $cdf0fb09351d055e$var$getBodyContentFragment = (editorState, bodyAdf)=>{
    const { schema: schema } = editorState;
    const parsedBodyAdf = $cdf0fb09351d055e$var$getParsedBodyAdf(bodyAdf);
    let contentAdf;
    if (Array.isArray(parsedBodyAdf)) contentAdf = parsedBodyAdf;
    else if ($cdf0fb09351d055e$var$isRecord(parsedBodyAdf) && parsedBodyAdf.type === 'doc' && Array.isArray(parsedBodyAdf.content)) contentAdf = parsedBodyAdf.content;
    else if ($cdf0fb09351d055e$var$isRecord(parsedBodyAdf)) contentAdf = [
        parsedBodyAdf
    ];
    else return undefined;
    const nodes = contentAdf.map((nodeAdf)=>(0, $aPdNQ.Node).fromJSON(schema, nodeAdf));
    nodes.forEach((node)=>node.check());
    return (0, $aPdNQ.Fragment).fromArray(nodes.length > 0 ? nodes : [
        schema.nodes.paragraph.createChecked()
    ]);
};
const $cdf0fb09351d055e$export$9bf0e7e84e355342 = (editorState, tr, bodyAdf, localId)=>{
    const currentFound = (0, $5lo82.findAgentManagedExtensionByLocalId)(editorState, localId) ?? (0, $5lo82.findAgentManagedExtension)(editorState);
    if (!currentFound) return false;
    const bodyContent = $cdf0fb09351d055e$var$getBodyContentFragment(editorState, bodyAdf);
    if (!bodyContent) return false;
    const { node: node, pos: pos } = currentFound;
    tr.replaceWith(pos + 1, pos + node.nodeSize - 1, bodyContent);
    return true;
};
module.exports["getAiManagedObjectParameter"] = $cdf0fb09351d055e$export$243049e993020673;
module.exports["dispatchAgentManagedExtensionMeta"] = $cdf0fb09351d055e$export$1d94409780da32d7;
module.exports["setAgentManagedExtensionMeta"] = $cdf0fb09351d055e$export$f83837a9435c0146;
module.exports["findConfiguredAgentManagedExtension"] = $cdf0fb09351d055e$export$8954665daa104974;
module.exports["setNodeAiManagedObject"] = $cdf0fb09351d055e$export$ec063d45d04777d0;
module.exports["replaceNodeBodyContent"] = $cdf0fb09351d055e$export$9bf0e7e84e355342;

});

parcelRegister("4HMJH", function(module, exports) {

var $eYo03 = parcelRequire("eYo03");


var $5lo82 = parcelRequire("5lo82");


var $cvhuh = parcelRequire("cvhuh");

const $f5cbf74e0e1bd48d$var$META_KEY = 'agentManagedExtension';
const $f5cbf74e0e1bd48d$export$88a8803dc14be868 = (tr, meta)=>tr.setMeta($f5cbf74e0e1bd48d$var$META_KEY, meta);
const $f5cbf74e0e1bd48d$export$c47913ca32a5c6f7 = (tr)=>tr.getMeta($f5cbf74e0e1bd48d$var$META_KEY);
const $f5cbf74e0e1bd48d$export$d4c72bab9d6cc13a = ()=>({
        aiManagedObjectsById: {},
        aiManagedObjectIdsByLocalId: {},
        aiManagedObjectLoadStatusById: {},
        executionErrorLocalIds: {},
        executionLifecycleByLocalId: {},
        isAutoUpdateIntervalOpen: false,
        isConfigOpen: false
    });
const $f5cbf74e0e1bd48d$export$dc1c618ed44aafba = (state)=>(0, $eYo03.pluginKey).getState(state)?.isConfigOpen ?? false;
const $f5cbf74e0e1bd48d$export$b8d7e2929655e39c = (state)=>{
    const pluginState = (0, $eYo03.pluginKey).getState(state);
    return {
        isOpen: pluginState?.isAutoUpdateIntervalOpen ?? false,
        localId: pluginState?.autoUpdateIntervalLocalId
    };
};
const $f5cbf74e0e1bd48d$var$collectLocalIds = (doc)=>{
    const found = new Set();
    doc.descendants((node)=>{
        if (!(0, $5lo82.isAgentManagedExtension)(node)) return true;
        const localId = node.attrs.localId;
        if (localId) found.add(localId);
        return false;
    });
    return found;
};
const $f5cbf74e0e1bd48d$var$findNewLocalIds = (oldState, newState)=>{
    const oldLocalIds = $f5cbf74e0e1bd48d$var$collectLocalIds(oldState.doc);
    const newLocalIds = $f5cbf74e0e1bd48d$var$collectLocalIds(newState.doc);
    return [
        ...newLocalIds
    ].filter((localId)=>!oldLocalIds.has(localId));
};
const $f5cbf74e0e1bd48d$var$isPasteTransaction = (tr)=>Boolean(tr.getMeta('paste') ?? tr.getMeta('uiEvent') === 'paste');
const $f5cbf74e0e1bd48d$var$isLocalUserInsertTransaction = (tr)=>tr.docChanged && !tr.getMeta('isRemote') && !tr.getMeta('replaceDocument') && !$f5cbf74e0e1bd48d$var$isPasteTransaction(tr);
const $f5cbf74e0e1bd48d$var$getSelectedAgentManagedLocalId = (state)=>(0, $5lo82.findAgentManagedExtension)(state)?.node.attrs.localId;
const $f5cbf74e0e1bd48d$var$closeConfig = (prev)=>({
        ...prev,
        autoUpdateIntervalLocalId: undefined,
        configLocalId: undefined,
        isAutoUpdateIntervalOpen: false,
        isConfigOpen: false,
        pendingAutoOpenLocalId: undefined
    });
const $f5cbf74e0e1bd48d$var$openAutoUpdateInterval = (prev, localId)=>({
        ...prev,
        autoUpdateIntervalLocalId: localId,
        configLocalId: undefined,
        isAutoUpdateIntervalOpen: true,
        isConfigOpen: false,
        pendingAutoOpenLocalId: undefined
    });
const $f5cbf74e0e1bd48d$var$closeAutoUpdateInterval = (prev)=>({
        ...prev,
        autoUpdateIntervalLocalId: undefined,
        isAutoUpdateIntervalOpen: false
    });
const $f5cbf74e0e1bd48d$var$toggleAutoUpdateInterval = (prev, localId)=>prev.isAutoUpdateIntervalOpen && prev.autoUpdateIntervalLocalId === localId ? $f5cbf74e0e1bd48d$var$closeAutoUpdateInterval(prev) : $f5cbf74e0e1bd48d$var$openAutoUpdateInterval(prev, localId);
const $f5cbf74e0e1bd48d$var$openConfigForBlock = (prev, newState, localId)=>{
    const target = localId ? (0, $5lo82.findAgentManagedExtensionByLocalId)(newState, localId) : (0, $5lo82.findAgentManagedExtension)(newState);
    const configLocalId = target?.node.attrs.localId;
    if (!configLocalId) return {
        ...prev,
        autoUpdateIntervalLocalId: undefined,
        configLocalId: undefined,
        isAutoUpdateIntervalOpen: false,
        isConfigOpen: false
    };
    return {
        ...prev,
        configLocalId: configLocalId,
        autoUpdateIntervalLocalId: undefined,
        isAutoUpdateIntervalOpen: false,
        isConfigOpen: true,
        pendingAutoOpenLocalId: undefined
    };
};
const $f5cbf74e0e1bd48d$var$startExecution = (prev, localId, requestId, lifecycleState)=>{
    const { [localId]: _removedError, ...executionErrorLocalIds } = prev.executionErrorLocalIds;
    const { [localId]: _removedLifecycle, ...executionLifecycleByLocalId } = prev.executionLifecycleByLocalId;
    return {
        ...prev,
        executionErrorLocalIds: executionErrorLocalIds,
        executionLifecycleByLocalId: {
            ...executionLifecycleByLocalId,
            [localId]: {
                requestId: requestId,
                state: lifecycleState
            }
        }
    };
};
const $f5cbf74e0e1bd48d$var$failExecution = (prev, localId, requestId)=>{
    if (prev.executionLifecycleByLocalId[localId]?.requestId !== requestId) return prev;
    return {
        ...prev,
        executionErrorLocalIds: {
            ...prev.executionErrorLocalIds,
            [localId]: true
        }
    };
};
const $f5cbf74e0e1bd48d$var$finishExecution = (prev, localId, requestId)=>{
    if (prev.executionLifecycleByLocalId[localId]?.requestId !== requestId) return prev;
    const { [localId]: _removedLifecycle, ...executionLifecycleByLocalId } = prev.executionLifecycleByLocalId;
    return {
        ...prev,
        executionLifecycleByLocalId: executionLifecycleByLocalId
    };
};
const $f5cbf74e0e1bd48d$var$applyMetaAction = (prev, meta, newState)=>{
    switch(meta.type){
        case 'CACHE_AI_MANAGED_OBJECT':
            return (0, $cvhuh.cacheAiManagedObjectInPluginState)(prev, meta.aiManagedObject, meta.localId);
        case 'OPEN_AUTO_UPDATE_INTERVAL':
            return $f5cbf74e0e1bd48d$var$openAutoUpdateInterval(prev, meta.localId);
        case 'CLOSE_AUTO_UPDATE_INTERVAL':
            return $f5cbf74e0e1bd48d$var$closeAutoUpdateInterval(prev);
        case 'TOGGLE_AUTO_UPDATE_INTERVAL':
            return $f5cbf74e0e1bd48d$var$toggleAutoUpdateInterval(prev, meta.localId);
        case 'START_AIMO_LOAD':
            return (0, $cvhuh.setAiManagedObjectLoadStatusInPluginState)(prev, meta.aimoId, 'loading', meta.localId);
        case 'FAIL_AIMO_LOAD':
            return (0, $cvhuh.setAiManagedObjectLoadStatusInPluginState)(prev, meta.aimoId, 'failed', meta.localId);
        case 'START_EXECUTION':
            return $f5cbf74e0e1bd48d$var$startExecution(prev, meta.localId, meta.requestId, meta.lifecycleState);
        case 'FAIL_EXECUTION':
            return $f5cbf74e0e1bd48d$var$failExecution(prev, meta.localId, meta.requestId);
        case 'FINISH_EXECUTION':
            return $f5cbf74e0e1bd48d$var$finishExecution(prev, meta.localId, meta.requestId);
        case 'OPEN_CONFIG':
            return $f5cbf74e0e1bd48d$var$openConfigForBlock(prev, newState, meta.localId);
        case 'CLOSE_CONFIG':
            return $f5cbf74e0e1bd48d$var$closeConfig(prev);
        case 'TOGGLE_CONFIG':
            return prev.isConfigOpen ? $f5cbf74e0e1bd48d$var$closeConfig(prev) : $f5cbf74e0e1bd48d$var$openConfigForBlock(prev, newState);
        default:
            return prev;
    }
};
const $f5cbf74e0e1bd48d$export$dc971eca220011b5 = (prev, meta, newState)=>{
    if (!meta) return prev;
    const actions = Array.isArray(meta) ? meta : [
        meta
    ];
    return actions.reduce((nextState, action)=>$f5cbf74e0e1bd48d$var$applyMetaAction(nextState, action, newState), prev);
};
const $f5cbf74e0e1bd48d$export$f172bb0778b94dcf = (prev, tr, oldState, newState)=>{
    if (!$f5cbf74e0e1bd48d$var$isLocalUserInsertTransaction(tr)) return prev;
    const newLocalIds = $f5cbf74e0e1bd48d$var$findNewLocalIds(oldState, newState);
    if (newLocalIds.length !== 1) return prev;
    return {
        ...prev,
        pendingAutoOpenLocalId: newLocalIds[0]
    };
};
const $f5cbf74e0e1bd48d$export$ed1fbe84aea74733 = (prev, tr, newState)=>{
    if (!tr.selectionSet) return prev;
    const selectedLocalId = $f5cbf74e0e1bd48d$var$getSelectedAgentManagedLocalId(newState);
    let nextState = prev;
    if (prev.isAutoUpdateIntervalOpen && (!selectedLocalId || selectedLocalId !== prev.autoUpdateIntervalLocalId)) nextState = $f5cbf74e0e1bd48d$var$closeAutoUpdateInterval(nextState);
    if (!nextState.isConfigOpen) return nextState;
    if (selectedLocalId && selectedLocalId === nextState.configLocalId) return nextState;
    return {
        ...nextState,
        configLocalId: undefined,
        isConfigOpen: false,
        pendingAutoOpenLocalId: undefined
    };
};
module.exports["setMeta"] = $f5cbf74e0e1bd48d$export$88a8803dc14be868;
module.exports["getMeta"] = $f5cbf74e0e1bd48d$export$c47913ca32a5c6f7;
module.exports["initialState"] = $f5cbf74e0e1bd48d$export$d4c72bab9d6cc13a;
module.exports["getAutoUpdateIntervalTargetFromState"] = $f5cbf74e0e1bd48d$export$b8d7e2929655e39c;
module.exports["applyMeta"] = $f5cbf74e0e1bd48d$export$dc971eca220011b5;
module.exports["applyAutoOpenOnInsert"] = $f5cbf74e0e1bd48d$export$f172bb0778b94dcf;
module.exports["applyAutoCloseOnSelectionChange"] = $f5cbf74e0e1bd48d$export$ed1fbe84aea74733;

});

parcelRegister("cvhuh", function(module, exports) {

var $eYo03 = parcelRequire("eYo03");

const $5071644c3fd072b3$export$fb64e3189f6a8b74 = (pluginState, aimoId)=>pluginState?.aiManagedObjectsById?.[aimoId];
const $5071644c3fd072b3$export$74ea48bebce2aaa3 = (state, aimoId)=>$5071644c3fd072b3$export$fb64e3189f6a8b74((0, $eYo03.pluginKey).getState(state), aimoId);
const $5071644c3fd072b3$export$493b987ffc9c6ed = (pluginState, aimoId)=>aimoId ? pluginState?.aiManagedObjectLoadStatusById?.[aimoId] : undefined;
const $5071644c3fd072b3$export$883c5adee59477ac = (state, aimoId)=>$5071644c3fd072b3$export$493b987ffc9c6ed((0, $eYo03.pluginKey).getState(state), aimoId);
const $5071644c3fd072b3$export$a190249fc74f618e = (pluginState, localId)=>{
    const aimoId = localId ? pluginState?.aiManagedObjectIdsByLocalId[localId] : undefined;
    return aimoId ? $5071644c3fd072b3$export$fb64e3189f6a8b74(pluginState, aimoId) : undefined;
};
const $5071644c3fd072b3$export$2b78ae5d11ad7a3d = (pluginState, localId)=>{
    const aimoId = localId ? pluginState?.aiManagedObjectIdsByLocalId[localId] : undefined;
    return $5071644c3fd072b3$export$493b987ffc9c6ed(pluginState, aimoId);
};
const $5071644c3fd072b3$export$855a63f7e761e3e0 = (prev, aiManagedObject, localId)=>{
    const { [aiManagedObject.id]: _removedLoadStatus, ...aiManagedObjectLoadStatusById } = prev.aiManagedObjectLoadStatusById;
    return {
        ...prev,
        aiManagedObjectIdsByLocalId: localId ? {
            ...prev.aiManagedObjectIdsByLocalId,
            [localId]: aiManagedObject.id
        } : prev.aiManagedObjectIdsByLocalId,
        aiManagedObjectsById: {
            ...prev.aiManagedObjectsById,
            [aiManagedObject.id]: aiManagedObject
        },
        aiManagedObjectLoadStatusById: aiManagedObjectLoadStatusById
    };
};
const $5071644c3fd072b3$export$988483d0ff280023 = (prev, aimoId, status, localId)=>({
        ...prev,
        aiManagedObjectIdsByLocalId: localId ? {
            ...prev.aiManagedObjectIdsByLocalId,
            [localId]: aimoId
        } : prev.aiManagedObjectIdsByLocalId,
        aiManagedObjectLoadStatusById: {
            ...prev.aiManagedObjectLoadStatusById,
            [aimoId]: status
        }
    });
module.exports["getCachedAiManagedObjectFromPluginState"] = $5071644c3fd072b3$export$fb64e3189f6a8b74;
module.exports["getCachedAiManagedObjectFromState"] = $5071644c3fd072b3$export$74ea48bebce2aaa3;
module.exports["getAiManagedObjectLoadStatusFromPluginState"] = $5071644c3fd072b3$export$493b987ffc9c6ed;
module.exports["getAiManagedObjectLoadStatusFromState"] = $5071644c3fd072b3$export$883c5adee59477ac;
module.exports["getCachedAiManagedObjectByLocalIdFromPluginState"] = $5071644c3fd072b3$export$a190249fc74f618e;
module.exports["getAiManagedObjectLoadStatusByLocalIdFromPluginState"] = $5071644c3fd072b3$export$2b78ae5d11ad7a3d;
module.exports["cacheAiManagedObjectInPluginState"] = $5071644c3fd072b3$export$855a63f7e761e3e0;
module.exports["setAiManagedObjectLoadStatusInPluginState"] = $5071644c3fd072b3$export$988483d0ff280023;

});

parcelRegister("1tIRv", function(module, exports) {

var $4HMJH = parcelRequire("4HMJH");

const $78caae81778c5bd4$var$dispatchMeta = (meta)=>({ tr: tr })=>{
        (0, $4HMJH.setMeta)(tr, meta);
        tr.setMeta('addToHistory', false);
        return tr;
    };
const $78caae81778c5bd4$export$6ab73a0f6a2dedbd = ()=>$78caae81778c5bd4$var$dispatchMeta({
        type: 'OPEN_CONFIG'
    });
const $78caae81778c5bd4$export$fdec615f1fb6136e = ()=>$78caae81778c5bd4$var$dispatchMeta({
        type: 'CLOSE_CONFIG'
    });
const $78caae81778c5bd4$export$154fc2a614d19abc = ()=>$78caae81778c5bd4$var$dispatchMeta({
        type: 'TOGGLE_CONFIG'
    });
const $78caae81778c5bd4$export$fc45dd51dd1c777a = (aiManagedObject, localId)=>({
        aiManagedObject: aiManagedObject,
        localId: localId,
        type: 'CACHE_AI_MANAGED_OBJECT'
    });
const $78caae81778c5bd4$var$getStartAiManagedObjectLoadMeta = (aimoId, localId)=>({
        aimoId: aimoId,
        localId: localId,
        type: 'START_AIMO_LOAD'
    });
const $78caae81778c5bd4$var$getFailAiManagedObjectLoadMeta = (aimoId, localId)=>({
        aimoId: aimoId,
        localId: localId,
        type: 'FAIL_AIMO_LOAD'
    });
const $78caae81778c5bd4$export$e04cafc153b0e975 = (aiManagedObject, localId)=>$78caae81778c5bd4$var$dispatchMeta($78caae81778c5bd4$export$fc45dd51dd1c777a(aiManagedObject, localId));
const $78caae81778c5bd4$export$c96ab19c9b3b9153 = (aimoId, localId)=>$78caae81778c5bd4$var$dispatchMeta($78caae81778c5bd4$var$getStartAiManagedObjectLoadMeta(aimoId, localId));
const $78caae81778c5bd4$export$facc64fcbc2df2d2 = (aimoId, localId)=>$78caae81778c5bd4$var$dispatchMeta($78caae81778c5bd4$var$getFailAiManagedObjectLoadMeta(aimoId, localId));
module.exports["openConfig"] = $78caae81778c5bd4$export$6ab73a0f6a2dedbd;
module.exports["closeConfig"] = $78caae81778c5bd4$export$fdec615f1fb6136e;
module.exports["toggleConfig"] = $78caae81778c5bd4$export$154fc2a614d19abc;
module.exports["getCacheAiManagedObjectMeta"] = $78caae81778c5bd4$export$fc45dd51dd1c777a;
module.exports["cacheAiManagedObject"] = $78caae81778c5bd4$export$e04cafc153b0e975;
module.exports["startAiManagedObjectLoad"] = $78caae81778c5bd4$export$c96ab19c9b3b9153;
module.exports["failAiManagedObjectLoad"] = $78caae81778c5bd4$export$facc64fcbc2df2d2;

});

parcelRegister("3og17", function(module, exports) {

let $278009a3186895be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $278009a3186895be$var$load("5XuQQ").then(()=>parcelRequire('307vi'));

});

parcelRegister("dq7fL", function(module, exports) {

let $9c53546e45f75829$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9c53546e45f75829$var$load("i7vSS").then(()=>parcelRequire('ew6l0'));

});

parcelRegister("ez9s8", function(module, exports) {

let $a9abaab090e03f44$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a9abaab090e03f44$var$load("3Lk1s").then(()=>parcelRequire('bsD5Z'));

});

parcelRegister("aenax", function(module, exports) {

let $772d2f15974b8e4d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $772d2f15974b8e4d$var$load("eN9Y4").then(()=>parcelRequire('b30JW'));

});

parcelRegister("9vMEa", function(module, exports) {

let $6eccbe8f094fcd96$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6eccbe8f094fcd96$var$load("CfmiU").then(()=>parcelRequire('gWsFk'));

});

parcelRegister("kIuhf", function(module, exports) {

var $56j2k = parcelRequire("56j2k");


var $heBrg = parcelRequire("heBrg");

const $8b9224d600385d27$export$b1b8dab78d04f9b9 = (count = (0, $56j2k.DEFAULT_TAB_COUNT))=>{
    const tabs = [];
    const frames = [];
    for(let i = 0; i < count; i += 1){
        tabs.push({
            id: (0, $heBrg.generateTabId)(),
            title: (0, $56j2k.getDefaultTabTitle)(i)
        });
        frames.push({
            type: 'extensionFrame',
            content: [
                {
                    type: 'paragraph'
                }
            ]
        });
    }
    return {
        tabs: tabs,
        frames: frames
    };
};
const $8b9224d600385d27$export$b7c68ae3ee40cac3 = (currentTabs, options)=>{
    const newTab = {
        id: (0, $heBrg.generateTabId)(),
        title: (0, $56j2k.getDefaultTabTitle)(currentTabs.length),
        ...options?.applyToAll && options.globalColor !== undefined ? {
            color: options.globalColor
        } : {}
    };
    return {
        tabs: [
            ...currentTabs,
            newTab
        ],
        newTab: newTab
    };
};
const $8b9224d600385d27$export$972c857c0ab45437 = (parameters, frameCount)=>(parameters?.tabs ?? []).length === frameCount;
const $8b9224d600385d27$var$repairTabsListForFrameCount = (currentTabs, frameCount)=>{
    const tabs = currentTabs.slice(0, frameCount);
    for(let i = tabs.length; i < frameCount; i += 1)tabs.push({
        id: (0, $heBrg.generateTabId)(),
        title: (0, $56j2k.getDefaultTabTitle)(i)
    });
    return tabs;
};
const $8b9224d600385d27$export$562249f0767b155a = (parameters, frameCount)=>({
        tabs: $8b9224d600385d27$var$repairTabsListForFrameCount(parameters?.tabs ?? [], frameCount),
        ...parameters?.applyToAll !== undefined ? {
            applyToAll: parameters.applyToAll
        } : {}
    });
module.exports["buildDefaultParameters"] = $8b9224d600385d27$export$b1b8dab78d04f9b9;
module.exports["appendTab"] = $8b9224d600385d27$export$b7c68ae3ee40cac3;
module.exports["meetsTabsIntegrity"] = $8b9224d600385d27$export$972c857c0ab45437;
module.exports["repairTabsForFrameCount"] = $8b9224d600385d27$export$562249f0767b155a;

});

parcelRegister("heBrg", function(module, exports) {
/**
 * Generates a compact 6-char base36 id for a tab handle.
 *
 * Scoped to a single extension instance — collision probability for
 * up to a few hundred tabs per instance is negligible (~36^6 ≈ 2.18B).
 * Not cryptographically secure (uses `Math.random`); tab ids are not
 * a security boundary.
 */ const $839d5de4c52ab93e$export$c490856f450b09c6 = ()=>{
    let id = Math.random().toString(36).slice(2, 8);
    // Defensive pad: very rarely Math.random produces a trailing run of zeros
    // that get stripped by toString(36); top up to 6 chars.
    while(id.length < 6)id += Math.random().toString(36).slice(2);
    return id;
};
module.exports["generateTabId"] = $839d5de4c52ab93e$export$c490856f450b09c6;

});

parcelRegister("ixTN9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5bAC0 = parcelRequire("5bAC0");


var $56j2k = parcelRequire("56j2k");

const $46bc82440ed7037d$var$i18n = (0, $kSwu1.defineMessages)({
    tabsExtensionTitle: {
        id: "native-tabs.extension.title.non-final",
        defaultMessage: "Tabs"
    },
    tabsExtensionDescription: {
        id: "native-tabs.extension.description.non-final",
        defaultMessage: "Organize content with clickable tabs"
    }
});
const $46bc82440ed7037d$var$NativeTabsIcon = ({ label: label = 'Tabs', size: size })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5bAC0))), {
        label: label,
        size: size
    });
const $46bc82440ed7037d$export$fbced299fe97e028 = (intl)=>{
    const title = intl.formatMessage($46bc82440ed7037d$var$i18n.tabsExtensionTitle);
    const description = intl.formatMessage($46bc82440ed7037d$var$i18n.tabsExtensionDescription);
    const Icon = ({ label: label = title, size: size } = {})=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($46bc82440ed7037d$var$NativeTabsIcon, {
            label: label,
            size: size
        });
    return {
        icon: Icon,
        manifest: {
            title: title,
            type: (0, $56j2k.EXTENSION_TYPE),
            key: (0, $56j2k.EXTENSION_KEY),
            description: description,
            icons: {
                '48': async ()=>Icon
            }
        }
    };
};
module.exports["buildBaseManifest"] = $46bc82440ed7037d$export$fbced299fe97e028;

});

parcelRegister("5bAC0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::94be1d1872b273caa51a0ea423eb015d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c6a61353e13353e$var$_react = $3c6a61353e13353e$var$_interopRequireDefault((parcelRequire("cozmU")));

var $3c6a61353e13353e$var$_iconNew = $3c6a61353e13353e$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $3c6a61353e13353e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tabs".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/tabs
 * Usage guidance:
 * Known uses: tabs macro feature from the slash command menu in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3c6a61353e13353e$var$TabsIcon = (props)=>/*#__PURE__*/ $3c6a61353e13353e$var$_react.default.createElement($3c6a61353e13353e$var$_iconNew.default, Object.assign({
        name: "TabsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.75 1c.78 0 1.467.397 1.871 1h6.504C15.161 2 16 2.84 16 3.875V13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V6.5h-6a2 2 0 0 1-2-2V3.25a.75.75 0 0 0-.75-.75zM12 5h2.5V3.875a.375.375 0 0 0-.375-.375H12zm-4-.5a.5.5 0 0 0 .5.5h2V3.5H8z"/>`
    }, props));
$3c6a61353e13353e$var$TabsIcon.displayName = 'TabsIcon';
var $3c6a61353e13353e$var$_default = module.exports.default = $3c6a61353e13353e$var$TabsIcon;

});

parcelRegister("lVgnR", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $ipqo7 = parcelRequire("ipqo7");

const $12e6d06854f63a40$var$i18n = (0, $kSwu1.defineMessages)({
    untitledTab: {
        id: "native-tabs.block-transform.untitled-tab.ai-non-final",
        defaultMessage: "Tab {number}"
    }
});
// Panel accepts a narrower block set than Native Tabs frames, so known-invalid conversions stay
// hidden before Block Menu performs its final schema and insertion-position validation.
const $12e6d06854f63a40$var$panelContentTypes = new Set([
    'blockCard',
    'bulletList',
    'codeBlock',
    'decisionList',
    'extension',
    'heading',
    'mediaGroup',
    'mediaSingle',
    'orderedList',
    'paragraph',
    'rule',
    'taskList'
]);
const $12e6d06854f63a40$var$tableCellContentTypes = new Set([
    'blockCard',
    'blockquote',
    'bulletList',
    'codeBlock',
    'decisionList',
    'embedCard',
    'extension',
    'heading',
    'mediaGroup',
    'mediaSingle',
    'orderedList',
    'panel',
    'paragraph',
    'rule',
    'taskList',
    'unsupportedBlock'
]);
const $12e6d06854f63a40$var$isRecord = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value);
const $12e6d06854f63a40$var$isAdfEntity = (value)=>$12e6d06854f63a40$var$isRecord(value) && typeof value.type === 'string';
const $12e6d06854f63a40$var$isAdfContent = (content)=>content.every($12e6d06854f63a40$var$isAdfEntity);
const $12e6d06854f63a40$var$getTransformItems = (source, intl)=>{
    if (source.type !== 'multiBodiedExtension') return null;
    const tabs = source.attrs?.parameters?.tabs;
    const frames = source.content;
    if (!Array.isArray(tabs) || !Array.isArray(frames) || tabs.length === 0 || tabs.length !== frames.length) return null;
    const items = [];
    for (const [index, tab] of tabs.entries()){
        if (!$12e6d06854f63a40$var$isRecord(tab)) return null;
        const frame = frames[index];
        if (!$12e6d06854f63a40$var$isAdfEntity(frame) || frame.type !== 'extensionFrame') return null;
        const frameContent = Array.isArray(frame.content) ? frame.content : [];
        if (!$12e6d06854f63a40$var$isAdfContent(frameContent)) return null;
        const metadata = tab;
        const title = typeof metadata.title === 'string' && metadata.title.trim().length > 0 ? metadata.title : intl.formatMessage($12e6d06854f63a40$var$i18n.untitledTab, {
            number: index + 1
        });
        items.push({
            color: (0, $ipqo7.getPanelColorForTabColor)(metadata.color),
            content: frameContent,
            emoji: typeof metadata.emoji === 'string' ? metadata.emoji : undefined,
            title: title
        });
    }
    return items;
};
const $12e6d06854f63a40$var$createEmojiNode = (emoji)=>{
    const isEmojiId = /^[a-z0-9_-]+$/i.test(emoji);
    return {
        type: 'emoji',
        attrs: isEmojiId ? {
            shortName: emoji,
            id: emoji,
            text: emoji
        } : {
            shortName: emoji,
            text: emoji
        }
    };
};
const $12e6d06854f63a40$var$createTitleParagraph = (title, emoji)=>({
        type: 'paragraph',
        content: [
            ...emoji ? [
                $12e6d06854f63a40$var$createEmojiNode(emoji),
                {
                    type: 'text',
                    text: ' '
                }
            ] : [],
            {
                type: 'text',
                text: title
            }
        ]
    });
const $12e6d06854f63a40$var$createExpand = (item)=>({
        type: 'expand',
        attrs: {
            localId: crypto.randomUUID(),
            title: item.title
        },
        content: item.content
    });
const $12e6d06854f63a40$var$createPanel = (item, targetTypeName)=>({
        type: targetTypeName,
        attrs: {
            localId: crypto.randomUUID(),
            panelType: 'custom',
            ...item.color ? {
                panelColor: item.color
            } : {},
            ...item.emoji ? {
                panelIcon: item.emoji,
                panelIconId: item.emoji,
                panelIconText: item.emoji
            } : {}
        },
        content: [
            $12e6d06854f63a40$var$createTitleParagraph(item.title),
            ...item.content
        ]
    });
const $12e6d06854f63a40$var$createLayoutSection = (items)=>{
    const width = Number((100 / items.length).toFixed(2));
    return {
        type: 'layoutSection',
        content: items.map((item)=>({
                type: 'layoutColumn',
                attrs: {
                    width: width
                },
                content: [
                    $12e6d06854f63a40$var$createTitleParagraph(item.title, item.emoji),
                    ...item.content
                ]
            }))
    };
};
const $12e6d06854f63a40$var$createLayout = (items)=>{
    const sections = [];
    for(let index = 0; index < items.length; index += 5)sections.push($12e6d06854f63a40$var$createLayoutSection(items.slice(index, index + 5)));
    return sections;
};
const $12e6d06854f63a40$var$createTable = (items, tableWidth)=>({
        type: 'table',
        attrs: {
            localId: crypto.randomUUID(),
            ...tableWidth ? {
                width: tableWidth
            } : {}
        },
        content: [
            {
                type: 'tableRow',
                attrs: {
                    localId: crypto.randomUUID()
                },
                content: items.map((item)=>({
                        type: 'tableHeader',
                        attrs: {
                            localId: crypto.randomUUID(),
                            // Table's color picker compares the raw `background` attr against lower-case
                            // palette values, so store table header backgrounds in lower-case hex.
                            ...item.color ? {
                                background: item.color.toLowerCase()
                            } : {}
                        },
                        content: [
                            $12e6d06854f63a40$var$createTitleParagraph(item.title, item.emoji)
                        ]
                    }))
            },
            {
                type: 'tableRow',
                attrs: {
                    localId: crypto.randomUUID()
                },
                content: items.map((item)=>({
                        type: 'tableCell',
                        attrs: {
                            localId: crypto.randomUUID()
                        },
                        content: item.content
                    }))
            }
        ]
    });
const $12e6d06854f63a40$var$toResult = (output)=>output.length > 0 ? {
        output: output
    } : null;
const $12e6d06854f63a40$var$isPanelContentSupported = (item)=>item.content.every((node)=>$12e6d06854f63a40$var$panelContentTypes.has(node.type));
const $12e6d06854f63a40$var$isTableContentSupported = (item)=>item.content.every((node)=>$12e6d06854f63a40$var$tableCellContentTypes.has(node.type));
const $12e6d06854f63a40$var$isTargetSupported = (items, targetTypeName)=>{
    if (targetTypeName === 'layoutSection') return items.length >= 2;
    if (targetTypeName === 'panel' || targetTypeName === 'panel_c1') return items.every($12e6d06854f63a40$var$isPanelContentSupported);
    if (targetTypeName === 'table') return items.every($12e6d06854f63a40$var$isTableContentSupported);
    return targetTypeName === 'expand';
};
const $12e6d06854f63a40$export$720c525173769f1a = (intl, options = {})=>({
        isSupported: ({ source: source, targetTypeName: targetTypeName })=>{
            const items = $12e6d06854f63a40$var$getTransformItems(source, intl);
            if (!items) return false;
            return $12e6d06854f63a40$var$isTargetSupported(items, targetTypeName);
        },
        key: 'confluence-native-tabs',
        transform: ({ source: source, targetTypeName: targetTypeName })=>{
            const items = $12e6d06854f63a40$var$getTransformItems(source, intl);
            if (!items || !$12e6d06854f63a40$var$isTargetSupported(items, targetTypeName)) return null;
            if (targetTypeName === 'expand') return $12e6d06854f63a40$var$toResult(items.map($12e6d06854f63a40$var$createExpand));
            if (targetTypeName === 'panel' || targetTypeName === 'panel_c1') return $12e6d06854f63a40$var$toResult(items.map((item)=>$12e6d06854f63a40$var$createPanel(item, targetTypeName)));
            if (targetTypeName === 'layoutSection') return $12e6d06854f63a40$var$toResult($12e6d06854f63a40$var$createLayout(items));
            if (targetTypeName === 'table') return $12e6d06854f63a40$var$toResult([
                $12e6d06854f63a40$var$createTable(items, options.tableWidth)
            ]);
            return null;
        }
    });
module.exports["getNativeTabsBlockTransform"] = $12e6d06854f63a40$export$720c525173769f1a;

});

parcelRegister("725X8", function(module, exports) {

let $51ed5666947764eb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $51ed5666947764eb$var$load("6wr18"),
    $51ed5666947764eb$var$load("1xDdE"),
    $51ed5666947764eb$var$load("dlYE2"),
    $51ed5666947764eb$var$load("1fGjB"),
    $51ed5666947764eb$var$load("bxj2D"),
    $51ed5666947764eb$var$load("ffEVr"),
    $51ed5666947764eb$var$load("Wowvf"),
    $51ed5666947764eb$var$load("8KaCS"),
    $51ed5666947764eb$var$load("6SzM6"),
    $51ed5666947764eb$var$load("5Obzi")
]).then(()=>parcelRequire('bGshI'));

});

parcelRegister("2fGKa", function(module, exports) {

let $1a3e23789d7e17e0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1a3e23789d7e17e0$var$load("8ikac"),
    $1a3e23789d7e17e0$var$load("58WtS"),
    $1a3e23789d7e17e0$var$load("1olsN"),
    $1a3e23789d7e17e0$var$load("cyDpt"),
    $1a3e23789d7e17e0$var$load("6wr18"),
    $1a3e23789d7e17e0$var$load("fE5au"),
    $1a3e23789d7e17e0$var$load("1xDdE"),
    $1a3e23789d7e17e0$var$load("1fGjB"),
    $1a3e23789d7e17e0$var$load("bxj2D"),
    $1a3e23789d7e17e0$var$load("Wowvf"),
    $1a3e23789d7e17e0$var$load("ffEVr"),
    $1a3e23789d7e17e0$var$load("03rqT")
]).then(()=>parcelRequire('5p9jx'));

});

parcelRegister("b4ALZ", function(module, exports) {

let $80fc97cf3f3f4d02$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $80fc97cf3f3f4d02$var$load("gCHto").then(()=>parcelRequire('47bbw'));

});

parcelRegister("Qcu7n", function(module, exports) {
/**
 * Resolves the correct macro extension key.
 *
 * Handles the migration from Connect questionslist-macro to native
 * questionslist-macro-native by remapping the legacy key to the native one.
 */ const $faff5e0943db906b$export$141553e7ddf20c24 = (extensionKey)=>{
    if (extensionKey === 'questionslist-macro') return 'questionslist-macro-native';
    return extensionKey;
};
const $faff5e0943db906b$export$23818186db3523fd = (macroKey)=>{
    if (macroKey === 'questionslist-macro') return false;
    return true;
};
module.exports["resolveQuestionsMacroExtensionKey"] = $faff5e0943db906b$export$141553e7ddf20c24;
module.exports["shouldIncludeMacroInQuickInsert"] = $faff5e0943db906b$export$23818186db3523fd;

});

parcelRegister("cV0On", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $94a28c7ac9ed7f37$export$cccbb2118061f032 = [
    'chart',
    'contributors-summary',
    'gallery',
    'google-drive-docs',
    'google-drive-sheets',
    'google-drive-slides',
    'index',
    'viewppt',
    'viewdoc',
    'recently-updated-dashboard',
    'related-labels',
    'spaces',
    'span'
];
const $94a28c7ac9ed7f37$export$adfeadb35be8d156 = 'https://support.atlassian.com/confluence-cloud/docs/learn-which-macros-are-being-removed/';
const $94a28c7ac9ed7f37$export$9d00c2217e733ab2 = (extensionKey)=>{
    if ($94a28c7ac9ed7f37$export$cccbb2118061f032.includes(extensionKey) && (0, $9wGTI.fg)('deprecating_low_usage_macros')) switch(extensionKey){
        case 'chart':
            return (0, $9wGTI.fg)('confluence_deprecate_chart_macro');
        case 'contributors-summary':
            return (0, $9wGTI.fg)('confluence_deprecate_contributors_summary');
        case 'gallery':
            return (0, $9wGTI.fg)('confluence_deprecate_gallery_macro');
        case 'google-drive-docs':
            return (0, $9wGTI.fg)('confluence_deprecate_google_drive_macro');
        case 'google-drive-sheets':
            return (0, $9wGTI.fg)('confluence_deprecate_google_drive_macro');
        case 'google-drive-slides':
            return (0, $9wGTI.fg)('confluence_deprecate_google_drive_macro');
        case 'index':
            return (0, $9wGTI.fg)('confluence_deprecate_page_index_macro');
        case 'viewppt':
            return (0, $9wGTI.fg)('confluence_deprecate_powerpoint_macro');
        case 'viewdoc':
            return (0, $9wGTI.fg)('confluence_deprecate_word_macro');
        case 'recently-updated-dashboard':
            return (0, $9wGTI.fg)('confluence_deprecate_recently_updated_dashboard');
        case 'related-labels':
            return (0, $9wGTI.fg)('confluence_deprecate_related_labels_macro');
        case 'spaces':
            return (0, $9wGTI.fg)('confluence_deprecate_spaces_list_macro');
        case 'span':
            return (0, $9wGTI.fg)('confluence_deprecate_span_macro');
        default:
            return false;
    }
    return false;
};
module.exports["DEPRECATED_MACROS"] = $94a28c7ac9ed7f37$export$cccbb2118061f032;
module.exports["MACRO_DEPRECATION_INFO_URL"] = $94a28c7ac9ed7f37$export$adfeadb35be8d156;
module.exports["isMacroDeprecated"] = $94a28c7ac9ed7f37$export$9d00c2217e733ab2;

});

parcelRegister("lyokC", function(module, exports) {

let $fb0fa5ab199510fb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fb0fa5ab199510fb$var$load("8ikac"),
    $fb0fa5ab199510fb$var$load("58WtS"),
    $fb0fa5ab199510fb$var$load("1olsN"),
    $fb0fa5ab199510fb$var$load("cyDpt"),
    $fb0fa5ab199510fb$var$load("ebXHc"),
    $fb0fa5ab199510fb$var$load("fWCBZ"),
    $fb0fa5ab199510fb$var$load("43z9c"),
    $fb0fa5ab199510fb$var$load("6wr18"),
    $fb0fa5ab199510fb$var$load("5EJB0"),
    $fb0fa5ab199510fb$var$load("53Y0O"),
    $fb0fa5ab199510fb$var$load("kYlwR"),
    $fb0fa5ab199510fb$var$load("RylUf"),
    $fb0fa5ab199510fb$var$load("dtNxV"),
    $fb0fa5ab199510fb$var$load("jXx9i"),
    $fb0fa5ab199510fb$var$load("e3Gt5"),
    $fb0fa5ab199510fb$var$load("9zpfi"),
    $fb0fa5ab199510fb$var$load("9pNir"),
    $fb0fa5ab199510fb$var$load("ffEVr"),
    $fb0fa5ab199510fb$var$load("kDVdu"),
    $fb0fa5ab199510fb$var$load("8Jd6S"),
    $fb0fa5ab199510fb$var$load("lixsQ"),
    $fb0fa5ab199510fb$var$load("9iWFV"),
    $fb0fa5ab199510fb$var$load("fkGqG"),
    $fb0fa5ab199510fb$var$load("6zCMk"),
    $fb0fa5ab199510fb$var$load("g4jdB"),
    $fb0fa5ab199510fb$var$load("6f0Yj"),
    $fb0fa5ab199510fb$var$load("fwbNS"),
    $fb0fa5ab199510fb$var$load("ckGjo"),
    $fb0fa5ab199510fb$var$load("kGmwI"),
    $fb0fa5ab199510fb$var$load("9gCvF"),
    $fb0fa5ab199510fb$var$load("ayJxT"),
    $fb0fa5ab199510fb$var$load("hhss7"),
    $fb0fa5ab199510fb$var$load("kT6dz"),
    $fb0fa5ab199510fb$var$load("aAWLw"),
    $fb0fa5ab199510fb$var$load("jjWia")
]).then(()=>parcelRequire('liyuV'));

});

parcelRegister("dgMPt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $77ec1934d08f9c33$export$aa662dd09c22e89d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "jkeTg",
    name: "GlobalQuestionsListMacroHandler",
    loader: async ()=>(await (parcelRequire("9zxxF"))).GlobalQuestionsListMacroHandler
});
module.exports["GlobalQuestionsListMacroHandler"] = $77ec1934d08f9c33$export$aa662dd09c22e89d;

});

parcelRegister("9zxxF", function(module, exports) {

let $6f8166b3bebd9c1d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6f8166b3bebd9c1d$var$load("6wr18"),
    $6f8166b3bebd9c1d$var$load("7NQuo"),
    $6f8166b3bebd9c1d$var$load("1GCFv"),
    $6f8166b3bebd9c1d$var$load("7EorR"),
    $6f8166b3bebd9c1d$var$load("ffEVr"),
    $6f8166b3bebd9c1d$var$load("3aVUP")
]).then(()=>parcelRequire('kDxBO'));

});

parcelRegister("5h7sn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $eS4Za = parcelRequire("eS4Za");


var $8pcS0 = parcelRequire("8pcS0");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $aJPUt = parcelRequire("aJPUt");


var $lrmHr = parcelRequire("lrmHr");


var $7y0YZ = parcelRequire("7y0YZ");


var $1d1K5 = parcelRequire("1d1K5");


var $79lDc = parcelRequire("79lDc");

const $9ac0f262dcfc95d3$export$28dc7f04b737fd63 = ({ contentId: contentId, contextProviders: contextProviders })=>(0, $eS4Za.createMacroExtensionHandler)((extension)=>{
        if (!extension) return null;
        const { extensionKey: extensionKey, parameters: parameters } = extension;
        const { ClassicEditorContextProvider: ClassicEditorContextProvider = ({ children: children })=>children } = contextProviders;
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extension);
        let implementation;
        const defaultProps = {
            contentId: contentId,
            mode: (0, $5kjCz.EDITOR),
            extensionKey: extensionKey,
            node: extension
        };
        switch(extensionKey){
            case (0, $8pcS0.EXTENSION_KEY).INVALID:
                // extension is rendered outside of React DOM tree and require access to the ClassicEditorContext
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ClassicEditorContextProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7y0YZ.InvalidExtensionLoader), {
                    parameters: parameters,
                    ...defaultProps
                }));
                break;
            case (0, $8pcS0.EXTENSION_KEY).INLINE_EXTERNAL_IMAGE:
                const inlineExtImageProps = parameters;
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lrmHr.InlineExternalImage), {
                    ...inlineExtImageProps,
                    ...defaultProps
                });
                break;
            case (0, $8pcS0.EXTENSION_KEY).INLINE_MEDIA_IMAGE:
                const inlineMediaImageProps = parameters;
                const { link: link } = parameters;
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1d1K5.InlineImage), {
                    ...inlineMediaImageProps,
                    ...defaultProps,
                    link: link
                });
                break;
            case (0, $8pcS0.EXTENSION_KEY).LEGACY_CONTENT:
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $79lDc.LegacyContentExtensionHandler), defaultProps);
                break;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: (0, $5kjCz.getExperienceName)((0, $5kjCz.EDITOR), extension),
            contentId: contentId,
            mode: (0, $5kjCz.EDITOR),
            extensionKey: extensionKey,
            attributes: attributes,
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
        }), implementation);
    });
module.exports["getMigrationExtHandlerForEditor"] = $9ac0f262dcfc95d3$export$28dc7f04b737fd63;

});

parcelRegister("gMz8j", function(module, exports) {

let $c37c61b88cbbeebd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c37c61b88cbbeebd$var$load("6wr18"),
    $c37c61b88cbbeebd$var$load("io60f"),
    $c37c61b88cbbeebd$var$load("dkoen"),
    $c37c61b88cbbeebd$var$load("aoih9"),
    $c37c61b88cbbeebd$var$load("5YLV5"),
    $c37c61b88cbbeebd$var$load("fR7a0"),
    $c37c61b88cbbeebd$var$load("gA528"),
    $c37c61b88cbbeebd$var$load("ffEVr"),
    $c37c61b88cbbeebd$var$load("h3G8d")
]).then(()=>parcelRequire('cul1e'));

});

parcelRegister("c7Q3h", function(module, exports) {

let $8d3e83ed58f4f3ea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8d3e83ed58f4f3ea$var$load("9vDBp"),
    $8d3e83ed58f4f3ea$var$load("RI3SR"),
    $8d3e83ed58f4f3ea$var$load("8iQSt")
]).then(()=>parcelRequire('6842f'));

});

parcelRegister("79lDc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a114cedef1505cfa$export$91aed7d8dfc4aa1f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "qiYRw",
    name: "LegacyContentExtensionHandler",
    loader: async ()=>(await (parcelRequire("e5bYl"))).LegacyContentExtensionHandler
});
module.exports["LegacyContentExtensionHandler"] = $a114cedef1505cfa$export$91aed7d8dfc4aa1f;

});

parcelRegister("e5bYl", function(module, exports) {

let $a40ad1c0ed16e1a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a40ad1c0ed16e1a4$var$load("6MdJu"),
    $a40ad1c0ed16e1a4$var$load("1olsN"),
    $a40ad1c0ed16e1a4$var$load("cyDpt"),
    $a40ad1c0ed16e1a4$var$load("1Pi84"),
    $a40ad1c0ed16e1a4$var$load("8LtYa"),
    $a40ad1c0ed16e1a4$var$load("4t77a"),
    $a40ad1c0ed16e1a4$var$load("8rgnV")
]).then(()=>parcelRequire('gmxua'));

});

parcelRegister("7NX4e", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2HGN8 = parcelRequire("2HGN8");


var $hMRhJ = parcelRequire("hMRhJ");


var $giS6h = parcelRequire("giS6h");


var $jJli4 = parcelRequire("jJli4");


var $gnzsm = parcelRequire("gnzsm");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

/**
 * Extension handler for "excerpt-include" macro.
 *
 * This macro, when given a target page, will attempt to fetch and display
 * the first excerpt found on the target page.
 */ const $98ab978010b85277$var$ExcerptIncludeExtensionHandlerImpl = (props)=>{
    const { contentId: contentId, spaceKey: spaceKey, extensionKey: extensionKey, node: node, mode: mode, Renderer: Renderer, isLivePage: isLivePage, getHeadingLinkPath: getHeadingLinkPath } = props;
    const { contentAppearance: { appearance: appearance } } = (0, $2HGN8.useContentAppearance)();
    const RendererWrapper = (0, $cozmU.useMemo)(()=>({ targetContentId: targetContentId, adf: adf, mediaToken: mediaToken, isInsideOfInlineExtension: isInsideOfInlineExtension, headingIdPrefix: headingIdPrefix, getHeadingLink: getHeadingLink })=>{
            let allowHeadingAnchorLinks;
            if ((0, $6mKj3.expValEquals)('confluence_toc_included_content_exp', 'isEnabled', true)) {
                // Only override the heading link when we have a real path builder
                // (editor / live-page paths), where the platform default would
                // otherwise produce the *edit* URL. On the view-page renderer path
                // `getHeadingLinkPath` is undefined, so we omit the override and let
                // the platform default (`getCurrentUrlWithHash` — current page URL +
                // hash) apply, matching normal (non-included) headings.
                const resolvedGetHeadingLink = getHeadingLink ?? (getHeadingLinkPath ? (headingId)=>(0, $gnzsm.createHeadingLink)(getHeadingLinkPath, headingId) ?? '' : undefined);
                allowHeadingAnchorLinks = {
                    allowNestedHeaderLinks: true,
                    ...resolvedGetHeadingLink ? {
                        getHeadingLink: resolvedGetHeadingLink
                    } : {}
                };
            }
            const rendererProps = {
                contentId: targetContentId,
                spaceKey: spaceKey,
                // Transform the adf data into something PageContentRenderer understands (matching with content API response)
                data: {
                    content: {
                        nodes: [
                            {
                                body: {
                                    dynamic: {
                                        representation: 'atlas_doc_format',
                                        value: JSON.stringify({
                                            content: adf,
                                            type: 'doc'
                                        }) // Have to transform this back to a string :(
                                    }
                                }
                            }
                        ]
                    }
                },
                appearance: appearance,
                hasInlineComments: false,
                mediaToken: mediaToken,
                headingIdPrefix: headingIdPrefix,
                allowHeadingAnchorLinks: allowHeadingAnchorLinks,
                annotationProvider: undefined,
                allowAnnotations: false,
                isInsideOfInlineExtension: isInsideOfInlineExtension
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Renderer, rendererProps);
        }, [
        spaceKey,
        appearance,
        Renderer,
        getHeadingLinkPath
    ]);
    const componentProps = {
        mode: mode,
        contentId: contentId,
        spaceKey: spaceKey,
        extensionKey: extensionKey,
        macroNode: node,
        RendererWrapper: RendererWrapper,
        isLegacyRenderer: true,
        isLivePage: isLivePage
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJli4.ExcerptIncludeLoader), componentProps);
};
const $98ab978010b85277$export$c9121b65b8e7bfb = (props)=>{
    const { getExtensionHandlers: getExtensionHandlers, populateExtensionProviders: populateExtensionProviders, getHeadingLinkPath: getHeadingLinkPath } = (0, $cozmU.useContext)((0, $giS6h.ClassicEditorContext));
    const rendererExtensionOptions = (0, $cozmU.useMemo)(()=>({
            getExtensionHandlers: getExtensionHandlers,
            populateExtensionProviders: populateExtensionProviders,
            getHeadingLinkPath: getHeadingLinkPath
        }), [
        getExtensionHandlers,
        populateExtensionProviders,
        getHeadingLinkPath
    ]);
    // New version history doesn't store page widths, so always use default appearance
    // to avoid layout breakage when the actual source page is full-width
    const isVersionHistoryView = (0, $dPJCf.useRouteName)({
        selector: (routeName)=>routeName === (0, $1NBp8.CONTENT_HISTORY).name
    });
    // ExcerptInclude use PageContentRenderer which depends on RendererExtensionContext
    // New version history doesn't store page widths, so skip ContentAppearanceContextProvider
    // in version history to avoid layout breakage when the actual source page is full-width
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMRhJ.RendererExtensionContext).Provider, {
        value: rendererExtensionOptions
    }, isVersionHistoryView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($98ab978010b85277$var$ExcerptIncludeExtensionHandlerImpl, {
        ...props,
        getHeadingLinkPath: getHeadingLinkPath
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2HGN8.ContentAppearanceContextProvider), {
        contentId: props.contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($98ab978010b85277$var$ExcerptIncludeExtensionHandlerImpl, {
        ...props,
        getHeadingLinkPath: getHeadingLinkPath
    })));
};
module.exports["ExcerptIncludeExtensionHandler"] = $98ab978010b85277$export$c9121b65b8e7bfb;

});

parcelRegister("l8XTa", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8Ksv7 = parcelRequire("8Ksv7");


var $2oP7l = parcelRequire("2oP7l");

const $e2da6a71c8c8a211$export$44b3939aef06d313 = ({ Renderer: Renderer, appearance: appearance, macroParams: macroParams, ...macroDefaultProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2oP7l.NestedAdfRendererWrapperProvider), {
        Renderer: Renderer,
        appearance: appearance
    }, (RendererWrapper)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Ksv7.BlogPostsMacroHandler), {
            macroDefaultProps: macroDefaultProps,
            macroParams: macroParams,
            RendererWrapper: RendererWrapper
        }));
module.exports["BlogPostsExtensionHandler"] = $e2da6a71c8c8a211$export$44b3939aef06d313;

});

parcelRegister("2n2cE", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aP3K1 = parcelRequire("aP3K1");


var $2oP7l = parcelRequire("2oP7l");

const $879b0c3a16515022$export$515d7b80af1ed5d7 = ({ Renderer: Renderer, appearance: appearance, macroParams: macroParams, ...macroDefaultProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2oP7l.NestedAdfRendererWrapperProvider), {
        Renderer: Renderer,
        appearance: appearance
    }, (RendererWrapper)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aP3K1.ContentByLabelMacroHandler), {
            macroDefaultProps: macroDefaultProps,
            macroParams: macroParams,
            RendererWrapper: RendererWrapper
        }));
module.exports["ContentByLabelExtensionHandler"] = $879b0c3a16515022$export$515d7b80af1ed5d7;

});

parcelRegister("18Eyu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ZJvdP = parcelRequire("ZJvdP");


var $2oP7l = parcelRequire("2oP7l");

const $846f3dafcdd6e0aa$export$b231c38d77061882 = ({ Renderer: Renderer, appearance: appearance, macroParams: macroParams, ...macroDefaultProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2oP7l.NestedAdfRendererWrapperProvider), {
        Renderer: Renderer,
        appearance: appearance
    }, (RendererWrapper)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ZJvdP.PageIncludeMacroHandler), {
            macroDefaultProps: macroDefaultProps,
            macroParams: macroParams,
            RendererWrapper: RendererWrapper
        }));
module.exports["PageIncludeExtensionHandler"] = $846f3dafcdd6e0aa$export$b231c38d77061882;

});

parcelRegister("aIqlA", function(module, exports) {

var $eNbr2 = parcelRequire("eNbr2");


var $2lPWP = parcelRequire("2lPWP");


var $iDrrr = parcelRequire("iDrrr");


var $9cGsb = parcelRequire("9cGsb");


var $bLswh = parcelRequire("bLswh");


var $9PdUw = parcelRequire("9PdUw");

const $7e94665fb6a19916$export$5e2bcfbdd2ce465e = 'configUserPicker';
class $7e94665fb6a19916$export$2191b9da168c6cf0 extends Error {
    constructor(message){
        super(message);
        Object.setPrototypeOf(this, $7e94665fb6a19916$export$2191b9da168c6cf0.prototype);
    }
}
const $7e94665fb6a19916$export$d856d2d55ba6ad50 = `For this app to display, you need to press the Allow Access button in the
macro to allow the app to access Atlassian products on your behalf.`;
function $7e94665fb6a19916$var$findDefaultValue(options, isMulti) {
    const defaultValues = options.reduce((acc, { props: props })=>{
        if (props) for (const prop of [
            'defaultChecked',
            'defaultSelected'
        ]){
            if (prop in props) return [
                ...acc,
                props.value
            ];
        }
        return acc;
    }, []);
    return isMulti ? defaultValues : defaultValues[0];
}
const $7e94665fb6a19916$var$findItems = (options)=>options.map(({ props: props, type: type })=>{
        if (!props) throw new Error(`Props are undefined on ${type}`);
        return {
            label: props.label,
            value: props.value
        };
    });
const $7e94665fb6a19916$var$fieldMap = {
    TextField: (props)=>({
            type: 'string',
            name: props.name,
            label: props.label,
            description: props.description,
            defaultValue: props.defaultValue,
            isRequired: props.isRequired,
            isHidden: props.isHidden,
            placeholder: props.placeholder
        }),
    DatePicker: (props)=>({
            type: 'date',
            name: props.name,
            label: props.label,
            description: props.description,
            defaultValue: props.defaultValue,
            isRequired: props.isRequired,
            placeholder: props.placeholder
        }),
    Select: (props, children)=>({
            type: 'enum',
            name: props.name,
            label: props.label,
            description: props.description,
            isRequired: props.isRequired,
            style: 'select',
            isMultiple: props.isMulti,
            placeholder: props.placeholder,
            items: $7e94665fb6a19916$var$findItems(children),
            defaultValue: $7e94665fb6a19916$var$findDefaultValue(children, props.isMulti)
        }),
    CheckboxGroup: (props, children)=>({
            type: 'enum',
            name: props.name,
            label: props.label,
            description: props.description,
            isRequired: props.isRequired,
            style: 'checkbox',
            isMultiple: true,
            items: $7e94665fb6a19916$var$findItems(children),
            defaultValue: $7e94665fb6a19916$var$findDefaultValue(children, true)
        }),
    RadioGroup: (props, children)=>({
            type: 'enum',
            name: props.name,
            label: props.label,
            description: props.description,
            isRequired: props.isRequired,
            style: 'radio',
            isMultiple: false,
            items: $7e94665fb6a19916$var$findItems(children),
            defaultValue: $7e94665fb6a19916$var$findDefaultValue(children, false)
        }),
    UserPicker: (props)=>({
            type: 'user',
            name: props.name,
            label: props.label,
            isMultiple: props.isMulti,
            isRequired: props.isRequired,
            options: {
                provider: {
                    type: $7e94665fb6a19916$export$5e2bcfbdd2ce465e
                }
            },
            placeholder: props.placeholder,
            description: props.description,
            defaultValue: props.defaultValue
        }),
    TextArea: (props)=>({
            type: 'string',
            name: props.name,
            style: 'multiline',
            label: props.label,
            placeholder: props.placeholder,
            description: props.description,
            isRequired: props.isRequired,
            defaultValue: props.defaultValue
        })
};
const $7e94665fb6a19916$var$getSelectDefaultValue = (options, isMulti)=>{
    if (!options) return undefined;
    if (Array.isArray(options)) return isMulti ? options.map((option)=>option.value) : options[0].value;
    return options.value;
};
const $7e94665fb6a19916$var$codegenComponentFieldMap = {
    Textfield: (props)=>({
            type: 'string',
            name: props.name,
            label: props.label,
            description: props.description,
            defaultValue: props.defaultValue,
            isRequired: props.isRequired,
            isHidden: props.isHidden,
            placeholder: props.placeholder
        }),
    DatePicker: (props)=>({
            type: 'date',
            name: props.name,
            label: props.label,
            defaultValue: props.defaultValue,
            isRequired: props.isRequired,
            placeholder: props.placeholder
        }),
    Select: (props)=>({
            type: 'enum',
            name: props.name,
            label: props.label,
            description: props.description,
            isRequired: props.isRequired,
            style: 'select',
            isMultiple: props.isMulti,
            placeholder: props.placeholder,
            items: props.options,
            defaultValue: $7e94665fb6a19916$var$getSelectDefaultValue(props.defaultValue, props.isMulti)
        }),
    CheckboxGroup: (props)=>({
            type: 'enum',
            name: props.name,
            label: props.label,
            isRequired: props.isRequired,
            isMultiple: true,
            style: 'checkbox',
            items: props.options,
            defaultValue: props.defaultValue
        }),
    RadioGroup: (props)=>({
            type: 'enum',
            name: props.name,
            label: props.label,
            isRequired: props.isRequired,
            style: 'radio',
            isMultiple: false,
            items: props.options,
            defaultValue: props.defaultValue
        }),
    UserPicker: (props)=>({
            type: 'user',
            name: props.name,
            label: props.label,
            isMultiple: props.isMulti,
            isRequired: props.isRequired,
            options: {
                provider: {
                    type: $7e94665fb6a19916$export$5e2bcfbdd2ce465e
                }
            },
            placeholder: props.placeholder,
            description: props.description,
            defaultValue: props.defaultValue
        }),
    TextArea: (props)=>({
            type: 'string',
            name: props.name,
            style: 'multiline',
            label: props.label,
            placeholder: props.placeholder,
            isRequired: props.isRequired,
            defaultValue: props.defaultValue
        })
};
/** The shape of the XIS error is "Expected direct child of MacroConfig to be one of [...]. Received <component> component."
 * for each component, which is not ideal if the app contains multiple invalid components as the first part repeats.
 */ const $7e94665fb6a19916$var$formatErrorDetailsFromXIS = (errorDetails)=>{
    let invalidComponentArr = [];
    const regex = /Received (.*?) component/g;
    let match;
    while((match = regex.exec(errorDetails)) !== null){
        const [_, component] = match;
        invalidComponentArr.push(component);
    }
    return $7e94665fb6a19916$var$createValidationError(invalidComponentArr);
};
const $7e94665fb6a19916$var$createValidationError = (invalidComponentTypes)=>{
    // Filter out duplicate types. e.g. if there were multiple Images we only need to mention it once.
    // Error shouldn't look like: "Image and Image components are not supported in macro config"
    const types = Array.from(new Set(invalidComponentTypes));
    return `${types.length === 1 ? '' : `${types.slice(0, -1).join(', ')} and`} ${types.slice(-1)} components are not supported in macro config`;
};
const $7e94665fb6a19916$var$toLabelInferredForgeDoc = (configForgeDoc)=>{
    const newConfigForgeDoc = [];
    let previousNodeLabel = null;
    configForgeDoc.forEach(({ children: children, props: props, type: type, ...rest })=>{
        const newProps = {
            ...props
        };
        if (previousNodeLabel && type !== 'Label') {
            newProps.label = previousNodeLabel;
            previousNodeLabel = null;
        } else if (type === 'Label') previousNodeLabel = children[0]?.props?.text ?? null;
        else if (props && !props.label) newProps.label = '';
        newConfigForgeDoc.push({
            ...rest,
            children: children,
            type: type,
            props: newProps
        });
    });
    return newConfigForgeDoc;
};
const $7e94665fb6a19916$export$bc2ca0929473b0d4 = (configChildren, forgeReactMajorVersion)=>{
    /* For codegen components, the label prop does not exist on the component, so we are allowing users to add <Label/> components to format their config the same way.
     This requires the following mutation where the label text gets applied to the next component. Editor also requires a label component in their mapping
     (see https://product-fabric.atlassian.net/wiki/spaces/E/pages/1245610891/Extension+configuration) so we must mutate the props like so.
   */ const configChildrenClone = $7e94665fb6a19916$var$toLabelInferredForgeDoc(configChildren);
    const schema = forgeReactMajorVersion && forgeReactMajorVersion >= 10 ? configChildrenClone.filter((forgeDoc)=>forgeDoc.type !== 'Label').map(({ children: children, props: props, type: type })=>{
        if (!$7e94665fb6a19916$var$codegenComponentFieldMap[type]) return type;
        return $7e94665fb6a19916$var$codegenComponentFieldMap[type](props || {}, children);
    }) : configChildren.map(({ children: children, props: props, type: type })=>{
        if (!$7e94665fb6a19916$var$fieldMap[type]) return type;
        return $7e94665fb6a19916$var$fieldMap[type](props || {}, children);
    });
    // Check if any validation errors occured
    const invalidComponentTypes = schema.filter((field)=>typeof field === 'string');
    if (invalidComponentTypes.length > 0) throw new $7e94665fb6a19916$export$2191b9da168c6cf0($7e94665fb6a19916$var$createValidationError(invalidComponentTypes));
    return schema;
};
const $7e94665fb6a19916$export$1f45aada55d3f94 = (forgeDoc)=>{
    const forgeReactMajorVersion = forgeDoc.children[0]?.forgeReactMajorVersion;
    for (const { type: type, props: props, children: children } of forgeDoc.children){
        if (type === 'ErrorPanel' && props) {
            const { error: { errorMessage: errorMessage, errorDetails: errorDetails } } = props;
            if (errorMessage.includes('Validation error') && errorDetails.includes('Expected direct child of MacroConfig to be one of')) throw new $7e94665fb6a19916$export$2191b9da168c6cf0($7e94665fb6a19916$var$formatErrorDetailsFromXIS(errorDetails));
            throw new Error(`${errorDetails || errorMessage || ''}`);
        }
        if (type === 'ThreeLOPrompt') throw new Error($7e94665fb6a19916$export$d856d2d55ba6ad50);
        if (type === 'MacroConfig') return $7e94665fb6a19916$export$bc2ca0929473b0d4(children, forgeReactMajorVersion);
    }
    throw new Error('<MacroConfig> must be used at the root');
};


var $hRcC4 = parcelRequire("hRcC4");
const $0e17dde5dc080ea0$export$44487a86467333c3 = ({ config: config, guestParams: guestParams })=>guestParams || config;
const $0e17dde5dc080ea0$export$c995c5854d98b6ef = (parameters)=>$0e17dde5dc080ea0$export$44487a86467333c3(parameters);
const $0e17dde5dc080ea0$export$33006db0d9b837ff = (parameters)=>({
        guestParams: parameters
    });


var $87Lnp = parcelRequire("87Lnp");

// lib/isZodErrorLike.ts

var $ddnoW = parcelRequire("ddnoW");


var $hIlhY = parcelRequire("hIlhY");

function $e8943b36ad55f730$export$1a9c93cf4c5ae6b(err) {
    return err instanceof Error && err.name === "ZodError" && "issues" in err && Array.isArray(err.issues);
}
// lib/ValidationError.ts
var $e8943b36ad55f730$export$2191b9da168c6cf0 = class extends Error {
    toString() {
        return this.message;
    }
    constructor(message, options){
        super(message, options), (0, $ddnoW._)(this, "name", void 0), (0, $ddnoW._)(this, "details", void 0);
        this.name = "ZodValidationError";
        this.details = $e8943b36ad55f730$var$getIssuesFromErrorOptions(options);
    }
};
function $e8943b36ad55f730$var$getIssuesFromErrorOptions(options) {
    if (options) {
        const cause = options.cause;
        if ($e8943b36ad55f730$export$1a9c93cf4c5ae6b(cause)) return cause.issues;
    }
    return [];
}
// lib/isValidationError.ts
function $e8943b36ad55f730$export$f715db496ec47204(err) {
    return err instanceof $e8943b36ad55f730$export$2191b9da168c6cf0;
}
// lib/isValidationErrorLike.ts
function $e8943b36ad55f730$export$cb29fc10431ed2ef(err) {
    return err instanceof Error && err.name === "ZodValidationError";
}
// lib/utils/NonEmptyArray.ts
function $e8943b36ad55f730$var$isNonEmptyArray(value) {
    return value.length !== 0;
}
// lib/utils/joinPath.ts
var $e8943b36ad55f730$var$identifierRegex = RegExp("[$_\\p{ID_Start}][$\\u200c\\u200d\\p{ID_Continue}]*", "u");
function $e8943b36ad55f730$var$joinPath(path) {
    if (path.length === 1) return path[0].toString();
    return path.reduce((acc, item)=>{
        if (typeof item === "number") return acc + "[" + item.toString() + "]";
        if (item.includes('"')) return acc + '["' + $e8943b36ad55f730$var$escapeQuotes(item) + '"]';
        if (!$e8943b36ad55f730$var$identifierRegex.test(item)) return acc + '["' + item + '"]';
        const separator = acc.length === 0 ? "" : ".";
        return acc + separator + item;
    }, "");
}
function $e8943b36ad55f730$var$escapeQuotes(str) {
    return str.replace(/"/g, '\\"');
}
// lib/config.ts
var $e8943b36ad55f730$var$ISSUE_SEPARATOR = "; ";
var $e8943b36ad55f730$var$MAX_ISSUES_IN_MESSAGE = 99;
var $e8943b36ad55f730$var$PREFIX = "Validation error";
var $e8943b36ad55f730$var$PREFIX_SEPARATOR = ": ";
var $e8943b36ad55f730$var$UNION_SEPARATOR = ", or ";
// lib/MessageBuilder.ts
function $e8943b36ad55f730$export$3b08560649d6c7b9(props = {}) {
    const { issueSeparator: issueSeparator = $e8943b36ad55f730$var$ISSUE_SEPARATOR, unionSeparator: unionSeparator = $e8943b36ad55f730$var$UNION_SEPARATOR, prefixSeparator: prefixSeparator = $e8943b36ad55f730$var$PREFIX_SEPARATOR, prefix: prefix = $e8943b36ad55f730$var$PREFIX, includePath: includePath = true, maxIssuesInMessage: maxIssuesInMessage = $e8943b36ad55f730$var$MAX_ISSUES_IN_MESSAGE } = props;
    return (issues)=>{
        const message = issues.slice(0, maxIssuesInMessage).map((issue)=>$e8943b36ad55f730$var$getMessageFromZodIssue({
                issue: issue,
                issueSeparator: issueSeparator,
                unionSeparator: unionSeparator,
                includePath: includePath
            })).join(issueSeparator);
        return $e8943b36ad55f730$var$prefixMessage(message, prefix, prefixSeparator);
    };
}
function $e8943b36ad55f730$var$getMessageFromZodIssue(props) {
    const { issue: issue, issueSeparator: issueSeparator, unionSeparator: unionSeparator, includePath: includePath } = props;
    if (issue.code === $hIlhY.ZodIssueCode.invalid_union) return issue.unionErrors.reduce((acc, zodError)=>{
        const newIssues = zodError.issues.map((issue2)=>$e8943b36ad55f730$var$getMessageFromZodIssue({
                issue: issue2,
                issueSeparator: issueSeparator,
                unionSeparator: unionSeparator,
                includePath: includePath
            })).join(issueSeparator);
        if (!acc.includes(newIssues)) acc.push(newIssues);
        return acc;
    }, []).join(unionSeparator);
    if (issue.code === $hIlhY.ZodIssueCode.invalid_arguments) return [
        issue.message,
        ...issue.argumentsError.issues.map((issue2)=>$e8943b36ad55f730$var$getMessageFromZodIssue({
                issue: issue2,
                issueSeparator: issueSeparator,
                unionSeparator: unionSeparator,
                includePath: includePath
            }))
    ].join(issueSeparator);
    if (issue.code === $hIlhY.ZodIssueCode.invalid_return_type) return [
        issue.message,
        ...issue.returnTypeError.issues.map((issue2)=>$e8943b36ad55f730$var$getMessageFromZodIssue({
                issue: issue2,
                issueSeparator: issueSeparator,
                unionSeparator: unionSeparator,
                includePath: includePath
            }))
    ].join(issueSeparator);
    if (includePath && $e8943b36ad55f730$var$isNonEmptyArray(issue.path)) {
        if (issue.path.length === 1) {
            const identifier = issue.path[0];
            if (typeof identifier === "number") return `${issue.message} at index ${identifier}`;
        }
        return `${issue.message} at "${$e8943b36ad55f730$var$joinPath(issue.path)}"`;
    }
    return issue.message;
}
function $e8943b36ad55f730$var$prefixMessage(message, prefix, prefixSeparator) {
    if (prefix !== null) {
        if (message.length > 0) return [
            prefix,
            message
        ].join(prefixSeparator);
        return prefix;
    }
    if (message.length > 0) return message;
    return $e8943b36ad55f730$var$PREFIX;
}
// lib/fromZodIssue.ts
function $e8943b36ad55f730$export$c7733c549e56da8b(issue, options = {}) {
    const messageBuilder = $e8943b36ad55f730$var$createMessageBuilderFromOptions(options);
    const message = messageBuilder([
        issue
    ]);
    return new $e8943b36ad55f730$export$2191b9da168c6cf0(message, {
        cause: new $hIlhY.ZodError([
            issue
        ])
    });
}
function $e8943b36ad55f730$var$createMessageBuilderFromOptions(options) {
    if ("messageBuilder" in options) return options.messageBuilder;
    return $e8943b36ad55f730$export$3b08560649d6c7b9(options);
}
// lib/errorMap.ts
var $e8943b36ad55f730$export$2c018edeeb9ce969 = (issue, ctx)=>{
    const error = $e8943b36ad55f730$export$c7733c549e56da8b({
        ...issue,
        // fallback to the default error message
        // when issue does not have a message
        message: issue.message ?? ctx.defaultError
    });
    return {
        message: error.message
    };
};
// lib/fromZodError.ts
function $e8943b36ad55f730$export$7952627fdcb1e348(zodError, options = {}) {
    if (!$e8943b36ad55f730$export$1a9c93cf4c5ae6b(zodError)) throw new TypeError(`Invalid zodError param; expected instance of ZodError. Did you mean to use the "${$e8943b36ad55f730$export$4fd972edbe7450d3.name}" method instead?`);
    return $e8943b36ad55f730$var$fromZodErrorWithoutRuntimeCheck(zodError, options);
}
function $e8943b36ad55f730$var$fromZodErrorWithoutRuntimeCheck(zodError, options = {}) {
    const zodIssues = zodError.errors;
    let message;
    if ($e8943b36ad55f730$var$isNonEmptyArray(zodIssues)) {
        const messageBuilder = $e8943b36ad55f730$var$createMessageBuilderFromOptions2(options);
        message = messageBuilder(zodIssues);
    } else message = zodError.message;
    return new $e8943b36ad55f730$export$2191b9da168c6cf0(message, {
        cause: zodError
    });
}
function $e8943b36ad55f730$var$createMessageBuilderFromOptions2(options) {
    if ("messageBuilder" in options) return options.messageBuilder;
    return $e8943b36ad55f730$export$3b08560649d6c7b9(options);
}
// lib/toValidationError.ts
var $e8943b36ad55f730$export$4995a8d075259da0 = (options = {})=>(err)=>{
        if ($e8943b36ad55f730$export$1a9c93cf4c5ae6b(err)) return $e8943b36ad55f730$var$fromZodErrorWithoutRuntimeCheck(err, options);
        if (err instanceof Error) return new $e8943b36ad55f730$export$2191b9da168c6cf0(err.message, {
            cause: err
        });
        return new $e8943b36ad55f730$export$2191b9da168c6cf0("Unknown error");
    };
// lib/fromError.ts
function $e8943b36ad55f730$export$4fd972edbe7450d3(err, options = {}) {
    return $e8943b36ad55f730$export$4995a8d075259da0(options)(err);
}
 //# sourceMappingURL=index.mjs.map



var $4XbfY = parcelRequire("4XbfY");


var $dHQOi = parcelRequire("dHQOi");

var $4AavA = parcelRequire("4AavA");


var $3ztIq = parcelRequire("3ztIq");


var $iNIw3 = parcelRequire("iNIw3");

const $509cf1f98caebc07$export$d6710954d38d35b9 = (data, { isBodiedExtension: isBodiedExtension, isInitialInsertion: isInitialInsertion, schema: schema })=>{
    if (!$509cf1f98caebc07$var$isObject(data)) throw new $509cf1f98caebc07$export$62e82e1130ec89d2('Must provide payload object', 'INVALID_PAYLOAD');
    const { config: config, keepEditing: keepEditing } = data;
    const body = data.body || data.insertBody;
    if (!$509cf1f98caebc07$var$isObject(config)) throw new $509cf1f98caebc07$export$62e82e1130ec89d2('Invalid "config" provided. Expected object', 'INVALID_CONFIG');
    try {
        $509cf1f98caebc07$var$validateMacroConfig(config);
    } catch (error) {
        throw new $509cf1f98caebc07$export$62e82e1130ec89d2($509cf1f98caebc07$var$processMacroConfigError(error), 'INVALID_CONFIG');
    }
    // Only worth validating the body if it's actually going to be used
    if (body) {
        if (!isBodiedExtension) throw new $509cf1f98caebc07$export$62e82e1130ec89d2('Cannot set "body" for non bodied extension', 'INVALID_EXTENSION_TYPE');
        // We need to do basic validation of the body before we can safely do proper ADF validation
        if (!$509cf1f98caebc07$var$isDocNodeShape(body)) throw new $509cf1f98caebc07$export$62e82e1130ec89d2('Invalid ADF "body" provided. Expected node of type doc with content', 'INVALID_BODY');
        const { valid: valid, errors: errors } = $509cf1f98caebc07$var$validateAdfBody(body, schema);
        if (!valid || errors.length) throw new $509cf1f98caebc07$export$62e82e1130ec89d2(`Invalid ADF "body" provided.\n${errors.map((e)=>`${e.code}: ${e.message}`).join('\n')}`, 'INVALID_BODY');
    }
    return {
        config: config,
        keepEditing: Boolean(keepEditing),
        body: body ? body : undefined
    };
};
const $509cf1f98caebc07$export$4537e246a5edda0a = (error)=>{
    if (error instanceof Error && error.message.includes('Could not find node')) throw new $509cf1f98caebc07$export$62e82e1130ec89d2('Macro not found.', 'MACRO_NOT_FOUND');
    throw error;
};
const $509cf1f98caebc07$var$isObject = (obj)=>{
    return obj !== null && typeof obj === 'object' && !Array.isArray(obj);
};
const $509cf1f98caebc07$var$isDocNodeShape = (body)=>{
    return $509cf1f98caebc07$var$isObject(body) && body.type === 'doc' && Array.isArray(body.content);
};
class $509cf1f98caebc07$export$62e82e1130ec89d2 extends Error {
    constructor(message, code){
        super($509cf1f98caebc07$var$prefixMessage(message));
        this.code = void 0;
        this.code = code;
    }
}
/**
 * Recursively finds the deepest "invalid_union" issue in the unionErrors array.
 * @param unionErrors The unionErrors array to search
 * @returns The error message and path of the deepest "invalid_union" issue
 */ const $509cf1f98caebc07$var$findDeepestUnionError = (unionErrors)=>{
    // Check if there are nested union errors:
    const nestedIssues = unionErrors.filter((error)=>error?.issues.some((issue)=>issue.code === 'invalid_union'));
    if (nestedIssues.length) {
        // Grab the first issue (it doesn't matter for union errors which one we pick)
        const firstNestedIssue = nestedIssues[0].issues[0];
        if (firstNestedIssue.code === 'invalid_union') return $509cf1f98caebc07$var$findDeepestUnionError(firstNestedIssue.unionErrors);
    }
    // This works due to the way zod generates error messages for union types:
    // For a union type, zod generates one error message for each entry in the union
    // So we know that there will be at least one entry in the "issues" array
    return {
        message: unionErrors[0].issues[0].message,
        path: unionErrors[0].issues[0].path
    };
};
/**
 * Builds a user-friendly error message from the zod validation issues.
 * @param issues The issues generated by the zod validation
 * @returns A list of user-friendly error messages
 */ const $509cf1f98caebc07$var$simplifyErrorMessage = (issues)=>{
    // There are two problems with the way that zod creates error messages
    // 1. For nested entries, one error message is generated for each level of nesting.
    // 2. For union types, one error message is generated for each entry in the union.
    // This code attempts to improve the error message by:
    // 1. For nested entries, only using the error message for the deepest level of nesting.
    // 2. For union types, only using the error message for the first entry in the union.
    return issues.reduce((acc, issue)=>{
        // We're only interested in changing the format for "invalid_union" issues
        if (issue.code === 'invalid_union') {
            const deepestError = $509cf1f98caebc07$var$findDeepestUnionError(issue.unionErrors);
            acc.push({
                message: deepestError.message,
                path: deepestError.path
            });
        } else acc.push({
            message: issue.message,
            path: issue.path
        });
        return acc;
    }, []).reduce((prev, { message: message, path: path })=>prev + `${message} at "${path.join('.')}"\n`, '');
};
/**
 * Processes the error thrown by the zod validation and returns a user-friendly error message.
 * @param error The error thrown by the zod validation
 * @returns A user-friendly error message
 */ const $509cf1f98caebc07$var$processMacroConfigError = (error)=>{
    const validationError = (0, $e8943b36ad55f730$export$4fd972edbe7450d3)(error, {
        messageBuilder: $509cf1f98caebc07$var$simplifyErrorMessage,
        prefix: null
    });
    return validationError.message;
};
/**
 * Validates the macro config object using zod.
 * @param config The macro config object to validate
 * @throws If the config object is invalid
 * @returns void
 */ const $509cf1f98caebc07$var$validateMacroConfig = (config)=>{
    // These are the rules for the zod schema:
    // 1. Allowed values are: string, number, boolean, array, object
    // 2. When arrays are used, all entries must contain the same data type
    // 3. Objects can be nested and contain any of the allowed values
    // 4. Arrays can not be nested
    // Define a recursive schema to handle nested objects and arrays
    const jsonSchema = (0, $87Lnp.z).lazy(()=>(0, $87Lnp.z).union([
            (0, $87Lnp.z).undefined(),
            (0, $87Lnp.z).string(),
            (0, $87Lnp.z).number(),
            (0, $87Lnp.z).boolean(),
            (0, $87Lnp.z).object({}).catchall(jsonSchema),
            // Objects can contain any of the allowed values, including nested objects
            (0, $87Lnp.z).array((0, $87Lnp.z).union([
                (0, $87Lnp.z).string(),
                (0, $87Lnp.z).number(),
                (0, $87Lnp.z).boolean(),
                (0, $87Lnp.z).object({}).catchall(jsonSchema)
            ])).superRefine((value, ctx)=>{
                // Check if all items in the array have the same type
                if (value.length > 0) {
                    const typeOfFirstItem = typeof value[0];
                    if (!value.every((item)=>typeof item === typeOfFirstItem)) ctx.addIssue({
                        code: 'custom',
                        // using "z.ZodIssueCode.custom" here breaks the "afm workspace @af/mono-typecheck" task somehow ¯\_(ツ)_/¯
                        message: 'All array items must be of the same type'
                    });
                }
            })
        ]));
    const configSchema = (0, $87Lnp.z).record(jsonSchema);
    configSchema.parse(config);
};
const $509cf1f98caebc07$var$prefixMessage = (message)=>{
    return `view.submit(): ${message}`;
};
const $509cf1f98caebc07$var$validateAdfBody = (body, editorSchema)=>{
    const schema = editorSchema || (0, $4XbfY.defaultSchema);
    const marks = Object.keys(schema.marks);
    const nodes = Object.keys(schema.nodes);
    const validate = (0, $3ztIq.validator)(nodes, marks, {
        mode: 'strict'
    });
    const { content: content } = body;
    // Make sure we're validating in the context of the extension node, to prevent invalid nested extensions
    const extension = (0, $dHQOi.bodiedExtension)({
        extensionType: (0, $iNIw3.EXTENSION_NAMESPACE),
        extensionKey: 'dummy-validate-only'
    })(...content);
    const errors = [];
    const { valid: valid } = validate((0, $4AavA.doc)(extension), (_entity, error)=>{
        errors.push(error);
        return undefined;
    });
    return {
        valid: valid,
        errors: errors
    };
};



var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $2VNj8 = parcelRequire("2VNj8");


var $4aRua = parcelRequire("4aRua");


var $1VhsF = parcelRequire("1VhsF");


var $jtT80 = parcelRequire("jtT80");




const $96301369204ad39e$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    blockedMacroTitle: {
        id: "xen-editor-provider.app-access-blocked-macro.title",
        defaultMessage: "An administrator blocked this app"
    },
    blockedMacroBodyWithAppName: {
        id: "xen-editor-provider.app-access-blocked-macro.bodyWithAppName",
        defaultMessage: "<strong>{extensionName}</strong> has been blocked by your administrator in this space. For any questions, reach out to your organization admin."
    },
    blockedMacroBodyWithoutAppName: {
        id: "xen-editor-provider.app-access-blocked-macro.bodyWithoutAppName",
        defaultMessage: "<strong>This app</strong> has been blocked by your administrator in this space. For any questions, reach out to your organization admin."
    },
    blockedMacroLearnMore: {
        id: "xen-editor-provider.app-access-blocked-macro.learnMoreAction",
        defaultMessage: "Learn more about which apps are blocked"
    },
    exportMacroError: {
        id: "xen-editor-provider.export-macro.error",
        defaultMessage: "We've encountered an issue exporting this macro. Please try exporting this page again later"
    },
    convertToSmartlinkToolbarItemLabel: {
        id: "xen-editor-provider.convert-to-smartlink-toolbarItem.label",
        defaultMessage: "Convert to link"
    }
});


const $e4497f55fedcae17$export$c168e7f7a7836a1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { extensionName: extensionName } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = $e4497f55fedcae17$var$_temp;
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== extensionName || $[2] !== intl) {
        const sharedFormattedMessageValues = {
            strong: t1
        };
        t2 = extensionName ? intl.formatMessage((0, $96301369204ad39e$export$defe85febe8b728c).blockedMacroBodyWithAppName, {
            extensionName: extensionName,
            ...sharedFormattedMessageValues
        }) : intl.formatMessage((0, $96301369204ad39e$export$defe85febe8b728c).blockedMacroBodyWithoutAppName, {
            ...sharedFormattedMessageValues
        });
        $[1] = extensionName;
        $[2] = intl;
        $[3] = t2;
    } else t2 = $[3];
    const formattedMessage = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $2VNj8.getATLContextDomain)("id");
        $[4] = t3;
    } else t3 = $[4];
    const identityDomain = t3;
    const learnMoreURL = `https://${identityDomain}/manage-profile/apps`;
    let t4;
    if ($[5] !== intl) {
        t4 = intl.formatMessage((0, $96301369204ad39e$export$defe85febe8b728c).blockedMacroTitle);
        $[5] = intl;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jtT80.default), {
                href: learnMoreURL
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $96301369204ad39e$export$defe85febe8b728c).blockedMacroLearnMore))
        ];
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== formattedMessage) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p"
        }, formattedMessage);
        $[8] = formattedMessage;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t4 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            title: t4,
            actions: t5
        }, t6);
        $[10] = t4;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
} : ({ extensionName: extensionName })=>{
    const intl = (0, $kSwu1.useIntl)();
    const sharedFormattedMessageValues = {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                as: "strong"
            }, chunks)
    };
    const formattedMessage = extensionName ? intl.formatMessage((0, $96301369204ad39e$export$defe85febe8b728c).blockedMacroBodyWithAppName, {
        extensionName: extensionName,
        ...sharedFormattedMessageValues
    }) : intl.formatMessage((0, $96301369204ad39e$export$defe85febe8b728c).blockedMacroBodyWithoutAppName, {
        ...sharedFormattedMessageValues
    });
    const identityDomain = (0, $2VNj8.getATLContextDomain)('id');
    const learnMoreURL = `https://${identityDomain}/manage-profile/apps`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        title: intl.formatMessage((0, $96301369204ad39e$export$defe85febe8b728c).blockedMacroTitle),
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jtT80.default), {
                href: learnMoreURL
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $96301369204ad39e$export$defe85febe8b728c).blockedMacroLearnMore))
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p"
    }, formattedMessage));
};
const $e4497f55fedcae17$export$17b6162b15b3194c = ({ extension: extension })=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e4497f55fedcae17$export$c168e7f7a7836a1, {
            extensionName: extension.properties.title
        });
const $e4497f55fedcae17$export$61f675db88ce9814 = (extension)=>extension.type === 'xen:macro' && extension.dataClassificationPolicyDecision?.status === 'BLOCKED';
function $e4497f55fedcae17$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "strong"
    }, chunks);
}





var $5W8qe = parcelRequire("5W8qe");


var $dOBRD = parcelRequire("dOBRD");


var $852mP = parcelRequire("852mP");





var $cIUmi = parcelRequire("cIUmi");

var $4K6lC = parcelRequire("4K6lC");




function $e135764dedc3ef6a$export$4ea6c6225eccc91(parameters) {
    return parameters?.macroMetadata?.macroId?.value;
}












var $hekY6 = parcelRequire("hekY6");











var $ah4BL = parcelRequire("ah4BL");


var $4ewzf = parcelRequire("4ewzf");


var $eLuPt = parcelRequire("eLuPt");

var $bTHR7 = parcelRequire("bTHR7");

var $kKOjD = parcelRequire("kKOjD");


var $d5gEx = parcelRequire("d5gEx");





const $90b5d8eb44fcddd8$var$PDF_URL = '/wiki/pdf/';
const $90b5d8eb44fcddd8$var$isCurrentLocationPdf = ()=>{
    return window?.location.href.includes($90b5d8eb44fcddd8$var$PDF_URL);
};
const $90b5d8eb44fcddd8$export$50f023e8da1e5a6b = (extension)=>{
    return $90b5d8eb44fcddd8$var$isCurrentLocationPdf() && extension?.properties?.export;
};
const $90b5d8eb44fcddd8$export$cb9938fa51e44b87 = (extension)=>{
    return $90b5d8eb44fcddd8$var$isCurrentLocationPdf() && extension?.properties?.adfExport;
};















var $3BY7M = parcelRequire("3BY7M");


var $hRnS5 = parcelRequire("hRnS5");





var $lCGo1 = parcelRequire("lCGo1");








var $lBErP = parcelRequire("lBErP");

/**
 * Checks if a value is a structurally valid ADF document by verifying it has
 * the required top-level properties: `version`, `type`, and `content`.
 * This guards against non-ADF return values (e.g. `null`, `false`, `-1`, `{}`, `'xxx'`)
 * being passed to the ADF renderer.
 */ const $9d48d763629547cd$var$isValidAdfDoc = (body)=>body !== null && typeof body === 'object' && 'version' in body && 'type' in body && 'content' in body;
function $9d48d763629547cd$var$parseExtensionId(extensionId) {
    const ari = (0, $9cGsb.parse)(extensionId);
    const [appId, environmentId, groupId, moduleKey] = ari.resourceId.split('/');
    return {
        appId: appId,
        environmentId: environmentId,
        groupId: groupId,
        moduleKey: moduleKey
    };
}
const $9d48d763629547cd$export$62e4612940199d99 = ({ accountId: accountId, contextIds: contextIds, extensionId: extensionId, coreData: coreData, extensionData: extensionData, extensionPayload: extensionPayload, getContextToken: getContextToken })=>{
    const [adfDoc, setAdfDoc] = (0, $cozmU.useState)(undefined);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const memoedContextIds = (0, $cozmU.useMemo)(()=>contextIds, [
        contextIds
    ]);
    const { moduleKey: moduleKey } = $9d48d763629547cd$var$parseExtensionId(extensionId);
    const siteUrl = window.location.origin;
    const memoedCoreData = (0, $cozmU.useMemo)(()=>({
            accountId: accountId,
            ...coreData,
            ...extensionData,
            moduleKey: moduleKey,
            siteUrl: siteUrl
        }), [
        coreData,
        extensionData,
        moduleKey,
        siteUrl,
        accountId
    ]);
    const invoker = (0, $lBErP.useInvokeExtension)(memoedContextIds, extensionId);
    // Keep getContextToken in a ref so the effect doesn't re-run when the parent passes a new reference.
    const getContextTokenRef = (0, $cozmU.useRef)(getContextToken);
    (0, $cozmU.useEffect)(()=>{
        const context = {
            ...memoedCoreData
        };
        const fetchAdfExport = async ()=>{
            setIsLoading(true);
            try {
                const getToken = getContextTokenRef.current;
                const contextToken = getToken ? await getToken() : undefined;
                const mutationResult = await invoker({
                    context: context,
                    extensionPayload: extensionPayload,
                    exportType: 'pdf',
                    ...contextToken ? {
                        contextToken: contextToken
                    } : {}
                }, 'adfExport');
                const response = mutationResult.data.invokeExtension.response || {};
                if ($9d48d763629547cd$var$isValidAdfDoc(response?.body)) setAdfDoc(response.body);
                else // If the adfExport resolver does not return a valid ADF document (e.g. returns `null`,
                // `false`, `-1`, `'xxx'`, `undefined`, or an empty object), fall back to the default HTML export.
                setAdfDoc(null);
                setError(response?.error);
            } catch (error_0) {
                setError(error_0 && error_0.message);
            }
            setIsLoading(false);
        };
        fetchAdfExport();
    }, [
        invoker,
        memoedCoreData,
        extensionPayload
    ]);
    return {
        adfDoc: adfDoc,
        isLoading: isLoading,
        error: error
    };
};



const $f02a442899f88e74$var$MEDIA_OPTIONS_WITH_LINKING = {
    allowLinking: true
};
const $f02a442899f88e74$export$f4fa252563062f56 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { accountId: accountId, contextIds: contextIds, coreData: coreData, dataProviders: dataProviders, extensionData: extensionData, extensionId: extensionId, extensionPayload: extensionPayload, fallbackRenderer: fallbackRenderer, getContextToken: getContextToken } = t0;
    let t1;
    if ($[0] !== accountId || $[1] !== contextIds || $[2] !== coreData || $[3] !== extensionData || $[4] !== extensionId || $[5] !== extensionPayload || $[6] !== getContextToken) {
        t1 = {
            accountId: accountId,
            contextIds: contextIds,
            extensionId: extensionId,
            coreData: coreData,
            extensionData: extensionData,
            extensionPayload: extensionPayload,
            getContextToken: getContextToken
        };
        $[0] = accountId;
        $[1] = contextIds;
        $[2] = coreData;
        $[3] = extensionData;
        $[4] = extensionId;
        $[5] = extensionPayload;
        $[6] = getContextToken;
        $[7] = t1;
    } else t1 = $[7];
    const { adfDoc: adfDoc, error: error, isLoading: isLoading } = (0, $9d48d763629547cd$export$62e4612940199d99)(t1);
    const intl = (0, $kSwu1.useIntl)();
    if (error) {
        let t2;
        if ($[8] !== intl) {
            t2 = intl.formatMessage((0, $96301369204ad39e$export$defe85febe8b728c).exportMacroError);
            $[8] = intl;
            $[9] = t2;
        } else t2 = $[9];
        let t3;
        if ($[10] !== t2) {
            t3 = /*#__PURE__*/ $cozmU.createElement((0, $1VhsF.default), {
                appearance: "error"
            }, t2);
            $[10] = t2;
            $[11] = t3;
        } else t3 = $[11];
        return t3;
    }
    if (isLoading) {
        let t2;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ $cozmU.createElement((0, $lCGo1.Loader), null);
            $[12] = t2;
        } else t2 = $[12];
        return t2;
    }
    if (!adfDoc) {
        let t2;
        if ($[13] !== fallbackRenderer) {
            t2 = fallbackRenderer ? fallbackRenderer() : null;
            $[13] = fallbackRenderer;
            $[14] = t2;
        } else t2 = $[14];
        return t2;
    }
    let t2;
    if ($[15] !== adfDoc || $[16] !== dataProviders) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ $cozmU.createElement((0, $3BY7M.default), {
            dataProviders: dataProviders,
            document: adfDoc,
            media: $f02a442899f88e74$var$MEDIA_OPTIONS_WITH_LINKING
        }));
        $[15] = adfDoc;
        $[16] = dataProviders;
        $[17] = t2;
    } else t2 = $[17];
    return t2;
} : ({ accountId: accountId, contextIds: contextIds, coreData: coreData, dataProviders: dataProviders, extensionData: extensionData, extensionId: extensionId, extensionPayload: extensionPayload, fallbackRenderer: fallbackRenderer, getContextToken: getContextToken })=>{
    const { adfDoc: adfDoc, error: error, isLoading: isLoading } = (0, $9d48d763629547cd$export$62e4612940199d99)({
        accountId: accountId,
        contextIds: contextIds,
        extensionId: extensionId,
        coreData: coreData,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        getContextToken: getContextToken
    });
    const intl = (0, $kSwu1.useIntl)();
    if (error) return /*#__PURE__*/ $cozmU.createElement((0, $1VhsF.default), {
        appearance: "error"
    }, intl.formatMessage((0, $96301369204ad39e$export$defe85febe8b728c).exportMacroError));
    if (isLoading) return /*#__PURE__*/ $cozmU.createElement((0, $lCGo1.Loader), null);
     // adfDoc is null/undefined - vendor intentionally returned null/undefined to signal
    // "don't use ADF rendering for this export type". Use fallback renderer if provided,
    // otherwise render nothing.
    if (!adfDoc) return fallbackRenderer ? fallbackRenderer() : null;
     // Successfully got ADF doc - render it
    return /*#__PURE__*/ $cozmU.createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ $cozmU.createElement((0, $3BY7M.default), {
        dataProviders: dataProviders,
        document: adfDoc,
        media: $f02a442899f88e74$var$MEDIA_OPTIONS_WITH_LINKING
    }));
};

/* ForgeUIExtension.tsx generated by @compiled/babel-plugin v3.0.2 */ 








var $fd6b6881ac0fa987$export$d779b02e6b68c3e8;
var $fd6b6881ac0fa987$export$719c70722b10e5ff;
var $fd6b6881ac0fa987$export$ab1029bcae9ddb4a;
var $fd6b6881ac0fa987$export$8916d2c8119541bb;
var $fd6b6881ac0fa987$export$d6b40c95035461c7;
var $fd6b6881ac0fa987$export$91115bdd8709945f;
var $fd6b6881ac0fa987$export$9e55760d3282e08c;
var $fd6b6881ac0fa987$export$3dede90624df3ba9;
var $fd6b6881ac0fa987$export$29ae691b7de52fe3;
var $fd6b6881ac0fa987$export$77fa7d86f5204e8a;
var $fd6b6881ac0fa987$export$ee1b3e54f0441b22;
var $fd6b6881ac0fa987$export$b314777ae20abca9;
var $fd6b6881ac0fa987$export$c28c8388be0ab31a;
var $fd6b6881ac0fa987$export$82fbd7a2841d2484;
var $fd6b6881ac0fa987$export$85b9a36db797e02b;
var $fd6b6881ac0fa987$export$61fc7d43ac8f84b0;
var $fd6b6881ac0fa987$export$7843a4469d64c07e;
var $fd6b6881ac0fa987$export$e4ca6d7b7a6dcf9b;
var $fd6b6881ac0fa987$export$1391212d75b2ee65;
var $fd6b6881ac0fa987$export$286ca829307725c9;
var $fd6b6881ac0fa987$export$ab9a5985b741fa7a;
var $fd6b6881ac0fa987$export$983a3b5fb2f7202e;
var $fd6b6881ac0fa987$export$779c5fb865a0172e;
var $fd6b6881ac0fa987$export$571da16e28367bde;
var $fd6b6881ac0fa987$export$91d69c7761a17bbc;
var $fd6b6881ac0fa987$export$7ecc1a3b11b57dab;
var $fd6b6881ac0fa987$export$31039f1fbd797b9c;
var $fd6b6881ac0fa987$export$d70d492cd31004c0;
var $fd6b6881ac0fa987$export$9f77e0932fb78f72;
var $fd6b6881ac0fa987$export$3dea766d36a8935f;
var $fd6b6881ac0fa987$export$578723aef62d92f5;
var $fd6b6881ac0fa987$export$71aa6c912b956294;
var $fd6b6881ac0fa987$export$de3a4d4a0d731119;
var $fd6b6881ac0fa987$export$43128fadae87b74a;
var $fd6b6881ac0fa987$export$3f063810d7bf01bd;
var $fd6b6881ac0fa987$export$6953b97c7d866605;
var $fd6b6881ac0fa987$export$dd1bc94b04021eeb;
var $fd6b6881ac0fa987$export$4c7897fafd92b108;
var $fd6b6881ac0fa987$export$871de8747c9eaa88;
var $fd6b6881ac0fa987$export$e0eaf3a86c03b2ad;
var $fd6b6881ac0fa987$export$76dbd6ffd832405d;
var $fd6b6881ac0fa987$export$8960430cfd85939f;
var $fd6b6881ac0fa987$export$4950aa0f605343fb;
var $fd6b6881ac0fa987$export$18aef43295bbe906;
var $fd6b6881ac0fa987$export$6b9f6c0d32c093f9;
var $fd6b6881ac0fa987$export$5b8affa63fc6df16;
var $fd6b6881ac0fa987$export$bd7cfc9a42b8a412;
var $fd6b6881ac0fa987$export$c1fc905202bced53;
var $fd6b6881ac0fa987$export$96ec731ed4dcb222;
var $fd6b6881ac0fa987$export$1364843af8d5a963;
var $fd6b6881ac0fa987$export$9007f49c319d1ac7;
var $fd6b6881ac0fa987$export$5fba66d61591f42;
var $fd6b6881ac0fa987$export$8f9d79d42bff1aac;
var $fd6b6881ac0fa987$export$b29f828819edca8d;
var $fd6b6881ac0fa987$export$c44985b87d605eff;
var $fd6b6881ac0fa987$export$89b472e03be495df;
var $fd6b6881ac0fa987$export$16ae46fda9567053;
var $fd6b6881ac0fa987$export$42d9b6b38c68d989;
var $fd6b6881ac0fa987$export$1f3342bf81d92d52;
var $fd6b6881ac0fa987$export$236c05de452bec2;
var $fd6b6881ac0fa987$export$533b26079ad0b4b;
var $fd6b6881ac0fa987$export$76d90c956114f2c2;
var $fd6b6881ac0fa987$export$b39ac5b4ffd1415a;
var $fd6b6881ac0fa987$export$9369b12211e1fce4;
var $fd6b6881ac0fa987$export$1281551253cfee02;
var $fd6b6881ac0fa987$export$18d0766d894cba0c;
var $fd6b6881ac0fa987$export$4812e460280c6ef2;
var $fd6b6881ac0fa987$export$fe33c7b2002d97b0;
var $fd6b6881ac0fa987$export$c87d910e63d22ed6;
var $fd6b6881ac0fa987$export$d0a07e60ae428313;
var $fd6b6881ac0fa987$export$ed80d9de1d9df928;
var $fd6b6881ac0fa987$export$db61d692014e534e;
var $fd6b6881ac0fa987$export$863d7ca51b416cee;
var $fd6b6881ac0fa987$export$955fc4a6c4be454d;
var $fd6b6881ac0fa987$export$635f6273df29ea1c;
var $fd6b6881ac0fa987$export$facc584867c26fde;
var $fd6b6881ac0fa987$export$175dedd748069215;
var $fd6b6881ac0fa987$export$a4fe86229b0e9bdd;
var $fd6b6881ac0fa987$export$6a45284a4b0bf33a;
var $fd6b6881ac0fa987$export$9f6ea8e48bc26eab;
var $fd6b6881ac0fa987$export$a439dc30c845238;
var $fd6b6881ac0fa987$export$b7df5d561049483a;
var $fd6b6881ac0fa987$export$1b47ad771ce5af5e;
var $fd6b6881ac0fa987$export$ac8dfd3a7ad06e80;
var $fd6b6881ac0fa987$export$9384c7afe4015e42;
var $fd6b6881ac0fa987$export$3f23594af5f37336;
var $fd6b6881ac0fa987$export$de363e709c412c8a;
var $fd6b6881ac0fa987$export$4efe28f192921dd4;
var $fd6b6881ac0fa987$export$1a539c8b2950ab40;
var $fd6b6881ac0fa987$export$83e74882c5df8fe1;
var $fd6b6881ac0fa987$export$86fe999fba7953f2;
var $fd6b6881ac0fa987$export$fc00ee57782020aa;
var $fd6b6881ac0fa987$export$45b10814cc054894;
var $fd6b6881ac0fa987$export$8291e5b88f90ce4;
var $fd6b6881ac0fa987$export$f3a19e933f377396;
var $fd6b6881ac0fa987$export$1284415effa79ee0;
var $fd6b6881ac0fa987$export$3182be990e0eeaad;
var $fd6b6881ac0fa987$export$6a5dea797879f644;
var $fd6b6881ac0fa987$export$d449030e5c10edf7;
var $fd6b6881ac0fa987$export$8901015135f2fb22;
var $fd6b6881ac0fa987$export$adddb6a2fa3864e9;
"use strict";

var $4TFr0 = parcelRequire("4TFr0");

$fd6b6881ac0fa987$export$d779b02e6b68c3e8 = $4TFr0.audit;
var $4e574a1ed5376b30$export$719c70722b10e5ff;
"use strict";

var $zAMIg = parcelRequire("zAMIg");




var $2e5159bbe6bc0739$export$9dc4ecf953986f04;
"use strict";

var $8gBFa = parcelRequire("8gBFa");

$2e5159bbe6bc0739$export$9dc4ecf953986f04 = $8gBFa.TimerObservable.create; //# sourceMappingURL=timer.js.map


/**
 * Ignores source values for `duration` milliseconds, then emits the most recent
 * value from the source Observable, then repeats this process.
 *
 * <span class="informal">When it sees a source values, it ignores that plus
 * the next ones for `duration` milliseconds, and then it emits the most recent
 * value from the source.</span>
 *
 * <img src="./img/auditTime.png" width="100%">
 *
 * `auditTime` is similar to `throttleTime`, but emits the last value from the
 * silenced time window, instead of the first value. `auditTime` emits the most
 * recent value from the source Observable on the output Observable as soon as
 * its internal timer becomes disabled, and ignores source values while the
 * timer is enabled. Initially, the timer is disabled. As soon as the first
 * source value arrives, the timer is enabled. After `duration` milliseconds (or
 * the time unit determined internally by the optional `scheduler`) has passed,
 * the timer is disabled, then the most recent source value is emitted on the
 * output Observable, and this process repeats for the next source value.
 * Optionally takes a {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.auditTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} duration Time to wait before emitting the most recent source
 * value, measured in milliseconds or the time unit determined internally
 * by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the rate-limiting behavior.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method auditTime
 * @owner Observable
 */ function $4e574a1ed5376b30$var$auditTime(duration, scheduler) {
    if (scheduler === void 0) scheduler = $zAMIg.async;
    return $4TFr0.audit(function() {
        return $2e5159bbe6bc0739$export$9dc4ecf953986f04(duration, scheduler);
    });
}
$4e574a1ed5376b30$export$719c70722b10e5ff = $4e574a1ed5376b30$var$auditTime; //# sourceMappingURL=auditTime.js.map


$fd6b6881ac0fa987$export$719c70722b10e5ff = $4e574a1ed5376b30$export$719c70722b10e5ff;

var $iVt9k = parcelRequire("iVt9k");

$fd6b6881ac0fa987$export$ab1029bcae9ddb4a = $iVt9k.buffer;

var $hHjgG = parcelRequire("hHjgG");

$fd6b6881ac0fa987$export$8916d2c8119541bb = $hHjgG.bufferCount;

var $jyqW3 = parcelRequire("jyqW3");

$fd6b6881ac0fa987$export$d6b40c95035461c7 = $jyqW3.bufferTime;

var $ihrZj = parcelRequire("ihrZj");

$fd6b6881ac0fa987$export$91115bdd8709945f = $ihrZj.bufferToggle;

var $5iYhi = parcelRequire("5iYhi");

$fd6b6881ac0fa987$export$9e55760d3282e08c = $5iYhi.bufferWhen;

var $1PPDm = parcelRequire("1PPDm");

$fd6b6881ac0fa987$export$3dede90624df3ba9 = $1PPDm.catchError;
var $7c4883280bbadfea$export$29ae691b7de52fe3;
"use strict";

var $fKaLK = parcelRequire("fKaLK");

function $7c4883280bbadfea$var$combineAll(project) {
    return function(source) {
        return source.lift(new $fKaLK.CombineLatestOperator(project));
    };
}
$7c4883280bbadfea$export$29ae691b7de52fe3 = $7c4883280bbadfea$var$combineAll; //# sourceMappingURL=combineAll.js.map


$fd6b6881ac0fa987$export$29ae691b7de52fe3 = $7c4883280bbadfea$export$29ae691b7de52fe3;



$fd6b6881ac0fa987$export$77fa7d86f5204e8a = $fKaLK.combineLatest;
var $268010b3a0cbd2fd$export$9343b684b018b33a;
var $268010b3a0cbd2fd$export$ee1b3e54f0441b22;
"use strict";
var $b7fb214b02e40636$export$ee1b3e54f0441b22;
"use strict";

var $lRrDg = parcelRequire("lRrDg");


var $lv9Cv = parcelRequire("lv9Cv");


var $7081j = parcelRequire("7081j");

var $6cc2aa5b07c65124$export$b314777ae20abca9;
"use strict";

var $c9SbF = parcelRequire("c9SbF");

/**
 * Converts a higher-order Observable into a first-order Observable by
 * concatenating the inner Observables in order.
 *
 * <span class="informal">Flattens an Observable-of-Observables by putting one
 * inner Observable after the other.</span>
 *
 * <img src="./img/concatAll.png" width="100%">
 *
 * Joins every Observable emitted by the source (a higher-order Observable), in
 * a serial fashion. It subscribes to each inner Observable only after the
 * previous inner Observable has completed, and merges all of their values into
 * the returned observable.
 *
 * __Warning:__ If the source Observable emits Observables quickly and
 * endlessly, and the inner Observables it emits generally complete slower than
 * the source emits, you can run into memory issues as the incoming Observables
 * collect in an unbounded buffer.
 *
 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
 * var firstOrder = higherOrder.concatAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link combineAll}
 * @see {@link concat}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable emitting values from all the inner
 * Observables concatenated.
 * @method concatAll
 * @owner Observable
 */ function $6cc2aa5b07c65124$var$concatAll() {
    return $c9SbF.mergeAll(1);
}
$6cc2aa5b07c65124$export$b314777ae20abca9 = $6cc2aa5b07c65124$var$concatAll; //# sourceMappingURL=concatAll.js.map


/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which sequentially emits all values from given
 * Observable and then moves on to the next.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * `concat` joins multiple Observables together, by subscribing to them one at a time and
 * merging their results into the output Observable. You can pass either an array of
 * Observables, or put them directly as arguments. Passing an empty array will result
 * in Observable that completes immediately.
 *
 * `concat` will subscribe to first input Observable and emit all its values, without
 * changing or affecting them in any way. When that Observable completes, it will
 * subscribe to then next Observable passed and, again, emit its values. This will be
 * repeated, until the operator runs out of Observables. When last input Observable completes,
 * `concat` will complete as well. At any given moment only one Observable passed to operator
 * emits values. If you would like to emit values from passed Observables concurrently, check out
 * {@link merge} instead, especially with optional `concurrent` parameter. As a matter of fact,
 * `concat` is an equivalent of `merge` operator with `concurrent` parameter set to `1`.
 *
 * Note that if some input Observable never completes, `concat` will also never complete
 * and Observables following the one that did not complete will never be subscribed. On the other
 * hand, if some Observable simply completes immediately after it is subscribed, it will be
 * invisible for `concat`, which will just move on to the next Observable.
 *
 * If any Observable in chain errors, instead of passing control to the next Observable,
 * `concat` will error immediately as well. Observables that would be subscribed after
 * the one that emitted error, never will.
 *
 * If you pass to `concat` the same Observable many times, its stream of values
 * will be "replayed" on every subscription, which means you can repeat given Observable
 * as many times as you like. If passing the same Observable to `concat` 1000 times becomes tedious,
 * you can always use {@link repeat}.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = Rx.Observable.concat(timer, sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 *
 * @example <caption>Concatenate an array of 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = Rx.Observable.concat([timer1, timer2, timer3]); // note that array is passed
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 *
 * @example <caption>Concatenate the same Observable to repeat it</caption>
 * const timer = Rx.Observable.interval(1000).take(2);
 *
 * Rx.Observable.concat(timer, timer) // concating the same Observable!
 * .subscribe(
 *   value => console.log(value),
 *   err => {},
 *   () => console.log('...and it is done!')
 * );
 *
 * // Logs:
 * // 0 after 1s
 * // 1 after 2s
 * // 0 after 3s
 * // 1 after 4s
 * // "...and it is done!" also after 4s
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} input1 An input Observable to concatenate with others.
 * @param {ObservableInput} input2 An input Observable to concatenate with others.
 * More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @static true
 * @name concat
 * @owner Observable
 */ function $b7fb214b02e40636$var$concat() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    if (observables.length === 1 || observables.length === 2 && $lRrDg.isScheduler(observables[1])) return $7081j.from(observables[0]);
    return $6cc2aa5b07c65124$export$b314777ae20abca9()($lv9Cv.of.apply(void 0, observables));
}
$b7fb214b02e40636$export$ee1b3e54f0441b22 = $b7fb214b02e40636$var$concat; //# sourceMappingURL=concat.js.map



$268010b3a0cbd2fd$export$9343b684b018b33a = $b7fb214b02e40636$export$ee1b3e54f0441b22;
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which sequentially emits all values from every
 * given input Observable after the current Observable.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * Joins this Observable with multiple other Observables by subscribing to them
 * one at a time, starting with the source, and merging their results into the
 * output Observable. Will wait for each Observable to complete before moving
 * on to the next.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = timer.concat(sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 * @example <caption>Concatenate 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = timer1.concat(timer2, timer3);
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} other An input Observable to concatenate after the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @method concat
 * @owner Observable
 */ function $268010b3a0cbd2fd$var$concat() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function(source) {
        return source.lift.call($b7fb214b02e40636$export$ee1b3e54f0441b22.apply(void 0, [
            source
        ].concat(observables)));
    };
}
$268010b3a0cbd2fd$export$ee1b3e54f0441b22 = $268010b3a0cbd2fd$var$concat; //# sourceMappingURL=concat.js.map


$fd6b6881ac0fa987$export$ee1b3e54f0441b22 = $268010b3a0cbd2fd$export$ee1b3e54f0441b22;

$fd6b6881ac0fa987$export$b314777ae20abca9 = $6cc2aa5b07c65124$export$b314777ae20abca9;

var $ifZfw = parcelRequire("ifZfw");

$fd6b6881ac0fa987$export$c28c8388be0ab31a = $ifZfw.concatMap;
var $434a5e1d0c6de27a$export$82fbd7a2841d2484;
"use strict";



/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in a serialized fashion on the output Observable.
 *
 * <span class="informal">It's like {@link concatMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/concatMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. Each new `innerObservable`
 * instance emitted on the output Observable is concatenated with the previous
 * `innerObservable` instance.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
 * set to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link mergeMapTo}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An observable of values merged together by joining the
 * passed observable with itself, one after the other, for each value emitted
 * from the source.
 * @method concatMapTo
 * @owner Observable
 */ function $434a5e1d0c6de27a$var$concatMapTo(innerObservable, resultSelector) {
    return $ifZfw.concatMap(function() {
        return innerObservable;
    }, resultSelector);
}
$434a5e1d0c6de27a$export$82fbd7a2841d2484 = $434a5e1d0c6de27a$var$concatMapTo; //# sourceMappingURL=concatMapTo.js.map


$fd6b6881ac0fa987$export$82fbd7a2841d2484 = $434a5e1d0c6de27a$export$82fbd7a2841d2484;

var $iUi6G = parcelRequire("iUi6G");

$fd6b6881ac0fa987$export$85b9a36db797e02b = $iUi6G.count;

var $krMWu = parcelRequire("krMWu");

$fd6b6881ac0fa987$export$61fc7d43ac8f84b0 = $krMWu.debounce;

var $2zdC2 = parcelRequire("2zdC2");

$fd6b6881ac0fa987$export$7843a4469d64c07e = $2zdC2.debounceTime;

var $dTFgb = parcelRequire("dTFgb");

$fd6b6881ac0fa987$export$e4ca6d7b7a6dcf9b = $dTFgb.defaultIfEmpty;

var $hrJHY = parcelRequire("hrJHY");

$fd6b6881ac0fa987$export$1391212d75b2ee65 = $hrJHY.delay;

var $5CHAu = parcelRequire("5CHAu");

$fd6b6881ac0fa987$export$286ca829307725c9 = $5CHAu.delayWhen;

var $lbCzi = parcelRequire("lbCzi");

$fd6b6881ac0fa987$export$ab9a5985b741fa7a = $lbCzi.dematerialize;

var $8NmrP = parcelRequire("8NmrP");

$fd6b6881ac0fa987$export$983a3b5fb2f7202e = $8NmrP.distinct;

var $1xJn2 = parcelRequire("1xJn2");

$fd6b6881ac0fa987$export$779c5fb865a0172e = $1xJn2.distinctUntilChanged;
var $be86f0fc340bab40$export$571da16e28367bde;
"use strict";



/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
 * using a property accessed by using the key provided to check if the two items are distinct.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>An example comparing the name of persons</caption>
 *
 *  interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'},
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilKeyChanged('name')
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @example <caption>An example comparing the first letters of the name</caption>
 *
 * interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo1'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo2'},
 *     { age: 6, name: 'Foo3'})
 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo1' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo2' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 *
 * @param {string} key String key for object property lookup on each item.
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
 * @method distinctUntilKeyChanged
 * @owner Observable
 */ function $be86f0fc340bab40$var$distinctUntilKeyChanged(key, compare) {
    return $1xJn2.distinctUntilChanged(function(x, y) {
        return compare ? compare(x[key], y[key]) : x[key] === y[key];
    });
}
$be86f0fc340bab40$export$571da16e28367bde = $be86f0fc340bab40$var$distinctUntilKeyChanged; //# sourceMappingURL=distinctUntilKeyChanged.js.map


$fd6b6881ac0fa987$export$571da16e28367bde = $be86f0fc340bab40$export$571da16e28367bde;

var $fKoPv = parcelRequire("fKoPv");

$fd6b6881ac0fa987$export$91d69c7761a17bbc = $fKoPv.elementAt;

var $9tnen = parcelRequire("9tnen");

$fd6b6881ac0fa987$export$7ecc1a3b11b57dab = $9tnen.every;

var $ajXCP = parcelRequire("ajXCP");

$fd6b6881ac0fa987$export$31039f1fbd797b9c = $ajXCP.exhaust;

var $4LCEp = parcelRequire("4LCEp");

$fd6b6881ac0fa987$export$d70d492cd31004c0 = $4LCEp.exhaustMap;

var $cWC1J = parcelRequire("cWC1J");

$fd6b6881ac0fa987$export$9f77e0932fb78f72 = $cWC1J.expand;

var $8Bx1z = parcelRequire("8Bx1z");

$fd6b6881ac0fa987$export$3dea766d36a8935f = $8Bx1z.filter;

var $2FoNr = parcelRequire("2FoNr");

$fd6b6881ac0fa987$export$578723aef62d92f5 = $2FoNr.finalize;

var $gCYzh = parcelRequire("gCYzh");

$fd6b6881ac0fa987$export$71aa6c912b956294 = $gCYzh.find;
var $51f9e0943a65dc25$export$de3a4d4a0d731119;
"use strict";



/**
 * Emits only the index of the first value emitted by the source Observable that
 * meets some condition.
 *
 * <span class="informal">It's like {@link find}, but emits the index of the
 * found value, not the value itself.</span>
 *
 * <img src="./img/findIndex.png" width="100%">
 *
 * `findIndex` searches for the first item in the source Observable that matches
 * the specified condition embodied by the `predicate`, and returns the
 * (zero-based) index of the first occurrence in the source. Unlike
 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
 * an error if a valid value is not found.
 *
 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link first}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of the index of the first item that
 * matches the condition.
 * @method find
 * @owner Observable
 */ function $51f9e0943a65dc25$var$findIndex(predicate, thisArg) {
    return function(source) {
        return source.lift(new $gCYzh.FindValueOperator(predicate, source, true, thisArg));
    };
}
$51f9e0943a65dc25$export$de3a4d4a0d731119 = $51f9e0943a65dc25$var$findIndex; //# sourceMappingURL=findIndex.js.map


$fd6b6881ac0fa987$export$de3a4d4a0d731119 = $51f9e0943a65dc25$export$de3a4d4a0d731119;

var $imhbM = parcelRequire("imhbM");

$fd6b6881ac0fa987$export$43128fadae87b74a = $imhbM.first;

var $lPY1W = parcelRequire("lPY1W");

$fd6b6881ac0fa987$export$3f063810d7bf01bd = $lPY1W.groupBy;

var $9ZC39 = parcelRequire("9ZC39");

$fd6b6881ac0fa987$export$6953b97c7d866605 = $9ZC39.ignoreElements;

var $8ubGV = parcelRequire("8ubGV");

$fd6b6881ac0fa987$export$dd1bc94b04021eeb = $8ubGV.isEmpty;

var $696yK = parcelRequire("696yK");

$fd6b6881ac0fa987$export$4c7897fafd92b108 = $696yK.last;

var $5pyN0 = parcelRequire("5pyN0");

$fd6b6881ac0fa987$export$871de8747c9eaa88 = $5pyN0.map;

var $lzXbg = parcelRequire("lzXbg");

$fd6b6881ac0fa987$export$e0eaf3a86c03b2ad = $lzXbg.mapTo;

var $baU6e = parcelRequire("baU6e");

$fd6b6881ac0fa987$export$76dbd6ffd832405d = $baU6e.materialize;
var $0d8af049a4d9ea45$export$8960430cfd85939f;
"use strict";

var $7bBVm = parcelRequire("7bBVm");

/**
 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the largest value.
 *
 * <img src="./img/max.png" width="100%">
 *
 * @example <caption>Get the maximal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .max()
 *   .subscribe(x => console.log(x)); // -> 8
 *
 * @example <caption>Use a comparer function to get the maximal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
 * }
 *
 * @see {@link min}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable} An Observable that emits item with the largest value.
 * @method max
 * @owner Observable
 */ function $0d8af049a4d9ea45$var$max(comparer) {
    var max = typeof comparer === 'function' ? function(x, y) {
        return comparer(x, y) > 0 ? x : y;
    } : function(x, y) {
        return x > y ? x : y;
    };
    return $7bBVm.reduce(max);
}
$0d8af049a4d9ea45$export$8960430cfd85939f = $0d8af049a4d9ea45$var$max; //# sourceMappingURL=max.js.map


$fd6b6881ac0fa987$export$8960430cfd85939f = $0d8af049a4d9ea45$export$8960430cfd85939f;
var $4a5b2d3cd2e45a57$export$9f199afc30ae2269;
var $4a5b2d3cd2e45a57$export$4950aa0f605343fb;
"use strict";

var $9Hb6D = parcelRequire("9Hb6D");




$4a5b2d3cd2e45a57$export$9f199afc30ae2269 = $9Hb6D.merge;
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (either the source or an
 * Observable given as argument), and simply forwards (without doing any
 * transformation) all the values from all the input Observables to the output
 * Observable. The output Observable only completes once all input Observables
 * have completed. Any error delivered by an input Observable will be immediately
 * emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = clicks.merge(timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = timer1.merge(timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {ObservableInput} other An input Observable to merge with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} An Observable that emits items that are the result of
 * every input Observable.
 * @method merge
 * @owner Observable
 */ function $4a5b2d3cd2e45a57$var$merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function(source) {
        return source.lift.call($9Hb6D.merge.apply(void 0, [
            source
        ].concat(observables)));
    };
}
$4a5b2d3cd2e45a57$export$4950aa0f605343fb = $4a5b2d3cd2e45a57$var$merge; //# sourceMappingURL=merge.js.map


$fd6b6881ac0fa987$export$4950aa0f605343fb = $4a5b2d3cd2e45a57$export$4950aa0f605343fb;



$fd6b6881ac0fa987$export$18aef43295bbe906 = $c9SbF.mergeAll;

var $inXGV = parcelRequire("inXGV");

$fd6b6881ac0fa987$export$6b9f6c0d32c093f9 = $inXGV.mergeMap;



$fd6b6881ac0fa987$export$5b8affa63fc6df16 = $inXGV.mergeMap;

var $6k8sk = parcelRequire("6k8sk");

$fd6b6881ac0fa987$export$bd7cfc9a42b8a412 = $6k8sk.mergeMapTo;

var $b0JAN = parcelRequire("b0JAN");

$fd6b6881ac0fa987$export$c1fc905202bced53 = $b0JAN.mergeScan;
var $a183e5744fc9c00b$export$96ec731ed4dcb222;
"use strict";



/**
 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the smallest value.
 *
 * <img src="./img/min.png" width="100%">
 *
 * @example <caption>Get the minimal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .min()
 *   .subscribe(x => console.log(x)); // -> 2
 *
 * @example <caption>Use a comparer function to get the minimal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
 * }
 *
 * @see {@link max}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable<R>} An Observable that emits item with the smallest value.
 * @method min
 * @owner Observable
 */ function $a183e5744fc9c00b$var$min(comparer) {
    var min = typeof comparer === 'function' ? function(x, y) {
        return comparer(x, y) < 0 ? x : y;
    } : function(x, y) {
        return x < y ? x : y;
    };
    return $7bBVm.reduce(min);
}
$a183e5744fc9c00b$export$96ec731ed4dcb222 = $a183e5744fc9c00b$var$min; //# sourceMappingURL=min.js.map


$fd6b6881ac0fa987$export$96ec731ed4dcb222 = $a183e5744fc9c00b$export$96ec731ed4dcb222;
var $c13009df871a10ca$export$1364843af8d5a963;
var $c13009df871a10ca$export$150d52413393bf2c;
"use strict";

var $dtFo6 = parcelRequire("dtFo6");

/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits the results of invoking a specified selector on items
 * emitted by a ConnectableObservable that shares a single subscription to the underlying stream.
 *
 * <img src="./img/multicast.png" width="100%">
 *
 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate subject through
 * which the source sequence's elements will be multicast to the selector function
 * or Subject to push source elements into.
 * @param {Function} [selector] - Optional selector function that can use the multicasted source stream
 * as many times as needed, without causing multiple subscriptions to the source stream.
 * Subscribers to the given source will receive all notifications of the source from the
 * time of the subscription forward.
 * @return {Observable} An Observable that emits the results of invoking the selector
 * on the items emitted by a `ConnectableObservable` that shares a single subscription to
 * the underlying stream.
 * @method multicast
 * @owner Observable
 */ function $c13009df871a10ca$var$multicast(subjectOrSubjectFactory, selector) {
    return function multicastOperatorFunction(source) {
        var subjectFactory;
        if (typeof subjectOrSubjectFactory === 'function') subjectFactory = subjectOrSubjectFactory;
        else subjectFactory = function subjectFactory() {
            return subjectOrSubjectFactory;
        };
        if (typeof selector === 'function') return source.lift(new $c13009df871a10ca$var$MulticastOperator(subjectFactory, selector));
        var connectable = Object.create(source, $dtFo6.connectableObservableDescriptor);
        connectable.source = source;
        connectable.subjectFactory = subjectFactory;
        return connectable;
    };
}
$c13009df871a10ca$export$1364843af8d5a963 = $c13009df871a10ca$var$multicast;
var $c13009df871a10ca$var$MulticastOperator = function() {
    function MulticastOperator(subjectFactory, selector) {
        this.subjectFactory = subjectFactory;
        this.selector = selector;
    }
    MulticastOperator.prototype.call = function(subscriber, source) {
        var selector = this.selector;
        var subject = this.subjectFactory();
        var subscription = selector(subject).subscribe(subscriber);
        subscription.add(source.subscribe(subject));
        return subscription;
    };
    return MulticastOperator;
}();
$c13009df871a10ca$export$150d52413393bf2c = $c13009df871a10ca$var$MulticastOperator; //# sourceMappingURL=multicast.js.map


$fd6b6881ac0fa987$export$1364843af8d5a963 = $c13009df871a10ca$export$1364843af8d5a963;

var $45rOu = parcelRequire("45rOu");

$fd6b6881ac0fa987$export$9007f49c319d1ac7 = $45rOu.observeOn;

var $kkbhK = parcelRequire("kkbhK");

$fd6b6881ac0fa987$export$5fba66d61591f42 = $kkbhK.onErrorResumeNext;

var $3jLcS = parcelRequire("3jLcS");

$fd6b6881ac0fa987$export$8f9d79d42bff1aac = $3jLcS.pairwise;
var $2d447a429a3f31f1$export$b29f828819edca8d;
"use strict";
var $1df1cc362ee3d3b4$export$6003a5f097c73977;
"use strict";
function $1df1cc362ee3d3b4$var$not(pred, thisArg) {
    function notPred() {
        return !notPred.pred.apply(notPred.thisArg, arguments);
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}
$1df1cc362ee3d3b4$export$6003a5f097c73977 = $1df1cc362ee3d3b4$var$not; //# sourceMappingURL=not.js.map





/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */ function $2d447a429a3f31f1$var$partition(predicate, thisArg) {
    return function(source) {
        return [
            $8Bx1z.filter(predicate, thisArg)(source),
            $8Bx1z.filter($1df1cc362ee3d3b4$export$6003a5f097c73977(predicate, thisArg))(source)
        ];
    };
}
$2d447a429a3f31f1$export$b29f828819edca8d = $2d447a429a3f31f1$var$partition; //# sourceMappingURL=partition.js.map


$fd6b6881ac0fa987$export$b29f828819edca8d = $2d447a429a3f31f1$export$b29f828819edca8d;
var $88b6f545086daa06$export$c44985b87d605eff;
"use strict";



/**
 * Maps each source value (an object) to its specified nested property.
 *
 * <span class="informal">Like {@link map}, but meant only for picking one of
 * the nested properties of every emitted object.</span>
 *
 * <img src="./img/pluck.png" width="100%">
 *
 * Given a list of strings describing a path to an object property, retrieves
 * the value of a specified nested property from all values in the source
 * Observable. If a property can't be resolved, it will return `undefined` for
 * that value.
 *
 * @example <caption>Map every click to the tagName of the clicked target element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var tagNames = clicks.pluck('target', 'tagName');
 * tagNames.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {...string} properties The nested properties to pluck from each source
 * value (an object).
 * @return {Observable} A new Observable of property values from the source values.
 * @method pluck
 * @owner Observable
 */ function $88b6f545086daa06$var$pluck() {
    var properties = [];
    for(var _i = 0; _i < arguments.length; _i++)properties[_i - 0] = arguments[_i];
    var length = properties.length;
    if (length === 0) throw new Error('list of properties cannot be empty.');
    return function(source) {
        return $5pyN0.map($88b6f545086daa06$var$plucker(properties, length))(source);
    };
}
$88b6f545086daa06$export$c44985b87d605eff = $88b6f545086daa06$var$pluck;
function $88b6f545086daa06$var$plucker(props, length) {
    var mapper = function(x) {
        var currentProp = x;
        for(var i = 0; i < length; i++){
            var p = currentProp[props[i]];
            if (typeof p !== 'undefined') currentProp = p;
            else return undefined;
        }
        return currentProp;
    };
    return mapper;
} //# sourceMappingURL=pluck.js.map


$fd6b6881ac0fa987$export$c44985b87d605eff = $88b6f545086daa06$export$c44985b87d605eff;
var $d52376ede9e137bb$export$89b472e03be495df;
"use strict";

var $gGP9M = parcelRequire("gGP9M");


/* tslint:enable:max-line-length */ /**
 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
 * before it begins emitting items to those Observers that have subscribed to it.
 *
 * <img src="./img/publish.png" width="100%">
 *
 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
 * as needed, without causing multiple subscriptions to the source sequence.
 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
 * @method publish
 * @owner Observable
 */ function $d52376ede9e137bb$var$publish(selector) {
    return selector ? $c13009df871a10ca$export$1364843af8d5a963(function() {
        return new $gGP9M.Subject();
    }, selector) : $c13009df871a10ca$export$1364843af8d5a963(new $gGP9M.Subject());
}
$d52376ede9e137bb$export$89b472e03be495df = $d52376ede9e137bb$var$publish; //# sourceMappingURL=publish.js.map


$fd6b6881ac0fa987$export$89b472e03be495df = $d52376ede9e137bb$export$89b472e03be495df;
var $b26a6c420c617589$export$16ae46fda9567053;
"use strict";

var $4Otfs = parcelRequire("4Otfs");


/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */ function $b26a6c420c617589$var$publishBehavior(value) {
    return function(source) {
        return $c13009df871a10ca$export$1364843af8d5a963(new $4Otfs.BehaviorSubject(value))(source);
    };
}
$b26a6c420c617589$export$16ae46fda9567053 = $b26a6c420c617589$var$publishBehavior; //# sourceMappingURL=publishBehavior.js.map


$fd6b6881ac0fa987$export$16ae46fda9567053 = $b26a6c420c617589$export$16ae46fda9567053;
var $459b8da5dd35de20$export$42d9b6b38c68d989;
"use strict";

var $Uz5yd = parcelRequire("Uz5yd");


function $459b8da5dd35de20$var$publishLast() {
    return function(source) {
        return $c13009df871a10ca$export$1364843af8d5a963(new $Uz5yd.AsyncSubject())(source);
    };
}
$459b8da5dd35de20$export$42d9b6b38c68d989 = $459b8da5dd35de20$var$publishLast; //# sourceMappingURL=publishLast.js.map


$fd6b6881ac0fa987$export$42d9b6b38c68d989 = $459b8da5dd35de20$export$42d9b6b38c68d989;
var $e77fb34465299563$export$1f3342bf81d92d52;
"use strict";

var $eyCIo = parcelRequire("eyCIo");


/* tslint:enable:max-line-length */ function $e77fb34465299563$var$publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') scheduler = selectorOrScheduler;
    var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
    var subject = new $eyCIo.ReplaySubject(bufferSize, windowTime, scheduler);
    return function(source) {
        return $c13009df871a10ca$export$1364843af8d5a963(function() {
            return subject;
        }, selector)(source);
    };
}
$e77fb34465299563$export$1f3342bf81d92d52 = $e77fb34465299563$var$publishReplay; //# sourceMappingURL=publishReplay.js.map


$fd6b6881ac0fa987$export$1f3342bf81d92d52 = $e77fb34465299563$export$1f3342bf81d92d52;
var $b33b57a022d70eb2$export$236c05de452bec2;
"use strict";

var $cH4eu = parcelRequire("cH4eu");


var $4Elvw = parcelRequire("4Elvw");

/* tslint:enable:max-line-length */ /**
 * Returns an Observable that mirrors the first source Observable to emit an item
 * from the combination of this Observable and supplied Observables.
 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
 * @method race
 * @owner Observable
 */ function $b33b57a022d70eb2$var$race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function raceOperatorFunction(source) {
        // if the only argument is an array, it was most likely called with
        // `pair([obs1, obs2, ...])`
        if (observables.length === 1 && $cH4eu.isArray(observables[0])) observables = observables[0];
        return source.lift.call($4Elvw.race.apply(void 0, [
            source
        ].concat(observables)));
    };
}
$b33b57a022d70eb2$export$236c05de452bec2 = $b33b57a022d70eb2$var$race; //# sourceMappingURL=race.js.map


$fd6b6881ac0fa987$export$236c05de452bec2 = $b33b57a022d70eb2$export$236c05de452bec2;



$fd6b6881ac0fa987$export$533b26079ad0b4b = $7bBVm.reduce;

var $2yT9v = parcelRequire("2yT9v");

$fd6b6881ac0fa987$export$76d90c956114f2c2 = $2yT9v.repeat;

var $4E7OW = parcelRequire("4E7OW");

$fd6b6881ac0fa987$export$b39ac5b4ffd1415a = $4E7OW.repeatWhen;

var $9BXI4 = parcelRequire("9BXI4");

$fd6b6881ac0fa987$export$9369b12211e1fce4 = $9BXI4.retry;

var $jcaZc = parcelRequire("jcaZc");

$fd6b6881ac0fa987$export$1281551253cfee02 = $jcaZc.retryWhen;

var $8nouZ = parcelRequire("8nouZ");

$fd6b6881ac0fa987$export$18d0766d894cba0c = $8nouZ.refCount;

var $lyDF3 = parcelRequire("lyDF3");

$fd6b6881ac0fa987$export$4812e460280c6ef2 = $lyDF3.sample;

var $kNoLt = parcelRequire("kNoLt");

$fd6b6881ac0fa987$export$fe33c7b2002d97b0 = $kNoLt.sampleTime;

var $bbCp3 = parcelRequire("bbCp3");

$fd6b6881ac0fa987$export$c87d910e63d22ed6 = $bbCp3.scan;

var $i3T1u = parcelRequire("i3T1u");

$fd6b6881ac0fa987$export$d0a07e60ae428313 = $i3T1u.sequenceEqual;
var $810d8cd258a135ce$export$ed80d9de1d9df928;
"use strict";







function $810d8cd258a135ce$var$shareSubjectFactory() {
    return new $gGP9M.Subject();
}
/**
 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
 * This is an alias for .multicast(() => new Subject()).refCount().
 *
 * <img src="./img/share.png" width="100%">
 *
 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
 * @method share
 * @owner Observable
 */ function $810d8cd258a135ce$var$share() {
    return function(source) {
        return $8nouZ.refCount()($c13009df871a10ca$export$1364843af8d5a963($810d8cd258a135ce$var$shareSubjectFactory)(source));
    };
}
$810d8cd258a135ce$export$ed80d9de1d9df928 = $810d8cd258a135ce$var$share;
 //# sourceMappingURL=share.js.map


$fd6b6881ac0fa987$export$ed80d9de1d9df928 = $810d8cd258a135ce$export$ed80d9de1d9df928;
var $785e4d3b19154707$export$db61d692014e534e;
"use strict";



/**
 * @method shareReplay
 * @owner Observable
 */ function $785e4d3b19154707$var$shareReplay(bufferSize, windowTime, scheduler) {
    return function(source) {
        return source.lift($785e4d3b19154707$var$shareReplayOperator(bufferSize, windowTime, scheduler));
    };
}
$785e4d3b19154707$export$db61d692014e534e = $785e4d3b19154707$var$shareReplay;
function $785e4d3b19154707$var$shareReplayOperator(bufferSize, windowTime, scheduler) {
    var subject;
    var refCount = 0;
    var subscription;
    var hasError = false;
    var isComplete = false;
    return function shareReplayOperation(source) {
        refCount++;
        if (!subject || hasError) {
            hasError = false;
            subject = new $eyCIo.ReplaySubject(bufferSize, windowTime, scheduler);
            subscription = source.subscribe({
                next: function(value) {
                    subject.next(value);
                },
                error: function(err) {
                    hasError = true;
                    subject.error(err);
                },
                complete: function() {
                    isComplete = true;
                    subject.complete();
                }
            });
        }
        var innerSub = subject.subscribe(this);
        return function() {
            refCount--;
            innerSub.unsubscribe();
            if (subscription && refCount === 0 && isComplete) subscription.unsubscribe();
        };
    };
}
 //# sourceMappingURL=shareReplay.js.map


$fd6b6881ac0fa987$export$db61d692014e534e = $785e4d3b19154707$export$db61d692014e534e;

var $16fIO = parcelRequire("16fIO");

$fd6b6881ac0fa987$export$863d7ca51b416cee = $16fIO.single;

var $68JyP = parcelRequire("68JyP");

$fd6b6881ac0fa987$export$955fc4a6c4be454d = $68JyP.skip;

var $3jZqE = parcelRequire("3jZqE");

$fd6b6881ac0fa987$export$635f6273df29ea1c = $3jZqE.skipLast;

var $1bcQU = parcelRequire("1bcQU");

$fd6b6881ac0fa987$export$facc584867c26fde = $1bcQU.skipUntil;

var $ebEo2 = parcelRequire("ebEo2");

$fd6b6881ac0fa987$export$175dedd748069215 = $ebEo2.skipWhile;
var $c52579074ed2354b$export$a4fe86229b0e9bdd;
"use strict";

var $hmT2x = parcelRequire("hmT2x");


var $3deWP = parcelRequire("3deWP");


var $kjYch = parcelRequire("kjYch");





/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits the items you specify as arguments before it begins to emit
 * items emitted by the source Observable.
 *
 * <img src="./img/startWith.png" width="100%">
 *
 * @param {...T} values - Items you want the modified Observable to emit first.
 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
 * the emissions of the `next` notifications.
 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
 * emitted by the source Observable.
 * @method startWith
 * @owner Observable
 */ function $c52579074ed2354b$var$startWith() {
    var array = [];
    for(var _i = 0; _i < arguments.length; _i++)array[_i - 0] = arguments[_i];
    return function(source) {
        var scheduler = array[array.length - 1];
        if ($lRrDg.isScheduler(scheduler)) array.pop();
        else scheduler = null;
        var len = array.length;
        if (len === 1) return $b7fb214b02e40636$export$ee1b3e54f0441b22(new $3deWP.ScalarObservable(array[0], scheduler), source);
        else if (len > 1) return $b7fb214b02e40636$export$ee1b3e54f0441b22(new $hmT2x.ArrayObservable(array, scheduler), source);
        else return $b7fb214b02e40636$export$ee1b3e54f0441b22(new $kjYch.EmptyObservable(scheduler), source);
    };
}
$c52579074ed2354b$export$a4fe86229b0e9bdd = $c52579074ed2354b$var$startWith; //# sourceMappingURL=startWith.js.map


$fd6b6881ac0fa987$export$a4fe86229b0e9bdd = $c52579074ed2354b$export$a4fe86229b0e9bdd;
var $39e7ec2e1e97c538$export$6a45284a4b0bf33a;
"use strict";

var $c7Xul = parcelRequire("c7Xul");


var $lIS42 = parcelRequire("lIS42");

function $39e7ec2e1e97c538$var$switchAll() {
    return $c7Xul.switchMap($lIS42.identity);
}
$39e7ec2e1e97c538$export$6a45284a4b0bf33a = $39e7ec2e1e97c538$var$switchAll; //# sourceMappingURL=switchAll.js.map


$fd6b6881ac0fa987$export$6a45284a4b0bf33a = $39e7ec2e1e97c538$export$6a45284a4b0bf33a;



$fd6b6881ac0fa987$export$9f6ea8e48bc26eab = $c7Xul.switchMap;

var $15FKI = parcelRequire("15FKI");

$fd6b6881ac0fa987$export$a439dc30c845238 = $15FKI.switchMapTo;

var $eeWDH = parcelRequire("eeWDH");

$fd6b6881ac0fa987$export$b7df5d561049483a = $eeWDH.take;

var $lQvgf = parcelRequire("lQvgf");

$fd6b6881ac0fa987$export$1b47ad771ce5af5e = $lQvgf.takeLast;

var $fYICX = parcelRequire("fYICX");

$fd6b6881ac0fa987$export$ac8dfd3a7ad06e80 = $fYICX.takeUntil;

var $9xhQL = parcelRequire("9xhQL");

$fd6b6881ac0fa987$export$9384c7afe4015e42 = $9xhQL.takeWhile;

var $4ZLyq = parcelRequire("4ZLyq");

$fd6b6881ac0fa987$export$3f23594af5f37336 = $4ZLyq.tap;

var $1WunK = parcelRequire("1WunK");

$fd6b6881ac0fa987$export$de363e709c412c8a = $1WunK.throttle;

var $dtjlM = parcelRequire("dtjlM");

$fd6b6881ac0fa987$export$4efe28f192921dd4 = $dtjlM.throttleTime;

var $1mLOG = parcelRequire("1mLOG");

$fd6b6881ac0fa987$export$1a539c8b2950ab40 = $1mLOG.timeInterval;

var $cmyqT = parcelRequire("cmyqT");

$fd6b6881ac0fa987$export$83e74882c5df8fe1 = $cmyqT.timeout;

var $4YU6O = parcelRequire("4YU6O");

$fd6b6881ac0fa987$export$86fe999fba7953f2 = $4YU6O.timeoutWith;

var $1eEGG = parcelRequire("1eEGG");

$fd6b6881ac0fa987$export$fc00ee57782020aa = $1eEGG.timestamp;

var $34cAP = parcelRequire("34cAP");

$fd6b6881ac0fa987$export$45b10814cc054894 = $34cAP.toArray;

var $fkGmq = parcelRequire("fkGmq");

$fd6b6881ac0fa987$export$8291e5b88f90ce4 = $fkGmq.window;

var $cey0E = parcelRequire("cey0E");

$fd6b6881ac0fa987$export$f3a19e933f377396 = $cey0E.windowCount;

var $3FVta = parcelRequire("3FVta");

$fd6b6881ac0fa987$export$1284415effa79ee0 = $3FVta.windowTime;

var $468GZ = parcelRequire("468GZ");

$fd6b6881ac0fa987$export$3182be990e0eeaad = $468GZ.windowToggle;

var $a659n = parcelRequire("a659n");

$fd6b6881ac0fa987$export$6a5dea797879f644 = $a659n.windowWhen;

var $2PecL = parcelRequire("2PecL");

$fd6b6881ac0fa987$export$d449030e5c10edf7 = $2PecL.withLatestFrom;

var $jzRCB = parcelRequire("jzRCB");

$fd6b6881ac0fa987$export$8901015135f2fb22 = $jzRCB.zip;
var $8d1c0bb8abb490a4$export$adddb6a2fa3864e9;
"use strict";



function $8d1c0bb8abb490a4$var$zipAll(project) {
    return function(source) {
        return source.lift(new $jzRCB.ZipOperator(project));
    };
}
$8d1c0bb8abb490a4$export$adddb6a2fa3864e9 = $8d1c0bb8abb490a4$var$zipAll; //# sourceMappingURL=zipAll.js.map


$fd6b6881ac0fa987$export$adddb6a2fa3864e9 = $8d1c0bb8abb490a4$export$adddb6a2fa3864e9; //# sourceMappingURL=operators.js.map






var $gyUf8 = parcelRequire("gyUf8");





var $cK21K = parcelRequire("cK21K");








var $lfoFx = parcelRequire("lfoFx");


var $jp2Q3 = parcelRequire("jp2Q3");


var $8yKod = parcelRequire("8yKod");


var $qeywr = parcelRequire("qeywr");


var $3h37U = parcelRequire("3h37U");

var $dYD92 = parcelRequire("dYD92");


var $1uMa2 = parcelRequire("1uMa2");


var $gKVSw = parcelRequire("gKVSw");

var $6ojvx = parcelRequire("6ojvx");

var $4v1ex = parcelRequire("4v1ex");


var $1G3WB = parcelRequire("1G3WB");

const $ed8b01c4a83a1c53$export$144453187d3223d6 = (extension)=>extension?.properties?.staticView;
const $ed8b01c4a83a1c53$var$defaultStaticViewProperties = {
    isContentViewAvailable: false,
    contentKey: 'default'
};
const $ed8b01c4a83a1c53$var$extractExtensionStaticViewPropertiesImpl = (extension, properties)=>{
    if (!extension || !properties) return $ed8b01c4a83a1c53$var$defaultStaticViewProperties;
    const staticView = $ed8b01c4a83a1c53$export$144453187d3223d6(extension);
    if (!staticView) return $ed8b01c4a83a1c53$var$defaultStaticViewProperties;
    const contentKeyConfigLookupField = staticView.contentTitleConfigKey;
    const contentKey = properties[contentKeyConfigLookupField];
    return {
        isContentViewAvailable: !!contentKey,
        contentKey: contentKey ?? $ed8b01c4a83a1c53$var$defaultStaticViewProperties.contentKey
    };
};
const $ed8b01c4a83a1c53$var$defaultImpl = ()=>$ed8b01c4a83a1c53$var$defaultStaticViewProperties;
const $ed8b01c4a83a1c53$export$44e1e942f87ec1e9 = (0, $1G3WB.functionWithFG)('forge-ui-static-macros', $ed8b01c4a83a1c53$var$extractExtensionStaticViewPropertiesImpl, $ed8b01c4a83a1c53$var$defaultImpl);



var $a2foB = parcelRequire("a2foB");

const $8454dda16cf658c8$export$723a1497b2536563 = ({ showFlag: showFlag, hideFlag: hideFlag })=>{
    if (!showFlag || !hideFlag) return {};
    const createFlag = (flagOptions)=>{
        const { isAutoDismiss: isAutoDismiss, ...restOptions } = flagOptions;
        const { type: type, appearance: appearance, actions: actions } = flagOptions;
        const shouldAutoDismiss = isAutoDismiss ?? (appearance === 'info' || appearance === 'success');
        showFlag({
            ...restOptions,
            type: appearance ?? type,
            actions: actions?.map(({ text: content, onClick: onClick })=>({
                    onClick: ()=>onClick(),
                    content: content
                })),
            customComponent: shouldAutoDismiss ? (0, $a2foB.default) : undefined
        });
        return true;
    };
    const closeFlag = ({ id: id })=>{
        hideFlag(id);
        return true;
    };
    return {
        showFlag: createFlag,
        closeFlag: closeFlag
    };
};












var $6SsN4 = parcelRequire("6SsN4");




/**
 * @generated SignedSource<<7b44477e5366e798735b79abeb9aa6ef>>
 * @relayHash 9f5add8c554cee4aa25bd65ef402579c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 45e434683e79a84d6f76d9e5e7cf2c4d47020e40b0df83b10e143dee2dd76cbe
const $346b5f632f08dff0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageOffset"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageSize"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "pageSize"
        },
        {
            "kind": "Variable",
            "name": "offset",
            "variableName": "pageOffset"
        },
        {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
        }
    ], v6 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v7 = {
        "concreteType": "ContentBodyPerRepresentation",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentBody",
                "kind": "LinkedField",
                "name": "atlas_doc_format",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "title"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "queryTypedChildrenContentQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "PaginatedContentList",
                                    "kind": "LinkedField",
                                    "name": "children",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "queryTypedChildrenContentQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "PaginatedContentList",
                                    "kind": "LinkedField",
                                    "name": "children",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "45e434683e79a84d6f76d9e5e7cf2c4d47020e40b0df83b10e143dee2dd76cbe",
            "metadata": {},
            "name": "queryTypedChildrenContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$346b5f632f08dff0$var$node.hash = "0e23ecd85c3b1faf715343e340dca31c";
var $346b5f632f08dff0$export$2e2bcd8739ae039 = $346b5f632f08dff0$var$node;





const $69cb77abb357b865$var$formatResponseNodes = (content)=>{
    return content.reduce((acc, node)=>{
        return {
            ...acc,
            [node.title]: JSON.parse(node.body.atlas_doc_format.value)
        };
    }, {});
};
// Content type -> container ID -> keyed children (value)
const $69cb77abb357b865$var$containerChildrenContentCache = {};
const $69cb77abb357b865$export$34e4a3147c43af65 = ({ contentContainerId: contentContainerId, childContentType: childContentType })=>{
    return $69cb77abb357b865$var$containerChildrenContentCache[childContentType]?.[contentContainerId]?.values;
};
const $69cb77abb357b865$export$c027be1ebfc40079 = async ({ contentContainerId: contentContainerId, childContentType: childContentType, relayEnvironment: relayEnvironment })=>{
    var _containerChildrenContentCache, _childContentType, _containerCache, _contentContainerId, _contentCache;
    const containerCache = (_containerChildrenContentCache = $69cb77abb357b865$var$containerChildrenContentCache)[_childContentType = childContentType] ?? (_containerChildrenContentCache[_childContentType] = {});
    const contentCache = (_containerCache = containerCache)[_contentContainerId = contentContainerId] ?? (_containerCache[_contentContainerId] = {
        promise: null,
        values: null
    });
    if (!relayEnvironment) return null;
    const children = (_contentCache = contentCache).promise ?? (_contentCache.promise = new Promise((resolve, reject)=>{
        let allNodes = [];
        // Page size needs to be < 100 for manual pagination to work correctly..
        // >=100 results in pageInfo.hasNextPage always returning false.
        const pageSize = 99;
        let pageOffset = 0;
        const MAX_TOTAL_ITEMS = 1000;
        let hasNextPage = true;
        const fetchAllPages = async ()=>{
            try {
                while(hasNextPage && allNodes.length < MAX_TOTAL_ITEMS){
                    const data = await new Promise((pageResolve, pageReject)=>{
                        (0, $6SsN4.fetchQuery)(relayEnvironment, (0, $346b5f632f08dff0$export$2e2bcd8739ae039), {
                            id: contentContainerId,
                            type: childContentType,
                            pageSize: pageSize,
                            pageOffset: pageOffset
                        }, {
                            fetchPolicy: 'network-only'
                        }).subscribe({
                            next: pageResolve,
                            error: pageReject
                        });
                    });
                    const { nodes: nodes = [], pageInfo: pageInfo } = data?.content?.nodes?.[0]?.children || {};
                    const nextPage = pageInfo?.hasNextPage ?? false;
                    allNodes.push(...nodes);
                    // Stop loading if total count exceeds 1000
                    if (allNodes.length >= MAX_TOTAL_ITEMS) {
                        resolve(allNodes);
                        return;
                    }
                    hasNextPage = nextPage;
                    pageOffset += pageSize;
                }
                resolve(allNodes);
            } catch (error) {
                reject(error);
            }
        };
        fetchAllPages();
    }).then((responseNodes)=>{
        if (!responseNodes) return null;
        const content = $69cb77abb357b865$var$formatResponseNodes(responseNodes);
        contentCache.values = content;
        return content;
    }).catch(()=>{
        return null;
    }));
    return children;
};


const $957e2025cb5c0d52$var$getCustomContentType = (extension)=>{
    const appId = extension?.appId, envId = extension?.environmentId, customContentKey = extension?.properties?.staticView?.customContentTypeKey;
    if (!appId || !envId || !customContentKey) return null;
    return `forge:${appId}:${envId}:${customContentKey}`;
};
const $957e2025cb5c0d52$var$useMacroStaticContentViewImpl = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { extension: extension, contentContainerId: contentContainerId, contentKey: contentKey } = t0;
    let childContentType;
    let hasStaticViewDefinition;
    let t1;
    if ($[0] !== contentContainerId || $[1] !== contentKey || $[2] !== extension) {
        childContentType = $957e2025cb5c0d52$var$getCustomContentType(extension);
        hasStaticViewDefinition = !!extension?.properties?.staticView && !!childContentType;
        t1 = hasStaticViewDefinition ? (0, $69cb77abb357b865$export$34e4a3147c43af65)({
            contentContainerId: contentContainerId,
            childContentType: childContentType
        })?.[contentKey] : null;
        $[0] = contentContainerId;
        $[1] = contentKey;
        $[2] = extension;
        $[3] = childContentType;
        $[4] = hasStaticViewDefinition;
        $[5] = t1;
    } else {
        childContentType = $[3];
        hasStaticViewDefinition = $[4];
        t1 = $[5];
    }
    const cachedContentValue = t1;
    const relayEnvironment = (0, $6SsN4.useRelayEnvironment)();
    const t2 = hasStaticViewDefinition && !cachedContentValue;
    let t3;
    if ($[6] !== cachedContentValue || $[7] !== t2) {
        t3 = {
            isLoading: t2,
            content: cachedContentValue
        };
        $[6] = cachedContentValue;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    const [t4, setState] = (0, $cozmU.useState)(t3);
    const { isLoading: isLoading, content: content } = t4;
    let t5;
    let t6;
    if ($[9] !== cachedContentValue || $[10] !== childContentType || $[11] !== content || $[12] !== contentContainerId || $[13] !== contentKey || $[14] !== relayEnvironment) {
        t5 = ()=>{
            if (!!cachedContentValue && cachedContentValue === content) return;
            if (!!cachedContentValue && !content) {
                setState({
                    isLoading: false,
                    content: cachedContentValue
                });
                return;
            }
            let cancelled = false;
            (async ()=>{
                if (!childContentType) return;
                const childrenContent = await (0, $69cb77abb357b865$export$c027be1ebfc40079)({
                    contentContainerId: contentContainerId,
                    childContentType: childContentType,
                    relayEnvironment: relayEnvironment
                }).catch($957e2025cb5c0d52$var$_temp);
                if (cancelled || !childrenContent) return;
                setState({
                    isLoading: false,
                    content: childrenContent[contentKey]
                });
            })();
            return ()=>{
                cancelled = true;
            };
        };
        t6 = [
            content,
            cachedContentValue,
            contentKey,
            childContentType,
            contentContainerId,
            relayEnvironment
        ];
        $[9] = cachedContentValue;
        $[10] = childContentType;
        $[11] = content;
        $[12] = contentContainerId;
        $[13] = contentKey;
        $[14] = relayEnvironment;
        $[15] = t5;
        $[16] = t6;
    } else {
        t5 = $[15];
        t6 = $[16];
    }
    (0, $cozmU.useEffect)(t5, t6);
    const t7 = content;
    let t8;
    if ($[17] !== isLoading || $[18] !== t7) {
        t8 = {
            isLoading: isLoading,
            content: t7
        };
        $[17] = isLoading;
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    return t8;
} : ({ extension: extension, contentContainerId: contentContainerId, contentKey: contentKey })=>{
    const childContentType = $957e2025cb5c0d52$var$getCustomContentType(extension);
    const hasStaticViewDefinition = !!extension?.properties?.staticView && !!childContentType;
    const cachedContentValue = hasStaticViewDefinition ? (0, $69cb77abb357b865$export$34e4a3147c43af65)({
        contentContainerId: contentContainerId,
        childContentType: childContentType
    })?.[contentKey] : null;
    const relayEnvironment = (0, $6SsN4.useRelayEnvironment)();
    const [{ isLoading: isLoading, content: content }, setState] = (0, $cozmU.useState)({
        isLoading: hasStaticViewDefinition && !cachedContentValue,
        content: cachedContentValue
    });
    (0, $cozmU.useEffect)(()=>{
        // First render matches content.
        if (!!cachedContentValue && cachedContentValue === content) return;
        // No content -> content found (e.g. contentKey changed).
        if (!!cachedContentValue && !content) {
            setState({
                isLoading: false,
                content: cachedContentValue
            });
            return;
        }
        let cancelled = false;
        // Content type not yet queried.
        (async ()=>{
            if (!childContentType) return;
            const childrenContent = await (0, $69cb77abb357b865$export$c027be1ebfc40079)({
                contentContainerId: contentContainerId,
                childContentType: childContentType,
                relayEnvironment: relayEnvironment
            }).catch(()=>null);
            if (cancelled || !childrenContent) return;
            setState({
                isLoading: false,
                content: childrenContent[contentKey]
            });
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        content,
        cachedContentValue,
        contentKey,
        childContentType,
        contentContainerId,
        relayEnvironment
    ]);
    return {
        isLoading: isLoading,
        content: content
    };
};
const $957e2025cb5c0d52$var$defaultImpl = (_)=>({
        isLoading: false,
        content: null
    });
const $957e2025cb5c0d52$export$fa4a375558cec54f = (0, $1G3WB.functionWithFG)('forge-ui-static-macros', $957e2025cb5c0d52$var$useMacroStaticContentViewImpl, $957e2025cb5c0d52$var$defaultImpl);
function $957e2025cb5c0d52$var$_temp() {
    return null;
}














const $ffcaaa2cf6e880bd$export$7fa3a225a8945f98 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (enabled)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    let t1;
    if ($[0] !== enabled) {
        t0 = ()=>{
            if (!enabled) return;
            const origin = window.location.origin;
            const readyEventSub = (0, $1uMa2.on)("EXTENSION_READY", async (t2)=>{
                const { localId: localId } = t2;
                window.postMessage({
                    source: "forge-extension",
                    type: "EXTENSION_READY",
                    localId: localId
                }, origin);
            });
            return ()=>{
                readyEventSub.unsubscribe();
            };
        };
        t1 = [
            enabled
        ];
        $[0] = enabled;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
} : (enabled)=>{
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) return;
        const origin = window.location.origin;
        const readyEventSub = (0, $1uMa2.on)('EXTENSION_READY', async ({ localId: localId })=>{
            window.postMessage({
                source: 'forge-extension',
                type: 'EXTENSION_READY',
                localId: localId
            }, origin);
        });
        return ()=>{
            readyEventSub.unsubscribe();
        };
    }, [
        enabled
    ]);
};





const $1dfa1ff46d40bb55$export$823759185d8a77e8 = ({ isEditing: isEditing, localId: localId, editorAPI: editorAPI })=>{
    if (!isEditing) return undefined;
    const getEditorContent = async ()=>{
        return new Promise((resolve)=>{
            editorAPI?.core?.actions.requestDocument((doc)=>{
                if (!doc) resolve({
                    data: ''
                });
                else resolve({
                    data: JSON.stringify(doc)
                });
            });
        });
    };
    const getMacroContent = async (bridgeData)=>{
        const extensionAPI = editorAPI?.extension?.actions?.api();
        if (!extensionAPI) throw new Error('Unable to get macro content: extensionAPI is not available');
        try {
            const macroLocalId = bridgeData?.embeddedMacroLocalId ?? localId;
            const nodeWithPos = extensionAPI.getNodeWithPosByLocalId(macroLocalId);
            const { node: node } = nodeWithPos;
            return {
                data: JSON.stringify(node)
            };
        } catch (error) {
            throw new Error(`Failed to get macro: ${error}`);
        }
    };
    const updateMacro = async (newExtensionContent)=>{
        if (!newExtensionContent?.data) return false;
        try {
            const macroLocalId = newExtensionContent?.embeddedMacroLocalId ?? localId;
            const newExtensionData = JSON.parse(newExtensionContent.data);
            const extensionAPI = editorAPI?.extension?.actions?.api();
            if (extensionAPI && newExtensionData) {
                extensionAPI.doc?.update(macroLocalId, ()=>newExtensionData);
                return true;
            }
        } catch (error) {
            throw new Error(`Failed to update macro: ${error}`);
        }
        return false;
    };
    const setMacroViewportHeight = async (height)=>{
        if (!(0, $iDrrr.fg)('platform_measure_macro_height')) throw new Error('setMacroViewportHeight is not available');
        try {
            const extensionAPI = editorAPI?.extension?.actions?.api();
            if (extensionAPI) {
                extensionAPI.doc?.update(localId, (currNode)=>{
                    const newNode = {
                        attrs: {
                            ...currNode.attrs,
                            parameters: {
                                ...currNode.attrs?.parameters,
                                viewportHeight: height
                            }
                        }
                    };
                    return newNode;
                });
                return true;
            }
        } catch (error) {
            throw new Error(`Failed to set the macro's viewport height: ${error}`);
        }
        return false;
    };
    return {
        getEditorContent: getEditorContent,
        getMacroContent: getMacroContent,
        updateMacro: updateMacro,
        setMacroViewportHeight: setMacroViewportHeight
    };
};





/**
 * Finds the macro node by `macroLocalId`, falling back to `migratedForgeLocalId`.
 *
 * For connect to forge migrated macros, the node may be identified by the localId given by
 * the editor (`migratedForgeLocalId`, from `extension.parameters.localId`) rather than `localId`.
 *
 * Note: `getNodeWithPosByLocalId` throws (rather than returning null) when the node is not found.
 * Returns the node along with the localId that was used to find it.
 *
 * Only call this when `platform_migrated_forge_local_id_confluence_bridge` is enabled.
 */ const $4c21319b6cac852a$var$getMacroNodeWithPos = (extensionAPI, macroLocalId, migratedForgeLocalId)=>{
    try {
        const nodeWithPos = extensionAPI.getNodeWithPosByLocalId(macroLocalId);
        return {
            nodeWithPos: nodeWithPos,
            resolvedLocalId: macroLocalId
        };
    } catch (error) {
        const canFallback = !!migratedForgeLocalId && migratedForgeLocalId !== macroLocalId;
        if (!canFallback) throw error;
        const nodeWithPos = extensionAPI.getNodeWithPosByLocalId(migratedForgeLocalId);
        return {
            nodeWithPos: nodeWithPos,
            resolvedLocalId: migratedForgeLocalId
        };
    }
};
const $4c21319b6cac852a$export$eb4e2fb67dcd4d5b = ({ editorAPI: editorAPI })=>{
    const getEditorContent = async ({ extensionPayload: extensionPayload }, _payload)=>{
        if (!extensionPayload?.isEditing) return undefined;
        return new Promise((resolve)=>{
            editorAPI?.core?.actions.requestDocument((doc)=>{
                if (!doc) resolve({
                    data: ''
                });
                else resolve({
                    data: JSON.stringify(doc)
                });
            });
        });
    };
    const getMacroContent = async ({ resolverContext: resolverContext, extensionPayload: extensionPayload }, _payload)=>{
        if (!extensionPayload?.isEditing) return undefined;
        const extensionAPI = editorAPI?.extension?.actions?.api();
        if (!extensionAPI) throw new Error('Unable to get macro content: extensionAPI is not available');
        try {
            const macroLocalId = resolverContext?.localId;
            const nodeWithPos = (0, $iDrrr.fg)('platform_migrated_forge_local_id_confluence_bridge') ? $4c21319b6cac852a$var$getMacroNodeWithPos(extensionAPI, macroLocalId, resolverContext?.migratedForgeLocalId).nodeWithPos : extensionAPI.getNodeWithPosByLocalId(macroLocalId);
            const { node: node } = nodeWithPos;
            return {
                data: JSON.stringify(node)
            };
        } catch (error) {
            throw new Error(`Failed to get macro: ${error}`);
        }
    };
    const updateMacro = async ({ resolverContext: resolverContext, extensionPayload: extensionPayload }, payload)=>{
        if (!extensionPayload?.isEditing) return false;
        const newExtensionContent = payload;
        if (!newExtensionContent?.data) return false;
        try {
            const macroLocalId = resolverContext?.localId;
            const newExtensionData = JSON.parse(newExtensionContent.data);
            const extensionAPI = editorAPI?.extension?.actions?.api();
            if (extensionAPI && newExtensionData) {
                const localIdToUpdate = (0, $iDrrr.fg)('platform_migrated_forge_local_id_confluence_bridge') ? $4c21319b6cac852a$var$getMacroNodeWithPos(extensionAPI, macroLocalId, resolverContext?.migratedForgeLocalId).resolvedLocalId : macroLocalId;
                extensionAPI.doc?.update(localIdToUpdate, ()=>newExtensionData);
                return true;
            }
        } catch (error) {
            throw new Error(`Failed to update macro: ${error}`);
        }
        return false;
    };
    const setMacroViewportHeight = async ({ resolverContext: resolverContext, extensionPayload: extensionPayload }, payload)=>{
        if (!extensionPayload?.isEditing) return false;
        if (!(0, $iDrrr.fg)('platform_measure_macro_height')) throw new Error('setMacroViewportHeight is not available');
        const height = payload;
        const macroLocalId = resolverContext?.localId;
        try {
            const extensionAPI = editorAPI?.extension?.actions?.api();
            if (extensionAPI) {
                const localIdToUpdate = (0, $iDrrr.fg)('platform_migrated_forge_local_id_confluence_bridge') ? $4c21319b6cac852a$var$getMacroNodeWithPos(extensionAPI, macroLocalId, resolverContext?.migratedForgeLocalId).resolvedLocalId : macroLocalId;
                extensionAPI.doc?.update(localIdToUpdate, (currNode)=>({
                        attrs: {
                            ...currNode.attrs,
                            parameters: {
                                ...currNode.attrs?.parameters,
                                viewportHeight: height
                            }
                        }
                    }));
                return true;
            }
        } catch (error) {
            throw new Error(`Failed to set the macro's viewport height: ${error}`);
        }
        return false;
    };
    return {
        getEditorContent: getEditorContent,
        getMacroContent: getMacroContent,
        updateMacro: updateMacro,
        setMacroViewportHeight: setMacroViewportHeight
    };
};


const $bf4a93b18a6c4623$var$spinnerContainerStyles = null; // Module-level constant to ensure referential stability across renders.
const $bf4a93b18a6c4623$export$5b3cf03752a81609 = (prev, next, changes, getContext)=>{
    if (!changes.extensionPayloadChanges.config) return;
    const prevConfig = prev.extensionPayload?.config;
    const nextConfig = next.extensionPayload?.config; // extensionPayloadChanges is a reference pre-filter only — verify actual value change
    // to avoid spurious emits when Confluence reconstructs the payload object.
    if (!(0, $5W8qe.dequal)(prevConfig, nextConfig)) getContext().emit('FORGE_CORE_MACRO_CONFIG_CHANGED', {
        config: nextConfig
    });
}; // This is added to contextChangeListeners of the ForgeUIRenderer, and this setup is currently only applicable to
// v2 bridge runtime (https://hello.atlassian.net/wiki/x/ep08mwE), and will not have impact to current behaviors.
// All the changes are guarded behind `forge-ui-bridge-core-reset` feature gate, and hence no impact on the production
// environment for this change.
const $bf4a93b18a6c4623$var$MACRO_CONFIG_CHANGE_LISTENERS = [
    $bf4a93b18a6c4623$export$5b3cf03752a81609
];
const $bf4a93b18a6c4623$export$a61c6459586c5198 = ({ accountId: accountId, contextIds: contextIds, coreData: coreData, configLocalId: configLocalId, dataProviders: dataProviders, nestedAdfMediaProvider: nestedAdfMediaProvider, extensionData: extensionData, extensionViewData: extensionViewData, extensionPayload: extensionPayload, environment: environment, extension: extension, forgeMacroExtensions: forgeMacroExtensions, isBodiedMacro: isBodiedMacro, isInlinePresentation: isInlinePresentation = false, locale: locale, migratedForgeLocalId: migratedForgeLocalId, flags: flags, getContextToken: getContextToken, productExtensionHandlers: productExtensionHandlers, customEditContext: customEditContext, isEditing: isEditing, editorAPI: editorAPI, onForgeDocUpdated: onForgeDocUpdated, viewportDimensions: viewportDimensions, useRouteActions: useRouteActions })=>{
    const { cloudId: cloudId, localId: localId } = coreData;
    const modalExtension = customEditContext?.modalExtension;
    const bridge = customEditContext?.bridge;
    const memoizedCustomBridgeMethods = (0, $cozmU.useMemo)(()=>{
        return (0, $1dfa1ff46d40bb55$export$823759185d8a77e8)({
            isEditing: isEditing,
            localId: localId,
            editorAPI: editorAPI
        });
    }, [
        isEditing,
        localId,
        editorAPI
    ]);
    const memoizedCustomBridgeMethodsV2 = (0, $cozmU.useMemo)(()=>{
        if (!(0, $iDrrr.fg)('forge-ui-bridge-core-reset')) return;
        return (0, $4c21319b6cac852a$export$eb4e2fb67dcd4d5b)({
            editorAPI: editorAPI
        });
    }, [
        editorAPI
    ]);
    const confluenceSpa = useRouteActions?.();
    const [macroConfigForgeDocSubject$] = (0, $cozmU.useState)(()=>new (0, $eyCIo.ReplaySubject)(10));
    const configValueRef = (0, $cozmU.useRef)(undefined); // Stores the forgeDoc for the macro config schema. The ref is often a render behind
    // the actual schema, so should only be used on the initial load.
    const macroConfigForgeDocRef = (0, $cozmU.useRef)(undefined); // This sets up an event listener to respond to Editor's requests for the macro config schema.
    // When the GET_CONFIG_FORGE_DOC_${id} event is emitted, the payload includes the current
    // config value, and the resolve and reject functions of a Promise. The listener should be
    // resolving the promise with the value of the macro config forgeDoc.
    // Migrated macros use their original macro ID for configuration, while body APIs need the ADF node ID.
    const id = `${extension.id}-${(0, $iDrrr.fg)('platform_forge_dynamic_connect_key') ? configLocalId ?? coreData.localId : coreData.localId}`;
    const reconcile = (0, $cozmU.useCallback)(({ forgeDoc: forgeDoc })=>{
        Object.freeze(forgeDoc);
        macroConfigForgeDocRef.current = forgeDoc;
        macroConfigForgeDocSubject$.next(forgeDoc);
        (0, $1uMa2.emit)(`CONFIG_FORGE_DOC_UPDATED_${id}`);
    }, [
        id,
        macroConfigForgeDocSubject$
    ]);
    (0, $cozmU.useEffect)(()=>{
        const macroConfigForgeDocSubscription = (0, $1uMa2.on)(`GET_CONFIG_FORGE_DOC_${id}`, async ({ resolve: resolve, config: config })=>{
            const subscription = macroConfigForgeDocSubject$.pipe((0, $fd6b6881ac0fa987$export$7843a4469d64c07e)(200)).subscribe({
                next: (forgeDoc_0)=>{
                    resolve({
                        type: 'Root',
                        props: {},
                        children: [
                            forgeDoc_0
                        ]
                    });
                    subscription.unsubscribe();
                }
            });
            configValueRef.current = config;
        });
        return ()=>{
            macroConfigForgeDocSubscription.unsubscribe();
        };
    }, [
        id,
        macroConfigForgeDocSubject$
    ]);
    /*the emitReadyEvent emited by the macro
  must be receive by cc-puppeteer an internal service responsible for
  generating PDFs from confluence pages, the issue is that it does not
  recieve events from other origins such as iframes, so we capture and
  reemit the event here */ (0, $ffcaaa2cf6e880bd$export$7fa3a225a8945f98)((0, $iDrrr.fg)('forge-ui-reemit-ready-event'));
    const { showFlag: showFlag, closeFlag: closeFlag } = (0, $cozmU.useMemo)(()=>(0, $8454dda16cf658c8$export$723a1497b2536563)(flags), [
        flags
    ]);
    const bridgeConfig = (0, $cozmU.useMemo)(()=>({
            ...bridge,
            showFlag: showFlag,
            closeFlag: closeFlag,
            reconcile: reconcile,
            spaPush: confluenceSpa?.push
        }), [
        bridge,
        showFlag,
        closeFlag,
        reconcile,
        confluenceSpa?.push
    ]); // For bodied macros, adf content is stored in context.extension.macro.body. Forward the host
    // ProviderFactory (the nested renderer picks the task-decision + context-identifier providers off
    // it) so action items inside the macro body can persist their checked state. This is scoped to
    // bodied macros; undefined otherwise so no providers are forwarded.
    const bodiedMacroDataProviders = (0, $cozmU.useMemo)(()=>{
        if (!isBodiedMacro || !dataProviders) return undefined;
        return dataProviders;
    }, [
        dataProviders,
        isBodiedMacro
    ]);
    const AdfRendererWithEmbeddedMacros = (0, $cozmU.useMemo)(()=>(0, $qeywr.makeADFRenderer)({
            bridge: bridgeConfig,
            userId: accountId,
            customBridgeMethods: memoizedCustomBridgeMethods,
            customBridge: (0, $iDrrr.fg)('forge-ui-bridge-core-reset') ? memoizedCustomBridgeMethodsV2 : undefined,
            getContextToken: getContextToken,
            extensionData: extensionData,
            isEditing: isEditing,
            productExtensionHandlers: productExtensionHandlers,
            cloudId: cloudId,
            forgeMacroExtensions: forgeMacroExtensions,
            productContextIds: contextIds,
            dataProviders: bodiedMacroDataProviders,
            nestedAdfMediaProvider: nestedAdfMediaProvider
        }), [
        accountId,
        bridgeConfig,
        cloudId,
        contextIds,
        forgeMacroExtensions,
        getContextToken,
        extensionData,
        memoizedCustomBridgeMethods,
        memoizedCustomBridgeMethodsV2,
        isEditing,
        productExtensionHandlers,
        bodiedMacroDataProviders,
        nestedAdfMediaProvider
    ]);
    let loadingComponent;
    if (!(0, $8yKod.isCustomUI)(extension) && modalExtension) loadingComponent = /*#__PURE__*/ $cozmU.createElement((0, $cK21K.default), {
        zIndex: (0, $jp2Q3.layers).blanket()
    }, /*#__PURE__*/ $cozmU.createElement((0, $gyUf8.default), {
        isTinted: true,
        onBlanketClicked: ()=>modalExtension.closeModalExtension()
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _39xV02N91d _0jFU0VN91d _0hPCNLDIqT _37wbyuDIqT _1pp6NdYbGa"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        size: "large"
    }))));
     // Sets the forgeDoc for classic sidebar macro config
    const handleMacroConfigForgeDoc = (0, $cozmU.useCallback)((forgeDoc_1)=>{
        if (forgeDoc_1.type === 'MacroConfig') {
            if (customEditContext) throw new Error('ForgeReconciler.addConfig() cannot be called from within a custom config resource');
            macroConfigForgeDocRef.current = forgeDoc_1;
            macroConfigForgeDocSubject$.next(forgeDoc_1);
            (0, $1uMa2.emit)(`CONFIG_FORGE_DOC_UPDATED_${id}`);
        }
    }, [
        customEditContext,
        id,
        macroConfigForgeDocRef,
        macroConfigForgeDocSubject$
    ]);
    const { isContentViewAvailable: isContentViewAvailable, contentKey: contentKey } = (0, $ed8b01c4a83a1c53$export$44e1e942f87ec1e9)(extension, extensionPayload.config);
    const { isLoading: isLoading, content: content } = (0, $957e2025cb5c0d52$export$fa4a375558cec54f)({
        extension: extension,
        contentContainerId: extensionData?.content?.id,
        contentKey: contentKey
    });
    const shouldRenderStaticContentView = !modalExtension && isContentViewAvailable && (isLoading || content);
    if (shouldRenderStaticContentView) return /*#__PURE__*/ $cozmU.createElement((0, $hRnS5.RendererActionsContext), null, content ? /*#__PURE__*/ $cozmU.createElement((0, $3BY7M.default), {
        document: content
    }) : /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        size: "small"
    }));
    return /*#__PURE__*/ $cozmU.createElement((0, $6ojvx.EnvironmentContext).Provider, {
        value: environment
    }, /*#__PURE__*/ $cozmU.createElement((0, $4v1ex.ForgeUIRenderer), {
        accountId: accountId,
        bridge: bridgeConfig,
        cloudId: cloudId,
        contextIds: [
            `ari:cloud:confluence::site/${cloudId}`
        ],
        components: {
            // Override to use latest renderer with embedded macro support for Confluence
            ...(0, $iDrrr.fg)('platform-forge-ui-kit-adf-renderer') ? {
                AdfRenderer: AdfRendererWithEmbeddedMacros
            } : {},
            ChromelessEditor: $3h37U.ChromelessEditor,
            CommentEditor: $dYD92.CommentEditor
        },
        extension: extension,
        extensionData: extensionData,
        extensionViewData: extensionViewData,
        extensionPayload: extensionPayload,
        customBridgeMethods: memoizedCustomBridgeMethods,
        customBridge: memoizedCustomBridgeMethodsV2,
        height: extension.properties.viewportSize && !isInlinePresentation ? (0, $gKVSw.calculateViewportSizeHeight)(extension.properties.viewportSize) : undefined,
        isInlinePresentation: isInlinePresentation,
        locale: locale,
        localId: localId,
        migratedForgeLocalId: migratedForgeLocalId,
        getContextToken: getContextToken,
        product: "confluence",
        onForgeDocUpdated: (forgeDoc_2)=>{
            onForgeDocUpdated?.(forgeDoc_2);
            handleMacroConfigForgeDoc(forgeDoc_2);
        },
        modalExtension: modalExtension,
        onModalExtensionClose: modalExtension?.closeModalExtension,
        loadingComponent: loadingComponent,
        viewportDimensions: viewportDimensions,
        contextChangeListeners: $bf4a93b18a6c4623$var$MACRO_CONFIG_CHANGE_LISTENERS
    }));
};


const $13e0118f3a6b7faa$var$styles1 = null;
const $13e0118f3a6b7faa$var$styles2 = null;
const $13e0118f3a6b7faa$var$APP_CONTAINER_PADDING = "var(--ds-space-100, 8px)";
const $13e0118f3a6b7faa$var$useMemoedExtensionData = (extensionData)=>{
    const ref = (0, $cozmU.useRef)(extensionData);
    if (!(0, $5W8qe.dequal)(ref.current, extensionData)) ref.current = extensionData;
    return ref.current;
};
const $13e0118f3a6b7faa$var$ForgeUIExtensionWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(92);
    const { contextIds: contextIds, cloudId: cloudId, environment: environment, extensionData: extensionData, editorAPI: editorAPI, accountId: accountId, dataProviders: dataProviders, nestedAdfMediaProvider: nestedAdfMediaProvider, extension: extension, isEditing: isEditing, flags: flags, forgeMacroExtensions: forgeMacroExtensions, getContextToken: getContextToken, productExtensionHandlers: productExtensionHandlers, hideGlassPane: hideGlassPane, customEditContext: customEditContext, useRouteActions: useRouteActions } = t0;
    const elRef = (0, $cozmU.useRef)(null);
    const timerRef = (0, $cozmU.useRef)(null);
    const { extension: gqlExtension, extensionId: extensionId, extensionTitle: extensionTitle, measuredHeight: measuredHeight, viewportHeight: viewportHeight } = extension.parameters;
    let localId;
    if ($[0] !== extension.localId || $[1] !== extension.parameters.localId) {
        localId = "";
        if ((0, $iDrrr.fg)("forge-ui-use-extension-local-id")) localId = extension?.localId || extension.parameters?.localId || "";
        else {
            localId = extension.parameters?.localId || "";
            if (!localId) localId = extension.localId;
        }
        $[0] = extension.localId;
        $[1] = extension.parameters.localId;
        $[2] = localId;
    } else localId = $[2];
    const paramsLocalId = extension.parameters?.localId || extension.localId || "";
    const migratedForgeLocalId = extension.localId;
    let t1;
    if ($[3] !== measuredHeight || $[4] !== viewportHeight) {
        t1 = (0, $iDrrr.fg)("platform_measure_macro_height") ? {
            measuredHeight: measuredHeight,
            viewportHeight: viewportHeight
        } : undefined;
        $[3] = measuredHeight;
        $[4] = viewportHeight;
        $[5] = t1;
    } else t1 = $[5];
    const viewportDimensions = t1;
    let t2;
    if ($[6] !== extension.parameters) {
        t2 = (0, $0e17dde5dc080ea0$export$44487a86467333c3)(extension.parameters);
        $[6] = extension.parameters;
        $[7] = t2;
    } else t2 = $[7];
    const config = t2;
    const isBodiedMacro = extension.type === "bodiedExtension";
    let t3;
    if ($[8] !== extension.content || $[9] !== isBodiedMacro) {
        t3 = isBodiedMacro && !!extension.content ? {
            macro: {
                body: {
                    type: "doc",
                    version: 1,
                    content: extension.content
                }
            }
        } : {};
        $[8] = extension.content;
        $[9] = isBodiedMacro;
        $[10] = t3;
    } else t3 = $[10];
    const extensionViewData = t3;
    const t4 = gqlExtension;
    let t5;
    if ($[11] !== t4) {
        t5 = (0, $90b5d8eb44fcddd8$export$cb9938fa51e44b87)(t4);
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    const isAdfExport = t5;
    const isHostedResource = Boolean(gqlExtension?.properties?.resource);
    const isUiKitTwo = gqlExtension?.properties?.render === "native";
    const isCustomUI = isHostedResource && !isUiKitTwo;
    let t6;
    if ($[13] !== gqlExtension?.properties?.layout || $[14] !== isBodiedMacro || $[15] !== isEditing) {
        t6 = isBodiedMacro && !isEditing && (0, $iDrrr.fg)("platform_forge_inline_bodied_layout_switch") && gqlExtension?.properties?.layout === "inline-bodied" && (0, $iDrrr.fg)("platform_forge_inline_bodied_macro");
        $[13] = gqlExtension?.properties?.layout;
        $[14] = isBodiedMacro;
        $[15] = isEditing;
        $[16] = t6;
    } else t6 = $[16];
    const isInlineBodiedLayout = t6;
    const isInlineBodied = isInlineBodiedLayout && !isCustomUI && config?.[0, $iNIw3.FORGE_INLINE_BODIED_PARAM] === "true";
    const isInlineBodiedCustomUI = isInlineBodiedLayout && isCustomUI;
    const isInline = (gqlExtension?.properties?.layout === "inline" || isInlineBodied || isInlineBodiedCustomUI) && (!isCustomUI || isInlineBodiedCustomUI);
    localId;
    let t7;
    if ($[17] !== cloudId || $[18] !== localId) {
        t7 = {
            localId: localId,
            cloudId: cloudId
        };
        $[17] = cloudId;
        $[18] = localId;
        $[19] = t7;
    } else t7 = $[19];
    const coreData = t7;
    let t8;
    if ($[20] !== customEditContext) {
        t8 = customEditContext ? {
            isConfiguring: true,
            isInserting: customEditContext.isInserting
        } : {};
        $[20] = customEditContext;
        $[21] = t8;
    } else t8 = $[21];
    let t9;
    if ($[22] !== isBodiedMacro) {
        t9 = isBodiedMacro ? {
            layout: "bodied"
        } : {};
        $[22] = isBodiedMacro;
        $[23] = t9;
    } else t9 = $[23];
    let t10;
    if ($[24] !== t8 || $[25] !== t9) {
        t10 = {
            ...t8,
            ...t9
        };
        $[24] = t8;
        $[25] = t9;
        $[26] = t10;
    } else t10 = $[26];
    const macroExtensionData = t10;
    let t11;
    if ($[27] !== gqlExtension?.appId) {
        t11 = gqlExtension?.appId === "76206a70-b9d6-4328-9e20-db79196c548a" && (0, $iDrrr.fg)("forge-ui-move-macro-data-for-tempo");
        $[27] = gqlExtension?.appId;
        $[28] = t11;
    } else t11 = $[28];
    const enabledForTempo = t11;
    let t12;
    if ($[29] !== enabledForTempo) {
        t12 = enabledForTempo || (0, $iDrrr.fg)("forge-ui-move-macro-data-to-extension-data");
        $[29] = enabledForTempo;
        $[30] = t12;
    } else t12 = $[30];
    const shouldIncludeMacroDataInExtensionData = t12;
    const memoedExtensionData = $13e0118f3a6b7faa$var$useMemoedExtensionData(extensionData);
    let t13;
    if ($[31] !== config || $[32] !== isEditing || $[33] !== macroExtensionData || $[34] !== shouldIncludeMacroDataInExtensionData) {
        t13 = shouldIncludeMacroDataInExtensionData ? {
            config: config
        } : {
            config: config,
            isEditing: isEditing,
            ...Object.keys(macroExtensionData).length ? {
                macro: macroExtensionData
            } : {}
        };
        $[31] = config;
        $[32] = isEditing;
        $[33] = macroExtensionData;
        $[34] = shouldIncludeMacroDataInExtensionData;
        $[35] = t13;
    } else t13 = $[35];
    const extensionPayload = $13e0118f3a6b7faa$var$useMemoedExtensionData(t13);
    let t14;
    if ($[36] !== extensionPayload || $[37] !== extensionViewData) {
        t14 = {
            ...extensionPayload,
            ...extensionViewData
        };
        $[36] = extensionPayload;
        $[37] = extensionViewData;
        $[38] = t14;
    } else t14 = $[38];
    const adfExportExtensionPayload = t14;
    const { locale: locale } = (0, $kSwu1.useIntl)();
    let t15;
    if ($[39] !== editorAPI?.extension?.actions || $[40] !== editorAPI?.extension?.sharedState || $[41] !== isBodiedMacro || $[42] !== isEditing || $[43] !== localId || $[44] !== paramsLocalId) {
        t15 = (forgeDoc)=>{
            if (isBodiedMacro && forgeDoc?.children?.[0]?.type === "AdfRenderer") {
                const event = new CustomEvent((0, $iNIw3.FORGE_DOC_UPDATED_EVENT), {
                    detail: {
                        forgeDoc: forgeDoc,
                        localId: (0, $iDrrr.fg)("forge-ui-use-extension-local-id") ? paramsLocalId : localId
                    },
                    bubbles: true
                });
                document.dispatchEvent(event);
            }
            if ((0, $iDrrr.fg)("platform_measure_macro_height")) {
                const isContextPanelOpen = editorAPI?.extension?.sharedState?.currentState()?.showContextPanel;
                const actionsAPI = editorAPI?.extension?.actions?.api();
                if (!actionsAPI || !isContextPanelOpen) return;
                if (elRef.current && isEditing) {
                    if (timerRef.current) clearTimeout(timerRef.current);
                    timerRef.current = setTimeout(()=>{
                        const rectHeight = elRef?.current?.getBoundingClientRect().height;
                        try {
                            actionsAPI.doc.update(localId, (currentNode)=>{
                                const newNode = {
                                    attrs: {
                                        ...currentNode.attrs,
                                        parameters: {
                                            ...currentNode.attrs?.parameters,
                                            measuredHeight: rectHeight
                                        }
                                    }
                                };
                                return newNode;
                            });
                        } catch  {}
                    }, 3000);
                }
            }
        };
        $[39] = editorAPI?.extension?.actions;
        $[40] = editorAPI?.extension?.sharedState;
        $[41] = isBodiedMacro;
        $[42] = isEditing;
        $[43] = localId;
        $[44] = paramsLocalId;
        $[45] = t15;
    } else t15 = $[45];
    const handleOnMacroUpdated = t15;
    let t16;
    if ($[46] !== accountId || $[47] !== adfExportExtensionPayload || $[48] !== contextIds || $[49] !== coreData || $[50] !== customEditContext || $[51] !== dataProviders || $[52] !== editorAPI || $[53] !== environment || $[54] !== extensionId || $[55] !== extensionPayload || $[56] !== extensionTitle || $[57] !== extensionViewData || $[58] !== flags || $[59] !== forgeMacroExtensions || $[60] !== getContextToken || $[61] !== gqlExtension || $[62] !== handleOnMacroUpdated || $[63] !== isAdfExport || $[64] !== isBodiedMacro || $[65] !== isEditing || $[66] !== isHostedResource || $[67] !== isInlineBodiedCustomUI || $[68] !== locale || $[69] !== memoedExtensionData || $[70] !== migratedForgeLocalId || $[71] !== nestedAdfMediaProvider || $[72] !== paramsLocalId || $[73] !== productExtensionHandlers || $[74] !== useRouteActions || $[75] !== viewportDimensions) {
        t16 = ()=>{
            if (isAdfExport && isHostedResource) {
                const fallbackRenderer = ()=>/*#__PURE__*/ $cozmU.createElement((0, $kKOjD.ReservedHeightWrapper), {
                        extension: gqlExtension,
                        isInlinePresentation: isInlineBodiedCustomUI
                    }, /*#__PURE__*/ $cozmU.createElement((0, $bf4a93b18a6c4623$export$a61c6459586c5198), {
                        accountId: accountId,
                        contextIds: contextIds,
                        environment: environment,
                        extension: gqlExtension,
                        coreData: coreData,
                        migratedForgeLocalId: migratedForgeLocalId,
                        extensionData: memoedExtensionData,
                        extensionPayload: adfExportExtensionPayload,
                        extensionViewData: extensionViewData,
                        forgeMacroExtensions: forgeMacroExtensions,
                        flags: flags,
                        getContextToken: getContextToken,
                        isEditing: false,
                        locale: locale,
                        onForgeDocUpdated: handleOnMacroUpdated,
                        useRouteActions: useRouteActions,
                        viewportDimensions: viewportDimensions,
                        productExtensionHandlers: productExtensionHandlers,
                        nestedAdfMediaProvider: nestedAdfMediaProvider,
                        isInlinePresentation: isInlineBodiedCustomUI
                    }));
                return /*#__PURE__*/ $cozmU.createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ $cozmU.createElement((0, $f02a442899f88e74$export$f4fa252563062f56), {
                    accountId: accountId,
                    contextIds: contextIds,
                    coreData: coreData,
                    dataProviders: dataProviders,
                    extension: gqlExtension,
                    extensionData: memoedExtensionData,
                    extensionPayload: adfExportExtensionPayload,
                    extensionId: extensionId,
                    extensionTitle: extensionTitle,
                    fallbackRenderer: fallbackRenderer,
                    getContextToken: getContextToken
                }));
            }
            return /*#__PURE__*/ $cozmU.createElement((0, $kKOjD.ReservedHeightWrapper), {
                extension: gqlExtension,
                isInlinePresentation: isInlineBodiedCustomUI
            }, /*#__PURE__*/ $cozmU.createElement((0, $bf4a93b18a6c4623$export$a61c6459586c5198), {
                accountId: accountId,
                contextIds: contextIds,
                dataProviders: dataProviders,
                nestedAdfMediaProvider: nestedAdfMediaProvider,
                environment: environment,
                extension: gqlExtension,
                coreData: coreData,
                configLocalId: paramsLocalId,
                migratedForgeLocalId: migratedForgeLocalId,
                extensionData: memoedExtensionData,
                extensionPayload: extensionPayload,
                editorAPI: editorAPI,
                extensionViewData: extensionViewData,
                forgeMacroExtensions: forgeMacroExtensions,
                isBodiedMacro: isBodiedMacro,
                locale: locale,
                flags: flags,
                getContextToken: getContextToken,
                productExtensionHandlers: productExtensionHandlers,
                customEditContext: customEditContext,
                isEditing: isEditing,
                onForgeDocUpdated: handleOnMacroUpdated,
                viewportDimensions: viewportDimensions,
                useRouteActions: useRouteActions,
                isInlinePresentation: isInlineBodiedCustomUI
            }));
        };
        $[46] = accountId;
        $[47] = adfExportExtensionPayload;
        $[48] = contextIds;
        $[49] = coreData;
        $[50] = customEditContext;
        $[51] = dataProviders;
        $[52] = editorAPI;
        $[53] = environment;
        $[54] = extensionId;
        $[55] = extensionPayload;
        $[56] = extensionTitle;
        $[57] = extensionViewData;
        $[58] = flags;
        $[59] = forgeMacroExtensions;
        $[60] = getContextToken;
        $[61] = gqlExtension;
        $[62] = handleOnMacroUpdated;
        $[63] = isAdfExport;
        $[64] = isBodiedMacro;
        $[65] = isEditing;
        $[66] = isHostedResource;
        $[67] = isInlineBodiedCustomUI;
        $[68] = locale;
        $[69] = memoedExtensionData;
        $[70] = migratedForgeLocalId;
        $[71] = nestedAdfMediaProvider;
        $[72] = paramsLocalId;
        $[73] = productExtensionHandlers;
        $[74] = useRouteActions;
        $[75] = viewportDimensions;
        $[76] = t16;
    } else t16 = $[76];
    const renderRenderer = t16;
    const t17 = isEditing ? "var(--ds-surface, #FFFFFF)" : "transparent";
    const t18 = isEditing && !isInline ? $13e0118f3a6b7faa$var$APP_CONTAINER_PADDING : 0;
    const t19 = isInline ? "inline-block" : "block";
    const t20 = isInline ? "middle" : "";
    let t21;
    if ($[77] !== t17 || $[78] !== t18 || $[79] !== t19 || $[80] !== t20) {
        t21 = {
            background: t17,
            padding: t18,
            display: t19,
            verticalAlign: t20
        };
        $[77] = t17;
        $[78] = t18;
        $[79] = t19;
        $[80] = t20;
        $[81] = t21;
    } else t21 = $[81];
    let t22;
    if ($[82] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = (0, $hekY6.default)([
            "_1mT5xdRAKS"
        ]);
        $[82] = t22;
    } else t22 = $[82];
    let t23;
    if ($[83] !== renderRenderer) {
        t23 = renderRenderer();
        $[83] = renderRenderer;
        $[84] = t23;
    } else t23 = $[84];
    let t24;
    if ($[85] !== hideGlassPane || $[86] !== isEditing) {
        t24 = isEditing && !hideGlassPane && /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "GlassPane",
            className: (0, $hekY6.default)([
                "_0KLXrujOvk _0wOv4Qsyl5 _3OE6xYdnbC _1mT5xdWVPG _0jFU0VN91d _2IhTondnbC _39xV02N91d _42Yu6B7dHp"
            ])
        });
        $[85] = hideGlassPane;
        $[86] = isEditing;
        $[87] = t24;
    } else t24 = $[87];
    let t25;
    if ($[88] !== t21 || $[89] !== t23 || $[90] !== t24) {
        t25 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-forge-extension-container": "true",
            "data-testid": "ForgeExtensionContainer",
            style: t21,
            ref: elRef,
            className: t22
        }, t23, t24);
        $[88] = t21;
        $[89] = t23;
        $[90] = t24;
        $[91] = t25;
    } else t25 = $[91];
    return t25;
} : ({ contextIds: contextIds, cloudId: cloudId, environment: environment, extensionData: extensionData, editorAPI: editorAPI, accountId: accountId, dataProviders: dataProviders, nestedAdfMediaProvider: nestedAdfMediaProvider, extension: extension, isEditing: isEditing, flags: flags, forgeMacroExtensions: forgeMacroExtensions, getContextToken: getContextToken, productExtensionHandlers: productExtensionHandlers, hideGlassPane: hideGlassPane, customEditContext: customEditContext, useRouteActions: useRouteActions })=>{
    const elRef = (0, $cozmU.useRef)(null);
    const timerRef = (0, $cozmU.useRef)(null);
    const { extension: gqlExtension, extensionId: extensionId, extensionTitle: extensionTitle, measuredHeight: measuredHeight, viewportHeight: viewportHeight // If `parameters` is missing, we'll let that bubble up to the extension's error boundary.
     } = extension.parameters; /**
                              * For standard macros, extension.localId === extension.parameters?.localId.
                              * Macros created by auto convert flow does not generate a `localId`. `localId` is being created by `quickInsert` in convertToExtensionManifest.tsx and is stored in the extension object.
                              * For connect to forge macros, extension.parameters?.localId represents the macroId and extension.localId is the actual localId.
                              *
                              * For connect to forge macros
                              *  - the localId is required for getMacroContent() to work. This is passed through coreData.
                              *  - the macroId is required by the editor panel instead of localId. This connection is established via the FORGE_DOC_UPDATED_EVENT.
                              */ 
    let localId = '';
    if ((0, $iDrrr.fg)('forge-ui-use-extension-local-id')) localId = extension?.localId || extension.parameters?.localId || '';
    else {
        localId = extension.parameters?.localId || '';
        if (!localId) localId = extension.localId;
    }
    const paramsLocalId = extension.parameters?.localId || extension.localId || ''; // For connect to forge macros, this is the localId given by the editor. Passed to ForgeUIRenderer coreData.
    const migratedForgeLocalId = extension.localId;
    const viewportDimensions = (0, $cozmU.useMemo)(()=>(0, $iDrrr.fg)('platform_measure_macro_height') ? {
            measuredHeight: measuredHeight,
            viewportHeight: viewportHeight
        } : undefined, [
        measuredHeight,
        viewportHeight
    ]);
    const config = (0, $0e17dde5dc080ea0$export$44487a86467333c3)(extension.parameters);
    const isBodiedMacro = extension.type === 'bodiedExtension';
    const extensionViewData = (0, $cozmU.useMemo)(()=>isBodiedMacro && !!extension.content ? {
            macro: {
                body: {
                    type: 'doc',
                    version: 1,
                    content: extension.content
                }
            }
        } : {}, [
        extension.content,
        isBodiedMacro
    ]);
    const isAdfExport = (0, $90b5d8eb44fcddd8$export$cb9938fa51e44b87)(gqlExtension);
    const isHostedResource = Boolean(gqlExtension?.properties?.resource);
    const isUiKitTwo = gqlExtension?.properties?.render === 'native';
    const isCustomUI = isHostedResource && !isUiKitTwo;
    const isInlineBodiedLayout = isBodiedMacro && !isEditing && (0, $iDrrr.fg)('platform_forge_inline_bodied_layout_switch') && gqlExtension?.properties?.layout === 'inline-bodied' && (0, $iDrrr.fg)('platform_forge_inline_bodied_macro');
    const isInlineBodied = isInlineBodiedLayout && !isCustomUI && config?.[0, $iNIw3.FORGE_INLINE_BODIED_PARAM] === 'true'; // Custom UI uses the same layout gate, but it has no Native UI marker to persist.
    const isInlineBodiedCustomUI = isInlineBodiedLayout && isCustomUI; // Custom UI inline-bodied macros retain the rich-body node and bridge semantics. Their inline
    // rendering is an internal presentation concern.
    const isInline = (gqlExtension?.properties?.layout === 'inline' || isInlineBodied || isInlineBodiedCustomUI) && (!isCustomUI || isInlineBodiedCustomUI);
    const coreData = (0, $cozmU.useMemo)(()=>({
            localId: localId,
            cloudId: cloudId
        }), [
        localId,
        cloudId
    ]);
    const macroExtensionData = {
        ...customEditContext ? {
            isConfiguring: true,
            isInserting: customEditContext.isInserting
        } : {},
        ...isBodiedMacro ? {
            layout: 'bodied'
        } : {}
    }; // moves specific macro extension data (isEditing, macro) to extensionData instead of extensionPayload as this is required for Tempo (#hot-300905)
    // the first check enables the feature for Tempo specifically, the second check enables the feature for all extensions if needed
    const enabledForTempo = gqlExtension?.appId === '76206a70-b9d6-4328-9e20-db79196c548a' && (0, $iDrrr.fg)('forge-ui-move-macro-data-for-tempo');
    const shouldIncludeMacroDataInExtensionData = enabledForTempo || (0, $iDrrr.fg)('forge-ui-move-macro-data-to-extension-data'); // additional data is already added in xen-editor-provider/src/render/renderExtension.tsx (remove comment after flag cleanup)
    const memoedExtensionData = $13e0118f3a6b7faa$var$useMemoedExtensionData(extensionData);
    const extensionPayload = $13e0118f3a6b7faa$var$useMemoedExtensionData(shouldIncludeMacroDataInExtensionData ? {
        config: config
    } : {
        config: config,
        isEditing: isEditing,
        ...Object.keys(macroExtensionData).length ? {
            macro: macroExtensionData
        } : {}
    });
    const adfExportExtensionPayload = (0, $cozmU.useMemo)(()=>({
            ...extensionPayload,
            ...extensionViewData
        }), [
        extensionPayload,
        extensionViewData
    ]);
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const handleOnMacroUpdated = (forgeDoc)=>{
        if (isBodiedMacro && forgeDoc?.children?.[0]?.type === 'AdfRenderer') {
            const event = new CustomEvent((0, $iNIw3.FORGE_DOC_UPDATED_EVENT), {
                detail: {
                    forgeDoc: forgeDoc,
                    localId: (0, $iDrrr.fg)('forge-ui-use-extension-local-id') ? paramsLocalId : localId
                },
                bubbles: true
            });
            document.dispatchEvent(event);
        }
        if ((0, $iDrrr.fg)('platform_measure_macro_height')) {
            const isContextPanelOpen = editorAPI?.extension?.sharedState?.currentState()?.showContextPanel;
            const actionsAPI = editorAPI?.extension?.actions?.api(); // Check if the context panel is open to filter for macro config updates
            if (!actionsAPI || !isContextPanelOpen) return;
             // Only call this function in edit/live page mode
            if (elRef.current && isEditing) {
                if (timerRef.current) clearTimeout(timerRef.current);
                timerRef.current = setTimeout(()=>{
                    const rectHeight = elRef?.current?.getBoundingClientRect().height; // allow three seconds for any async effects
                    try {
                        /**
             * This attribute will be Forge's effort to estimate and reserve rendered height
             * to achieve 0 CLS on behalf of vendors. Alongside this change will be some
             * heuristic measurements on view page to check the accuracy of this over time.
             */ actionsAPI.doc.update(localId, (currentNode)=>{
                            const newNode = {
                                attrs: {
                                    ...currentNode.attrs,
                                    parameters: {
                                        ...currentNode.attrs?.parameters,
                                        measuredHeight: rectHeight
                                    }
                                }
                            };
                            return newNode;
                        });
                    } catch  {}
                }, 3000);
            }
        }
    };
    const renderRenderer = ()=>{
        if (isAdfExport && isHostedResource) {
            /**
       * For frontend macro rendering, we only pass the `extensionViewData` (macro body) to the iframe over the JS bridge.
       * This is to avoid it being included in the Forge Invocation Token (FIT) for remote endpoint resolver calls.
       * However, the `AdfExport` is a backend function, so we cannot pass it over the JS bridge.
       * Nevertheless, it won't be included in the FIT, because the export does not use a remote endpoint resolver.
       * It also won't be included in the Forge Compute Token (FCT), because the FCT only includes context--not `extensionPayload`.
       */ // Fallback renderer used when adfExport returns null/undefined, allowing vendors to opt out
            // of ADF rendering for a specific export type (e.g. PDF) and fall back to iframe rendering.
            // This is a render prop (function) so ForgeUIExtension is only mounted — and only fires its
            // invokeExtension call — when AdfExportRenderer has confirmed that adfExport did not return
            // a valid ADF document.
            const fallbackRenderer = ()=>/*#__PURE__*/ $cozmU.createElement((0, $kKOjD.ReservedHeightWrapper), {
                    extension: gqlExtension,
                    isInlinePresentation: isInlineBodiedCustomUI
                }, /*#__PURE__*/ $cozmU.createElement((0, $bf4a93b18a6c4623$export$a61c6459586c5198), {
                    accountId: accountId,
                    contextIds: contextIds,
                    environment: environment,
                    extension: gqlExtension,
                    coreData: coreData,
                    migratedForgeLocalId: migratedForgeLocalId,
                    extensionData: memoedExtensionData,
                    extensionPayload: adfExportExtensionPayload,
                    extensionViewData: extensionViewData,
                    forgeMacroExtensions: forgeMacroExtensions,
                    flags: flags,
                    getContextToken: getContextToken,
                    isEditing: false,
                    locale: locale,
                    onForgeDocUpdated: handleOnMacroUpdated,
                    useRouteActions: useRouteActions,
                    viewportDimensions: viewportDimensions,
                    productExtensionHandlers: productExtensionHandlers,
                    nestedAdfMediaProvider: nestedAdfMediaProvider,
                    isInlinePresentation: isInlineBodiedCustomUI
                }));
            return /*#__PURE__*/ $cozmU.createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ $cozmU.createElement((0, $f02a442899f88e74$export$f4fa252563062f56), {
                accountId: accountId,
                contextIds: contextIds,
                coreData: coreData,
                dataProviders: dataProviders,
                extension: gqlExtension,
                extensionData: memoedExtensionData,
                extensionPayload: adfExportExtensionPayload,
                extensionId: extensionId,
                extensionTitle: extensionTitle,
                fallbackRenderer: fallbackRenderer,
                getContextToken: getContextToken
            }));
        }
        return /*#__PURE__*/ $cozmU.createElement((0, $kKOjD.ReservedHeightWrapper), {
            extension: gqlExtension,
            isInlinePresentation: isInlineBodiedCustomUI
        }, /*#__PURE__*/ $cozmU.createElement((0, $bf4a93b18a6c4623$export$a61c6459586c5198), {
            accountId: accountId,
            contextIds: contextIds,
            dataProviders: dataProviders,
            nestedAdfMediaProvider: nestedAdfMediaProvider,
            environment: environment,
            extension: gqlExtension,
            coreData: coreData,
            configLocalId: paramsLocalId,
            migratedForgeLocalId: migratedForgeLocalId,
            extensionData: memoedExtensionData,
            extensionPayload: extensionPayload,
            editorAPI: editorAPI,
            extensionViewData: extensionViewData,
            forgeMacroExtensions: forgeMacroExtensions,
            isBodiedMacro: isBodiedMacro,
            locale: locale,
            flags: flags,
            getContextToken: getContextToken,
            productExtensionHandlers: productExtensionHandlers,
            customEditContext: customEditContext,
            isEditing: isEditing,
            onForgeDocUpdated: handleOnMacroUpdated,
            viewportDimensions: viewportDimensions,
            useRouteActions: useRouteActions,
            isInlinePresentation: isInlineBodiedCustomUI
        }));
    };
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-forge-extension-container": "true",
        "data-testid": "ForgeExtensionContainer",
        style: {
            background: isEditing ? "var(--ds-surface, #FFFFFF)" : 'transparent',
            padding: isEditing && !isInline ? $13e0118f3a6b7faa$var$APP_CONTAINER_PADDING : 0,
            display: isInline ? 'inline-block' : 'block',
            verticalAlign: isInline ? 'middle' : ''
        },
        ref: elRef,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS"
        ])
    }, renderRenderer(), isEditing && !hideGlassPane && /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "GlassPane",
        className: (0, $hekY6.default)([
            "_0KLXrujOvk _0wOv4Qsyl5 _3OE6xYdnbC _1mT5xdWVPG _0jFU0VN91d _2IhTondnbC _39xV02N91d _42Yu6B7dHp"
        ])
    }));
};
const $13e0118f3a6b7faa$var$ForgeUIExtensionWrapperWithBoundary = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(11);
    const { extension: extension, product: product, environment: environment, page: page, analyticsWebClient: analyticsWebClient } = props;
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ $cozmU.createElement((0, $eLuPt.default), null, /*#__PURE__*/ $cozmU.createElement($13e0118f3a6b7faa$var$ForgeUIExtensionWrapper, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    const children = t0;
    let t1;
    if ($[2] !== children || $[3] !== extension.parameters) {
        t1 = extension.parameters ? /*#__PURE__*/ $cozmU.createElement((0, $bTHR7.ForgeUIExtensionAnalyticsContext), {
            localId: extension.parameters.localId,
            extensionId: extension.parameters.extensionId
        }, children) : children;
        $[2] = children;
        $[3] = extension.parameters;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== analyticsWebClient || $[6] !== environment || $[7] !== page || $[8] !== product || $[9] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $ah4BL.UFOThirdPartySegment), {
            name: "forge-ui-app-content-root"
        }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ $cozmU.createElement((0, $4ewzf.ForgeUIExtensionPointProvider), {
            analyticsWebClient: analyticsWebClient,
            product: product,
            environment: environment,
            page: page
        }, t1)));
        $[5] = analyticsWebClient;
        $[6] = environment;
        $[7] = page;
        $[8] = product;
        $[9] = t1;
        $[10] = t2;
    } else t2 = $[10];
    return t2;
} : (props)=>{
    const { extension: extension, product: product, environment: environment, page: page, analyticsWebClient: analyticsWebClient } = props;
    const children = /*#__PURE__*/ $cozmU.createElement((0, $eLuPt.default), null, /*#__PURE__*/ $cozmU.createElement($13e0118f3a6b7faa$var$ForgeUIExtensionWrapper, props));
    return /*#__PURE__*/ $cozmU.createElement((0, $ah4BL.UFOThirdPartySegment), {
        name: "forge-ui-app-content-root"
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ewzf.ForgeUIExtensionPointProvider), {
        analyticsWebClient: analyticsWebClient,
        product: product,
        environment: environment,
        page: page
    }, extension.parameters ? /*#__PURE__*/ $cozmU.createElement((0, $bTHR7.ForgeUIExtensionAnalyticsContext), {
        localId: extension.parameters.localId,
        extensionId: extension.parameters.extensionId
    }, children) : children)));
};
var $13e0118f3a6b7faa$export$2e2bcd8739ae039 = $13e0118f3a6b7faa$var$ForgeUIExtensionWrapperWithBoundary;


function $11919ce3ce390e79$var$ContextTokenHandlerWrapper({ useGetContextToken: useGetContextToken, extension: extension, extensionData: extensionData, localId: localId, contextIds: contextIds, children: children }) {
    const getContextTokenHandler = useGetContextToken({
        extension: extension,
        extensionData: extensionData,
        localId: localId,
        contextIds: contextIds,
        cachingEnabled: true
    });
    return children(getContextTokenHandler);
}
const $11919ce3ce390e79$export$b7482bdc8aff85e4 = ({ accountId: accountId, analyticsWebClient: analyticsWebClient, cloudId: cloudId, contextIds: contextIds, environment: environment, extension: extension, extensionData: extensionData, extensionHandlerWithReference: extensionHandlerWithReference, forgeMacroExtensions: forgeMacroExtensions, forgeUIAnalyticsContext: forgeUIAnalyticsContext, isEditing: isEditing, page: page, product: product, dataProviders: dataProviders, nestedAdfMediaProvider: nestedAdfMediaProvider, FlagProvider: FlagProvider, hideGlassPane: hideGlassPane, editorAPI: editorAPI, customEditContext: customEditContext, useGetContextToken: useGetContextToken, useRouteActions: useRouteActions, productExtensionHandlers: productExtensionHandlers })=>(0, $dOBRD.default)(({ node: node, references: references })=>{
        // Some nodes come through with a malformed `extensionId` where an extra segment
        // (e.g. `:1:`) is present between the colons of the ARI prefix, i.e.
        // `ari:cloud:ecosystem:1:extension/...` instead of the correct
        // `ari:cloud:ecosystem::extension/...`. Downstream consumers parse this value with
        // `@atlassian/cs-ari`'s `parse()`, which throws on the malformed form. Normalise it
        // here, before rendering, so the extension can still be rendered.
        $11919ce3ce390e79$export$e7238f9ddf5f260(node.parameters);
        const extensionWithParam = {
            ...node,
            parameters: {
                // we always insert with parameters
                ...node.parameters,
                extensionTitle: extension?.properties.title,
                extension: extension
            }
        };
        // If `localId` doesn't exist at this point, pass the `localId` on the node created from `quickInsert` into the parameters object
        // Required to render the correct config sidebar panel
        if (node.parameters && !node.parameters.localId) node.parameters.localId = node.localId;
        // moves specific macro extension data (isEditing, macro) to extensionData instead of extensionPayload as this is required for Tempo (#hot-300905)
        // the first check enables the feature for Tempo specifically, the second check enables the feature for all extensions if needed
        const enabledForTempo = extension?.appId === '76206a70-b9d6-4328-9e20-db79196c548a' && (0, $iDrrr.fg)('forge-ui-move-macro-data-for-tempo');
        const shouldIncludeMacroDataInExtensionData = enabledForTempo || (0, $iDrrr.fg)('forge-ui-move-macro-data-to-extension-data');
        const isBodiedMacro = extension?.type === 'bodiedExtension';
        const macroExtensionData = {
            ...customEditContext ? {
                isConfiguring: true,
                isInserting: customEditContext.isInserting
            } : {},
            ...isBodiedMacro ? {
                layout: 'bodied'
            } : {}
        };
        const augmentedExtensionData = shouldIncludeMacroDataInExtensionData ? {
            ...extensionData,
            autoConvertLink: node.parameters?.autoConvertLink,
            isEditing: isEditing,
            ...Object.keys(macroExtensionData).length ? {
                macro: macroExtensionData
            } : {}
        } : {
            ...extensionData,
            autoConvertLink: node.parameters?.autoConvertLink
        };
        const connectMetadata = $11919ce3ce390e79$var$getConnectMacroMetadata(node.parameters);
        if (connectMetadata) augmentedExtensionData.connectMetadata = connectMetadata;
        const getForgeEditorExtensionComponent = ({ references: references })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FlagProvider, null, (flags)=>useGetContextToken ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($11919ce3ce390e79$var$ContextTokenHandlerWrapper, {
                    useGetContextToken: useGetContextToken,
                    extension: extensionWithParam?.parameters?.extension,
                    extensionData: augmentedExtensionData,
                    localId: node.parameters?.localId,
                    contextIds: contextIds
                }, (getContextTokenHandler)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13e0118f3a6b7faa$export$2e2bcd8739ae039), {
                        analyticsWebClient: analyticsWebClient,
                        accountId: accountId || '',
                        cloudId: cloudId,
                        contextIds: contextIds,
                        environment: environment,
                        extension: $11919ce3ce390e79$var$transformConnectToForgeExtension(extensionWithParam, extension, {
                            analyticsWebClient: analyticsWebClient,
                            forgeUIAnalyticsContext: forgeUIAnalyticsContext,
                            isEditing: isEditing
                        }),
                        extensionData: {
                            ...augmentedExtensionData,
                            references: references
                        },
                        forgeMacroExtensions: forgeMacroExtensions,
                        flags: flags,
                        isEditing: isEditing,
                        product: product,
                        dataProviders: dataProviders,
                        nestedAdfMediaProvider: nestedAdfMediaProvider,
                        page: page,
                        hideGlassPane: hideGlassPane,
                        editorAPI: editorAPI,
                        getContextToken: getContextTokenHandler,
                        customEditContext: customEditContext,
                        useRouteActions: useRouteActions,
                        productExtensionHandlers: productExtensionHandlers
                    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13e0118f3a6b7faa$export$2e2bcd8739ae039), {
                    analyticsWebClient: analyticsWebClient,
                    accountId: accountId || '',
                    cloudId: cloudId,
                    contextIds: contextIds,
                    environment: environment,
                    extension: $11919ce3ce390e79$var$transformConnectToForgeExtension(extensionWithParam, extension, {
                        analyticsWebClient: analyticsWebClient,
                        forgeUIAnalyticsContext: forgeUIAnalyticsContext,
                        isEditing: isEditing
                    }),
                    extensionData: {
                        ...augmentedExtensionData,
                        references: references
                    },
                    forgeMacroExtensions: forgeMacroExtensions,
                    flags: flags,
                    isEditing: isEditing,
                    product: product,
                    dataProviders: dataProviders,
                    nestedAdfMediaProvider: nestedAdfMediaProvider,
                    page: page,
                    hideGlassPane: hideGlassPane,
                    editorAPI: editorAPI,
                    customEditContext: customEditContext,
                    useRouteActions: useRouteActions,
                    productExtensionHandlers: productExtensionHandlers
                }));
        if (extensionHandlerWithReference) return extensionHandlerWithReference(node, ({ references: referencesFromHandler })=>getForgeEditorExtensionComponent({
                node: node,
                references: referencesFromHandler
            }));
        return getForgeEditorExtensionComponent({
            node: node,
            references: references
        });
    }, (0, $5W8qe.dequal));
// The correct Forge extension ARI prefix. Note the empty segment (`::`) for the
// unused `siteId` part of the ARI.
const $11919ce3ce390e79$var$VALID_EXTENSION_ID_PREFIX = 'ari:cloud:ecosystem::extension/';
// The malformed prefix that has an extra segment (e.g. `1`) where the ARI expects an
// empty segment, i.e. `ari:cloud:ecosystem:1:extension/`.
const $11919ce3ce390e79$var$MALFORMED_EXTENSION_ID_PREFIX_PATTERN = /^ari:cloud:ecosystem:[^:]+:extension\//;
function $11919ce3ce390e79$export$e7238f9ddf5f260(parameters) {
    const extensionId = parameters?.extensionId;
    if (typeof extensionId === 'string' && !extensionId.startsWith($11919ce3ce390e79$var$VALID_EXTENSION_ID_PREFIX) && $11919ce3ce390e79$var$MALFORMED_EXTENSION_ID_PREFIX_PATTERN.test(extensionId)) parameters.extensionId = extensionId.replace($11919ce3ce390e79$var$MALFORMED_EXTENSION_ID_PREFIX_PATTERN, $11919ce3ce390e79$var$VALID_EXTENSION_ID_PREFIX);
}
function $11919ce3ce390e79$var$getConnectMacroMetadata(parameters) {
    const macroId = (0, $e135764dedc3ef6a$export$4ea6c6225eccc91)(parameters);
    const title = parameters?.macroMetadata?.title;
    if (!macroId) // We don't want this function to return anything if it didn't have a Connect macro ID,
    // to avoid implying that pure Forge macros were Connect
    return undefined;
    return {
        macroId: macroId,
        title: title
    };
}
function $11919ce3ce390e79$var$transformConnectToForgeExtension(attrs, extension, analyticsProps) {
    if (attrs.extensionType !== (0, $iNIw3.P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE)) return attrs;
    const { analyticsWebClient: analyticsWebClient, forgeUIAnalyticsContext: forgeUIAnalyticsContext, isEditing: isEditing } = analyticsProps || {};
    const eventSource = isEditing ? 'editPageScreen' : 'viewPageScreen';
    const { extensionKey: extensionKey } = attrs;
    try {
        if (!extension?.id) throw new Error('No Forge extension for patching connect addon');
        if (attrs.parameters) {
            if (!attrs.parameters.extensionId) attrs.parameters.extensionId = extension.id;
            const macroId = (0, $e135764dedc3ef6a$export$4ea6c6225eccc91)(attrs.parameters);
            if (!attrs.parameters.localId && macroId) // Populate with Connect macroId
            attrs.parameters.localId = macroId;
        }
        // Transform Connect macroParams to Forge guestParams
        if (attrs.parameters?.macroParams) {
            attrs.parameters.guestParams = attrs.parameters.guestParams || {};
            const connectParams = attrs.parameters.macroParams;
            Object.entries(connectParams).forEach(([key, obj])=>{
                if (typeof attrs.parameters.guestParams[key] === 'undefined') attrs.parameters.guestParams[key] = obj.value;
            });
        }
        if (analyticsWebClient) (0, $4K6lC.sendEvent)(analyticsWebClient)({
            source: eventSource,
            ...forgeUIAnalyticsContext,
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            action: 'h11n_macro_render_success',
            actionSubject: (0, $iNIw3.CONNECT_ADDON_ACTION_SUBJECT),
            actionSubjectId: extensionKey,
            attributes: {
                extensionKey: extensionKey,
                ...(0, $cIUmi.extensionIdToAnalyticsAttributes)(extension?.id),
                nodeLocalId: attrs.localId
            }
        });
    } catch (e) {
        if (analyticsWebClient) (0, $4K6lC.sendEvent)(analyticsWebClient)({
            source: eventSource,
            ...forgeUIAnalyticsContext,
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            action: 'h11n_macro_render_failed',
            actionSubject: (0, $iNIw3.CONNECT_ADDON_ACTION_SUBJECT),
            actionSubjectId: extensionKey,
            attributes: {
                extensionKey: extensionKey,
                ...(0, $cIUmi.extensionIdToAnalyticsAttributes)(extension?.id),
                errorMessage: e instanceof Error ? e.message : String(e),
                nodeLocalId: attrs.localId
            }
        });
        throw e;
    }
    return attrs;
}













const $2bdd0b58a1f21904$export$30c16f5c43437fd7 = {
    FORGE_EXTENSION_INSERTED: 'inserted',
    FORGE_EXTENSION_FAILED: 'failed',
    FORGE_EXTENSION_ERRORED: 'errored',
    FORGE_MACRO_AUTO_CONVERT_SUCCESS: 'auto_convert_success',
    FORGE_MACRO_AUTO_CONVERT_TO_SMARTLINK: 'auto_convert_to_smartlink',
    H11N_CONFIG_WARNING: 'h11n_macro_config_warning',
    H11N_CONFIG_ERROR: 'h11n_macro_config_error',
    H11N_RESOLVE_FAILED: 'h11n_macro_resolve_failed',
    H11N_UPGRADE_RICH_TEST_SKIPPED: 'h11n_macro_upgrade_rich_text_skipped',
    H11N_UPGRADE_SUCCESS: 'h11n_macro_upgrade_success',
    H11N_UPGRADE_FAILED: 'h11n_macro_upgrade_failed',
    H11N_RENDER_SUCCESS: 'h11n_macro_render_success',
    H11N_RENDER_FAILED: 'h11n_macro_render_success',
    APP_MIGRATION_P2_MACRO_RESOLVED: 'app_migration_p2_macro_resolved',
    APP_MIGRATION_P2_MACRO_UPGRADE: 'app_migration_p2_macro_upgrade'
};
const $2bdd0b58a1f21904$export$3d970ca206012d6b = ({ analyticsWebClient: analyticsWebClient, forgeUIAnalyticsContext: forgeUIAnalyticsContext, source: source })=>{
    const analyticsClient = {
        sendEvent: (action, params)=>{
            const { localId: localId, nodeLocalId: nodeLocalId, extension: extension, extensionId: id, extensionKey: extensionKey, extensionType: extensionType, error: error, macroId: macroId, macroTitle: macroTitle, link: link, forgeEnvironment: forgeEnvironment, render: render } = params;
            const extensionId = id || extension?.id;
            const { environmentType: environmentType } = extension || {};
            const commonAttributes = {
                ...(0, $cIUmi.extensionIdToAnalyticsAttributes)(extensionId),
                ...extension?.environmentType ? {
                    forgeEnvironment: environmentType
                } : {}
            };
            const errorMessage = error instanceof Error ? error.message : String(error);
            const errorName = error instanceof Error ? error.name : String(error);
            const eventProperties = action.startsWith('h11n') ? {
                action: action,
                actionSubject: (0, $iNIw3.CONNECT_ADDON_ACTION_SUBJECT),
                actionSubjectId: commonAttributes.extensionKey,
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                source: source,
                ...forgeUIAnalyticsContext
            } : action.startsWith('app_migration') ? {
                action: action,
                actionSubject: (0, $iNIw3.MIGRATED_SERVER_P2_ADDON_ACTION_SUBJECT),
                actionSubjectId: commonAttributes.extensionKey,
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                source: source,
                ...forgeUIAnalyticsContext
            } : {
                action: action,
                actionSubject: (0, $iNIw3.FORGE_EXTENSION),
                actionSubjectId: extensionId,
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                source: source,
                ...forgeUIAnalyticsContext
            };
            switch(action){
                case $2bdd0b58a1f21904$export$30c16f5c43437fd7.H11N_UPGRADE_SUCCESS:
                    (0, $4K6lC.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        eventType: (0, $852mP.TRACK_EVENT_TYPE),
                        attributes: {
                            ...commonAttributes,
                            localId: localId,
                            nodeLocalId: nodeLocalId,
                            extensionType: extensionType
                        }
                    });
                    return;
                case $2bdd0b58a1f21904$export$30c16f5c43437fd7.H11N_RENDER_SUCCESS:
                    (0, $4K6lC.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        attributes: {
                            ...commonAttributes,
                            nodeLocalId: nodeLocalId
                        }
                    });
                    return;
                case $2bdd0b58a1f21904$export$30c16f5c43437fd7.H11N_RENDER_FAILED:
                    (0, $4K6lC.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        attributes: {
                            ...commonAttributes,
                            nodeLocalId: nodeLocalId,
                            errorMessage: errorMessage
                        }
                    });
                    return;
                case $2bdd0b58a1f21904$export$30c16f5c43437fd7.H11N_UPGRADE_FAILED:
                    (0, $4K6lC.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        actionSubjectId: extensionKey,
                        attributes: {
                            ...commonAttributes,
                            nodeLocalId: nodeLocalId,
                            errorMessage: errorMessage,
                            extensionKey: extensionKey,
                            extensionType: extensionType
                        }
                    });
                    return;
                case $2bdd0b58a1f21904$export$30c16f5c43437fd7.H11N_UPGRADE_RICH_TEST_SKIPPED:
                    (0, $4K6lC.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        attributes: {
                            ...commonAttributes,
                            nodeLocalId: nodeLocalId,
                            extensionType: (0, $iNIw3.EXTENSION_NAMESPACE)
                        }
                    });
                    return;
                case $2bdd0b58a1f21904$export$30c16f5c43437fd7.H11N_RESOLVE_FAILED:
                    (0, $4K6lC.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        attributes: {
                            ...commonAttributes,
                            errorMessage: errorMessage,
                            extensionKey: extensionKey
                        }
                    });
                    return;
                case $2bdd0b58a1f21904$export$30c16f5c43437fd7.APP_MIGRATION_P2_MACRO_RESOLVED:
                    (0, $4K6lC.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        attributes: {
                            ...commonAttributes,
                            extensionType: extensionType,
                            extensionKey: extensionKey
                        }
                    });
                    return;
                case $2bdd0b58a1f21904$export$30c16f5c43437fd7.APP_MIGRATION_P2_MACRO_UPGRADE:
                    (0, $4K6lC.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        attributes: {
                            ...commonAttributes,
                            localId: localId,
                            nodeLocalId: nodeLocalId,
                            extensionId: extensionId,
                            extensionType: extensionType,
                            extensionKey: extensionKey
                        }
                    });
                    return;
                case $2bdd0b58a1f21904$export$30c16f5c43437fd7.H11N_CONFIG_WARNING:
                case $2bdd0b58a1f21904$export$30c16f5c43437fd7.H11N_CONFIG_ERROR:
                    (0, $4K6lC.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        actionSubjectId: extensionId,
                        attributes: {
                            errorMessage: errorMessage,
                            macroId: macroId,
                            macroTitle: macroTitle,
                            macroKey: extension?.key,
                            extensionId: extensionId,
                            migrationKey: extension?.migrationKey
                        }
                    });
                    return;
                case $2bdd0b58a1f21904$export$30c16f5c43437fd7.FORGE_EXTENSION_INSERTED:
                    (0, $4K6lC.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        attributes: {
                            ...commonAttributes,
                            localId: localId,
                            extensionType: (0, $iNIw3.EXTENSION_NAMESPACE)
                        }
                    });
                    return;
                case $2bdd0b58a1f21904$export$30c16f5c43437fd7.FORGE_EXTENSION_FAILED:
                    (0, $4K6lC.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        actionSubjectId: extensionId,
                        attributes: {
                            ...commonAttributes,
                            method: 'convertNodeToForgeExtension',
                            localId: localId,
                            errorMessage: errorMessage
                        }
                    });
                    return;
                case $2bdd0b58a1f21904$export$30c16f5c43437fd7.FORGE_EXTENSION_ERRORED:
                    (0, $4K6lC.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        actionSubjectId: extensionId,
                        attributes: {
                            ...commonAttributes,
                            errorName: errorName,
                            errorMessage: errorMessage,
                            extensionType: (0, $iNIw3.EXTENSION_NAMESPACE)
                        }
                    });
                    return;
                case $2bdd0b58a1f21904$export$30c16f5c43437fd7.FORGE_MACRO_AUTO_CONVERT_SUCCESS:
                    // Event registered at https://data-portal.internal.atlassian.com/analytics/registry/77268?tabIndex=Details
                    (0, $4K6lC.sendEvent)(analyticsWebClient)({
                        ...eventProperties,
                        actionSubjectId: extensionId,
                        attributes: {
                            ...commonAttributes,
                            link: link,
                            macroTitle: macroTitle,
                            forgeEnvironment: forgeEnvironment,
                            render: render
                        }
                    });
                    return;
                default:
                    return;
            }
        }
    };
    return analyticsClient;
};





/* convertToExtensionManifest.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $1hQ0e = parcelRequire("1hQ0e");


var $4o0zT = parcelRequire("4o0zT");








var $1gaKI = parcelRequire("1gaKI");













// We keep track of the macro IDs that were rendered as Forge macros, for analytics purposes
const $ca0b1325ef9f57a7$var$connectRenderedAsForgeMacroIds = new Set();
const $ca0b1325ef9f57a7$export$44487a86467333c3 = ({ config: config, guestParams: guestParams })=>guestParams || config;
const $ca0b1325ef9f57a7$var$retirementMessage = `The app's version is outdated due to a deprecated platform component.\nThe app developer needs to update it to a compatible version.\nPlease ask your admin to check for updates or contact the app developer.`;
const $ca0b1325ef9f57a7$export$affb7f1b8986663b = ({ analyticsClient: analyticsClient, extension: extension, hasCustomConfig: hasCustomConfig })=>async (parameters)=>{
        const { extensionId: extensionId, localId: localId } = parameters;
        const config = $ca0b1325ef9f57a7$export$44487a86467333c3(parameters);
        const id = `${extensionId}-${localId}`;
        // Until Editor forceably closes the config panel, we need to clear the fields in the panel otherwise
        // config values will be overwritten by previous fields
        if (hasCustomConfig) return [];
        const getForgeDoc = new Promise((resolve, reject)=>{
            (0, $1uMa2.emit)(`GET_CONFIG_FORGE_DOC_${id}`, {
                resolve: resolve,
                reject: reject,
                config: config
            });
        });
        try {
            const forgeDoc = await getForgeDoc;
            const forgeReactMajorVersion = forgeDoc.children[0]?.forgeReactMajorVersion;
            if (!forgeReactMajorVersion) throw new Error($ca0b1325ef9f57a7$var$retirementMessage);
            return (0, $7e94665fb6a19916$export$1f45aada55d3f94)(forgeDoc);
        } catch (error) {
            const { message: message } = error;
            if (!(error instanceof (0, $7e94665fb6a19916$export$2191b9da168c6cf0))) {
                const { sendEvent: sendEvent } = analyticsClient;
                sendEvent((0, $2bdd0b58a1f21904$export$30c16f5c43437fd7).FORGE_EXTENSION_ERRORED, {
                    extension: extension,
                    error: error
                });
            }
            throw new Error(message || '');
        }
    };
const $ca0b1325ef9f57a7$export$55efa0cfd3b99204 = ({ analyticsClient: analyticsClient, connectToForgeBlockedExtensions: connectToForgeBlockedExtensions, extension: extension, hasCustomConfig: hasCustomConfig })=>async (parameters)=>{
        const macroId = (0, $e135764dedc3ef6a$export$4ea6c6225eccc91)(parameters);
        if (!parameters.extensionId) {
            /* If extensionId is missing, then we are dealing with a Connect or core macro instead of Forge
     * This can happen when
     *  - reverting a page with an upgraded Connect -> Forge addon back to Connect,
     *  - if the Connect macro wasn't upgraded for some reason (eg. bodiedExtension / rich text macro)
     *  - there is also a bug when loading a Forge macro, then clicking on a Connect macro that is uninstalled - https://product-fabric.atlassian.net/jira/servicedesk/projects/DTR/queues/issue/DTR-2569
     *
     * We can't edit/store the config in this state, so safer to just prevent panel loading
     */ // We start by assuming it's a core macro
            let userMessage = 'Macro configuration failed to load. Please close this panel and try again.';
            let errorMessage = 'non-forge-macro';
            // Macro ID is only defined for Connect/core macros, not Forge macros (for now, this is subject to change)
            if (!macroId) throw new Error(userMessage);
            // Whether we report this as a warning (expected) or an error (unexpected)
            let isWarning = false;
            const isBodied = connectToForgeBlockedExtensions.has(macroId);
            if (isBodied) {
                userMessage = `Editing multi-bodied macros is not currently supported.`;
                errorMessage = 'bodied-macro-blocked';
                isWarning = true;
            } else if ($ca0b1325ef9f57a7$var$connectRenderedAsForgeMacroIds.has(macroId)) {
                // We know that at some point this macro was rendered as a Forge macro, so it must have been reverted
                userMessage = 'This macro has been reverted. Please close this panel and try again.';
                errorMessage = 'macro-reverted';
                isWarning = true;
            }
            // Only report h11n errors for harmonised Connect macros
            if (extension.migrationKey) {
                const { sendEvent: sendEvent } = analyticsClient;
                if (isWarning) sendEvent((0, $2bdd0b58a1f21904$export$30c16f5c43437fd7).H11N_CONFIG_WARNING, {
                    extension: extension,
                    error: errorMessage,
                    macroId: macroId,
                    macroTitle: parameters.macroMetadata?.title
                });
                else sendEvent((0, $2bdd0b58a1f21904$export$30c16f5c43437fd7).H11N_CONFIG_ERROR, {
                    extension: extension,
                    error: errorMessage,
                    macroId: macroId,
                    macroTitle: parameters.macroMetadata?.title
                });
            }
        }
        // If we make it here, we are dealing with a Forge macro with an extensionId
        if (macroId) $ca0b1325ef9f57a7$var$connectRenderedAsForgeMacroIds.add(macroId);
        const uiKitTwoGetFieldsDefinitionFunction = $ca0b1325ef9f57a7$export$affb7f1b8986663b({
            analyticsClient: analyticsClient,
            extension: extension,
            hasCustomConfig: hasCustomConfig
        });
        return uiKitTwoGetFieldsDefinitionFunction(parameters);
    };








const $dc06fb4e25ee555d$export$a8391a3395b499ed = ()=>{
    return crypto.randomUUID();
};


const $3d4cd4bc04ae7b70$var$extractPrefix = '/static/';
const $3d4cd4bc04ae7b70$var$extractPrefixLength = $3d4cd4bc04ae7b70$var$extractPrefix.length;
const $3d4cd4bc04ae7b70$export$c47b515b4275a492 = (id)=>id.substr($3d4cd4bc04ae7b70$var$extractPrefixLength + id.indexOf($3d4cd4bc04ae7b70$var$extractPrefix));


const $006f1dc544dc19cb$export$f20788afb2a391e3 = (extension, extensionIdWithoutPrefix)=>{
    const segments = extensionIdWithoutPrefix.split('/');
    if (segments.length !== 4 || segments.some((segment)=>!segment)) return undefined;
    const [appId, environmentId, installationId, moduleKey] = segments;
    // Dynamic IDs use the installation ID where static IDs use "static". Verify that
    // association before using a bare key to resolve content created by another provider.
    if (installationId === 'static' || installationId !== extension.installationId) return undefined;
    if (extension.appId !== undefined && extension.appId !== appId || extension.environmentId !== undefined && extension.environmentId !== environmentId || extension.key !== undefined && extension.key !== moduleKey) return undefined;
    return moduleKey;
};




var $fKhWq = parcelRequire("fKhWq");












const $6cebec68dbaae69c$export$b83e318aa057e7ad = (link, autoConvertDefinitions)=>{
    const matchedAutoConvertDefinition = autoConvertDefinitions?.find((acd)=>{
        return !!link.match(acd.matcher);
    });
    return matchedAutoConvertDefinition;
};
const $6cebec68dbaae69c$export$ba0026a66deb9f75 = (link, analyticsClient, autoConvertDefinitions, macroAttributesMap, autoConvertMatcherToExtensionsMap)=>{
    if (!autoConvertDefinitions || !macroAttributesMap || !autoConvertMatcherToExtensionsMap) return null;
    const matchedAutoConvertDefinition = $6cebec68dbaae69c$export$b83e318aa057e7ad(link, autoConvertDefinitions);
    if (matchedAutoConvertDefinition) {
        const { extensionKey: extensionKey } = matchedAutoConvertDefinition;
        const macroAttributes = macroAttributesMap[extensionKey];
        // Clone the object here to avoid mutating the original object
        const convertedMacroAttributes = structuredClone(macroAttributes);
        convertedMacroAttributes.attrs.parameters.autoConvertLink = link;
        convertedMacroAttributes.attrs.parameters.hasBeenAutoConverted = true;
        analyticsClient.sendEvent((0, $2bdd0b58a1f21904$export$30c16f5c43437fd7).FORGE_MACRO_AUTO_CONVERT_SUCCESS, {
            extensionId: convertedMacroAttributes.attrs.parameters.extensionId,
            macroTitle: convertedMacroAttributes.attrs.parameters.extensionTitle,
            forgeEnvironment: convertedMacroAttributes.attrs.parameters.forgeEnvironment,
            render: convertedMacroAttributes.attrs.parameters.render,
            link: link
        });
        return convertedMacroAttributes;
    } else return null;
};


const $9b1ef37666c81eea$var$getExtensionTypeFromADFNodeLayout = (layout)=>{
    if ((0, $iDrrr.fg)('platform_forge_inline_bodied_layout_switch')) return (0, $1gaKI.getExtensionType)({
        properties: {
            layout: layout
        }
    });
    switch(layout){
        case 'bodied':
            return 'bodiedExtension';
        case 'inline':
            return 'inlineExtension';
        default:
            return 'extension';
    }
};
const $9b1ef37666c81eea$var$getNodeByLayout = (extension, currentNodeType, pastedLink)=>{
    const localId = (0, $dc06fb4e25ee555d$export$a8391a3395b499ed)();
    const extensionType = $9b1ef37666c81eea$var$getExtensionTypeFromADFNodeLayout(extension.macroADFNode?.attrs.parameters.layout);
    const extensionNode = {
        type: extensionType,
        attrs: {
            extensionKey: extension.extensionKey,
            extensionType: (0, $iNIw3.EXTENSION_NAMESPACE),
            localId: localId,
            parameters: {
                extensionId: extension.macroADFNode?.attrs.parameters.extensionId,
                extensionTitle: extension.macroADFNode?.attrs.parameters.extensionTitle,
                forgeEnvironment: extension.macroADFNode?.attrs.parameters.forgeEnvironment,
                render: extension.macroADFNode?.attrs.parameters.render,
                layout: extension.macroADFNode?.attrs.parameters.layout,
                autoConvertLink: pastedLink,
                hasBeenAutoConverted: true,
                ...(0, $iDrrr.fg)('platform_forge_inline_bodied_layout_switch') && extension.macroADFNode?.attrs.parameters.guestParams ? {
                    guestParams: extension.macroADFNode.attrs.parameters.guestParams
                } : {}
            },
            text: extension.macroADFNode?.attrs.text
        },
        ...extensionType === 'bodiedExtension' ? {
            // include empty content so bodiedExtension doesn't throw error
            content: [
                {
                    type: 'paragraph',
                    content: []
                }
            ]
        } : {}
    };
    //Changing from a block/bodied to inline extension requires establishing a paragraph wrapping node
    if ($9b1ef37666c81eea$var$getExtensionTypeFromADFNodeLayout(extension.macroADFNode?.attrs.parameters.layout) === 'inlineExtension' && (currentNodeType === 'extension' || currentNodeType === 'bodiedExtension')) return {
        type: 'paragraph',
        content: [
            extensionNode
        ]
    };
    return extensionNode;
};
const $9b1ef37666c81eea$export$423a31d6ceadaac3 = (autoConvertDefinitions, autoConvertMatcherToExtensionsMap, editorActions, link)=>{
    if (!autoConvertDefinitions || !autoConvertMatcherToExtensionsMap) return [];
    let pastedLink = link;
    if (!link) {
        const node = editorActions?.getSelectedNode();
        pastedLink = node?.attrs.parameters.autoConvertLink;
    }
    const matchedAutoConvertDefinition = pastedLink ? (0, $6cebec68dbaae69c$export$b83e318aa057e7ad)(pastedLink, autoConvertDefinitions) : undefined;
    if (matchedAutoConvertDefinition && autoConvertMatcherToExtensionsMap) {
        const extensionsWithTheSameMatcher = autoConvertMatcherToExtensionsMap[matchedAutoConvertDefinition.matcher];
        const node = editorActions?.getSelectedNode();
        const currentNodeType = node?.type.name;
        const options = extensionsWithTheSameMatcher.map((extension)=>{
            return {
                id: `${extension.extensionKey}-dropdown-option`,
                title: extension.macroName,
                selected: extension.extensionKey === node?.attrs.extensionKey,
                onClick: async (state, dispatch, view)=>{
                    if (view) {
                        const { selection: selection } = view?.state;
                        const insertPosition = selection.$from.pos;
                        // If the current node is an inlineExtension, replaceSelection is unable to delete the current inline node
                        if (currentNodeType === 'inlineExtension') {
                            const transaction = state.tr.deleteSelection().scrollIntoView();
                            view?.dispatch(transaction);
                        }
                        editorActions?.replaceSelection($9b1ef37666c81eea$var$getNodeByLayout(extension, currentNodeType, pastedLink), true, insertPosition);
                    }
                    return true;
                }
            };
        });
        return options;
    }
    return [];
};





const $0156d96fecb1d2a9$export$dc6604afff08e361 = {
    '16': ()=>Promise.resolve((parcelRequire("fKhWq"))),
    '24': ()=>Promise.resolve((parcelRequire("fKhWq"))),
    '48': ()=>Promise.resolve((parcelRequire("fKhWq")))
};
const $0156d96fecb1d2a9$var$dataAndChartsForgeMacroQuickInsertPriorities = {
    'bitbucket-snippet-code-macro': 1200,
    'gist-code-macro': 1300
};
const $0156d96fecb1d2a9$export$1fe770db7b01f9fc = (actions, localId, payload)=>{
    try {
        actions.doc.update(localId, (currentValue)=>$0156d96fecb1d2a9$export$227008f8867b6b1a(currentValue?.attrs || {}, payload));
    } catch (error) {
        (0, $509cf1f98caebc07$export$4537e246a5edda0a)(error);
    }
};
const $0156d96fecb1d2a9$export$227008f8867b6b1a = (attrs, { config: config, body: body })=>{
    // HOTFIX for HOT-115700
    // https://ecosystem-platform.atlassian.net/browse/EXT-2877
    // Remove "forgeEnvironment" and "render" from the node attributes, as they would break validation
    // and therefore prevent the user from submitting a macro configuration.
    const { forgeEnvironment: _forgeEnvironment, render: _render, ...cleanedAttrs } = attrs;
    const existingParameters = cleanedAttrs.parameters || {};
    const transformed = (0, $0e17dde5dc080ea0$export$33006db0d9b837ff)(config);
    const storedOutputType = existingParameters.guestParams?.[0, $iNIw3.MACRO_OUTPUT_TYPE_PARAM];
    const storedInlineBodied = existingParameters.guestParams?.[0, $iNIw3.FORGE_INLINE_BODIED_PARAM];
    const preservedGuestParams = storedInlineBodied !== undefined && (0, $iDrrr.fg)('platform_forge_inline_bodied_macro') ? {
        guestParams: {
            ...storedOutputType !== undefined ? {
                [(0, $iNIw3.MACRO_OUTPUT_TYPE_PARAM)]: storedOutputType
            } : {},
            [(0, $iNIw3.FORGE_INLINE_BODIED_PARAM)]: storedInlineBodied,
            ...transformed.guestParams
        }
    } : {};
    return {
        attrs: {
            ...cleanedAttrs,
            parameters: {
                ...existingParameters,
                ...transformed,
                ...preservedGuestParams
            }
        },
        ...body ? {
            content: body.content
        } : {}
    };
};
const $0156d96fecb1d2a9$export$4bf92a336c844766 = (actions, localId, payload)=>{
    try {
        const { node: node } = actions.getNodeWithPosByLocalId(localId);
        const nodeEl = (0, $1hQ0e.getDocument)()?.querySelector(`[extensionkey="${node?.attrs.extensionKey}"]`);
        if (nodeEl) setTimeout(()=>{
            const rectHeight = nodeEl?.getBoundingClientRect().height;
            actions.doc.update(localId, (currentValue)=>{
                const result = $0156d96fecb1d2a9$export$227008f8867b6b1a(currentValue.attrs || {}, payload);
                const newNode = {
                    attrs: {
                        ...result.attrs,
                        parameters: {
                            ...result.attrs.parameters,
                            measuredHeight: rectHeight
                        }
                    },
                    ...result.content ? {
                        content: result.content
                    } : {}
                };
                return newNode;
            });
        }, 3000);
        else actions.doc.update(localId, (currentValue)=>$0156d96fecb1d2a9$export$227008f8867b6b1a(currentValue?.attrs || {}, payload));
    } catch (error) {
        (0, $509cf1f98caebc07$export$4537e246a5edda0a)(error);
    }
};

const $0156d96fecb1d2a9$export$205fc211839e6c8b = ({ analyticsClient: analyticsClient, editorActions: editorActions, fieldsModules: fieldsModules, renderConfigHelper: renderConfigHelper, createRenderFunction: createRenderFunction, connectToForgeBlockedExtensions: connectToForgeBlockedExtensions, updateFunction: updateFunction, autoConvertDefinitions: autoConvertDefinitions, autoConvertMatcherToExtensionsMap: autoConvertMatcherToExtensionsMap, embeddedMacroContext: embeddedMacroContext, intl: intl })=>(extension)=>{
        const { sendEvent: sendEvent } = analyticsClient;
        const { appId: appId, id: id, properties: properties, environmentType: environmentType, migrationKey: migrationKey, environmentKey: environmentKey } = extension;
        const title = (0, $f549bb27bef546d1$export$553719da8802da2d)(properties.title || 'Forge UI Macro', environmentKey, environmentType);
        const extensionIdWithoutPrefix = (0, $9cGsb.parse)(id).resourceId;
        const isCustomUI = (0, $8yKod.isCustomUI)(extension);
        const isUiKitTwo = extension.properties.render === 'native';
        const hasConfig = isUiKitTwo || isCustomUI ? !!properties.config : false;
        const hasCustomConfig = (isUiKitTwo || isCustomUI) && !!properties.config?.resource;
        const hasAutoConvertLinks = !!properties.autoConvert;
        const isInline = properties.layout === 'inline';
        const isLayoutSwitchEnabled = (0, $iDrrr.fg)('platform_forge_inline_bodied_layout_switch');
        const isBodiedExtension = (0, $1gaKI.getExtensionType)(extension) === 'bodiedExtension';
        const isInlineBodiedExtension = isLayoutSwitchEnabled && properties.layout === 'inline-bodied' && isUiKitTwo && (0, $iDrrr.fg)('platform_forge_inline_bodied_macro');
        const isInlineBodiedCustomUI = isLayoutSwitchEnabled && properties.layout === 'inline-bodied' && isCustomUI && (0, $iDrrr.fg)('platform_forge_inline_bodied_macro'); // For UI Kit and custom UI apps with side context panel config only
        // Custom config openOnInsert is a different parameter in the manifest config object, and is rendered by renderConfigHelper()
        const openConfigOnInsert = (isUiKitTwo || isCustomUI) && hasConfig && !hasCustomConfig && !!properties.config?.openOnInsert;
        const connectModuleKey = (0, $3d4cd4bc04ae7b70$export$c47b515b4275a492)(extensionIdWithoutPrefix);
        const dynamicConnectModuleKey = (0, $iDrrr.fg)('platform_forge_dynamic_connect_key') ? (0, $006f1dc544dc19cb$export$f20788afb2a391e3)(extension, extensionIdWithoutPrefix) : undefined;
        const quickInsertPriority = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command') ? $0156d96fecb1d2a9$var$dataAndChartsForgeMacroQuickInsertPriorities[connectModuleKey] : undefined;
        const createExtensionProps = (macroId)=>{
            const localId = macroId || (0, $dc06fb4e25ee555d$export$a8391a3395b499ed)();
            const extensionId = id;
            const type = (0, $1gaKI.getExtensionType)(extension);
            return {
                // Do not add any additional props in this object or in attrs without changing the adf schema
                type: type,
                attrs: {
                    extensionKey: extensionIdWithoutPrefix,
                    extensionType: (0, $iNIw3.EXTENSION_NAMESPACE),
                    // Only parameters can change without changing the adf schema
                    // Be careful as connect and editor reference node.attrs.parameters.X in multiple places
                    parameters: {
                        localId: localId,
                        extensionId: extensionId,
                        extensionTitle: title,
                        // Persist inline presentation outside app config; keep the legacy value otherwise.
                        layout: isInlineBodiedCustomUI ? 'inline-bodied' : type,
                        forgeEnvironment: environmentType,
                        render: properties.render,
                        embeddedMacroContext: embeddedMacroContext,
                        ...isInlineBodiedExtension ? {
                            guestParams: {
                                [(0, $iNIw3.MACRO_OUTPUT_TYPE_PARAM)]: 'INLINE',
                                [(0, $iNIw3.FORGE_INLINE_BODIED_PARAM)]: 'true'
                            }
                        } : {}
                    },
                    text: title,
                    localId: localId
                },
                ...type === 'bodiedExtension' ? {
                    // include empty content so bodiedExtension doesn't throw error
                    content: [
                        {
                            type: 'paragraph',
                            content: []
                        }
                    ]
                } : {}
            };
        };
        const icon = /*#__PURE__*/ $cozmU.createElement((0, $fKhWq.default), {
            label: properties?.title ?? '',
            imgUrl: properties.icon
        });
        const macroIcons = properties.icon && properties.icon.length > 0 ? {
            '16': ()=>Promise.resolve(()=>icon),
            '24': ()=>Promise.resolve(()=>icon),
            '48': ()=>Promise.resolve(()=>icon)
        } : $0156d96fecb1d2a9$export$dc6604afff08e361;
        const getFieldsDefinition = (0, $ca0b1325ef9f57a7$export$55efa0cfd3b99204)({
            analyticsClient: analyticsClient,
            connectToForgeBlockedExtensions: connectToForgeBlockedExtensions,
            extension: extension,
            hasCustomConfig: hasCustomConfig
        });
        const makeAutoConvertDropdownOptionsInManifest = ()=>{
            const node = editorActions?.getSelectedNode();
            const link = node?.attrs.parameters.autoConvertLink;
            return (0, $9b1ef37666c81eea$export$423a31d6ceadaac3)(autoConvertDefinitions, autoConvertMatcherToExtensionsMap, editorActions, link);
        };
        const getQuickInsertNode = async (actions)=>{
            let extensionProps = createExtensionProps();
            const { localId: localId } = extensionProps.attrs.parameters;
            const { type: extensionType } = extensionProps;
            const isBodiedExtension = extensionType === 'bodiedExtension';
            if (hasCustomConfig) {
                // Skips merging node with payload that renders the config on insert
                if (extension.properties.config?.openOnInsert === false) {
                    sendEvent((0, $2bdd0b58a1f21904$export$30c16f5c43437fd7).FORGE_EXTENSION_INSERTED, {
                        extension: extension,
                        localId: localId
                    });
                    return extensionProps;
                }
                const forgeExtensionNode = {
                    ...extensionProps.attrs,
                    type: extensionType
                };
                const payload = await new Promise((resolve)=>{
                    let isInitialInsertion = true;
                    renderConfigHelper({
                        extension: extension,
                        forgeExtensionNode: forgeExtensionNode,
                        hasCustomConfig: hasCustomConfig,
                        isInitialInsertion: true,
                        createRenderFunction: // We don't use the variable here because this is only executed once
                        createRenderFunction,
                        onSubmit: (payload)=>{
                            if (isInitialInsertion) {
                                isInitialInsertion = false;
                                resolve(payload);
                            } else if (actions) // Update existing node
                            $0156d96fecb1d2a9$export$1fe770db7b01f9fc(actions, localId, payload);
                        },
                        onValidate: (data)=>(0, $509cf1f98caebc07$export$d6710954d38d35b9)(data, {
                                isBodiedExtension: isBodiedExtension,
                                isInitialInsertion: isInitialInsertion,
                                schema: editorActions?._privateGetEditorView?.()?.state.schema
                            })
                    });
                });
                extensionProps = {
                    ...extensionProps,
                    ...$0156d96fecb1d2a9$export$227008f8867b6b1a(extensionProps.attrs, payload)
                };
            }
            sendEvent((0, $2bdd0b58a1f21904$export$30c16f5c43437fd7).FORGE_EXTENSION_INSERTED, {
                extension: extension,
                localId: localId
            });
            return extensionProps;
        };
        const isExtensionHidden = ()=>{
            return extension.type === 'xen:macro' && 'hidden' in properties && properties.hidden === true;
        };
        const shouldBlockExtension = ()=>{
            return (0, $e4497f55fedcae17$export$61f675db88ce9814)(extension) || isExtensionHidden();
        };
        const app = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_app_category_analytics') || (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command') ? {
            key: appId ?? extensionIdWithoutPrefix.split('/')[0],
            source: 'ecosystem'
        } : undefined;
        return {
            title: title,
            description: properties.description,
            type: (0, $iNIw3.EXTENSION_NAMESPACE),
            key: extensionIdWithoutPrefix,
            icons: macroIcons,
            category: properties.category,
            categories: properties.categories,
            connectModuleKey: connectModuleKey,
            ...dynamicConnectModuleKey ? {
                dynamicConnectModuleKey: dynamicConnectModuleKey
            } : {},
            migrationKey: migrationKey,
            migratedFrom: properties.migratedFrom,
            ...app ? {
                app: app
            } : {},
            createExtensionProps: createExtensionProps,
            autoConvert: properties.autoConvert,
            modules: {
                ...shouldBlockExtension() ? {} : {
                    quickInsert: [
                        {
                            key: 'forge-macro',
                            ...quickInsertPriority !== undefined ? {
                                priority: quickInsertPriority
                            } : {},
                            action: async (actions)=>{
                                const node = await getQuickInsertNode(actions);
                                const insertAtSelection = actions.doc?.insertAtSelection;
                                if (isInlineBodiedExtension && insertAtSelection) {
                                    insertAtSelection(node);
                                    if (openConfigOnInsert) (0, $hRcC4.renderBodiedExtensionIframe)({
                                        extension: extension,
                                        forgeExtensionNode: node.attrs,
                                        createRenderFunction: createRenderFunction
                                    });
                                    if (openConfigOnInsert) setTimeout(()=>actions.editInContextPanel((0, $0e17dde5dc080ea0$export$c995c5854d98b6ef), async (params)=>// Saving the config panel replaces guestParams wholesale, which would drop
                                            // the inline-bodied markers seeded in createExtensionProps, so re-seed them.
                                            //
                                            // The spread order is deliberate: the seeded value is a DEFAULT, and a value
                                            // the app's config panel declares explicitly is meant to win, so that an app
                                            // can explicitly select a block presentation. Reversing this
                                            // would make the inline marker absolute and unoverridable. Kept
                                            // consistent with `mergeNodeWithPayload`, which orders it the same way.
                                            ({
                                                guestParams: {
                                                    [(0, $iNIw3.MACRO_OUTPUT_TYPE_PARAM)]: 'INLINE',
                                                    [(0, $iNIw3.FORGE_INLINE_BODIED_PARAM)]: 'true',
                                                    ...params
                                                }
                                            })), 0);
                                     // The provider has inserted the node, so editor-core must not insert it again.
                                    return;
                                }
                                if (openConfigOnInsert && editorActions?._privateGetEditorView()) {
                                    if (isBodiedExtension) (0, $hRcC4.renderBodiedExtensionIframe)({
                                        extension: extension,
                                        forgeExtensionNode: node.attrs,
                                        createRenderFunction: createRenderFunction
                                    });
                                    editorActions?.replaceSelection(node); // Workaround as the dispatch call within editorActions.replaceSelection() is async,
                                    // and we need to ensure that editInContextPanel is called after.
                                    setTimeout(()=>actions.editInContextPanel((0, $0e17dde5dc080ea0$export$c995c5854d98b6ef), async (params)=>// Saving the config panel replaces guestParams wholesale, which would drop
                                            // the inline-bodied markers seeded in createExtensionProps, so re-seed them.
                                            //
                                            // The spread order is deliberate: the seeded value is a DEFAULT, and a value
                                            // the app's config panel declares explicitly is meant to win, so that an app
                                            // can explicitly select a block presentation. Reversing this
                                            // would make the inline marker absolute and unoverridable. Kept
                                            // consistent with `mergeNodeWithPayload`, which orders it the same way.
                                            isInlineBodiedExtension ? {
                                                guestParams: {
                                                    [(0, $iNIw3.MACRO_OUTPUT_TYPE_PARAM)]: 'INLINE',
                                                    [(0, $iNIw3.FORGE_INLINE_BODIED_PARAM)]: 'true',
                                                    ...params
                                                }
                                            } : (0, $0e17dde5dc080ea0$export$33006db0d9b837ff)(params)), 0); // We return undefined here to skip the additional replaceSelection() in editor-core
                                    // platform/packages/editor/editor-core/src/utils/extensions.tsx getItems()
                                    return;
                                }
                                return node;
                            }
                        }
                    ]
                },
                nodes: {
                    default: {
                        type: 'extension',
                        render: ()=>createRenderFunction(extension),
                        update: hasConfig ? (params, actions)=>updateFunction(params, actions, extension, hasCustomConfig) : undefined,
                        getFieldsDefinition: getFieldsDefinition
                    }
                },
                fields: fieldsModules,
                contextualToolbars: hasAutoConvertLinks ? [
                    {
                        context: {
                            nodeType: (0, $1gaKI.getExtensionType)(extension),
                            extensionKey: extensionIdWithoutPrefix,
                            type: 'extension',
                            extensionType: 'com.atlassian.ecosystem',
                            shouldExclude: (node)=>{
                                return !node.attrs?.parameters.hasBeenAutoConverted;
                            }
                        },
                        toolbarItems: [
                            {
                                key: `${extension.key}-convert-to-smartlink-toolbarItem`,
                                label: intl.formatMessage((0, $96301369204ad39e$export$defe85febe8b728c).convertToSmartlinkToolbarItemLabel),
                                display: 'icon',
                                icon: ()=>Promise.resolve((parcelRequire("cSGyR"))).then((mod)=>mod.default),
                                action: async ()=>{
                                    /*We need the editorView object to determine the position of the node.
            By default, the safeInsert method inside replaceSelection inserts nodes in pos + 1 if the selected
            node is an extension. */ const editorView = editorActions?._privateGetEditorView();
                                    const node = editorActions?.getSelectedNode();
                                    const originalLink = node?.attrs.parameters.autoConvertLink;
                                    if (editorView) {
                                        const { selection: selection } = editorView.state;
                                        const insertPosition = selection.$from.pos;
                                        editorActions?.replaceSelection(isInline ? {
                                            type: 'inlineCard',
                                            attrs: {
                                                url: originalLink
                                            }
                                        } : {
                                            type: 'paragraph',
                                            content: [
                                                {
                                                    type: 'inlineCard',
                                                    attrs: {
                                                        url: originalLink
                                                    }
                                                }
                                            ]
                                        }, true, insertPosition);
                                        sendEvent((0, $2bdd0b58a1f21904$export$30c16f5c43437fd7).FORGE_MACRO_AUTO_CONVERT_TO_SMARTLINK, {
                                            extensionId: extension.key,
                                            forgeEnvironment: extension.environmentType,
                                            render: extension.properties.render,
                                            link: originalLink
                                        });
                                    }
                                },
                                tooltip: 'Convert to link',
                                ariaLabel: 'Convert to link'
                            },
                            {
                                id: `${extension.key}-display-options-toolbarItem`,
                                title: 'Display options',
                                type: 'dropdown',
                                options: ()=>makeAutoConvertDropdownOptionsInManifest(),
                                tooltip: 'Display options'
                            }
                        ]
                    }
                ] : []
            }
        };
    };



var $bdpeX = parcelRequire("bdpeX");








class $2d28af281fae44de$export$6add1decf4f736cc extends (0, $bdpeX.default) {
    async getExtension(type, key) {
        try {
            return await super.getExtension(type, key);
        } catch (forgeError) {
            // There is no Forge app to match the full ARI extensionKey
            // If the extensionType is Connect, we fall back to trying to resolve it by harmonised connect module key
            if (type === (0, $iNIw3.P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE)) {
                const { sendEvent: sendEvent } = this.analyticsClient || {};
                if (!this.connectExtensionProvider) {
                    if (sendEvent) sendEvent((0, $2bdd0b58a1f21904$export$30c16f5c43437fd7).H11N_RESOLVE_FAILED, {
                        extensionKey: key,
                        error: 'No connect extension provider'
                    });
                    else this.sendAnalytics?.(key, 'No connect extension provider');
                } else {
                    let forgeExtensionManifests;
                    if (this.isMigratedFromAliasEnabled) {
                        forgeExtensionManifests = this.getForgeExtensionManifests(await this.getExtensions());
                        const migratedFromExtension = this.getMigratedFromConnectToForgeExtension(key, forgeExtensionManifests);
                        if (migratedFromExtension) return migratedFromExtension;
                    }
                    try {
                        // We first check that no Connect app still exists that can handle this extensionKey
                        await (await this.connectExtensionProvider).getExtension(type, key);
                    } catch  {
                        // A lookup can fail because discovery failed. Dynamic migration verifies
                        // absence below before resolving a Forge app by its Connect key.
                        const extension = await this.getConnectToForgeExtension(key, forgeExtensionManifests, false);
                        if (extension) return extension;
                        if ((0, $iDrrr.fg)('platform_upgrade_p2_to_forge_macro')) {
                            const getP2ToForgeExtension = await this.getP2ToForgeExtension(key);
                            if (getP2ToForgeExtension) {
                                if (sendEvent) sendEvent((0, $2bdd0b58a1f21904$export$30c16f5c43437fd7).APP_MIGRATION_P2_MACRO_RESOLVED, {
                                    extensionKey: key,
                                    extensionType: (0, $iNIw3.P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE)
                                });
                                return getP2ToForgeExtension;
                            }
                        }
                        // Report failure to find a Forge extension for this Connect key
                        if (sendEvent) sendEvent((0, $2bdd0b58a1f21904$export$30c16f5c43437fd7).H11N_RESOLVE_FAILED, {
                            extensionKey: key,
                            error: forgeError
                        });
                        else this.sendAnalytics?.(key, forgeError instanceof Error ? forgeError.message : String(forgeError));
                    }
                }
            }
            throw forgeError;
        }
    }
    async getExtensions() {
        return super.getExtensions();
    }
    getPreloadedExtension(type, key) {
        try {
            return super.getPreloadedExtension(type, key);
        } catch (forgeError) {
            if (this.isMigratedFromAliasEnabled) {
                const migratedFromExtension = this.getPreloadedMigratedFromExtension(type, key);
                if (migratedFromExtension) return migratedFromExtension;
            }
            throw forgeError;
        }
    }
    async getMigratedFromExtension(type, key) {
        if (!this.isMigratedFromAliasEnabled || type !== (0, $iNIw3.P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE)) return undefined;
        return this.getMigratedFromConnectToForgeExtension(key, this.getForgeExtensionManifests(await this.getExtensions()));
    }
    getPreloadedMigratedFromExtension(type, key) {
        if (!this.isMigratedFromAliasEnabled || type !== (0, $iNIw3.P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE)) return undefined;
        return this.getMigratedFromConnectToForgeExtension(key, this.getForgeExtensionManifests(this.manifestsCache));
    }
    async getP2ToForgeExtension(key) {
        try {
            return await super.getExtension((0, $iNIw3.EXTENSION_NAMESPACE), key);
        } catch (_) {
            // Means no extension was found
            return;
        }
    }
    async getConnectToForgeExtension(key, forgeExtensionManifests, includeMigratedFromAliases = true) {
        const manifests = forgeExtensionManifests ?? this.getForgeExtensionManifests(await this.getExtensions());
        for (const manifest of manifests){
            const hasMigrationKeyMatch = Boolean(manifest.migrationKey) && manifest.connectModuleKey === key;
            if (hasMigrationKeyMatch) return manifest;
        }
        const migratedFromExtension = includeMigratedFromAliases && this.isMigratedFromAliasEnabled ? this.findMigratedFromMatch(key, manifests) : undefined;
        if ((0, $iDrrr.fg)('platform_forge_dynamic_connect_key')) return migratedFromExtension ?? this.getDynamicConnectToForgeExtension(key, manifests);
        else return migratedFromExtension;
    }
    async getDynamicConnectToForgeExtension(key, manifests) {
        const candidates = manifests.filter((manifest)=>Boolean(manifest.migrationKey) && manifest.dynamicConnectModuleKey === key);
        // Saved Connect nodes contain no app/environment identity. Do not choose an
        // installation by enumeration order when more than one successor claims the key.
        if (new Set(candidates.map((manifest)=>manifest.key)).size !== 1) return undefined;
        if (!this.connectExtensionProvider) return undefined;
        try {
            const connectManifests = await (await this.connectExtensionProvider).getExtensions();
            if (connectManifests.some((manifest)=>manifest.type === (0, $iNIw3.P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE) && manifest.key === key)) return undefined;
        } catch  {
            // A failed lookup does not establish that the Connect macro was removed.
            return undefined;
        }
        return candidates[0];
    }
    getMigratedFromConnectToForgeExtension(key, forgeExtensionManifests) {
        return this.findMigratedFromMatch(key, forgeExtensionManifests);
    }
    getForgeExtensionManifests(extensions) {
        return extensions.filter((manifest)=>'connectModuleKey' in manifest);
    }
    findMigratedFromMatch(key, forgeExtensionManifests) {
        return forgeExtensionManifests.find((manifest)=>Boolean(manifest.migratedFrom?.includes(key)));
    }
    constructor(manifests, connectExtensionProvider, sendAnalytics, autoConvertHandlers, analyticsClient, isMigratedFromAliasEnabled = false){
        super(manifests);
        this.connectExtensionProvider = void 0;
        this.sendAnalytics = void 0;
        this.analyticsClient = void 0;
        this.isMigratedFromAliasEnabled = void 0;
        this.connectExtensionProvider = connectExtensionProvider;
        this.sendAnalytics = sendAnalytics;
        this.manifestsPromise = Promise.resolve(manifests);
        this.autoConvertHandlers = autoConvertHandlers;
        this.analyticsClient = analyticsClient;
        this.isMigratedFromAliasEnabled = isMigratedFromAliasEnabled;
    }
}














const $e3ac653b9f50a643$export$6daa7566596cd68 = (pattern)=>{
    // Escape special regex characters, excluding `*`
    const escapePattern = (str)=>{
        return str.replace(/[\-\[\]\/\(\)\+\?\.\\\^\$\|]/g, '\\$&');
    };
    // Consolidate any double wildcards (** -> *)
    pattern = pattern.replace(/\*\*/g, '*');
    // Escape special characters (but leave `*` as-is for now)
    pattern = escapePattern(pattern);
    // Replace wildcards (*) with regex equivalent
    pattern = pattern.replace(/\*/g, '[^/]*?'); // Replace escaped `*`
    // Add start (^) and end ($) anchors
    pattern = '^' + pattern + '$';
    return pattern;
};


/**
 * Validates auto convert url patterns. The regex is matching:
 * - a required protocol (http:// or https:// or a custom protocol like myapp: or myapp:\\)
 * - allows wildcard (*) in any part of the url
 * - no whitespaces
 * - 1024 character limit
 * For more information: https://hello.atlassian.net/wiki/spaces/ECO/pages/4856894219/Manifest+Schema+Changes+Documentation
 */ const $da7e46c1285f751c$export$3ecb154bc09ddd37 = (pattern)=>{
    const urlRegex = /^(?=.{1,1024}$)[a-zA-Z]+:(\/\/)?(\\\\)?(?:[a-zA-Z0-9-\*]+[\.:])*[a-zA-Z0-9-\*]+(?:\.:[a-zA-Z\*]{1,})?(?:\/.*)?$/;
    return urlRegex.test(pattern);
};


const $5cbd942ce13ee5de$export$96c30bce9b9743b7 = (extensions, embeddedMacroContext)=>{
    if (!extensions) return {
        autoConvertDefinitions: undefined,
        macroADFNodeMap: undefined
    };
    const autoConvertDefinitions = [];
    // a map of macro key to ADF node
    const macroADFNodeMap = {};
    extensions.forEach((extension)=>{
        if (!(0, $9cGsb.parse)(extension.id).resourceId || !extension.properties.autoConvert) return;
        const extensionIdWithoutPrefix = (0, $9cGsb.parse)(extension.id).resourceId;
        const isLayoutSwitchEnabled = (0, $iDrrr.fg)('platform_forge_inline_bodied_layout_switch');
        const isInlineBodied = isLayoutSwitchEnabled && extension.properties.layout === 'inline-bodied' && extension.properties.render === 'native' && (0, $iDrrr.fg)('platform_forge_inline_bodied_macro');
        // only macro with autoconvertData can be converted
        extension.properties.autoConvert.matchers.forEach(({ pattern: pattern })=>{
            // Invalid patterns will silently fail. We are relying on the CLI linter to warn developers for invalid pattern
            if ((0, $da7e46c1285f751c$export$3ecb154bc09ddd37)(pattern)) {
                const type = (0, $1gaKI.getExtensionType)(extension);
                macroADFNodeMap[extensionIdWithoutPrefix] = {
                    type: type,
                    ...isLayoutSwitchEnabled && extension.properties.layout === 'inline-bodied' ? {
                        content: [
                            {
                                type: 'paragraph',
                                content: []
                            }
                        ]
                    } : {},
                    attrs: {
                        extensionKey: extensionIdWithoutPrefix,
                        extensionType: (0, $iNIw3.EXTENSION_NAMESPACE),
                        parameters: {
                            extensionId: extension.id,
                            extensionTitle: extension.properties.title,
                            layout: extension.properties.layout || 'block',
                            forgeEnvironment: extension.environmentType,
                            render: extension.properties.render || 'default',
                            embeddedMacroContext: embeddedMacroContext,
                            ...isInlineBodied ? {
                                guestParams: {
                                    [(0, $iNIw3.MACRO_OUTPUT_TYPE_PARAM)]: 'INLINE',
                                    [(0, $iNIw3.FORGE_INLINE_BODIED_PARAM)]: 'true'
                                }
                            } : {}
                        },
                        layout: 'default',
                        text: extension.properties.title
                    }
                };
                const autoConvertDefinition = {
                    macroName: extension.properties.title || '',
                    matcher: (0, $e3ac653b9f50a643$export$6daa7566596cd68)(pattern),
                    extensionKey: extensionIdWithoutPrefix
                };
                autoConvertDefinitions.push(autoConvertDefinition);
            }
        });
    });
    return {
        autoConvertDefinitions: autoConvertDefinitions,
        macroADFNodeMap: macroADFNodeMap
    };
};


const $ded722b7c52c8e2b$export$d2b6953e93cee5f0 = (autoConvertDefinitions, macroADFNodeMap)=>{
    if (!autoConvertDefinitions || !macroADFNodeMap) return {};
    return autoConvertDefinitions.reduce((acc, def)=>{
        if (!acc[def.matcher]) acc[def.matcher] = [];
        acc[def.matcher].push({
            macroName: def.macroName,
            macroADFNode: macroADFNodeMap[def.extensionKey],
            extensionKey: def.extensionKey
        });
        return acc;
    }, {});
};



const $4565612686466d94$export$83421df3e56a4930 = (analyticsClient, autoConvertDefinitions, macroADFNodeMap, autoConvertMatcherToExtensionsMap)=>{
    return (link)=>(0, $6cebec68dbaae69c$export$ba0026a66deb9f75)(link, analyticsClient, autoConvertDefinitions, macroADFNodeMap, autoConvertMatcherToExtensionsMap);
};










const $e446f29b5c6bf561$export$d302d43aa723dad0 = (node, extensionManifest)=>{
    const { attrs: attrs } = node;
    // Ensure extension hasn't been upgraded since the last check
    if (attrs?.extensionType === (0, $iNIw3.P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE)) {
        // Use the existing Connect macro ID as the Forge localId
        const macroId = (0, $e135764dedc3ef6a$export$4ea6c6225eccc91)(attrs.parameters);
        const extensionProps = extensionManifest?.createExtensionProps(macroId);
        let extensionParameters = extensionProps.attrs.parameters;
        if (extensionParameters.layout === 'inline-bodied' && (0, $iDrrr.fg)('platform_forge_inline_bodied_layout_switch')) // Migration retains Connect's stored presentation; only fresh Forge insertions opt in.
        extensionParameters = {
            ...extensionParameters,
            layout: 'bodiedExtension'
        };
        const migratedParameters = $e446f29b5c6bf561$var$convertConnectParametersToForge(attrs.parameters);
        const seededGuestParams = extensionProps.attrs.parameters?.guestParams;
        // The Connect node retains its original presentation contract when the Forge successor has
        // no Native UI inline-bodied markers.
        const isStoredConnectInlineExtension = node.type === 'extension' && migratedParameters.macroParams?.['atlassian-macro-output-type']?.value === 'INLINE' && (0, $iDrrr.fg)('platform_forge_inline_bodied_macro');
        return {
            ...node,
            ...isStoredConnectInlineExtension ? {
                type: 'inlineExtension'
            } : {},
            attrs: {
                ...attrs,
                ...extensionProps.attrs,
                // We shouldn't override the Editor localId of an existing node once it's been created
                localId: attrs.localId || extensionProps.attrs.localId,
                parameters: {
                    ...migratedParameters,
                    ...extensionParameters,
                    /**
           * `createExtensionProps` seeds `guestParams` for a macro declaring
           * `layout: inline-bodied`.
           */ ...seededGuestParams && (0, $iDrrr.fg)('platform_forge_inline_bodied_layout_switch') && (0, $iDrrr.fg)('platform_forge_inline_bodied_macro') ? {
                        guestParams: migratedParameters.guestParams
                    } : {}
                }
            }
        };
    }
    return node;
};
const $e446f29b5c6bf561$var$convertConnectParametersToForge = ({ guestParams: guestParams = {}, macroParams: macroParams = {}, ...restParams } = {})=>{
    const migratedGuestParams = {
        ...guestParams
    };
    Object.entries(macroParams).forEach(([key, obj])=>{
        // Don't override existing entries
        if (typeof migratedGuestParams[key] === 'undefined' && obj && 'value' in obj) migratedGuestParams[key] = obj.value;
    });
    // Strip macroMetadata so the upgraded node matches a natively-created Forge macro. While it
    // is present, the Confluence backend (MacroServiceImpl.readMacroId) extracts the node for
    // server-side render and invokes adfExport on every page view (CONFCLOUD-83809). macroParams
    // is kept: the frontend derives guestParams from it and the backend does not key on it.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { macroMetadata: macroMetadata, ...restWithoutMacroMetadata } = restParams;
    return {
        macroParams: macroParams,
        guestParams: migratedGuestParams,
        ...restWithoutMacroMetadata
    };
};
const $e446f29b5c6bf561$var$upgradeConnectExtensionToForge = async (attrs, actions, extensionProvider)=>{
    const { localId: localId, extensionKey: extensionKey } = attrs;
    let extensionManifest = await extensionProvider.getConnectToForgeExtension(extensionKey);
    let originalMacroType = 'CONNECT';
    if (!extensionManifest && (0, $iDrrr.fg)('platform_upgrade_p2_to_forge_macro')) {
        const p2ToForgeExtensionManifest = await extensionProvider.getP2ToForgeExtension(extensionKey);
        originalMacroType = 'P2';
        extensionManifest = p2ToForgeExtensionManifest;
    }
    if (!extensionManifest || !extensionManifest.createExtensionProps) throw new Error(`Connect to Forge macro upgrade: No ${!extensionManifest ? 'extension manifest' : 'createExtensionProps function'} found`);
    return new Promise((resolve)=>{
        actions.doc.update(localId, (currentValue)=>{
            const updatedNode = $e446f29b5c6bf561$export$d302d43aa723dad0(currentValue, extensionManifest);
            resolve({
                updatedNode: updatedNode,
                originalMacroType: originalMacroType
            });
            return updatedNode;
        });
    });
};
const $e446f29b5c6bf561$export$142e3c584022ba7e = async ({ connectToForgeBlockedExtensions: connectToForgeBlockedExtensions, extensionProvider: extensionProvider, actions: actions, analyticsClient: analyticsClient, editorActions: editorActions })=>{
    // Only passed through when we are in the Editor view
    if (!editorActions) return;
    const { sendEvent: sendEvent } = analyticsClient;
    const node = editorActions.getSelectedNode();
    const attrs = node?.attrs;
    if (attrs?.extensionType === (0, $iNIw3.P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE)) {
        const { extensionKey: extensionKey, localId: nodeLocalId } = attrs;
        const macroId = (0, $e135764dedc3ef6a$export$4ea6c6225eccc91)(attrs.parameters);
        const extensionType = node?.type.name;
        if (extensionType === (0, $iNIw3.EXTENSION_TYPE_MULTI_BODIED)) {
            // Upgrade to forge blocked because:
            //     Extension is multi-bodied which forge doesn't support
            connectToForgeBlockedExtensions.add(macroId);
            sendEvent((0, $2bdd0b58a1f21904$export$30c16f5c43437fd7).H11N_UPGRADE_RICH_TEST_SKIPPED, {
                nodeLocalId: nodeLocalId
            });
            return;
        }
        /* At this point, we know the extension should be upgraded from Connect to Forge
     * If anything goes wrong after this point, it should be logged as an upgrade failure */ try {
            if (!actions?.doc?.update) throw new Error('Connect to Forge macro upgrade: Missing ExtensionAPI update action');
            const { updatedNode: updatedNode, originalMacroType: originalMacroType } = await $e446f29b5c6bf561$var$upgradeConnectExtensionToForge(attrs, actions, extensionProvider);
            const { localId: localId, extensionId: extensionId } = updatedNode.attrs.parameters;
            if (originalMacroType === 'CONNECT') sendEvent((0, $2bdd0b58a1f21904$export$30c16f5c43437fd7).H11N_UPGRADE_SUCCESS, {
                extensionId: extensionId,
                extensionKey: extensionKey,
                localId: localId,
                nodeLocalId: nodeLocalId,
                extensionType: extensionType
            });
            else if (originalMacroType === 'P2') sendEvent((0, $2bdd0b58a1f21904$export$30c16f5c43437fd7).APP_MIGRATION_P2_MACRO_UPGRADE, {
                extensionId: extensionId,
                extensionKey: extensionKey,
                localId: localId,
                nodeLocalId: nodeLocalId,
                extensionType: extensionType
            });
        } catch (error) {
            sendEvent((0, $2bdd0b58a1f21904$export$30c16f5c43437fd7).H11N_UPGRADE_FAILED, {
                extensionKey: extensionKey,
                error: error,
                nodeLocalId: nodeLocalId,
                extensionType: extensionType
            });
            throw error;
        }
    }
};


const $f549bb27bef546d1$var$humanReadableEnvironmentType = {
    DEVELOPMENT: 'Development',
    STAGING: 'Staging',
    PRODUCTION: 'Production'
};
const $f549bb27bef546d1$export$553719da8802da2d = (title, environmentKey, environmentType = (0, $bLswh.ExtensionEnvironment).PRODUCTION)=>{
    if (environmentType === (0, $bLswh.ExtensionEnvironment).PRODUCTION) return title;
    if (environmentKey === undefined) return `${title} (${$f549bb27bef546d1$var$humanReadableEnvironmentType[environmentType]})`;
    if (environmentType === (0, $bLswh.ExtensionEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$f549bb27bef546d1$var$humanReadableEnvironmentType[environmentType]})`;
};
/*
	This exists to provide a default value for the flag functions that Confluence
	is meant to inject with the FlagProvider param. The param must be optional in
	getForgeExtensionProvider because breaking changes are disallowed without a
	deprecation period (which we want to avoid) - see go/releasing-changes-safely.
	The renderExtension function expects FlagProvider to be defined, so this default is provided.
*/ const $f549bb27bef546d1$var$noopFlags = {
    showFlag: async ()=>{
        return {};
    },
    hideFlag: async ()=>{}
};
const $f549bb27bef546d1$var$noopFlagProvider = ({ children: children })=>children($f549bb27bef546d1$var$noopFlags);
// We keep track of the reason that an extension failed to upgrade, for analytics purposes
const $f549bb27bef546d1$var$connectToForgeBlockedExtensions = new Set();
const $f549bb27bef546d1$export$5f25f73e1231045e = async ({ accountId: accountId, cloudId: cloudId, contextIds: contextIds, dataProviders: dataProviders, nestedAdfMediaProvider: nestedAdfMediaProvider, environment: environment, product: product, page: page, isEditing: isEditing, analyticsWebClient: analyticsWebClient, forgeUIAnalyticsContext: forgeUIAnalyticsContext = {}, extensionData: extensionData, extensionHandlerWithReference: extensionHandlerWithReference, connectExtensionProvider: connectExtensionProvider, editorActions: editorActions, editorAPI: editorAPI, FlagProvider: FlagProvider = $f549bb27bef546d1$var$noopFlagProvider, extensionsFilter: extensionsFilter, dataClassificationTagIds: dataClassificationTagIds, hideGlassPane: hideGlassPane, intl: intl, isMigratedFromAliasEnabled: isMigratedFromAliasEnabled, locale: locale, relayEnvironment: relayEnvironment, useGetContextToken: useGetContextToken, useRouteActions: useRouteActions, productExtensionHandlers: productExtensionHandlers })=>{
    let extensionProvider;
    let forgeMacroExtensions = null;
    const createRenderFunction = async (extension, customEditContext)=>extension && (0, $e4497f55fedcae17$export$61f675db88ce9814)(extension) ? (0, $e4497f55fedcae17$export$17b6162b15b3194c)({
            extension: extension
        }) : (0, $11919ce3ce390e79$export$b7482bdc8aff85e4)({
            accountId: accountId,
            analyticsWebClient: analyticsWebClient,
            cloudId: cloudId,
            extension: extension,
            extensionData: extensionData,
            extensionHandlerWithReference: extensionHandlerWithReference,
            forgeMacroExtensions: forgeMacroExtensions,
            forgeUIAnalyticsContext: forgeUIAnalyticsContext,
            contextIds: contextIds,
            isEditing: Boolean(isEditing),
            dataProviders: dataProviders,
            nestedAdfMediaProvider: nestedAdfMediaProvider,
            environment: environment,
            product: product,
            page: page,
            FlagProvider: FlagProvider,
            hideGlassPane: hideGlassPane,
            customEditContext: customEditContext,
            editorAPI: editorAPI,
            useGetContextToken: useGetContextToken,
            useRouteActions: useRouteActions,
            productExtensionHandlers: productExtensionHandlers
        });
    const { extensions: extensions } = await (0, $9PdUw.getForgeUIExtensionsRelayAsync)({
        contextIds: contextIds,
        moduleType: (0, $iNIw3.MODULE_NAME),
        extensionsFilter: extensionsFilter,
        dataClassificationTagIds: dataClassificationTagIds,
        locale: locale,
        cloudId: cloudId,
        context: {
            spaceKey: extensionData?.space?.key,
            contentId: extensionData?.content?.id
        },
        includeHidden: true,
        relayEnvironment: relayEnvironment
    });
    forgeMacroExtensions = extensions ?? null;
    const eventSource = editorActions ? 'editPageScreen' : 'viewPageScreen';
    const analyticsClient = (0, $2bdd0b58a1f21904$export$3d970ca206012d6b)({
        analyticsWebClient: analyticsWebClient,
        forgeUIAnalyticsContext: forgeUIAnalyticsContext,
        source: eventSource
    });
    const { sendEvent: sendEvent } = analyticsClient;
    const updateFunction = async (parameters, actions, extension, hasCustomConfig)=>{
        // Remember the localId of the selected node. If it's upgraded to Forge, it becomes unselected, so localId
        // is needed to find it again.
        const localId = editorActions?.getSelectedNode()?.attrs.localId;
        await (0, $e446f29b5c6bf561$export$142e3c584022ba7e)({
            actions: actions,
            analyticsClient: analyticsClient,
            connectToForgeBlockedExtensions: $f549bb27bef546d1$var$connectToForgeBlockedExtensions,
            editorActions: editorActions,
            extensionProvider: extensionProvider
        });
        const node = actions.getNodeWithPosByLocalId(localId)?.node;
        const isBodiedExtension = node?.type.name === 'bodiedExtension';
        if (node && extension && actions && (hasCustomConfig || isBodiedExtension)) {
            /**
       * Converts a ProseMirror Node (received by EditorActions API) to a ForgeExtension (provided to render function)
       * This includes:
       * - Extracting the node's attributes
       * - Extracting the node's type
       * - Transforming the node's content from ProseMirror to ADF JSON (and handling any errors)
       */ const forgeExtensionNode = (()=>{
                const forgeExtension = {
                    ...node.attrs,
                    type: node.type.name
                };
                try {
                    const { content: content } = new (0, $2lPWP.JSONTransformer)().encode(node);
                    return {
                        ...forgeExtension,
                        content: content
                    };
                } catch (error) {
                    // failed to encode node to JSON
                    // continue rendering custom config without content and emit analytics error event
                    const { localId: localId } = node.attrs;
                    sendEvent((0, $2bdd0b58a1f21904$export$30c16f5c43437fd7).FORGE_EXTENSION_FAILED, {
                        extension: extension,
                        error: error,
                        localId: localId
                    });
                    return forgeExtension;
                }
            })();
            // No need to wait for config to render to start showing the panel (for non-custom config)
            // noinspection ES6MissingAwait
            (0, $hRcC4.renderConfigHelper)({
                extension: extension,
                forgeExtensionNode: forgeExtensionNode,
                hasCustomConfig: Boolean(hasCustomConfig),
                isInitialInsertion: false,
                createRenderFunction: createRenderFunction,
                onSubmit: (payload)=>(0, $iDrrr.fg)('platform_measure_macro_height') ? (0, $0156d96fecb1d2a9$export$4bf92a336c844766)(actions, node.attrs.localId, payload) : (0, $0156d96fecb1d2a9$export$1fe770db7b01f9fc)(actions, node.attrs.localId, payload),
                onValidate: (data)=>(0, $509cf1f98caebc07$export$d6710954d38d35b9)(data, {
                        isBodiedExtension: isBodiedExtension,
                        isInitialInsertion: false,
                        schema: editorActions?._privateGetEditorView?.()?.state.schema
                    })
            });
        }
        if (!hasCustomConfig) return actions.editInContextPanel((0, $0e17dde5dc080ea0$export$c995c5854d98b6ef), async (params)=>{
            if ((0, $iDrrr.fg)('platform_measure_macro_height')) {
                const currentNode = actions.getNodeWithPosByLocalId(node?.attrs.localId);
                const existingParameters = currentNode?.node.attrs.parameters;
                if (existingParameters.measuredHeight) {
                    const tr = (0, $0e17dde5dc080ea0$export$33006db0d9b837ff)(params);
                    return {
                        ...tr,
                        measuredHeight: existingParameters.measuredHeight
                    };
                }
            }
            return (0, $0e17dde5dc080ea0$export$33006db0d9b837ff)(params);
        });
    };
    const fieldsModules = {
        user: {
            [(0, $7e94665fb6a19916$export$5e2bcfbdd2ce465e)]: {
                provider: async ()=>({
                        siteId: cloudId,
                        // If principalId === 'Context', upstream attempts to use other context to discover the principal ID
                        principalId: accountId || 'Context',
                        fieldId: 'forgeConfigUserPicker',
                        productKey: product
                    })
            }
        }
    };
    const embeddedMacroContext = {
        extensionData: extensionData,
        contextIds: contextIds,
        accountId: accountId || '',
        cloudId: cloudId
    };
    const { autoConvertDefinitions: autoConvertDefinitions, macroADFNodeMap: macroADFNodeMap } = (0, $5cbd942ce13ee5de$export$96c30bce9b9743b7)(extensions, embeddedMacroContext);
    const autoConvertMatcherToExtensionsMap = (0, $ded722b7c52c8e2b$export$d2b6953e93cee5f0)(autoConvertDefinitions, macroADFNodeMap);
    const convertLinkToADFNode = (0, $4565612686466d94$export$83421df3e56a4930)(analyticsClient, autoConvertDefinitions, macroADFNodeMap, autoConvertMatcherToExtensionsMap);
    const convertToExtensionManifest = (0, $0156d96fecb1d2a9$export$205fc211839e6c8b)({
        analyticsClient: analyticsClient,
        editorActions: editorActions,
        fieldsModules: fieldsModules,
        renderConfigHelper: $hRcC4.renderConfigHelper,
        createRenderFunction: createRenderFunction,
        connectToForgeBlockedExtensions: $f549bb27bef546d1$var$connectToForgeBlockedExtensions,
        updateFunction: updateFunction,
        autoConvertDefinitions: autoConvertDefinitions,
        autoConvertMatcherToExtensionsMap: autoConvertMatcherToExtensionsMap,
        embeddedMacroContext: embeddedMacroContext,
        intl: intl
    });
    const extensionManifests = (extensions || []).filter(({ id: id })=>(0, $9cGsb.parse)(id).resourceId !== undefined).map(convertToExtensionManifest);
    const legacyMacroManifest = {
        /**
     * title, description and icons are required but will not be used anywhere,
     * since this manifest is used solely for rendering legacy nodes
     **/ title: 'Forge UI Macro',
        description: 'Supports existing Forge UI Macro nodes',
        type: (0, $iNIw3.EXTENSION_NAMESPACE),
        key: 'xen:macro',
        icons: (0, $0156d96fecb1d2a9$export$dc6604afff08e361),
        modules: {
            nodes: {
                default: {
                    type: 'extension',
                    render: createRenderFunction,
                    update: updateFunction
                }
            },
            fields: fieldsModules
        }
    };
    const manifests = [
        legacyMacroManifest,
        ...extensionManifests
    ];
    extensionProvider = new (0, $2d28af281fae44de$export$6add1decf4f736cc)(manifests, connectExtensionProvider, undefined, [
        (link)=>{
            const result = convertLinkToADFNode(link);
            if (result) return result;
            return undefined;
        }
    ], analyticsClient, isMigratedFromAliasEnabled);
    return extensionProvider;
};



var $huSww = parcelRequire("huSww");


var $aF5bm = parcelRequire("aF5bm");


var $ix7El = parcelRequire("ix7El");


var $8z3oB = parcelRequire("8z3oB");


var $ge2sX = parcelRequire("ge2sX");


var $5bak6 = parcelRequire("5bak6");


var $04e9M = parcelRequire("04e9M");


var $5SzHz = parcelRequire("5SzHz");


var $9HB34 = parcelRequire("9HB34");


var $dPJCf = parcelRequire("dPJCf");


var $4IoVL = parcelRequire("4IoVL");


var $6mKj3 = parcelRequire("6mKj3");

const $011c3ef08c0f8175$export$31bd098138fa620d = async ({ spaceKey: spaceKey, spaceId: spaceId, contentId: contentId, contentType: contentType, mentionProvider: mentionProvider, isEditing: isEditing, contentMode: contentMode, contentVersion: contentVersion, connectExtensionProvider: connectExtensionProvider, editorActions: editorActions, hideGlassPaneForForge: hideGlassPaneForForge, intl: intl, locale: locale, isLivePage: isLivePage = false, editorAPI: editorAPI, useGetContextToken: useGetContextToken, templateId: templateId })=>{
    const { cloudId: cloudId, userId: userId, environment: environment, activationId: activationId } = await (0, $ge2sX.getSessionData)();
    const accountId = userId ?? '';
    const contextIds = [
        (0, $aF5bm.getWorkspaceARI)({
            cloudId: cloudId,
            activationId: activationId
        })
    ];
    const providerFactory = (0, $eNbr2.default).create(mentionProvider);
    // ADF returned by a Forge macro is rendered by the Forge AdfRenderer, not the editor, so give it a
    // collection-aware media provider (mirrors populateExtensionProviders). Tokens are minted for the
    // content owning the media collection, not the host page.
    const nestedAdfMediaProvider = (0, $6mKj3.expValEquals)('platform_media_token_nested_macro', 'isEnabled', true) ? (0, $4IoVL.createRendererMediaProvider)({
        contentId: contentId,
        spaceKey: spaceKey,
        isExternalShare: false,
        resolveContentIdFromCollection: true
    }) : undefined;
    const getProviderOptions = ({ spaceKey: spaceKeyArg, spaceId: spaceIdArg })=>({
            ...nestedAdfMediaProvider ? {
                nestedAdfMediaProvider: nestedAdfMediaProvider
            } : {},
            accountId: accountId,
            cloudId: cloudId,
            contextIds: contextIds,
            dataProviders: providerFactory,
            environment: (0, $5bak6.environmentToForgeProductEnvironment)(environment),
            product: 'confluence',
            page: 'confluence:macroEditor',
            isEditing: isEditing,
            contentMode: contentMode,
            analyticsWebClient: (0, $04e9M.getAnalyticsWebClient)(),
            forgeUIAnalyticsContext: (0, $5bak6.createForgeUIAnalyticsContext)({
                objectId: contentId,
                objectType: contentType,
                containerId: spaceKeyArg,
                // TODO replace with spaceId
                containerType: 'space'
            }),
            extensionData: (0, $5bak6.createForgeMacroExtensionData)({
                spaceKey: spaceKeyArg,
                spaceId: spaceIdArg ?? spaceId,
                contentId: contentId,
                contentType: contentType,
                isLivePage: isLivePage,
                templateId: templateId,
                contentVersion: contentVersion
            }),
            connectExtensionProvider: connectExtensionProvider,
            editorActions: editorActions,
            FlagProvider: $8z3oB.FlagProvider,
            extensionsFilter: undefined,
            hideGlassPane: hideGlassPaneForForge,
            intl: intl,
            locale: locale,
            editorAPI: editorAPI,
            relayEnvironment: (0, $9HB34.getRelayEnvironment)(),
            useGetContextToken: useGetContextToken,
            useRouteActions: $dPJCf.useRouteActions,
            extensionHandlerWithReference: (0, $huSww.createForgeMacroExtensionHandler)(isEditing, isLivePage)
        });
    const forgeExtensionProvider = $011c3ef08c0f8175$export$c165817f58cf8b({
        getProviderOptions: getProviderOptions,
        spaceKey: spaceKey
    });
    return forgeExtensionProvider;
};
const $011c3ef08c0f8175$export$c165817f58cf8b = async ({ getProviderOptions: getProviderOptions, spaceKey: spaceKey })=>{
    return (0, $5SzHz.fetchSpaceDetail)(spaceKey).then(({ data: data, loading: loading, error: error })=>{
        if (!loading) {
            const dataClassificationTags = data?.space?.dataClassificationTags;
            const spaceKeyFromQuery = data?.space?.key;
            const spaceIdFromQuery = data?.space?.id;
            return {
                dataClassificationTags: dataClassificationTags,
                spaceKeyFromQuery: spaceKeyFromQuery,
                spaceIdFromQuery: spaceIdFromQuery,
                error: error
            };
        }
    }).then((data)=>{
        if (data?.error) return Promise.reject(data.error);
        const providerOptions = getProviderOptions({
            spaceKey: data?.spaceKeyFromQuery,
            spaceId: data?.spaceIdFromQuery
        });
        // TODO: Should always use new extensions query regardless of whether there's dataClassificationTags
        // Remove as part of https://product-fabric.atlassian.net/browse/CCECO-3476
        const shouldUseNewExtensionsQuery = !!(data?.dataClassificationTags && data?.dataClassificationTags.length > 0);
        if (shouldUseNewExtensionsQuery) {
            providerOptions.extensionsFilter = [
                {
                    type: (0, $ix7El.GQLExtensionContextsFilterType).ExtensionType,
                    value: [
                        'xen:macro'
                    ]
                }
            ];
            providerOptions.dataClassificationTagIds = data?.dataClassificationTags;
        }
        return (0, $f549bb27bef546d1$export$5f25f73e1231045e)(providerOptions);
    });
};
module.exports["getForgeExtensionHandler"] = $011c3ef08c0f8175$export$31bd098138fa620d;
module.exports["fetchForgeExtensionProvider"] = $011c3ef08c0f8175$export$c165817f58cf8b;

});

parcelRegister("iVt9k", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/**
 * Buffers the source Observable values until `closingNotifier` emits.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when another Observable emits.</span>
 *
 * <img src="./img/buffer.png" width="100%">
 *
 * Buffers the incoming Observable values until the given `closingNotifier`
 * Observable emits a value, at which point it emits the buffer on the output
 * Observable and starts a new buffer internally, awaiting the next time
 * `closingNotifier` emits.
 *
 * @example <caption>On every click, emit array of most recent interval events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var buffered = interval.buffer(clicks);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link window}
 *
 * @param {Observable<any>} closingNotifier An Observable that signals the
 * buffer to be emitted on the output Observable.
 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
 * values.
 * @method buffer
 * @owner Observable
 */ function buffer(closingNotifier) {
    return function bufferOperatorFunction(source) {
        return source.lift(new BufferOperator(closingNotifier));
    };
}
exports.buffer = buffer;
var BufferOperator = function() {
    function BufferOperator(closingNotifier) {
        this.closingNotifier = closingNotifier;
    }
    BufferOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new BufferSubscriber(subscriber, this.closingNotifier));
    };
    return BufferOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var BufferSubscriber = function(_super) {
    __extends(BufferSubscriber, _super);
    function BufferSubscriber(destination, closingNotifier) {
        _super.call(this, destination);
        this.buffer = [];
        this.add($863V0.subscribeToResult(this, closingNotifier));
    }
    BufferSubscriber.prototype._next = function(value) {
        this.buffer.push(value);
    };
    BufferSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var buffer = this.buffer;
        this.buffer = [];
        this.destination.next(buffer);
    };
    return BufferSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=buffer.js.map

});

parcelRegister("iUi6G", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */ function count(predicate) {
    return function(source) {
        return source.lift(new CountOperator(predicate, source));
    };
}
exports.count = count;
var CountOperator = function() {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var CountSubscriber = function(_super) {
    __extends(CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.count = 0;
        this.index = 0;
    }
    CountSubscriber.prototype._next = function(value) {
        if (this.predicate) this._tryPredicate(value);
        else this.count++;
    };
    CountSubscriber.prototype._tryPredicate = function(value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.count++;
    };
    CountSubscriber.prototype._complete = function() {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=count.js.map

});

parcelRegister("1eEGG", function(module, exports) {
"use strict";

var $zAMIg = parcelRequire("zAMIg");


var $5pyN0 = parcelRequire("5pyN0");

/**
 * @param scheduler
 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timestamp
 * @owner Observable
 */ function timestamp(scheduler) {
    if (scheduler === void 0) scheduler = $zAMIg.async;
    return $5pyN0.map(function(value) {
        return new Timestamp(value, scheduler.now());
    });
// return (source: Observable<T>) => source.lift(new TimestampOperator(scheduler));
}
exports.timestamp = timestamp;
var Timestamp = function() {
    function Timestamp(value, timestamp) {
        this.value = value;
        this.timestamp = timestamp;
    }
    return Timestamp;
}();
exports.Timestamp = Timestamp;
 //# sourceMappingURL=timestamp.js.map

});

parcelRegister("fkGmq", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gGP9M = parcelRequire("gGP9M");


var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/**
 * Branch out the source Observable values as a nested Observable whenever
 * `windowBoundaries` emits.
 *
 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
 * instead of an array.</span>
 *
 * <img src="./img/window.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping
 * windows. It emits the current window and opens a new one whenever the
 * Observable `windowBoundaries` emits an item. Because each window is an
 * Observable, the output is a higher-order Observable.
 *
 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var result = clicks.window(interval)
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link buffer}
 *
 * @param {Observable<any>} windowBoundaries An Observable that completes the
 * previous window and starts a new window.
 * @return {Observable<Observable<T>>} An Observable of windows, which are
 * Observables emitting values of the source Observable.
 * @method window
 * @owner Observable
 */ function window(windowBoundaries) {
    return function windowOperatorFunction(source) {
        return source.lift(new WindowOperator(windowBoundaries));
    };
}
exports.window = window;
var WindowOperator = function() {
    function WindowOperator(windowBoundaries) {
        this.windowBoundaries = windowBoundaries;
    }
    WindowOperator.prototype.call = function(subscriber, source) {
        var windowSubscriber = new WindowSubscriber(subscriber);
        var sourceSubscription = source.subscribe(windowSubscriber);
        if (!sourceSubscription.closed) windowSubscriber.add($863V0.subscribeToResult(windowSubscriber, this.windowBoundaries));
        return sourceSubscription;
    };
    return WindowOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var WindowSubscriber = function(_super) {
    __extends(WindowSubscriber, _super);
    function WindowSubscriber(destination) {
        _super.call(this, destination);
        this.window = new $gGP9M.Subject();
        destination.next(this.window);
    }
    WindowSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow();
    };
    WindowSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function(innerSub) {
        this._complete();
    };
    WindowSubscriber.prototype._next = function(value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function(err) {
        this.window.error(err);
        this.destination.error(err);
    };
    WindowSubscriber.prototype._complete = function() {
        this.window.complete();
        this.destination.complete();
    };
    /** @deprecated internal use only */ WindowSubscriber.prototype._unsubscribe = function() {
        this.window = null;
    };
    WindowSubscriber.prototype.openWindow = function() {
        var prevWindow = this.window;
        if (prevWindow) prevWindow.complete();
        var destination = this.destination;
        var newWindow = this.window = new $gGP9M.Subject();
        destination.next(newWindow);
    };
    return WindowSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=window.js.map

});

parcelRegister("jzRCB", function(module, exports) {
"use strict";
var $e40ae156dafb6025$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hmT2x = parcelRequire("hmT2x");


var $cH4eu = parcelRequire("cH4eu");


var $fNVRJ = parcelRequire("fNVRJ");


var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");


var $cRoko = parcelRequire("cRoko");

/* tslint:enable:max-line-length */ /**
 * @param observables
 * @return {Observable<R>}
 * @method zip
 * @owner Observable
 */ function $e40ae156dafb6025$var$zip() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function zipOperatorFunction(source) {
        return source.lift.call($e40ae156dafb6025$var$zipStatic.apply(void 0, [
            source
        ].concat(observables)));
    };
}
module.exports.zip = $e40ae156dafb6025$var$zip;
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are calculated from the values, in order, of each
 * of its input Observables.
 *
 * If the latest parameter is a function, this function is used to compute the created value from the input values.
 * Otherwise, an array of the input values is returned.
 *
 * @example <caption>Combine age and name from different sources</caption>
 *
 * let age$ = Observable.of<number>(27, 25, 29);
 * let name$ = Observable.of<string>('Foo', 'Bar', 'Beer');
 * let isDev$ = Observable.of<boolean>(true, true, false);
 *
 * Observable
 *     .zip(age$,
 *          name$,
 *          isDev$,
 *          (age: number, name: string, isDev: boolean) => ({ age, name, isDev }))
 *     .subscribe(x => console.log(x));
 *
 * // outputs
 * // { age: 27, name: 'Foo', isDev: true }
 * // { age: 25, name: 'Bar', isDev: true }
 * // { age: 29, name: 'Beer', isDev: false }
 *
 * @param observables
 * @return {Observable<R>}
 * @static true
 * @name zip
 * @owner Observable
 */ function $e40ae156dafb6025$var$zipStatic() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var project = observables[observables.length - 1];
    if (typeof project === 'function') observables.pop();
    return new $hmT2x.ArrayObservable(observables).lift(new $e40ae156dafb6025$var$ZipOperator(project));
}
module.exports.zipStatic = $e40ae156dafb6025$var$zipStatic;
var $e40ae156dafb6025$var$ZipOperator = function() {
    function ZipOperator(project) {
        this.project = project;
    }
    ZipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $e40ae156dafb6025$var$ZipSubscriber(subscriber, this.project));
    };
    return ZipOperator;
}();
module.exports.ZipOperator = $e40ae156dafb6025$var$ZipOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e40ae156dafb6025$var$ZipSubscriber = function(_super) {
    $e40ae156dafb6025$var$__extends(ZipSubscriber, _super);
    function ZipSubscriber(destination, project, values) {
        if (values === void 0) values = Object.create(null);
        _super.call(this, destination);
        this.iterators = [];
        this.active = 0;
        this.project = typeof project === 'function' ? project : null;
        this.values = values;
    }
    ZipSubscriber.prototype._next = function(value) {
        var iterators = this.iterators;
        if ($cH4eu.isArray(value)) iterators.push(new $e40ae156dafb6025$var$StaticArrayIterator(value));
        else if (typeof value[$cRoko.iterator] === 'function') iterators.push(new $e40ae156dafb6025$var$StaticIterator(value[$cRoko.iterator]()));
        else iterators.push(new $e40ae156dafb6025$var$ZipBufferIterator(this.destination, this, value));
    };
    ZipSubscriber.prototype._complete = function() {
        var iterators = this.iterators;
        var len = iterators.length;
        if (len === 0) {
            this.destination.complete();
            return;
        }
        this.active = len;
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            if (iterator.stillUnsubscribed) this.add(iterator.subscribe(iterator, i));
            else this.active--; // not an observable
        }
    };
    ZipSubscriber.prototype.notifyInactive = function() {
        this.active--;
        if (this.active === 0) this.destination.complete();
    };
    ZipSubscriber.prototype.checkIterators = function() {
        var iterators = this.iterators;
        var len = iterators.length;
        var destination = this.destination;
        // abort if not all of them have values
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) return;
        }
        var shouldComplete = false;
        var args = [];
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            var result = iterator.next();
            // check to see if it's completed now that you've gotten
            // the next value.
            if (iterator.hasCompleted()) shouldComplete = true;
            if (result.done) {
                destination.complete();
                return;
            }
            args.push(result.value);
        }
        if (this.project) this._tryProject(args);
        else destination.next(args);
        if (shouldComplete) destination.complete();
    };
    ZipSubscriber.prototype._tryProject = function(args) {
        var result;
        try {
            result = this.project.apply(this, args);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return ZipSubscriber;
}($fNVRJ.Subscriber);
module.exports.ZipSubscriber = $e40ae156dafb6025$var$ZipSubscriber;
var $e40ae156dafb6025$var$StaticIterator = function() {
    function StaticIterator(iterator) {
        this.iterator = iterator;
        this.nextResult = iterator.next();
    }
    StaticIterator.prototype.hasValue = function() {
        return true;
    };
    StaticIterator.prototype.next = function() {
        var result = this.nextResult;
        this.nextResult = this.iterator.next();
        return result;
    };
    StaticIterator.prototype.hasCompleted = function() {
        var nextResult = this.nextResult;
        return nextResult && nextResult.done;
    };
    return StaticIterator;
}();
var $e40ae156dafb6025$var$StaticArrayIterator = function() {
    function StaticArrayIterator(array) {
        this.array = array;
        this.index = 0;
        this.length = 0;
        this.length = array.length;
    }
    StaticArrayIterator.prototype[$cRoko.iterator] = function() {
        return this;
    };
    StaticArrayIterator.prototype.next = function(value) {
        var i = this.index++;
        var array = this.array;
        return i < this.length ? {
            value: array[i],
            done: false
        } : {
            value: null,
            done: true
        };
    };
    StaticArrayIterator.prototype.hasValue = function() {
        return this.array.length > this.index;
    };
    StaticArrayIterator.prototype.hasCompleted = function() {
        return this.array.length === this.index;
    };
    return StaticArrayIterator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e40ae156dafb6025$var$ZipBufferIterator = function(_super) {
    $e40ae156dafb6025$var$__extends(ZipBufferIterator, _super);
    function ZipBufferIterator(destination, parent, observable) {
        _super.call(this, destination);
        this.parent = parent;
        this.observable = observable;
        this.stillUnsubscribed = true;
        this.buffer = [];
        this.isComplete = false;
    }
    ZipBufferIterator.prototype[$cRoko.iterator] = function() {
        return this;
    };
    // NOTE: there is actually a name collision here with Subscriber.next and Iterator.next
    //    this is legit because `next()` will never be called by a subscription in this case.
    ZipBufferIterator.prototype.next = function() {
        var buffer = this.buffer;
        if (buffer.length === 0 && this.isComplete) return {
            value: null,
            done: true
        };
        else return {
            value: buffer.shift(),
            done: false
        };
    };
    ZipBufferIterator.prototype.hasValue = function() {
        return this.buffer.length > 0;
    };
    ZipBufferIterator.prototype.hasCompleted = function() {
        return this.buffer.length === 0 && this.isComplete;
    };
    ZipBufferIterator.prototype.notifyComplete = function() {
        if (this.buffer.length > 0) {
            this.isComplete = true;
            this.parent.notifyInactive();
        } else this.destination.complete();
    };
    ZipBufferIterator.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.buffer.push(innerValue);
        this.parent.checkIterators();
    };
    ZipBufferIterator.prototype.subscribe = function(value, index) {
        return $863V0.subscribeToResult(this, this.observable, this, index);
    };
    return ZipBufferIterator;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=zip.js.map

});

parcelRegister("fKhWq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6Ec6w = parcelRequire("6Ec6w");

const $3b8812870ac1772d$var$Icon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { label: t1, imgUrl: imgUrl } = t0;
    const label = t1 === undefined ? "" : t1;
    let t2;
    if ($[0] !== imgUrl || $[1] !== label) {
        t2 = imgUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            "data-testid": "macro-custom-icon-img",
            alt: label,
            src: imgUrl,
            width: "100%"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))), {
            spacing: "spacious",
            label: label,
            color: "var(--ds-icon-accent-gray, #7D818A)"
        });
        $[0] = imgUrl;
        $[1] = label;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ label: label = '', imgUrl: imgUrl })=>{
    return imgUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        "data-testid": "macro-custom-icon-img",
        alt: label,
        src: imgUrl,
        width: "100%"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))), {
        spacing: "spacious",
        label: label,
        color: "var(--ds-icon-accent-gray, #7D818A)"
    });
};
var $3b8812870ac1772d$export$2e2bcd8739ae039 = $3b8812870ac1772d$var$Icon;
module.exports["default"] = $3b8812870ac1772d$export$2e2bcd8739ae039;

});

parcelRegister("gxXVf", function(module, exports) {

var $1i7uI = parcelRequire("1i7uI");


var $foRF9 = parcelRequire("foRF9");


var $6OgRG = parcelRequire("6OgRG");

var $6mEZ3 = parcelRequire("6mEZ3");

var $3IXUB = parcelRequire("3IXUB");


var $8pcS0 = parcelRequire("8pcS0");


var $fgbpl = parcelRequire("fgbpl");


var $9Cbhx = parcelRequire("9Cbhx");


var $7W8i8 = parcelRequire("7W8i8");


var $6Ywr0 = parcelRequire("6Ywr0");


var $7bL1M = parcelRequire("7bL1M");


var $bx6Tx = parcelRequire("bx6Tx");

// An empty adf node to fallback to if no selected macro is provided
const $e47b9ace59ffb2ab$var$fallbackADNode = {
    type: 'extension',
    content: (0, $8pcS0.EMPTY_ADF_CONTENT)
};
const $e47b9ace59ffb2ab$export$a40defd79158e045 = {
    showLabels: {
        value: 'true'
    },
    max: {
        value: '15'
    },
    sort: {
        value: null
    },
    showSpace: {
        value: 'true'
    },
    reverse: {
        value: 'false'
    },
    excerptType: {
        value: 'none'
    }
};
function $e47b9ace59ffb2ab$export$4793f1f3f9872794() {
    return (0, $3IXUB.getMacroMetaData)().then((macros)=>macros.filter((item)=>(0, $8pcS0.allowedMacrosForInsertMenu).includes(item.macroName)));
}
function $e47b9ace59ffb2ab$export$ace579897112f22(macroDefinition) {
    return {
        type: 'embedCard',
        attrs: {
            url: macroDefinition.params && macroDefinition.params.url,
            layout: 'wide'
        }
    };
}
const $e47b9ace59ffb2ab$var$fireAnchorAnalyticsEvent = (createAnalyticsEvent, action, contentId, nameStatus)=>{
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: action,
            actionSubject: `${action}Anchor`,
            source: 'extensions-editor',
            attributes: {
                contentId: contentId,
                nameStatus: nameStatus
            }
        }
    }).fire();
};
const $e47b9ace59ffb2ab$var$fireJIMAnalyticsEvent = (contentId, prevNodeType, newNodeType, createAnalyticsEvent)=>{
    const tableToIssueCount = prevNodeType === 'extension' && newNodeType === 'inlineExtension';
    const issueCountToTable = prevNodeType === 'inlineExtension' && newNodeType === 'extension';
    if (tableToIssueCount || issueCountToTable) createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'changedJiraIssueMacroExtensionView',
            source: 'JiraIssueMacro',
            objectId: contentId,
            attributes: {
                tableToIssueCount: tableToIssueCount,
                issueCountToTable: issueCountToTable
            }
        }
    }).fire();
};
const $e47b9ace59ffb2ab$var$fireContentByLabelAnalyticsEvent = (contentId, parameters, createAnalyticsEvent)=>{
    const getUGCFreeParameters = ()=>{
        const { cql: cql, title: title, ...rest } = parameters;
        return {
            ...$e47b9ace59ffb2ab$export$a40defd79158e045,
            ...rest
        };
    };
    if (parameters) createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'closed',
            actionSubject: 'modal',
            actionSubjectId: 'macroBrowser',
            source: 'ContentByLabel',
            objectId: contentId,
            attributes: {
                extensionKey: 'contentbylabel',
                parameters: {
                    ...getUGCFreeParameters()
                }
            }
        }
    }).fire();
};
const $e47b9ace59ffb2ab$var$fireErrorAnalytics = (contentId, actionSubject, createAnalyticsEvent, error, extensionKey)=>{
    createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            action: 'error',
            actionSubject: actionSubject,
            source: 'editor-extensions',
            objectId: contentId,
            attributes: {
                error: error?.message ?? error,
                stack: error?.stack,
                extensionKey: extensionKey
            }
        }
    }).fire();
};
async function $e47b9ace59ffb2ab$export$ff9b124c4a74b7b1(macroDefinition, isEditingMacro, extensionAnalyticsInfo) {
    if (macroDefinition.name === 'anchor') {
        const anchorNameProvidedByUser = macroDefinition.params[''];
        // Strip spaces off the beginning and end of the name
        let anchorNameWithoutSpaces = anchorNameProvidedByUser.replace(/^\s+/g, '');
        anchorNameWithoutSpaces = anchorNameWithoutSpaces.replace(/\s+$/g, '');
        // Changing any remaining spaces to '-' to match header logic
        anchorNameWithoutSpaces = anchorNameWithoutSpaces.replace(/\s+/g, '-');
        // Stripping out any single or double quotes for security (VULN-539679)
        anchorNameWithoutSpaces = anchorNameWithoutSpaces.replace(/["']+/g, '');
        if (extensionAnalyticsInfo && extensionAnalyticsInfo.createAnalyticsEvent) {
            let nameStatus;
            if (anchorNameWithoutSpaces === '') nameStatus = 'missing';
            else {
                anchorNameWithoutSpaces = anchorNameWithoutSpaces.substring(0, (0, $bx6Tx.MAX_ATLASSIAN_ALLOWED_FRAGMENT_LENGTH));
                try {
                    decodeURIComponent(anchorNameWithoutSpaces);
                    nameStatus = 'valid';
                } catch  {
                    nameStatus = 'invalid';
                }
            }
            $e47b9ace59ffb2ab$var$fireAnchorAnalyticsEvent(extensionAnalyticsInfo.createAnalyticsEvent, extensionAnalyticsInfo.action, extensionAnalyticsInfo?.contentId, nameStatus);
        }
        return {
            type: 'inlineExtension',
            attrs: {
                extensionType: 'com.atlassian.confluence.macro.core',
                extensionKey: 'anchor',
                parameters: {
                    macroParams: {
                        '': {
                            value: anchorNameWithoutSpaces
                        }
                    },
                    macroMetadata: {
                        title: 'Anchor'
                    }
                }
            }
        };
    } else if (macroDefinition.name === 'jiraroadmap') {
        /** jiraroadmap is always in confluence/next/packages/editor-features/src/utils/smartCardOptions.ts */ if (!isEditingMacro) return $e47b9ace59ffb2ab$export$ace579897112f22(macroDefinition);
    /*
        in order to render a single issue as a smart link the following conditions must be true or we default to inlineExtension
          - issue must be from a cloud server (params.key is defined and domain must be of a cloud instance)
          - required module from monolith (applinks-bridge-for-spa) must be loaded
          - the browser origin and issue link must be in the same environment (e.g. prod and prod, staging and staging) - only an issue for devs
      */ } else if (macroDefinition.name === 'jira' && !!macroDefinition.params.key) {
        if ((0, $6Ywr0.isRequiredModuleLoaded)('confluence/jim/jira/applinks-bridge-for-spa')) try {
            const ApplinksBridge = (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).require('confluence/jim/jira/applinks-bridge-for-spa');
            const issueUrl = await ApplinksBridge.getUrlForKey(macroDefinition.params.key, macroDefinition.params.serverId);
            if (await ApplinksBridge.isCloudAppLinkFromServerId(macroDefinition.params.serverId) && issueUrl) {
                const isIssueSameEnv = issueUrl.indexOf('atlassian.net') !== -1 === ((0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).location.origin.indexOf('atlassian.net') !== -1);
                // allow smart link insertion from localhost
                if (isIssueSameEnv || false) return {
                    type: 'inlineCard',
                    attrs: {
                        url: issueUrl
                    }
                };
            }
        } catch (e) {}
    }
    return null;
}
function $e47b9ace59ffb2ab$export$e33e56a93f919d6f(macro, config, extensionAnalyticsInfo) {
    const name = macro.macroName;
    // CFE-2344: despite not having a required parameter, the children macro should open the macro browser
    // so that the user can select a parent page. Without this, on a brand new page, the children display
    // macro renders a loading state, then completely disappears and looks broken.
    // CONFDEV-62041: tasks report macro also doesn't have a required parameter, but without any parameters
    // it tries to search the entirety of Confluence for tasks and usually times out, so let's ask for parameters anyway.
    if (macro.anyParameterRequired || name === 'children' || name === 'tasks-report-macro') return $e47b9ace59ffb2ab$export$2fcab9f40bb3cea4(macro, config, undefined, extensionAnalyticsInfo);
    return (0, $foRF9.fetchMacroAttributes)({
        macroDefinition: {
            name: name,
            body: '',
            params: {}
        },
        contentId: config.contentId
    });
}
function $e47b9ace59ffb2ab$export$5f89c55fbaf728a5(selectedMacroDefinition) {
    const { name: name, body: body, params: params, defaultParameterValue: defaultParameterValue, schemaVersion: schemaVersion } = selectedMacroDefinition;
    return {
        name: name || '',
        body: body || '',
        params: params,
        defaultParameterValue: defaultParameterValue || '',
        schemaVersion: schemaVersion
    };
}
async function $e47b9ace59ffb2ab$export$367af34aacb259a2(macroDefinition, contentId, selectedMacro) {
    const newMacroNode = await (0, $foRF9.fetchMacroAttributes)({
        macroDefinition: macroDefinition,
        contentId: contentId,
        selectedMacro: null
    });
    if ((0, $fgbpl.isBodiedExtension)(newMacroNode.type)) {
        // Updating the content of the macro if it was changed with saveMacro
        // If saveMacro does not include the body, macroDefinition.body will
        // be substituted with some function
        if (typeof macroDefinition.body === 'string') {
            let convertedBody;
            try {
                convertedBody = await (0, $6mEZ3.convertBody)('storage', 'atlas_doc_format', macroDefinition.body, contentId) || '';
                newMacroNode.content = JSON.parse(convertedBody).content;
            } catch (error) {
                const logger = (0, $7W8i8.getLogger)('getMacroBrowserSettings.onComplete');
                logger.error`Can't convert provided body from storage format to ADF: ${convertedBody}`;
                // if provided body can't be converted to ADF return the previous content
                if (selectedMacro?.content) newMacroNode.content = selectedMacro?.content;
            }
        } else if (selectedMacro?.content) newMacroNode.content = selectedMacro?.content;
    }
    return newMacroNode;
}
async function $e47b9ace59ffb2ab$export$9477d47ee97b1087(macroBrowser, config, selectedMacro, macroBrowserResolve, macroBrowserReject, extensionAnalyticsInfo, onCompleteCallback, updateMacro, macroId) {
    const blocklistRestore = await (0, $6OgRG.applyBlocklist)(macroBrowser);
    let isInserting;
    let insertUpdatedMacroFailureCount = 0;
    return {
        autoClose: false,
        onComplete: async (rowMacroDefinition)=>{
            isInserting = true;
            macroBrowser.UI.showBrowserSpinner(true);
            const macroDefinition = $e47b9ace59ffb2ab$export$5f89c55fbaf728a5(rowMacroDefinition);
            try {
                let newMacroNode = await $e47b9ace59ffb2ab$export$ff9b124c4a74b7b1(macroDefinition, selectedMacro?.attrs?.extensionKey === 'jiraroadmap', extensionAnalyticsInfo);
                // If no transformation happen process as general macro
                if (!newMacroNode) {
                    newMacroNode = await $e47b9ace59ffb2ab$export$367af34aacb259a2(macroDefinition, config.contentId, selectedMacro);
                    if (selectedMacro?.attrs?.extensionKey === 'jira' && extensionAnalyticsInfo && extensionAnalyticsInfo.createAnalyticsEvent) $e47b9ace59ffb2ab$var$fireJIMAnalyticsEvent(config.contentId, selectedMacro?.type, newMacroNode?.type, extensionAnalyticsInfo?.createAnalyticsEvent);
                    if (macroDefinition?.name === 'contentbylabel' && extensionAnalyticsInfo && extensionAnalyticsInfo.createAnalyticsEvent) $e47b9ace59ffb2ab$var$fireContentByLabelAnalyticsEvent(config.contentId, newMacroNode?.attrs?.parameters?.macroParams, extensionAnalyticsInfo?.createAnalyticsEvent);
                }
                if (macroId && !newMacroNode?.attrs?.parameters?.macroMetadata?.macroId) {
                    newMacroNode.attrs.parameters = newMacroNode?.attrs?.parameters || {};
                    newMacroNode.attrs.parameters.macroMetadata = newMacroNode?.attrs?.parameters?.macroMetadata || {};
                    newMacroNode.attrs.parameters.macroMetadata.macroId = {
                        value: macroId
                    };
                }
                macroBrowserResolve(newMacroNode);
                macroBrowser.close();
                blocklistRestore();
                onCompleteCallback?.({
                    macro: macroDefinition?.name,
                    isBodiedExtension: (0, $fgbpl.isBodiedExtension)(newMacroNode?.type)
                });
            } catch (err) {
                if ((0, $8pcS0.MODERENIZED_MACRO_KEYS).includes(selectedMacro?.attrs?.extensionKey)) $e47b9ace59ffb2ab$var$fireErrorAnalytics(config.contentId, 'onComplete', extensionAnalyticsInfo?.createAnalyticsEvent, err, selectedMacro?.attrs?.extensionKey);
                macroBrowserReject(err);
            }
        },
        onCancel: ()=>{
            blocklistRestore();
            // Macro browser can call cancel on insert, so we need to keep state
            // and only reject when someone isn't trying to insert
            if (!isInserting) macroBrowserReject({
                reason: 'cancel'
            });
        },
        insertUpdatedMacro: async (rowMacroDefinition)=>{
            const macroDefinition = $e47b9ace59ffb2ab$export$5f89c55fbaf728a5(rowMacroDefinition);
            try {
                const newMacroNode = await $e47b9ace59ffb2ab$export$367af34aacb259a2(macroDefinition, config.contentId, selectedMacro);
                updateMacro?.(newMacroNode);
                insertUpdatedMacroFailureCount = 0;
            } catch (error) {
                insertUpdatedMacroFailureCount++;
                if (insertUpdatedMacroFailureCount > 5) {
                    insertUpdatedMacroFailureCount = 0;
                    $e47b9ace59ffb2ab$var$fireErrorAnalytics(config.contentId, 'insertUpdatedMacro', extensionAnalyticsInfo?.createAnalyticsEvent, error, selectedMacro?.attrs?.extensionKey);
                }
            }
        }
    };
}
function $e47b9ace59ffb2ab$export$bb0b49ebec872281(selectedMacro, config, macroFilter, extensionAnalyticsInfo, updateMacro, intl) {
    return new Promise(async (resolve, reject)=>{
        const selectedMacroFormattedAsLegacyMacro = await (0, $6mEZ3.formatAsLegacyMacroWithOverrides)(selectedMacro || $e47b9ace59ffb2ab$var$fallbackADNode, intl);
        const macroBrowser = await (0, $7bL1M.loadMacroBrowserResources)();
        // filter based on dynamic data such as feature flags
        if (macroFilter) macroBrowser.metadataList = macroBrowser.metadataList.filter(macroFilter);
        if (extensionAnalyticsInfo) extensionAnalyticsInfo.action = 'update';
        const macroBrowserSettings = await $e47b9ace59ffb2ab$export$9477d47ee97b1087(macroBrowser, config, selectedMacro, resolve, reject, extensionAnalyticsInfo, undefined, updateMacro, null);
        try {
            macroBrowser.open({
                ...macroBrowserSettings,
                selectedMacro: {
                    ...selectedMacroFormattedAsLegacyMacro,
                    productContext: {
                        // product context is used by connect macros, when they call /wiki/plugins/servlet/ac/{app-key}/{macro-key}
                        // this endpoint enriches the response's structuredContext field, which is used by AP.context.getContext
                        // ideally would be good to check that this is a connect macro, however, it seems
                        // that there's no information available to check that
                        'content.id': config.contentId,
                        'macro.id': selectedMacro?.attrs?.parameters?.macroMetadata?.macroId?.value,
                        'enrich-content-context-parameters': true
                    }
                }
            });
        } catch (err) {
            $e47b9ace59ffb2ab$var$fireErrorAnalytics(config.contentId, 'openMacroBrowserToEditExistingMacro', extensionAnalyticsInfo?.createAnalyticsEvent, err, selectedMacro?.attrs?.extensionKey);
            reject(err);
        }
    });
}
function $e47b9ace59ffb2ab$export$2fcab9f40bb3cea4(selectedMacro, config, macroFilter, extensionAnalyticsInfo, onCompleteCallback, updateMacro) {
    return new Promise(async (resolve, reject)=>{
        // Generate macroId on insertion for macros since if they don't have one so BE will continuously regenrate since
        // it's not in FE ADF. This is a problem for 3P macros where vendors rely on a stable macroId to fetch their macros.
        const macroId = (0, $9Cbhx.getMacroId)(null);
        const macroBrowser = await (0, $7bL1M.loadMacroBrowserResources)();
        // filter based on dynamic data such as feature flags
        if (macroFilter) macroBrowser.metadataList = macroBrowser.metadataList.filter(macroFilter);
        if (extensionAnalyticsInfo) extensionAnalyticsInfo.action = 'insert';
        const macroBrowserSettings = await $e47b9ace59ffb2ab$export$9477d47ee97b1087(macroBrowser, config, selectedMacro, resolve, reject, extensionAnalyticsInfo, onCompleteCallback, updateMacro, macroId);
        macroBrowser.open({
            ...macroBrowserSettings,
            presetMacroMetadata: {
                ...selectedMacro,
                productContext: {
                    'macro.id': macroId,
                    'content.id': config.contentId,
                    'enrich-content-context-parameters': true
                }
            }
        });
    });
}
module.exports["openMacroBrowserForInitialConfiguration"] = $e47b9ace59ffb2ab$export$2fcab9f40bb3cea4;
module.exports["openMacroBrowserToEditExistingMacro"] = $e47b9ace59ffb2ab$export$bb0b49ebec872281;

});

parcelRegister("7bL1M", function(module, exports) {

var $1i7uI = parcelRequire("1i7uI");


var $dmKyV = parcelRequire("dmKyV");

const $eb991ea0881203b1$export$1a7a5965be14ecdf = ()=>[
        'wr!com.atlassian.confluence.plugins.confluence-create-content-plugin:editor-resources',
        'wr!com.atlassian.confluence.plugins.confluence-create-content-plugin:create-from-template-macro-browser-resources',
        'wr!com.atlassian.confluence.plugins.confluence-create-content-plugin:create-from-template-resources'
    ];

function $eb991ea0881203b1$export$db2ef8ac15563eb4() {
    return new Promise((resolve)=>{
        const resources = [
            // plugins contributing to macro browser will be loaded through this context.
            // `fabric-editor-macro-browser` context is found in core in case we want to add resources of other macro in future.
            'wrc!fabric-editor-macro-browser',
            // The inline task report plugin implements its own (legacy) way of loading JS overrides, hence we have to require
            // these overrides here.
            'wr!com.atlassian.confluence.plugins.confluence-inline-tasks:inline-tasks-macro-browser',
            // Jira gadgets
            'wr!com.atlassian.confluence.plugins.gadgets:macro-browser-for-gadgetsplugin',
            // these resources are necessary for create-from-template-macro to initialize and populate the template dropdown
            // copy from packages/confluence-editor/src/editor-plugins/create-from-template-macro/plugin.js
            // tinymce also did similar macro loading via packages/confluence-editor/src/editor-plugins/index.js
            ...$eb991ea0881203b1$export$1a7a5965be14ecdf()
        ];
        (0, $dmKyV.WRM).require(resources, ()=>{
            const macroBrowser = (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).require('confluence-macro-browser/macro-browser');
            (parcelRequire("5jyh2")).then((macroBrowserOverridesModule)=>{
                macroBrowserOverridesModule.default();
            }).then(()=>{
                /**
         * this is required for atlassian connect plugin to work correctly
         * e.g open custom dialog for DrawIO, Gliffy macro
         * check this repo for more info:
         * https://stash.atlassian.com/projects/AC/repos/atlassian-connect/browse
         */ // @ts-ignore TODO FIXME we really don't need typings for "window-or-global", we need to get rid of it instead
                (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).AJS.trigger('reset.rte');
                resolve(macroBrowser);
            });
        });
    });
}
module.exports["loadMacroBrowserResources"] = $eb991ea0881203b1$export$db2ef8ac15563eb4;

});

parcelRegister("5jyh2", function(module, exports) {

let $3de950299f817d56$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3de950299f817d56$var$load("2wLue").then(()=>parcelRequire('74DtK'));

});

parcelRegister("7okiz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hRnS5 = parcelRequire("hRnS5");


var $fUN4A = parcelRequire("fUN4A");


var $6O2BV = parcelRequire("6O2BV");


var $hFueH = parcelRequire("hFueH");





var $jmjWc = parcelRequire("jmjWc");

const $a3bfb2f361b9631e$export$e34f51b2cfaca368 = ()=>null;



const $93c4a623cfe89294$export$8b14718323f670aa = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "QOMzx",
    name: "RedactedPlaceholderExtensionHandler",
    loader: async ()=>{
        const { RedactedPlaceholder: RedactedPlaceholder } = await (parcelRequire("7wsf1"));
        return RedactedPlaceholder;
    },
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a3bfb2f361b9631e$export$e34f51b2cfaca368), null)
});



var $ge2sX = parcelRequire("ge2sX");


var $aJPUt = parcelRequire("aJPUt");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $bX5uj = parcelRequire("bX5uj");


var $5a4cC = parcelRequire("5a4cC");


var $9m03g = parcelRequire("9m03g");


var $n9ft3 = parcelRequire("n9ft3");


var $fxgwG = parcelRequire("fxgwG");


var $dgMPt = parcelRequire("dgMPt");


var $4EIU1 = parcelRequire("4EIU1");


var $bBRJy = parcelRequire("bBRJy");


var $kRkqT = parcelRequire("kRkqT");


var $56y8A = parcelRequire("56y8A");


var $1UHWj = parcelRequire("1UHWj");


var $aG1nm = parcelRequire("aG1nm");


var $9K8Oh = parcelRequire("9K8Oh");


var $2n2cE = parcelRequire("2n2cE");


var $l8XTa = parcelRequire("l8XTa");


var $18Eyu = parcelRequire("18Eyu");


var $jaHkh = parcelRequire("jaHkh");


var $bJaqz = parcelRequire("bJaqz");


var $CbxlN = parcelRequire("CbxlN");





var $j4RIK = parcelRequire("j4RIK");


var $2oP7l = parcelRequire("2oP7l");

const $dc3e4a0baa98f95b$export$a0da2dedb89544c8 = ({ Renderer: Renderer, appearance: appearance, macroParams: macroParams, ...macroDefaultProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2oP7l.NestedAdfRendererWrapperProvider), {
        Renderer: Renderer,
        appearance: appearance
    }, (RendererWrapper)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j4RIK.PageTreeMacroHandler), {
            macroDefaultProps: macroDefaultProps,
            macroParams: macroParams,
            RendererWrapper: RendererWrapper
        }));



var $hU8XU = parcelRequire("hU8XU");


var $fuLIO = parcelRequire("fuLIO");


var $7NX4e = parcelRequire("7NX4e");


var $bQCqI = parcelRequire("bQCqI");


var $8pcS0 = parcelRequire("8pcS0");


var $eS4Za = parcelRequire("eS4Za");


var $2E7zk = parcelRequire("2E7zk");


var $hMRhJ = parcelRequire("hMRhJ");


var $afWPV = parcelRequire("afWPV");


var $fQztD = parcelRequire("fQztD");


var $hCfPO = parcelRequire("hCfPO");


var $9e5dj = parcelRequire("9e5dj");


var $lE7FD = parcelRequire("lE7FD");


var $Qcu7n = parcelRequire("Qcu7n");


var $e1Stz = parcelRequire("e1Stz");


var $6mKj3 = parcelRequire("6mKj3");


var $ceVeI = parcelRequire("ceVeI");


var $e8Lxy = parcelRequire("e8Lxy");


var $kuTjv = parcelRequire("kuTjv");


var $fBjVq = parcelRequire("fBjVq");


var $69aHU = parcelRequire("69aHU");





var $lzgC6 = parcelRequire("lzgC6");


var $78QFu = parcelRequire("78QFu");




const $4f09d12458901289$export$9eec8c53e410de67 = (0, $lzgC6.default)()(class extends (0, $cozmU.Component) {
    async componentDidMount() {
        const { createAnalyticsEvent: createAnalyticsEvent, extensionKey: extensionKey, attributes: attributes, node: node } = this.props;
        if (createAnalyticsEvent) {
            const jiraHostingOption = await (0, $2E7zk.getJiraHostingOption)(extensionKey, node?.parameters?.macroParams?.serverId?.value, true);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'viewed',
                    actionSubject: 'macro',
                    actionSubjectId: extensionKey,
                    source: 'viewPageScreen',
                    attributes: {
                        ...attributes,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)(),
                        jiraHostingOption: jiraHostingOption
                    }
                }
            }).fire();
        }
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
    }
});


parcelRequire("2oer2");
var $cbr0D = parcelRequire("cbr0D");








var $cYJC5 = parcelRequire("cYJC5");

const $f19eca96759725e5$export$30c773822372f598 = ({ hasADF: hasADF, macroDefaultProps: macroDefaultProps, cloudId: cloudId, userId: userId, isPreviewMode: isPreviewMode, shouldLoadAfterPaint: shouldLoadAfterPaint })=>{
    if (!hasADF) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fuLIO.LegacyMacroRendererQuery), macroDefaultProps);
    return shouldLoadAfterPaint || isPreviewMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cYJC5.LazyCreateFromTemplateLoader), {
        userId: userId,
        cloudId: cloudId,
        macroDefaultProps: macroDefaultProps,
        isPreviewMode: isPreviewMode
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cYJC5.CreateFromTemplateLoader), {
        userId: userId,
        cloudId: cloudId,
        macroDefaultProps: macroDefaultProps,
        isPreviewMode: isPreviewMode
    });
};









var $6mEZ3 = parcelRequire("6mEZ3");


var $l7BGZ = parcelRequire("l7BGZ");

const $1fa3854e066af442$export$e8ac5007ab7a695a = ({ hasADF: hasADF, macroDefaultProps: macroDefaultProps, shouldLoadAfterPaint: shouldLoadAfterPaint })=>{
    // Fallback to LegacyMacroRenderer when adf string is not defined
    if (!hasADF) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fuLIO.LegacyMacroRendererQuery), macroDefaultProps);
    const { node: node } = macroDefaultProps;
    const macroNode = (0, $6mEZ3.extensionToADF)(node);
    return shouldLoadAfterPaint ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l7BGZ.LazyLiveSearchLoader), {
        macroNode: macroNode
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l7BGZ.LiveSearchLoader), {
        macroNode: macroNode
    });
};









var $dwS6P = parcelRequire("dwS6P");

const $ab0c2ef401baeb08$export$cf1c26fcb7e6ff9f = ({ adf: adf, macroDefaultProps: macroDefaultProps, cloudId: cloudId, userId: userId, shouldLoadAfterPaint: shouldLoadAfterPaint })=>{
    if (!adf) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fuLIO.LegacyMacroRendererQuery), macroDefaultProps);
    return shouldLoadAfterPaint ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dwS6P.LazyTableOfContentsLoader), {
        userId: userId,
        cloudId: cloudId,
        adf: adf,
        macroDefaultProps: macroDefaultProps
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dwS6P.TableOfContentsLoader), {
        userId: userId,
        cloudId: cloudId,
        adf: adf,
        macroDefaultProps: macroDefaultProps
    });
};



var $dOBRD = parcelRequire("dOBRD");



/* eslint-disable @atlaskit/editor/no-re-export */ 
var $3CKU8 = parcelRequire("3CKU8");



const $3bd71c84d7d120d2$var$memoAdfParsed = (0, $dOBRD.default)((adf)=>{
    let result = adf;
    if (typeof adf === 'string') try {
        result = JSON.parse(adf);
    } catch (e) {
        result = {
            version: 1,
            type: 'doc',
            content: []
        };
    }
    return result;
});
const $3bd71c84d7d120d2$export$c25b654b62d7c7b4 = ({ adf: adf, extensionParams: extensionParams, referentialityDataSourceProvider: referentialityDataSourceProvider, children: children })=>{
    const adfParsed = $3bd71c84d7d120d2$var$memoAdfParsed(adf);
    const { references: references } = (0, $3CKU8.useReference)({
        adf: adfParsed,
        extensionParams: extensionParams,
        dataSourceProvider: referentialityDataSourceProvider
    });
    return children({
        references: references
    });
};


var $27d039b331e27185$var$Styles = /*#__PURE__*/ function(Styles) {
    Styles["None"] = "none";
    Styles["Mixed"] = "mixed";
    Styles["Bullet"] = "bullet";
    Styles["Circle"] = "circle";
    Styles["Square"] = "square";
    Styles["Number"] = "number";
    return Styles;
}($27d039b331e27185$var$Styles || {});
var $27d039b331e27185$var$Separators = /*#__PURE__*/ function(Separators) {
    Separators["Brackets"] = "brackets";
    Separators["Braces"] = "braces";
    Separators["Pipe"] = "pipe";
    return Separators;
}($27d039b331e27185$var$Separators || {});
const $27d039b331e27185$export$b7595b0733376572 = (macroName, trackingData, createAnalyticsEvent, contentId)=>{
    const { minLevel: minLevel, maxLevel: maxLevel, outline: outline, type: type, printable: printable, style: style, separator: separator, include: include, exclude: exclude, indent: indent } = trackingData;
    const sensitiveData = {
        include: include?.value.length > 0 || false,
        exclude: exclude?.value.length > 0 || false,
        class: trackingData.class?.value.length > 0 || false,
        indent: indent?.value.length > 0 || false
    };
    // in the unlikely event these dropdown fields become custom input text, ensure no PII is logged
    const separatorValue = Object.values($27d039b331e27185$var$Separators).includes(separator?.value) ? separator?.value : 'invalid';
    const styleValue = Object.values($27d039b331e27185$var$Styles).includes(style?.value) ? style?.value : 'invalid';
    const potentiallySensitiveData = {};
    if (type) {
        if (type.value === 'flat') potentiallySensitiveData['separator'] = separatorValue;
        else if (type.value === 'list') potentiallySensitiveData['style'] = styleValue;
    } else potentiallySensitiveData['style'] = 'mixed';
    const nonSensitiveData = {
        minLevel: parseInt(minLevel?.value) || 1,
        maxLevel: parseInt(maxLevel?.value) || 6,
        outline: outline?.value === 'true' || false,
        printable: printable?.value === 'false' || true,
        type: type?.value === 'flat' ? 'flat' : 'list'
    };
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'viewed',
            actionSubject: 'macro',
            actionSubjectId: macroName,
            source: 'on page view',
            attributes: {
                pageID: contentId,
                ...sensitiveData,
                ...potentiallySensitiveData,
                ...nonSensitiveData
            },
            eventType: 'track'
        }
    }).fire();
};


const $53f1c3cb11bcb25b$export$fe33197d44e10fcf = ({ adf: adf, contentId: contentId, appearance: appearance, showTemplateVariablesInPreview: showTemplateVariablesInPreview, showTemplateInputInPreview: showTemplateInputInPreview, spaceKey: spaceKey, shouldIncludeMacroHandlers: shouldIncludeMacroHandlers = true, macroRenderedOutput: macroRenderedOutput, shouldIncludeMacroWithReferencesHandlers: shouldIncludeMacroWithReferencesHandlers = false, referentialityDataSourceProvider: referentialityDataSourceProvider, fromFabricEditor: fromFabricEditor = false, isPreviewMode: isPreviewMode = false, contentType: contentType, mediaToken: mediaToken, annotationProvider: annotationProvider, isInEditorRendererView: isInEditorRendererView }, createAnalyticsEvent)=>{
    const getMacroExtensionHandler = $53f1c3cb11bcb25b$export$d1ab742fa63c927c;
    const getTemplateHandler = showTemplateInputInPreview ? (0, $cbr0D.getTemplateVariableInputExtensionHandler) : (0, $cbr0D.getTemplateExtensionHandler);
    const templateHandler = showTemplateVariablesInPreview ? {
        [(0, $8pcS0.EXTENSION_TYPE).TEMPLATE]: getTemplateHandler
    } : {};
    const macroWithReferences = shouldIncludeMacroWithReferencesHandlers ? {
        [(0, $8pcS0.EXTENSION_TYPE).MACRO_WITH_REFERENCES]: $53f1c3cb11bcb25b$export$97164d5210648f5e({
            adf: adf,
            referentialityDataSourceProvider: referentialityDataSourceProvider
        })
    } : {};
    return shouldIncludeMacroHandlers ? {
        [(0, $8pcS0.EXTENSION_TYPE).MACRO_CORE]: getMacroExtensionHandler({
            adf: adf,
            appearance: appearance,
            contentId: contentId,
            showTemplateVariablesInPreview: showTemplateVariablesInPreview,
            showTemplateInputInPreview: showTemplateInputInPreview,
            spaceKey: spaceKey,
            macroRenderedOutput: macroRenderedOutput,
            referentialityDataSourceProvider: referentialityDataSourceProvider,
            fromFabricEditor: fromFabricEditor,
            isPreviewMode: isPreviewMode,
            contentType: contentType,
            mediaToken: mediaToken,
            annotationProvider: annotationProvider,
            isInEditorRendererView: isInEditorRendererView
        }, createAnalyticsEvent),
        [(0, $8pcS0.EXTENSION_TYPE).MIGRATION]: (0, $bQCqI.getMigrationExtHandlerForRenderer)({
            contentId: contentId,
            contextProviders: {
                ClassicEditorContextProvider: (0, $fUN4A.ClassicEditorContextProviderLazyLoader)
            }
        }),
        ...macroWithReferences,
        ...templateHandler
    } : {};
};
const $53f1c3cb11bcb25b$var$providers = {
    getExtensionHandlers: $53f1c3cb11bcb25b$export$fe33197d44e10fcf,
    populateExtensionProviders: $69aHU.populateExtensionProviders,
    EditorLoaderLoader: // CONFCLOUD-72035 - Make sure we are ALWAYS including the EditorLoaderLoader when loading
    //                   legacy macros or else the attachments macro WILL NOT WORK
    $hFueH.default
};
const $53f1c3cb11bcb25b$export$164cd9171430f0a5 = (isMacroSSRD, macroDefaultProps)=>{
    // if SSR Macros FF is disabled, page is not SSRd, or there are no macros on the page, do nothing
    if (!window.__SSR_RENDERED__ || !window?.__SSR_MACROS_INFO__) return;
    const { extensionKey: extensionKey } = macroDefaultProps;
    if (isMacroSSRD) {
        window.__SSR_MACROS_INFO__.successes[extensionKey] = (window.__SSR_MACROS_INFO__.successes[extensionKey] ?? 0) + 1;
        window.__SSR_MACROS_INFO__.successCount += 1;
    } else {
        window.__SSR_MACROS_INFO__.failures[extensionKey] = (window.__SSR_MACROS_INFO__.failures[extensionKey] ?? 0) + 1;
        window.__SSR_MACROS_INFO__.failureCount += 1;
    }
};
const $53f1c3cb11bcb25b$export$adb86c58ecb79d9c = (macroDefaultProps)=>{
    const { attributes: { macroId: macroId } } = macroDefaultProps;
    return Boolean(window?.__LEGACY_MACRO_RENDERED_OUTPUT__?.find((el)=>el.key === macroId));
};
const $53f1c3cb11bcb25b$export$97164d5210648f5e = ({ adf: adf, referentialityDataSourceProvider: referentialityDataSourceProvider })=>{
    const extensionHandlerWithReferences = (extension, extensionHandler)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3bd71c84d7d120d2$export$c25b654b62d7c7b4), {
            adf: adf,
            extensionParams: extension,
            referentialityDataSourceProvider: referentialityDataSourceProvider
        }, extensionHandler);
    };
    return extensionHandlerWithReferences;
};
const $53f1c3cb11bcb25b$export$d1ab742fa63c927c = ({ adf: adf, contentId: contentId, appearance: appearance, showTemplateVariablesInPreview: showTemplateVariablesInPreview, showTemplateInputInPreview: showTemplateInputInPreview, spaceKey: spaceKey, macroRenderedOutput: macroRenderedOutput, referentialityDataSourceProvider: referentialityDataSourceProvider, fromFabricEditor: fromFabricEditor, isPreviewMode: isPreviewMode, contentType: contentType, mediaToken: mediaToken, annotationProvider: annotationProvider, isInEditorRendererView: isInEditorRendererView }, createAnalyticsEvent)=>{
    const handler = (0, $eS4Za.createMacroExtensionHandler)((extension, doc)=>{
        let { extensionKey: extensionKey } = extension;
        const resolvedExtensionKey = (0, $Qcu7n.resolveQuestionsMacroExtensionKey)(extensionKey);
        if (resolvedExtensionKey !== extensionKey) {
            extensionKey = resolvedExtensionKey;
            extension = {
                ...extension,
                extensionKey: resolvedExtensionKey
            };
        }
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extension);
        const macroParams = extension?.parameters?.macroParams;
        const multiBodiedExtensionActions = doc?.[0]?.actions;
        const isBodiedMacro = extension?.type === 'bodiedExtension';
        const shouldUseDebouncedLegacyMacroRenderer = isBodiedMacro && isInEditorRendererView;
        // When isInEditorRendererView is true, we are rendering the macro in the editor renderer view.
        // In this scenario adf isn't passed to the macro extension handler as prop because we do not have access to
        // the adf from where we are using the macro extension handler. We can instead get the adf from the doc object provided to the handler.
        adf = isInEditorRendererView && !adf && !!doc ? doc?.[0] : adf;
        const attributesForAnalytics = {
            extensionType: extension?.type,
            ...extensionKey === 'excerpt-include' ? {
                isExcerptNamePresent: !!macroParams?.name
            } : undefined,
            ...extensionKey === 'gadget' && macroParams?.url?.value && typeof location !== 'undefined' && {
                gadgetUrl: new URL(macroParams.url.value, location.origin).pathname
            }
        };
        const redactedAttributes = extensionKey === 'redactedMacroPlaceholder' ? {
            extensionKey: macroParams?.redactedMacroPluginKey?.value || macroParams?.redactedMacroExtensionKey?.value
        } : undefined;
        const isMissingMacroParameters = macroParams?.isMissingRequiredParameters?.value;
        const contentHandler = (macroDefaultProps, cloudId, userId)=>{
            const excerptMacroProps = {
                ...macroDefaultProps,
                appearance: appearance
            };
            const macroOutput = extension?.parameters?.macroOutput;
            if (extensionKey === 'toc' && macroParams && createAnalyticsEvent) (0, $27d039b331e27185$export$b7595b0733376572)(extensionKey, macroParams, createAnalyticsEvent, contentId);
            const legacyMacroRenderer = ()=>{
                const isMacroSSRD = window.__SSR_RENDERED__ && $53f1c3cb11bcb25b$export$adb86c58ecb79d9c(macroDefaultProps) && !isMissingMacroParameters;
                $53f1c3cb11bcb25b$export$164cd9171430f0a5(isMacroSSRD, macroDefaultProps);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMRhJ.RendererExtensionContext).Provider, {
                    value: $53f1c3cb11bcb25b$var$providers
                }, shouldUseDebouncedLegacyMacroRenderer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fuLIO.DebouncedLegacyMacroRendererQuery), {
                    ...macroDefaultProps,
                    isTemplateEditorRenderer: showTemplateVariablesInPreview,
                    macroRenderedOutputFromSSR: isMacroSSRD && macroRenderedOutput,
                    macroOutput: macroOutput,
                    isPreviewMode: isPreviewMode,
                    isInEditorRendererView: isInEditorRendererView
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fuLIO.LegacyMacroRendererQuery), {
                    ...macroDefaultProps,
                    isTemplateEditorRenderer: showTemplateVariablesInPreview,
                    macroRenderedOutputFromSSR: isMacroSSRD && macroRenderedOutput,
                    macroOutput: macroOutput,
                    isPreviewMode: isPreviewMode
                }));
            };
            switch(extensionKey){
                case 'redactedMacroPlaceholder':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $93c4a623cfe89294$export$8b14718323f670aa), {
                        ...macroDefaultProps,
                        redactedAttributes: redactedAttributes
                    });
                case 'details':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e5dj.DetailsExtensionHandler), {
                        ...macroDefaultProps,
                        spaceKey: spaceKey,
                        Renderer: (0, $fBjVq.default),
                        isLegacyRenderer: true,
                        annotationProvider: annotationProvider
                    });
                case 'excerpt':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hCfPO.ExcerptExtensionHandler), {
                        ...excerptMacroProps,
                        spaceKey: spaceKey,
                        Renderer: (0, $fBjVq.default),
                        isLegacyRenderer: true,
                        mediaToken: mediaToken,
                        annotationProvider: annotationProvider
                    });
                case 'expand':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fQztD.ExpandExtensionHandler), {
                        ...macroDefaultProps,
                        Renderer: (0, $fBjVq.default),
                        annotationProvider: annotationProvider,
                        isLegacyRenderer: true
                    });
                case 'create-from-template':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f19eca96759725e5$export$30c773822372f598), {
                        hasADF: !!adf,
                        macroDefaultProps: macroDefaultProps,
                        cloudId: cloudId,
                        userId: userId,
                        isPreviewMode: isPreviewMode,
                        shouldLoadAfterPaint: fromFabricEditor
                    });
                case 'toc':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ab0c2ef401baeb08$export$cf1c26fcb7e6ff9f), {
                        adf: adf,
                        macroDefaultProps: macroDefaultProps,
                        cloudId: cloudId,
                        userId: userId,
                        shouldLoadAfterPaint: fromFabricEditor
                    });
                case 'calendar':
                    if ((0, $6mKj3.expValEquals)('cc-engagement-team-calendar-macro-afm-migration', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kuTjv.TeamCalendarMacroLoader), {
                        extensionNode: extension,
                        macroDefaultProps: macroDefaultProps
                    });
                    return legacyMacroRenderer();
                case 'livesearch':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1fa3854e066af442$export$e8ac5007ab7a695a), {
                        hasADF: !!adf,
                        macroDefaultProps: macroDefaultProps,
                        shouldLoadAfterPaint: fromFabricEditor
                    });
                case 'anchor':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $afWPV.AnchorExtensionHandler), {
                        ...macroDefaultProps,
                        isSSR: false
                    });
                case 'excerpt-include':
                    if (contentId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7NX4e.ExcerptIncludeExtensionHandler), {
                        ...macroDefaultProps,
                        Renderer: (0, $e8Lxy.PageContentRenderer)
                    }));
                case 'detailssummary':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), {
                        isWithinEditor: false
                    }, (0, $ceVeI.isMigratedMacroImplEnabled)('detailssummary') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lE7FD.DetailsSummaryExtensionHandler), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: macroParams,
                        Renderer: (0, $fBjVq.default),
                        isLegacyRenderer: true
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e1Stz.PagePropertiesReportRenderer), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: macroParams,
                        Renderer: (0, $fBjVq.default),
                        isLegacyRenderer: true
                    }));
                case 'blog-posts':
                    if ((0, $ceVeI.isMigratedMacroImplEnabled)('blog-posts')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8XTa.BlogPostsExtensionHandler), {
                        ...macroDefaultProps,
                        macroParams: extension?.parameters?.macroParams,
                        Renderer: (0, $e8Lxy.PageContentRenderer),
                        appearance: appearance
                    }));
                    return legacyMacroRenderer();
                case 'recently-updated':
                    if ((0, $ceVeI.isMigratedMacroImplEnabled)('recently-updated')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $n9ft3.RecentlyUpdatedMacroHandler), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: extension?.parameters?.macroParams
                    });
                    return legacyMacroRenderer();
                case 'profile-picture':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9m03g.ProfilePictureMacroHandler), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: extension?.parameters?.macroParams
                    });
                case 'profile':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5a4cC.UserProfileMacroHandler), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: extension?.parameters?.macroParams
                    });
                case 'include':
                    if ((0, $ceVeI.isMigratedMacroImplEnabled)('include')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $18Eyu.PageIncludeExtensionHandler), {
                        ...macroDefaultProps,
                        macroParams: extension?.parameters?.macroParams,
                        Renderer: (0, $e8Lxy.PageContentRenderer),
                        appearance: appearance
                    }));
                    return legacyMacroRenderer();
                case 'popular-labels':
                    return (0, $ceVeI.isMigratedMacroImplEnabled)('popular-labels') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bBRJy.PopularLabelsMacroHandler), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: {
                            ...extension?.parameters?.macroParams,
                            currentSpaceKey: spaceKey
                        }
                    }) : legacyMacroRenderer();
                case 'listlabels':
                    return (0, $ceVeI.isMigratedMacroImplEnabled)('listlabels') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kRkqT.ListLabelsMacroHandler), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: {
                            ...extension?.parameters?.macroParams,
                            currentSpaceKey: spaceKey
                        }
                    }) : legacyMacroRenderer();
                case 'contributors':
                    return (0, $ceVeI.isMigratedMacroImplEnabled)('contributors') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4EIU1.ContributorsMacroHandler), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: extension?.parameters?.macroParams
                    }) : legacyMacroRenderer();
                case 'viewpdf':
                    return (0, $ceVeI.isMigratedMacroImplEnabled)('viewpdf') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $56y8A.ViewPdfMacroHandler), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: extension?.parameters?.macroParams
                    }) : legacyMacroRenderer();
                case 'viewxls':
                    return (0, $ceVeI.isMigratedMacroImplEnabled)('viewxls') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1UHWj.ViewXlsMacroHandler), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: extension?.parameters?.macroParams
                    }) : legacyMacroRenderer();
                case 'widget':
                    return (0, $ceVeI.isMigratedMacroImplEnabled)('widget') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aG1nm.WidgetMacroHandler), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: extension?.parameters?.macroParams
                    }) : legacyMacroRenderer();
                case 'iframe':
                    return (0, $ceVeI.isMigratedMacroImplEnabled)('iframe') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9K8Oh.IFrameMacroRenderer), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: extension?.parameters?.macroParams
                    }) : legacyMacroRenderer();
                case 'contentbylabel':
                    return (0, $ceVeI.isMigratedMacroImplEnabled)('contentbylabel') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2n2cE.ContentByLabelExtensionHandler), {
                        ...macroDefaultProps,
                        macroParams: extension?.parameters?.macroParams,
                        Renderer: (0, $e8Lxy.PageContentRenderer),
                        appearance: appearance
                    })) : legacyMacroRenderer();
                case 'tasks-report-macro':
                    return (0, $ceVeI.isMigratedMacroImplEnabled)('tasks-report-macro') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fxgwG.TasksReportMacroHandler), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: extension?.parameters?.macroParams
                    }) : legacyMacroRenderer();
                case 'pagetree':
                    return (0, $ceVeI.isMigratedMacroImplEnabled)('pagetree') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dc3e4a0baa98f95b$export$a0da2dedb89544c8), {
                        ...macroDefaultProps,
                        macroParams: extension?.parameters?.macroParams,
                        Renderer: (0, $e8Lxy.PageContentRenderer),
                        appearance: appearance
                    })) : legacyMacroRenderer();
                case 'pagetreesearch':
                    return (0, $ceVeI.isMigratedMacroImplEnabled)('pagetreesearch') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hU8XU.PageTreeSearchMacroHandler), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: extension?.parameters?.macroParams
                    }) : legacyMacroRenderer();
                case 'content-report-table':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jaHkh.ContentReportTableMacroHandler), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: {
                            ...extension?.parameters?.macroParams,
                            currentSpaceKey: spaceKey
                        }
                    });
                case 'attachments':
                    return (0, $ceVeI.isMigratedMacroImplEnabled)('attachments') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bJaqz.AttachmentsMacroHandler), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: extension?.parameters?.macroParams
                    }) : legacyMacroRenderer();
                case 'change-history':
                    return (0, $ceVeI.isMigratedMacroImplEnabled)('change-history') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $CbxlN.ChangeHistoryMacroHandler), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: extension?.parameters?.macroParams
                    }) : legacyMacroRenderer();
                case 'questionslist-macro':
                    return legacyMacroRenderer();
                case 'questionslist-macro-native':
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dgMPt.GlobalQuestionsListMacroHandler), {
                        macroDefaultProps: macroDefaultProps,
                        macroParams: extension?.parameters?.macroParams
                    });
                case 'hide':
                    if ((0, $6mKj3.expVal)('platform_editor_hide_extension_renderer_support', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                        "data-extension-key": "hide"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
                        name: (0, $5kjCz.getExperienceName)((0, $5kjCz.RENDERER), extension),
                        extensionKey: extensionKey,
                        mode: (0, $5kjCz.RENDERER),
                        attributes: attributes,
                        contentId: contentId
                    }));
                    return legacyMacroRenderer();
                // generic macro renderer
                default:
                    return legacyMacroRenderer();
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3bd71c84d7d120d2$export$c25b654b62d7c7b4), {
            adf: adf,
            extensionParams: extension,
            referentialityDataSourceProvider: referentialityDataSourceProvider
        }, ({ references: references })=>{
            const macroDefaultProps = {
                node: extension,
                references: references,
                contentId: contentId,
                contentType: contentType,
                showTemplateVariablesInPreview: showTemplateVariablesInPreview || false,
                showTemplateInputInPreview: showTemplateInputInPreview || false,
                spaceKey: spaceKey || '',
                mode: (0, $5kjCz.RENDERER),
                extensionKey: extensionKey,
                attributes: attributes,
                multiBodiedExtensionActions: multiBodiedExtensionActions,
                isConnectMacro: Boolean(doc?.[0]?.isConnectMacro)
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4KFTW.MacroExperienceStart), {
                contentId: contentId,
                name: (0, $5kjCz.getExperienceName)((0, $5kjCz.RENDERER), extension),
                mode: (0, $5kjCz.RENDERER),
                extensionKey: extensionKey,
                attributes: attributes,
                timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4f09d12458901289$export$9eec8c53e410de67), {
                extensionKey: extensionKey,
                attributes: {
                    ...attributesForAnalytics,
                    ...redactedAttributes
                },
                node: extension
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ge2sX.SessionData), null, ({ cloudId: cloudId, userId: userId })=>contentHandler(macroDefaultProps, cloudId, userId))));
        }));
    });
    return (extension, doc)=>{
        if (extension?.extensionKey?.startsWith((0, $8pcS0.EXTENSION_KEY).NATIVE_EMBED)) return null;
        // Team Calendar stays on the product handler after manifests are ready to preserve its SSR
        // placeholder. When its required calendar ID is absent, step aside so the manifest renderer
        // can apply the standard missing-configuration placeholder instead of loading the macro.
        if (extension?.extensionKey === (0, $8pcS0.EXTENSION_KEY).TEAM_CALENDARS && !(0, $2E7zk.hasConfiguredTeamCalendar)(extension?.parameters?.macroParams) && (0, $6mKj3.expValEquals)('cc-engagement-team-calendar-macro-afm-migration', 'isEnabled', true)) return null;
        return handler(extension, doc);
    };
};
module.exports["getExtensionHandlers"] = $53f1c3cb11bcb25b$export$fe33197d44e10fcf;

});

parcelRegister("lF2in", function(module, exports) {

let $fc4f3522bdc4deec$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fc4f3522bdc4deec$var$load("kT6dz"),
    $fc4f3522bdc4deec$var$load("8KaCS"),
    $fc4f3522bdc4deec$var$load("6SzM6"),
    $fc4f3522bdc4deec$var$load("hUbK8"),
    $fc4f3522bdc4deec$var$load("53Y0O"),
    $fc4f3522bdc4deec$var$load("kYlwR"),
    $fc4f3522bdc4deec$var$load("eNgZ8"),
    $fc4f3522bdc4deec$var$load("lAHCT"),
    $fc4f3522bdc4deec$var$load("iCj4R"),
    $fc4f3522bdc4deec$var$load("hs6P3"),
    $fc4f3522bdc4deec$var$load("8MaGw"),
    $fc4f3522bdc4deec$var$load("cIET7"),
    $fc4f3522bdc4deec$var$load("RylUf"),
    $fc4f3522bdc4deec$var$load("9cVML"),
    $fc4f3522bdc4deec$var$load("dY0qT"),
    $fc4f3522bdc4deec$var$load("7ISl5"),
    $fc4f3522bdc4deec$var$load("7SteV"),
    $fc4f3522bdc4deec$var$load("6dLts"),
    $fc4f3522bdc4deec$var$load("jdPbE"),
    $fc4f3522bdc4deec$var$load("eUsnQ"),
    $fc4f3522bdc4deec$var$load("L98h8"),
    $fc4f3522bdc4deec$var$load("dfVn7"),
    $fc4f3522bdc4deec$var$load("8ikac"),
    $fc4f3522bdc4deec$var$load("58WtS"),
    $fc4f3522bdc4deec$var$load("41gDI"),
    $fc4f3522bdc4deec$var$load("59IUj"),
    $fc4f3522bdc4deec$var$load("4x9Jx"),
    $fc4f3522bdc4deec$var$load("7gL7H"),
    $fc4f3522bdc4deec$var$load("ea3NB"),
    $fc4f3522bdc4deec$var$load("6wr18"),
    $fc4f3522bdc4deec$var$load("59hV4"),
    $fc4f3522bdc4deec$var$load("aNyWk"),
    $fc4f3522bdc4deec$var$load("gSKF7"),
    $fc4f3522bdc4deec$var$load("dtNxV"),
    $fc4f3522bdc4deec$var$load("9zpfi"),
    $fc4f3522bdc4deec$var$load("9pNir"),
    $fc4f3522bdc4deec$var$load("a7sEM"),
    $fc4f3522bdc4deec$var$load("aLbuU"),
    $fc4f3522bdc4deec$var$load("ffEVr"),
    $fc4f3522bdc4deec$var$load("ctxM8"),
    $fc4f3522bdc4deec$var$load("8Jd6S"),
    $fc4f3522bdc4deec$var$load("1olsN"),
    $fc4f3522bdc4deec$var$load("cyDpt"),
    $fc4f3522bdc4deec$var$load("9iWFV"),
    $fc4f3522bdc4deec$var$load("fkGqG"),
    $fc4f3522bdc4deec$var$load("g4jdB"),
    $fc4f3522bdc4deec$var$load("6f0Yj"),
    $fc4f3522bdc4deec$var$load("fwbNS"),
    $fc4f3522bdc4deec$var$load("ckGjo"),
    $fc4f3522bdc4deec$var$load("1sii7"),
    $fc4f3522bdc4deec$var$load("ebXHc"),
    $fc4f3522bdc4deec$var$load("kWexk"),
    $fc4f3522bdc4deec$var$load("Wowvf"),
    $fc4f3522bdc4deec$var$load("4g6rd"),
    $fc4f3522bdc4deec$var$load("fq1gG"),
    $fc4f3522bdc4deec$var$load("fWCBZ"),
    $fc4f3522bdc4deec$var$load("9gCvF"),
    $fc4f3522bdc4deec$var$load("4UHov"),
    $fc4f3522bdc4deec$var$load("hhss7"),
    $fc4f3522bdc4deec$var$load("cWL7t"),
    $fc4f3522bdc4deec$var$load("gbJtu"),
    $fc4f3522bdc4deec$var$load("43z9c"),
    $fc4f3522bdc4deec$var$load("7EorR"),
    $fc4f3522bdc4deec$var$load("lsb09")
]).then(()=>parcelRequire('gnN3I'));

});

parcelRegister("hFueH", function(module, exports) {
parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


const $cdcdb83d150ac905$var$EditorLoaderLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uC_t0",
    name: "EditorLoaderLoader",
    loader: ()=>(parcelRequire("kftOo"))
});
var $cdcdb83d150ac905$export$2e2bcd8739ae039 = $cdcdb83d150ac905$var$EditorLoaderLoader;
module.exports["default"] = $cdcdb83d150ac905$export$2e2bcd8739ae039;

});

parcelRegister("kftOo", function(module, exports) {

let $ebdc555d3cf4b2da$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ebdc555d3cf4b2da$var$load("kHDuB").then(()=>parcelRequire('Il8QU'));

});

parcelRegister("7wsf1", function(module, exports) {

let $57a16daf0a480c40$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $57a16daf0a480c40$var$load("hhss7"),
    $57a16daf0a480c40$var$load("dQy5b")
]).then(()=>parcelRequire('fcgkZ'));

});

parcelRegister("69aHU", function(module, exports) {

var $bdpeX = parcelRequire("bdpeX");


var $1tdlM = parcelRequire("1tdlM");


var $5bak6 = parcelRequire("5bak6");


var $gKr8t = parcelRequire("gKr8t");


var $9HB34 = parcelRequire("9HB34");


var $bfil7 = parcelRequire("bfil7");


var $8pcS0 = parcelRequire("8pcS0");


var $04e9M = parcelRequire("04e9M");


var $7W8i8 = parcelRequire("7W8i8");


var $aIqlA = parcelRequire("aIqlA");


var $4IoVL = parcelRequire("4IoVL");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $aF5bm = parcelRequire("aF5bm");


var $8z3oB = parcelRequire("8z3oB");


var $huSww = parcelRequire("huSww");


var $gxXVf = parcelRequire("gxXVf");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6YkHb = parcelRequire("6YkHb");


var $3JqyB = parcelRequire("3JqyB");


var $2igSQ = parcelRequire("2igSQ");





var $2oer2 = parcelRequire("2oer2");

var $399836d35d211a20$export$f73f87f0b8cabb66 = /*#__PURE__*/ function(TemplateVariableMode) {
    TemplateVariableMode[TemplateVariableMode["CONFIG"] = 0] = "CONFIG";
    TemplateVariableMode[TemplateVariableMode["INPUT"] = 1] = "INPUT";
    return TemplateVariableMode;
}({});
const $399836d35d211a20$var$i18n = (0, $kSwu1.defineMessages)({
    templateVariablesAdd: {
        id: "confluence-fabric-editor.template.variables.add",
        defaultMessage: "New variable"
    },
    templateVariablesAddTooltip: {
        id: "confluence-fabric-editor.template.variables.add.tooltip",
        defaultMessage: "Add a new field into the page for the template user to fill out."
    }
});
function $399836d35d211a20$export$de09af8432d39de0(intl, mode = 0, config, editorActions) {
    const type = 'inlineExtension';
    const title = intl.formatMessage($399836d35d211a20$var$i18n.templateVariablesAdd);
    const Component = mode === 1 ? (0, $2igSQ.TemplateVariableInput) : (0, $3JqyB.TemplateVariableComponent);
    return {
        key: (0, $8pcS0.EXTENSION_KEY).TEMPLATE,
        type: (0, $8pcS0.EXTENSION_TYPE).TEMPLATE,
        title: title,
        description: intl.formatMessage($399836d35d211a20$var$i18n.templateVariablesAddTooltip),
        icons: {
            '48': async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))), {
                        color: "currentColor",
                        label: title,
                        spacing: "spacious"
                    })
        },
        modules: {
            quickInsert: editorActions && [
                {
                    key: (0, $8pcS0.EXTENSION_KEY).TEMPLATE,
                    featured: true,
                    action: {
                        type: 'node',
                        key: 'default',
                        parameters: {
                            type: (0, $2oer2.TEXT_TYPE),
                            name: (0, $2oer2.defaultVariableName)
                        }
                    }
                }
            ],
            nodes: {
                default: {
                    type: type,
                    render: async ()=>({ node: node })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                                parameters: node.parameters
                            }),
                    update: config && (async (parameters)=>{
                        try {
                            const { attrs: attrs } = await (0, $2oer2.openTemplateVariableDialog)({
                                type: type,
                                attrs: {
                                    parameters: parameters
                                }
                            }, config);
                            return attrs.parameters || parameters;
                        } catch  {
                            // On error keep the existing value
                            return parameters;
                        }
                    })
                }
            }
        }
    };
}



var $bgcaM = parcelRequire("bgcaM");


var $1JyKZ = parcelRequire("1JyKZ");


var $dPJCf = parcelRequire("dPJCf");


const $2d9ea9a54c5e94d8$var$createLCMRendererExtensionProvider = async (hasLegacyContentMacro, contentMode)=>{
    const { rendererManifest: rendererManifest, rendererManifestSsr: rendererManifestSsr } = await (parcelRequire("cXTjS"));
    return new (0, $bdpeX.default)([
        hasLegacyContentMacro ? rendererManifestSsr(contentMode) : rendererManifest
    ]);
};
const $2d9ea9a54c5e94d8$var$isMigratedMacroExtensionProvider = (provider)=>'getMigratedFromExtension' in provider && 'getPreloadedMigratedFromExtension' in provider;
const $2d9ea9a54c5e94d8$var$createMigratedMacroExtensionResolver = (forgeExtensionProvider)=>{
    let resolvedForgeExtensionProvider;
    forgeExtensionProvider.then((provider)=>{
        if ($2d9ea9a54c5e94d8$var$isMigratedMacroExtensionProvider(provider)) resolvedForgeExtensionProvider = provider;
    }, ()=>undefined);
    return {
        resolveExtension: async (type, key)=>{
            if (type === (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE) try {
                const provider = await forgeExtensionProvider;
                if ($2d9ea9a54c5e94d8$var$isMigratedMacroExtensionProvider(provider)) {
                    const migratedExtension = await provider.getMigratedFromExtension(type, key);
                    if (migratedExtension) return migratedExtension;
                }
            } catch  {
                return undefined;
            }
        },
        resolvePreloadedExtension: (type, key)=>{
            if (type === (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE && resolvedForgeExtensionProvider) {
                const migratedExtension = resolvedForgeExtensionProvider.getPreloadedMigratedFromExtension(type, key);
                if (migratedExtension) return migratedExtension;
            }
        }
    };
};
const $2d9ea9a54c5e94d8$export$c0ba9eb7d0e2ed47 = (providerFactory, { intl: intl, containerId: containerId, accountId: accountId, cloudId: cloudId, spaceKey: spaceKey, spaceId: spaceId, contentId: contentId, contentType: contentType, contentVersion: contentVersion, contentStatus: contentStatus, contentMode: contentMode, environment: environment, extensionHandlers: extensionHandlers, showTemplateInputInPreview: showTemplateInputInPreview, showTemplateVariablesInPreview: showTemplateVariablesInPreview, createAnalyticsEvent: createAnalyticsEvent, activationId: activationId, isLivePage: isLivePage = false, hasLegacyContentMacro: hasLegacyContentMacro = false })=>{
    const extensionProvidersList = [];
    const extensionProvider = (0, $bfil7.getConfluenceMacrosExtensionProviderForRenderer)({
        contentId: contentId,
        spaceKey: spaceKey,
        spaceId: spaceId,
        contentType: contentType,
        features: {}
    }, extensionHandlers, (0, $bgcaM.getMigrationExtensionManifest), (0, $gxXVf.openMacroBrowserToEditExistingMacro), (0, $gxXVf.openMacroBrowserForInitialConfiguration), intl, createAnalyticsEvent, providerFactory);
    const lcmExtension = $2d9ea9a54c5e94d8$var$createLCMRendererExtensionProvider(hasLegacyContentMacro, contentMode);
    extensionProvidersList.push(extensionProvider, lcmExtension);
    if (showTemplateInputInPreview || showTemplateVariablesInPreview) extensionProvidersList.push(new (0, $bdpeX.default)([
        (0, $399836d35d211a20$export$de09af8432d39de0)(intl, showTemplateInputInPreview ? (0, $399836d35d211a20$export$f73f87f0b8cabb66).INPUT : (0, $399836d35d211a20$export$f73f87f0b8cabb66).CONFIG)
    ]));
    const apolloClient = (0, $gKr8t.getAGGClient)();
    const contextIds = [
        (0, $aF5bm.getWorkspaceARI)({
            cloudId: cloudId,
            activationId: activationId
        })
    ];
    const forgeExtensionProvider = async ()=>{
        const nestedAdfMediaProvider = (0, $6mKj3.expValEquals)('platform_media_token_nested_macro', 'isEnabled', true) ? (0, $4IoVL.createRendererMediaProvider)({
            contentId: contentId,
            spaceKey: spaceKey,
            isExternalShare: false,
            resolveContentIdFromCollection: true
        }) : undefined;
        const getProviderOptions = ({ spaceKey: spaceKeyArg, spaceId: spaceIdArg })=>({
                accountId: accountId ?? undefined,
                cloudId: cloudId,
                apolloClient: apolloClient,
                relayEnvironment: (0, $9HB34.getRelayEnvironment)(),
                contextIds: contextIds,
                dataProviders: providerFactory,
                ...nestedAdfMediaProvider ? {
                    nestedAdfMediaProvider: nestedAdfMediaProvider
                } : {},
                environment: (0, $5bak6.environmentToForgeProductEnvironment)(environment),
                product: 'confluence',
                page: 'confluence:macroRenderer',
                isEditing: false,
                contentMode: contentMode,
                analyticsWebClient: (0, $04e9M.getAnalyticsWebClient)(),
                forgeUIAnalyticsContext: (0, $5bak6.createForgeUIAnalyticsContext)({
                    objectId: contentId,
                    // @ts-ignore
                    objectType: contentType,
                    containerId: containerId,
                    containerType: 'space'
                }),
                extensionData: {
                    ...(0, $5bak6.createForgeMacroExtensionData)({
                        spaceKey: spaceKeyArg ?? '',
                        isLivePage: isLivePage,
                        spaceId: spaceIdArg ?? spaceId ?? '',
                        contentId: contentId,
                        contentType: contentType,
                        contentVersion: contentVersion ?? undefined,
                        contentStatus: contentStatus ?? undefined
                    })
                },
                extensionHandlerWithReference: (0, $9wGTI.fg)('conf_frontend_forge_static_macro_mvp') ? (0, $huSww.createForgeMacroExtensionHandler)(false) : extensionHandlers[(0, $8pcS0.EXTENSION_TYPE).MACRO_WITH_REFERENCES],
                connectExtensionProvider: extensionProvider,
                FlagProvider: $8z3oB.FlagProvider,
                extensionsFilter: undefined,
                intl: intl,
                locale: intl.locale,
                useGetContextToken: $1JyKZ.useGetContextToken,
                useRouteActions: $dPJCf.useRouteActions,
                productExtensionHandlers: extensionHandlers,
                isMigratedFromAliasEnabled: true
            });
        return (0, $aIqlA.fetchForgeExtensionProvider)({
            getProviderOptions: getProviderOptions,
            spaceKey: spaceKey
        });
    };
    const forgeExtensionProviderPromise = forgeExtensionProvider();
    extensionProvidersList.push(forgeExtensionProviderPromise);
    const combinedProvider = (0, $1tdlM.default)(extensionProvidersList, $2d9ea9a54c5e94d8$var$createMigratedMacroExtensionResolver(forgeExtensionProviderPromise));
    providerFactory.setProvider('extensionProvider', Promise.resolve(combinedProvider));
    // Call preload on all provider that later we can use it synchronously in packages/editor/editor-common/src/extensions/extension-handlers.tsx
    const manifestPreload = combinedProvider.preload();
    // Callers are free to ignore the returned preload, so always keep a rejection handler attached.
    manifestPreload.catch((error)=>{
        (0, $7W8i8.getLogger)('populateExtensionProviders').error`Failed to preload extension manifests: ${error}`;
    });
    return manifestPreload;
};
module.exports["populateExtensionProviders"] = $2d9ea9a54c5e94d8$export$c0ba9eb7d0e2ed47;

});

parcelRegister("3JqyB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kwjRd = parcelRequire("kwjRd");

const $f366aa2b03faa65b$export$3e35a8e6e9fd352d = ({ parameters: parameters })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwjRd.TemplateVariableNameWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwjRd.TemplateVariableName), {
        "data-testid": "variable-name"
    }, parameters?.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwjRd.TemplateVariableType), {
        "data-testid": "variable-type"
    }, `| ${parameters?.type}`));
};
module.exports["TemplateVariableComponent"] = $f366aa2b03faa65b$export$3e35a8e6e9fd352d;

});

parcelRegister("iol5P", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $lOkIA = parcelRequire("lOkIA");


const $2957f690f8f5a888$export$4072164b6bd9337 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "FUMAJ",
    name: "TemplateVariableDialogLoader",
    loader: async ()=>(await (parcelRequire("9erY8"))).TemplateVariableDialogComponent,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium"
        })
});
module.exports["TemplateVariableDialogLoader"] = $2957f690f8f5a888$export$4072164b6bd9337;

});

parcelRegister("9erY8", function(module, exports) {

let $6b8b1de85dcc30b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b8b1de85dcc30b0$var$load("6IjKj").then(()=>parcelRequire('5KoaE'));

});

parcelRegister("j2dS3", function(module, exports) {
function $a9c66c4a525522c3$export$e2b5c5db9e2009fd(node) {
    return node.type.name || node.type;
}
function $a9c66c4a525522c3$export$8198c5b4e81b9082(node, newParams) {
    return {
        type: $a9c66c4a525522c3$export$e2b5c5db9e2009fd(node),
        attrs: {
            ...node.attrs,
            parameters: {
                ...node.attrs.parameters,
                ...newParams
            }
        }
    };
}
function $a9c66c4a525522c3$export$d1c50812de760a07(root, callbackFunc) {
    for (const nodeKey of Object.keys(root)){
        const nodeValue = root[nodeKey];
        callbackFunc(nodeKey, nodeValue);
        // go deeper
        if (nodeValue !== null && typeof nodeValue === 'object') $a9c66c4a525522c3$export$d1c50812de760a07(root[nodeKey], callbackFunc);
    }
}
function $a9c66c4a525522c3$export$676214b4858262c1(root, typeName) {
    const results = [];
    $a9c66c4a525522c3$export$d1c50812de760a07(root, (_nodeKey, nodeValue)=>{
        if (nodeValue && nodeValue.type === typeName) results.push(nodeValue);
    });
    return results;
}
module.exports["updateParams"] = $a9c66c4a525522c3$export$8198c5b4e81b9082;
module.exports["filterADNodesByType"] = $a9c66c4a525522c3$export$676214b4858262c1;

});

parcelRegister("bgcaM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6Ec6w = parcelRequire("6Ec6w");


var $8pcS0 = parcelRequire("8pcS0");


var $5h7sn = parcelRequire("5h7sn");

var $bQCqI = parcelRequire("bQCqI");







var $i1t43 = parcelRequire("i1t43");


var $8am3c = parcelRequire("8am3c");

const $3d419e1dae817d20$var$i18n = (0, $kSwu1.defineMessages)({
    unmodifiableMacroDialogTitle: {
        id: "fabric-extension-handlers.unmodifiable.macro.dialog.title",
        defaultMessage: "This macro can\u2019t be edited"
    },
    unmodifiableMacroDialogBody: {
        id: "fabric-extension-handlers.unmodifiable.macro.dialog.body",
        defaultMessage: "This macro was added to a page that was converted from the legacy editor. It can\u2019t be edited because it is now incompatible with the <alink>current editor</alink>."
    }
});
const $3d419e1dae817d20$export$752d3018048f7d27 = (selectedNode, flags, createAnalyticsEvent)=>new Promise((resolve, reject)=>{
        if (!selectedNode || !selectedNode.attrs || !flags) {
            reject(new Error('Cannot show unmodifiable macro error flag'));
            return;
        }
        const fireLinkClickAnalytics = ()=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'link',
                    actionSubjectId: 'unmodifiableMacroDialogComponentLearnMoreLink',
                    source: 'showUnmodifiableMacroFlag'
                }
            }).fire();
        };
        flags.showFlag({
            type: 'error',
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3d419e1dae817d20$var$i18n.unmodifiableMacroDialogTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...$3d419e1dae817d20$var$i18n.unmodifiableMacroDialogBody,
                values: {
                    alink: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                            href: (0, $8am3c.LEARN_MORE_URL),
                            target: "_blank",
                            onClick: fireLinkClickAnalytics
                        }, chunks)
                }
            }),
            close: 'auto'
        });
        resolve();
    });



var $6mKj3 = parcelRequire("6mKj3");


var $fUN4A = parcelRequire("fUN4A");

const $bc16cbc3cc94b402$var$i18n = (0, $kSwu1.defineMessages)({
    widthLabel: {
        id: "confluence-fabric-editor.migration-extension.manifest.width.label",
        defaultMessage: "Width"
    },
    widthDescription: {
        id: "confluence-fabric-editor.migration-extension.manifest.width.description",
        defaultMessage: "Width of image"
    },
    heightLabel: {
        id: "confluence-fabric-editor.migration-extension.manifest.height.label",
        defaultMessage: "Height"
    },
    heightDescription: {
        id: "confluence-fabric-editor.migration-extension.manifest.height.description",
        defaultMessage: "Height of image"
    },
    configPlaceholder: {
        id: "confluence-fabric-editor.migration-extension.manifest.config.placeholder",
        defaultMessage: "auto"
    }
});
function $bc16cbc3cc94b402$export$fb67662ebef720ab(contentId, isEditor, intl, flags, createAnalyticsEvent) {
    if ((0, $6mKj3.expValEquals)('enable_edit_of_inline_image_extensions', 'cohort', 'test')) return $bc16cbc3cc94b402$var$getMigrationExtensionManifestV2(contentId, isEditor, intl, flags, createAnalyticsEvent);
    const type = 'inlineExtension';
    const getExtensionHandler = isEditor ? (0, $5h7sn.getMigrationExtHandlerForEditor) : (0, $bQCqI.getMigrationExtHandlerForRenderer);
    return [
        (0, $8pcS0.EXTENSION_KEY).INVALID,
        (0, $8pcS0.EXTENSION_KEY).INLINE_MEDIA_IMAGE,
        (0, $8pcS0.EXTENSION_KEY).INLINE_EXTERNAL_IMAGE
    ].map((key)=>{
        const node = {
            type: type,
            async preloadRender () {
            // Intentionally left empty. But the function needs to be defined
            },
            renderSync () {
                return ({ node: node })=>getExtensionHandler({
                        contentId: contentId,
                        contextProviders: {
                            ClassicEditorContextProvider: (0, $fUN4A.ClassicEditorContextProviderLazyLoader)
                        }
                    })(node, {});
            },
            async render () {
                return this.renderSync();
            },
            update: isEditor ? (parameters)=>(0, $3d419e1dae817d20$export$752d3018048f7d27)({
                    type: type,
                    attrs: {
                        parameters: parameters
                    }
                }, flags, createAnalyticsEvent) : undefined
        };
        return {
            title: 'Migration Extension',
            key: key,
            type: (0, $8pcS0.EXTENSION_TYPE).MIGRATION,
            icons: {
                '48': async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))), {
                            label: "Migration Extension"
                        })
            },
            modules: {
                nodes: {
                    default: node
                }
            }
        };
    });
}
const $bc16cbc3cc94b402$var$getMigrationExtensionManifestV2 = (contentId, isEditor, intl, flags, createAnalyticsEvent)=>{
    const getExtensionHandler = isEditor ? (0, $5h7sn.getMigrationExtHandlerForEditor) : (0, $bQCqI.getMigrationExtHandlerForRenderer);
    const invalidExtensionManifest = $bc16cbc3cc94b402$var$createInvalidMigrationExtensionManifest(contentId, getExtensionHandler, isEditor, flags, createAnalyticsEvent);
    const inlineImagesExtensionManifests = [
        (0, $8pcS0.EXTENSION_KEY).INLINE_MEDIA_IMAGE,
        (0, $8pcS0.EXTENSION_KEY).INLINE_EXTERNAL_IMAGE
    ].map((key)=>$bc16cbc3cc94b402$var$createInlineImagesMigrationExtensionManifest(key, contentId, getExtensionHandler, isEditor, intl));
    return [
        invalidExtensionManifest,
        ...inlineImagesExtensionManifests
    ];
};
const $bc16cbc3cc94b402$var$createInlineImagesMigrationExtensionManifest = (key, contentId, getExtensionHandler, isEditor, intl)=>{
    const node = {
        type: 'inlineExtension',
        async preloadRender () {
        // Intentionally left empty. But the function needs to be defined
        },
        renderSync () {
            return ({ node: node })=>getExtensionHandler({
                    contentId: contentId,
                    contextProviders: {
                        ClassicEditorContextProvider: (0, $fUN4A.ClassicEditorContextProviderLazyLoader)
                    }
                })(node, {});
        },
        async render () {
            return this.renderSync();
        },
        async getFieldsDefinition () {
            return [
                {
                    name: 'width',
                    label: intl.formatMessage($bc16cbc3cc94b402$var$i18n.widthLabel),
                    isRequired: false,
                    description: intl.formatMessage($bc16cbc3cc94b402$var$i18n.widthDescription),
                    placeholder: intl.formatMessage($bc16cbc3cc94b402$var$i18n.configPlaceholder),
                    type: 'number'
                },
                {
                    name: 'height',
                    label: intl.formatMessage($bc16cbc3cc94b402$var$i18n.heightLabel),
                    isRequired: false,
                    description: intl.formatMessage($bc16cbc3cc94b402$var$i18n.heightDescription),
                    placeholder: intl.formatMessage($bc16cbc3cc94b402$var$i18n.configPlaceholder),
                    type: 'number'
                }
            ];
        },
        update: isEditor ? async (_, actions)=>actions.editInContextPanel((parameters)=>{
                return {
                    ...parameters,
                    width: Number(parameters.width) || undefined,
                    height: Number(parameters.height) || undefined
                };
            }, (parameters)=>{
                return {
                    ...parameters,
                    width: $bc16cbc3cc94b402$var$transformImageSize(parameters.width, 16),
                    height: $bc16cbc3cc94b402$var$transformImageSize(parameters.height, 8)
                };
            }) : undefined
    };
    return $bc16cbc3cc94b402$var$createMigrationExtenionManifest(key, node);
};
const $bc16cbc3cc94b402$var$createInvalidMigrationExtensionManifest = (contentId, getExtensionHandler, isEditor, flags, createAnalyticsEvent)=>{
    const node = {
        type: 'inlineExtension',
        async preloadRender () {
        // Intentionally left empty. But the function needs to be defined
        },
        renderSync () {
            return ({ node: node })=>getExtensionHandler({
                    contentId: contentId,
                    contextProviders: {
                        ClassicEditorContextProvider: (0, $fUN4A.ClassicEditorContextProviderLazyLoader)
                    }
                })(node, {});
        },
        async render () {
            return this.renderSync();
        },
        update: isEditor ? (parameters)=>(0, $3d419e1dae817d20$export$752d3018048f7d27)({
                type: 'inlineExtension',
                attrs: {
                    parameters: parameters
                }
            }, flags, createAnalyticsEvent) : undefined
    };
    return $bc16cbc3cc94b402$var$createMigrationExtenionManifest((0, $8pcS0.EXTENSION_KEY).INVALID, node);
};
const $bc16cbc3cc94b402$var$transformImageSize = (size, minSize)=>{
    if (size === undefined) return '';
    if (size <= minSize) return String(minSize);
    return String(size);
};
const $bc16cbc3cc94b402$var$createMigrationExtenionManifest = (key, node)=>{
    return {
        title: 'Migration Extension',
        key: key,
        type: (0, $8pcS0.EXTENSION_TYPE).MIGRATION,
        icons: {
            '48': async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))), {
                        label: "Migration Extension"
                    })
        },
        modules: {
            nodes: {
                default: node
            }
        }
    };
};
module.exports["getMigrationExtensionManifest"] = $bc16cbc3cc94b402$export$fb67662ebef720ab;

});

parcelRegister("8am3c", function(module, exports) {
const $5f205cb1fe7d8e74$export$2dd355223baa0569 = 'com.atlassian.confluence.plugins.confluence-frontend-support';
const $5f205cb1fe7d8e74$export$73d3e00099fbbdb2 = 'confluence.fabric.page.migration.banner';
const $5f205cb1fe7d8e74$export$af6d68522cb370b8 = 'https://confluence.atlassian.com/confcloud/converting-pages-to-the-new-editor-993930226.html';
module.exports["PLUGIN_KEY"] = $5f205cb1fe7d8e74$export$2dd355223baa0569;
module.exports["PAGE_MIGRATION_FEATURE_KEY"] = $5f205cb1fe7d8e74$export$73d3e00099fbbdb2;
module.exports["LEARN_MORE_URL"] = $5f205cb1fe7d8e74$export$af6d68522cb370b8;

});

parcelRegister("cXTjS", function(module, exports) {

let $9705e80a21b500ee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9705e80a21b500ee$var$load("6MdJu"),
    $9705e80a21b500ee$var$load("1Pi84"),
    $9705e80a21b500ee$var$load("8LtYa"),
    $9705e80a21b500ee$var$load("la2FE"),
    $9705e80a21b500ee$var$load("iq6Zv")
]).then(()=>parcelRequire('BiOSq'));

});

parcelRegister("2oP7l", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hRnS5 = parcelRequire("hRnS5");


var $hMRhJ = parcelRequire("hMRhJ");


var $giS6h = parcelRequire("giS6h");


var $gnzsm = parcelRequire("gnzsm");


var $6mKj3 = parcelRequire("6mKj3");


var $dF6Hu = parcelRequire("dF6Hu");

const $9bc6a89b7ea8c7a1$var$NestedAdfRendererWrapperComponent = ({ Renderer: Renderer, appearance: appearance, rendererExtensionOptions: rendererExtensionOptions, adf: adf, targetContentId: targetContentId, targetSpaceKey: targetSpaceKey, mediaToken: mediaToken, headingIdPrefix: headingIdPrefix, getHeadingLink: getHeadingLink, getHeadingLinkPath: getHeadingLinkPath })=>{
    const rendererAppearance = appearance === 'full-page' ? 'full-page' : 'full-width';
    const rendererData = (0, $cozmU.useMemo)(()=>(0, $dF6Hu.createNestedRendererData)(adf), [
        adf
    ]);
    const allowHeadingAnchorLinks = (0, $cozmU.useMemo)(()=>{
        if (!(0, $6mKj3.expValEquals)('confluence_toc_included_content_exp', 'isEnabled', true)) return undefined;
        // Only override the heading link when we have a real path builder (editor /
        // live-page paths), where the platform default would otherwise produce the
        // *edit* URL. On the view-page renderer path `getHeadingLinkPath` is
        // undefined, so we omit the override entirely and let the platform default
        // (`getCurrentUrlWithHash` — current page URL + hash) apply, matching normal
        // (non-included) headings.
        const resolvedGetHeadingLink = getHeadingLink ?? (getHeadingLinkPath ? (headingId)=>(0, $gnzsm.createHeadingLink)(getHeadingLinkPath, headingId) ?? '' : undefined);
        return {
            allowNestedHeaderLinks: true,
            ...resolvedGetHeadingLink ? {
                getHeadingLink: resolvedGetHeadingLink
            } : {}
        };
    }, [
        getHeadingLink,
        getHeadingLinkPath
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMRhJ.RendererExtensionContext).Provider, {
        value: rendererExtensionOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Renderer, {
        contentId: targetContentId,
        spaceKey: targetSpaceKey,
        data: rendererData,
        appearance: rendererAppearance,
        hasInlineComments: false,
        mediaToken: mediaToken,
        headingIdPrefix: headingIdPrefix,
        allowHeadingAnchorLinks: allowHeadingAnchorLinks
    })));
};
const $9bc6a89b7ea8c7a1$export$a35b4c1c128d912b = ({ children: children, Renderer: Renderer, appearance: appearance })=>{
    const { getExtensionHandlers: getExtensionHandlers, populateExtensionProviders: populateExtensionProviders, getHeadingLinkPath: getHeadingLinkPath } = (0, $cozmU.useContext)((0, $giS6h.ClassicEditorContext));
    const contextRendererExtensionOptions = (0, $cozmU.useMemo)(()=>({
            getExtensionHandlers: getExtensionHandlers,
            populateExtensionProviders: populateExtensionProviders
        }), [
        getExtensionHandlers,
        populateExtensionProviders
    ]);
    const RendererWrapper = (0, $cozmU.useMemo)(()=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9bc6a89b7ea8c7a1$var$NestedAdfRendererWrapperComponent, {
                ...props,
                Renderer: Renderer,
                appearance: appearance,
                getHeadingLinkPath: getHeadingLinkPath,
                rendererExtensionOptions: contextRendererExtensionOptions
            }), [
        appearance,
        Renderer,
        contextRendererExtensionOptions,
        getHeadingLinkPath
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(RendererWrapper));
};
module.exports["NestedAdfRendererWrapperProvider"] = $9bc6a89b7ea8c7a1$export$a35b4c1c128d912b;

});

parcelRegister("4TFr0", function(module, exports) {
"use strict";
var $390c7087c17e4575$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aRdp2 = parcelRequire("aRdp2");


var $iMtch = parcelRequire("iMtch");


var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/**
 * Ignores source values for a duration determined by another Observable, then
 * emits the most recent value from the source Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link auditTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/audit.png" width="100%">
 *
 * `audit` is similar to `throttle`, but emits the last value from the silenced
 * time window, instead of the first value. `audit` emits the most recent value
 * from the source Observable on the output Observable as soon as its internal
 * timer becomes disabled, and ignores source values while the timer is enabled.
 * Initially, the timer is disabled. As soon as the first source value arrives,
 * the timer is enabled by calling the `durationSelector` function with the
 * source value, which returns the "duration" Observable. When the duration
 * Observable emits a value or completes, the timer is disabled, then the most
 * recent source value is emitted on the output Observable, and this process
 * repeats for the next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration, returned as an Observable or a Promise.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method audit
 * @owner Observable
 */ function $390c7087c17e4575$var$audit(durationSelector) {
    return function auditOperatorFunction(source) {
        return source.lift(new $390c7087c17e4575$var$AuditOperator(durationSelector));
    };
}
module.exports.audit = $390c7087c17e4575$var$audit;
var $390c7087c17e4575$var$AuditOperator = function() {
    function AuditOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    AuditOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $390c7087c17e4575$var$AuditSubscriber(subscriber, this.durationSelector));
    };
    return AuditOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $390c7087c17e4575$var$AuditSubscriber = function(_super) {
    $390c7087c17e4575$var$__extends(AuditSubscriber, _super);
    function AuditSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.durationSelector = durationSelector;
        this.hasValue = false;
    }
    AuditSubscriber.prototype._next = function(value) {
        this.value = value;
        this.hasValue = true;
        if (!this.throttled) {
            var duration = $aRdp2.tryCatch(this.durationSelector)(value);
            if (duration === $iMtch.errorObject) this.destination.error($iMtch.errorObject.e);
            else {
                var innerSubscription = $863V0.subscribeToResult(this, duration);
                if (innerSubscription.closed) this.clearThrottle();
                else this.add(this.throttled = innerSubscription);
            }
        }
    };
    AuditSubscriber.prototype.clearThrottle = function() {
        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
        if (hasValue) {
            this.value = null;
            this.hasValue = false;
            this.destination.next(value);
        }
    };
    AuditSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        this.clearThrottle();
    };
    AuditSubscriber.prototype.notifyComplete = function() {
        this.clearThrottle();
    };
    return AuditSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=audit.js.map

});

parcelRegister("8gBFa", function(module, exports) {
"use strict";
var $604d086acf95c623$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3l2mn = parcelRequire("3l2mn");


var $1pK8e = parcelRequire("1pK8e");


var $zAMIg = parcelRequire("zAMIg");


var $lRrDg = parcelRequire("lRrDg");


var $fEWBj = parcelRequire("fEWBj");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $604d086acf95c623$var$TimerObservable = function(_super) {
    $604d086acf95c623$var$__extends(TimerObservable, _super);
    function TimerObservable(dueTime, period, scheduler) {
        if (dueTime === void 0) dueTime = 0;
        _super.call(this);
        this.period = -1;
        this.dueTime = 0;
        if ($3l2mn.isNumeric(period)) this.period = Number(period) < 1 && 1 || Number(period);
        else if ($lRrDg.isScheduler(period)) scheduler = period;
        if (!$lRrDg.isScheduler(scheduler)) scheduler = $zAMIg.async;
        this.scheduler = scheduler;
        this.dueTime = $fEWBj.isDate(dueTime) ? +dueTime - this.scheduler.now() : dueTime;
    }
    /**
     * Creates an Observable that starts emitting after an `initialDelay` and
     * emits ever increasing numbers after each `period` of time thereafter.
     *
     * <span class="informal">Its like {@link interval}, but you can specify when
     * should the emissions start.</span>
     *
     * <img src="./img/timer.png" width="100%">
     *
     * `timer` returns an Observable that emits an infinite sequence of ascending
     * integers, with a constant interval of time, `period` of your choosing
     * between those emissions. The first emission happens after the specified
     * `initialDelay`. The initial delay may be a {@link Date}. By default, this
     * operator uses the `async` IScheduler to provide a notion of time, but you
     * may pass any IScheduler to it. If `period` is not specified, the output
     * Observable emits only one value, `0`. Otherwise, it emits an infinite
     * sequence.
     *
     * @example <caption>Emits ascending numbers, one every second (1000ms), starting after 3 seconds</caption>
     * var numbers = Rx.Observable.timer(3000, 1000);
     * numbers.subscribe(x => console.log(x));
     *
     * @example <caption>Emits one number after five seconds</caption>
     * var numbers = Rx.Observable.timer(5000);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link interval}
     * @see {@link delay}
     *
     * @param {number|Date} initialDelay The initial delay time to wait before
     * emitting the first value of `0`.
     * @param {number} [period] The period of time between emissions of the
     * subsequent numbers.
     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
     * the emission of values, and providing a notion of "time".
     * @return {Observable} An Observable that emits a `0` after the
     * `initialDelay` and ever increasing numbers after each `period` of time
     * thereafter.
     * @static true
     * @name timer
     * @owner Observable
     */ TimerObservable.create = function(initialDelay, period, scheduler) {
        if (initialDelay === void 0) initialDelay = 0;
        return new TimerObservable(initialDelay, period, scheduler);
    };
    TimerObservable.dispatch = function(state) {
        var index = state.index, period = state.period, subscriber = state.subscriber;
        var action = this;
        subscriber.next(index);
        if (subscriber.closed) return;
        else if (period === -1) return subscriber.complete();
        state.index = index + 1;
        action.schedule(state, period);
    };
    /** @deprecated internal use only */ TimerObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, period = _a.period, dueTime = _a.dueTime, scheduler = _a.scheduler;
        return scheduler.schedule(TimerObservable.dispatch, dueTime, {
            index: index,
            period: period,
            subscriber: subscriber
        });
    };
    return TimerObservable;
}($1pK8e.Observable);
module.exports.TimerObservable = $604d086acf95c623$var$TimerObservable; //# sourceMappingURL=TimerObservable.js.map

});

parcelRegister("jyqW3", function(module, exports) {
"use strict";
var $e3c616185eb7e31e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $zAMIg = parcelRequire("zAMIg");


var $fNVRJ = parcelRequire("fNVRJ");


var $lRrDg = parcelRequire("lRrDg");

/* tslint:enable:max-line-length */ /**
 * Buffers the source Observable values for a specific time period.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * those arrays periodically in time.</span>
 *
 * <img src="./img/bufferTime.png" width="100%">
 *
 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
 * Unless the optional argument `bufferCreationInterval` is given, it emits and
 * resets the buffer every `bufferTimeSpan` milliseconds. If
 * `bufferCreationInterval` is given, this operator opens the buffer every
 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
 * `maxBufferSize` is specified, the buffer will be closed either after
 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
 *
 * @example <caption>Every second, emit an array of the recent click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(1000);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(2000, 5000);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link windowTime}
 *
 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
 * @param {number} [bufferCreationInterval] The interval at which to start new
 * buffers.
 * @param {number} [maxBufferSize] The maximum buffer size.
 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
 * intervals that determine buffer boundaries.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferTime
 * @owner Observable
 */ function $e3c616185eb7e31e$var$bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = $zAMIg.async;
    if ($lRrDg.isScheduler(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) bufferCreationInterval = arguments[1];
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) maxBufferSize = arguments[2];
    return function bufferTimeOperatorFunction(source) {
        return source.lift(new $e3c616185eb7e31e$var$BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
    };
}
module.exports.bufferTime = $e3c616185eb7e31e$var$bufferTime;
var $e3c616185eb7e31e$var$BufferTimeOperator = function() {
    function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
    }
    BufferTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $e3c616185eb7e31e$var$BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
    };
    return BufferTimeOperator;
}();
var $e3c616185eb7e31e$var$Context = function() {
    function Context() {
        this.buffer = [];
    }
    return Context;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e3c616185eb7e31e$var$BufferTimeSubscriber = function(_super) {
    $e3c616185eb7e31e$var$__extends(BufferTimeSubscriber, _super);
    function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        _super.call(this, destination);
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
        this.contexts = [];
        var context = this.openContext();
        this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
        if (this.timespanOnly) {
            var timeSpanOnlyState = {
                subscriber: this,
                context: context,
                bufferTimeSpan: bufferTimeSpan
            };
            this.add(context.closeAction = scheduler.schedule($e3c616185eb7e31e$var$dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        } else {
            var closeState = {
                subscriber: this,
                context: context
            };
            var creationState = {
                bufferTimeSpan: bufferTimeSpan,
                bufferCreationInterval: bufferCreationInterval,
                subscriber: this,
                scheduler: scheduler
            };
            this.add(context.closeAction = scheduler.schedule($e3c616185eb7e31e$var$dispatchBufferClose, bufferTimeSpan, closeState));
            this.add(scheduler.schedule($e3c616185eb7e31e$var$dispatchBufferCreation, bufferCreationInterval, creationState));
        }
    }
    BufferTimeSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        var len = contexts.length;
        var filledBufferContext;
        for(var i = 0; i < len; i++){
            var context = contexts[i];
            var buffer = context.buffer;
            buffer.push(value);
            if (buffer.length == this.maxBufferSize) filledBufferContext = context;
        }
        if (filledBufferContext) this.onBufferFull(filledBufferContext);
    };
    BufferTimeSubscriber.prototype._error = function(err) {
        this.contexts.length = 0;
        _super.prototype._error.call(this, err);
    };
    BufferTimeSubscriber.prototype._complete = function() {
        var _a = this, contexts = _a.contexts, destination = _a.destination;
        while(contexts.length > 0){
            var context = contexts.shift();
            destination.next(context.buffer);
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ BufferTimeSubscriber.prototype._unsubscribe = function() {
        this.contexts = null;
    };
    BufferTimeSubscriber.prototype.onBufferFull = function(context) {
        this.closeContext(context);
        var closeAction = context.closeAction;
        closeAction.unsubscribe();
        this.remove(closeAction);
        if (!this.closed && this.timespanOnly) {
            context = this.openContext();
            var bufferTimeSpan = this.bufferTimeSpan;
            var timeSpanOnlyState = {
                subscriber: this,
                context: context,
                bufferTimeSpan: bufferTimeSpan
            };
            this.add(context.closeAction = this.scheduler.schedule($e3c616185eb7e31e$var$dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
    };
    BufferTimeSubscriber.prototype.openContext = function() {
        var context = new $e3c616185eb7e31e$var$Context();
        this.contexts.push(context);
        return context;
    };
    BufferTimeSubscriber.prototype.closeContext = function(context) {
        this.destination.next(context.buffer);
        var contexts = this.contexts;
        var spliceIndex = contexts ? contexts.indexOf(context) : -1;
        if (spliceIndex >= 0) contexts.splice(contexts.indexOf(context), 1);
    };
    return BufferTimeSubscriber;
}($fNVRJ.Subscriber);
function $e3c616185eb7e31e$var$dispatchBufferTimeSpanOnly(state) {
    var subscriber = state.subscriber;
    var prevContext = state.context;
    if (prevContext) subscriber.closeContext(prevContext);
    if (!subscriber.closed) {
        state.context = subscriber.openContext();
        state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
    }
}
function $e3c616185eb7e31e$var$dispatchBufferCreation(state) {
    var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
    var context = subscriber.openContext();
    var action = this;
    if (!subscriber.closed) {
        subscriber.add(context.closeAction = scheduler.schedule($e3c616185eb7e31e$var$dispatchBufferClose, bufferTimeSpan, {
            subscriber: subscriber,
            context: context
        }));
        action.schedule(state, bufferCreationInterval);
    }
}
function $e3c616185eb7e31e$var$dispatchBufferClose(arg) {
    var subscriber = arg.subscriber, context = arg.context;
    subscriber.closeContext(context);
} //# sourceMappingURL=bufferTime.js.map

});

parcelRegister("ihrZj", function(module, exports) {
"use strict";
var $d4ef865bc9218593$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $9P4lO = parcelRequire("9P4lO");


var $863V0 = parcelRequire("863V0");


var $hmcLb = parcelRequire("hmcLb");

/**
 * Buffers the source Observable values starting from an emission from
 * `openings` and ending when the output of `closingSelector` emits.
 *
 * <span class="informal">Collects values from the past as an array. Starts
 * collecting only when `opening` emits, and calls the `closingSelector`
 * function to get an Observable that tells when to close the buffer.</span>
 *
 * <img src="./img/bufferToggle.png" width="100%">
 *
 * Buffers values from the source by opening the buffer via signals from an
 * Observable provided to `openings`, and closing and sending the buffers when
 * a Subscribable or Promise returned by the `closingSelector` function emits.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var buffered = clicks.bufferToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferWhen}
 * @see {@link windowToggle}
 *
 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
 * buffers.
 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
 * which, when it emits, signals that the associated buffer should be emitted
 * and cleared.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferToggle
 * @owner Observable
 */ function $d4ef865bc9218593$var$bufferToggle(openings, closingSelector) {
    return function bufferToggleOperatorFunction(source) {
        return source.lift(new $d4ef865bc9218593$var$BufferToggleOperator(openings, closingSelector));
    };
}
module.exports.bufferToggle = $d4ef865bc9218593$var$bufferToggle;
var $d4ef865bc9218593$var$BufferToggleOperator = function() {
    function BufferToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    BufferToggleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d4ef865bc9218593$var$BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return BufferToggleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d4ef865bc9218593$var$BufferToggleSubscriber = function(_super) {
    $d4ef865bc9218593$var$__extends(BufferToggleSubscriber, _super);
    function BufferToggleSubscriber(destination, openings, closingSelector) {
        _super.call(this, destination);
        this.openings = openings;
        this.closingSelector = closingSelector;
        this.contexts = [];
        this.add($863V0.subscribeToResult(this, openings));
    }
    BufferToggleSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        var len = contexts.length;
        for(var i = 0; i < len; i++)contexts[i].buffer.push(value);
    };
    BufferToggleSubscriber.prototype._error = function(err) {
        var contexts = this.contexts;
        while(contexts.length > 0){
            var context = contexts.shift();
            context.subscription.unsubscribe();
            context.buffer = null;
            context.subscription = null;
        }
        this.contexts = null;
        _super.prototype._error.call(this, err);
    };
    BufferToggleSubscriber.prototype._complete = function() {
        var contexts = this.contexts;
        while(contexts.length > 0){
            var context = contexts.shift();
            this.destination.next(context.buffer);
            context.subscription.unsubscribe();
            context.buffer = null;
            context.subscription = null;
        }
        this.contexts = null;
        _super.prototype._complete.call(this);
    };
    BufferToggleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
    };
    BufferToggleSubscriber.prototype.notifyComplete = function(innerSub) {
        this.closeBuffer(innerSub.context);
    };
    BufferToggleSubscriber.prototype.openBuffer = function(value) {
        try {
            var closingSelector = this.closingSelector;
            var closingNotifier = closingSelector.call(this, value);
            if (closingNotifier) this.trySubscribe(closingNotifier);
        } catch (err) {
            this._error(err);
        }
    };
    BufferToggleSubscriber.prototype.closeBuffer = function(context) {
        var contexts = this.contexts;
        if (contexts && context) {
            var buffer = context.buffer, subscription = context.subscription;
            this.destination.next(buffer);
            contexts.splice(contexts.indexOf(context), 1);
            this.remove(subscription);
            subscription.unsubscribe();
        }
    };
    BufferToggleSubscriber.prototype.trySubscribe = function(closingNotifier) {
        var contexts = this.contexts;
        var buffer = [];
        var subscription = new $9P4lO.Subscription();
        var context = {
            buffer: buffer,
            subscription: subscription
        };
        contexts.push(context);
        var innerSubscription = $863V0.subscribeToResult(this, closingNotifier, context);
        if (!innerSubscription || innerSubscription.closed) this.closeBuffer(context);
        else {
            innerSubscription.context = context;
            this.add(innerSubscription);
            subscription.add(innerSubscription);
        }
    };
    return BufferToggleSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=bufferToggle.js.map

});

parcelRegister("5iYhi", function(module, exports) {
"use strict";
var $3dcd642784b5f5f4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $9P4lO = parcelRequire("9P4lO");


var $aRdp2 = parcelRequire("aRdp2");


var $iMtch = parcelRequire("iMtch");


var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/**
 * Buffers the source Observable values, using a factory function of closing
 * Observables to determine when to close, emit, and reset the buffer.
 *
 * <span class="informal">Collects values from the past as an array. When it
 * starts collecting values, it calls a function that returns an Observable that
 * tells when to close the buffer and restart collecting.</span>
 *
 * <img src="./img/bufferWhen.png" width="100%">
 *
 * Opens a buffer immediately, then closes the buffer when the observable
 * returned by calling `closingSelector` function emits a value. When it closes
 * the buffer, it immediately opens a new buffer and repeats the process.
 *
 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferWhen(() =>
 *   Rx.Observable.interval(1000 + Math.random() * 4000)
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link windowWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals buffer closure.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferWhen
 * @owner Observable
 */ function $3dcd642784b5f5f4$var$bufferWhen(closingSelector) {
    return function(source) {
        return source.lift(new $3dcd642784b5f5f4$var$BufferWhenOperator(closingSelector));
    };
}
module.exports.bufferWhen = $3dcd642784b5f5f4$var$bufferWhen;
var $3dcd642784b5f5f4$var$BufferWhenOperator = function() {
    function BufferWhenOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    BufferWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $3dcd642784b5f5f4$var$BufferWhenSubscriber(subscriber, this.closingSelector));
    };
    return BufferWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3dcd642784b5f5f4$var$BufferWhenSubscriber = function(_super) {
    $3dcd642784b5f5f4$var$__extends(BufferWhenSubscriber, _super);
    function BufferWhenSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.closingSelector = closingSelector;
        this.subscribing = false;
        this.openBuffer();
    }
    BufferWhenSubscriber.prototype._next = function(value) {
        this.buffer.push(value);
    };
    BufferWhenSubscriber.prototype._complete = function() {
        var buffer = this.buffer;
        if (buffer) this.destination.next(buffer);
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ BufferWhenSubscriber.prototype._unsubscribe = function() {
        this.buffer = null;
        this.subscribing = false;
    };
    BufferWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openBuffer();
    };
    BufferWhenSubscriber.prototype.notifyComplete = function() {
        if (this.subscribing) this.complete();
        else this.openBuffer();
    };
    BufferWhenSubscriber.prototype.openBuffer = function() {
        var closingSubscription = this.closingSubscription;
        if (closingSubscription) {
            this.remove(closingSubscription);
            closingSubscription.unsubscribe();
        }
        var buffer = this.buffer;
        if (this.buffer) this.destination.next(buffer);
        this.buffer = [];
        var closingNotifier = $aRdp2.tryCatch(this.closingSelector)();
        if (closingNotifier === $iMtch.errorObject) this.error($iMtch.errorObject.e);
        else {
            closingSubscription = new $9P4lO.Subscription();
            this.closingSubscription = closingSubscription;
            this.add(closingSubscription);
            this.subscribing = true;
            closingSubscription.add($863V0.subscribeToResult(this, closingNotifier));
            this.subscribing = false;
        }
    };
    return BufferWhenSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=bufferWhen.js.map

});

parcelRegister("fKaLK", function(module, exports) {
"use strict";
var $b763816c54d82f3d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hmT2x = parcelRequire("hmT2x");


var $cH4eu = parcelRequire("cH4eu");


var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

var $b763816c54d82f3d$var$none = {};
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */ function $b763816c54d82f3d$var$combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var project = null;
    if (typeof observables[observables.length - 1] === 'function') project = observables.pop();
    // if the first and only other argument besides the resultSelector is an array
    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
    if (observables.length === 1 && $cH4eu.isArray(observables[0])) observables = observables[0].slice();
    return function(source) {
        return source.lift.call(new $hmT2x.ArrayObservable([
            source
        ].concat(observables)), new $b763816c54d82f3d$var$CombineLatestOperator(project));
    };
}
module.exports.combineLatest = $b763816c54d82f3d$var$combineLatest;
var $b763816c54d82f3d$var$CombineLatestOperator = function() {
    function CombineLatestOperator(project) {
        this.project = project;
    }
    CombineLatestOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $b763816c54d82f3d$var$CombineLatestSubscriber(subscriber, this.project));
    };
    return CombineLatestOperator;
}();
module.exports.CombineLatestOperator = $b763816c54d82f3d$var$CombineLatestOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $b763816c54d82f3d$var$CombineLatestSubscriber = function(_super) {
    $b763816c54d82f3d$var$__extends(CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, project) {
        _super.call(this, destination);
        this.project = project;
        this.active = 0;
        this.values = [];
        this.observables = [];
    }
    CombineLatestSubscriber.prototype._next = function(observable) {
        this.values.push($b763816c54d82f3d$var$none);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            this.active = len;
            this.toRespond = len;
            for(var i = 0; i < len; i++){
                var observable = observables[i];
                this.add($863V0.subscribeToResult(this, observable, observable, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function(unused) {
        if ((this.active -= 1) === 0) this.destination.complete();
    };
    CombineLatestSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond ? 0 : oldVal === $b763816c54d82f3d$var$none ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.project) this._tryProject(values);
            else this.destination.next(values.slice());
        }
    };
    CombineLatestSubscriber.prototype._tryProject = function(values) {
        var result;
        try {
            result = this.project.apply(this, values);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}($hmcLb.OuterSubscriber);
module.exports.CombineLatestSubscriber = $b763816c54d82f3d$var$CombineLatestSubscriber; //# sourceMappingURL=combineLatest.js.map

});

parcelRegister("krMWu", function(module, exports) {
"use strict";
var $ee2c4b312bcc6775$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/**
 * Emits a value from the source Observable only after a particular time span
 * determined by another Observable has passed without another source emission.
 *
 * <span class="informal">It's like {@link debounceTime}, but the time span of
 * emission silence is determined by a second Observable.</span>
 *
 * <img src="./img/debounce.png" width="100%">
 *
 * `debounce` delays values emitted by the source Observable, but drops previous
 * pending delayed emissions if a new value arrives on the source Observable.
 * This operator keeps track of the most recent value from the source
 * Observable, and spawns a duration Observable by calling the
 * `durationSelector` function. The value is emitted only when the duration
 * Observable emits a value or completes, and if no other value was emitted on
 * the source Observable since the duration Observable was spawned. If a new
 * value appears before the duration Observable emits, the previous value will
 * be dropped and will not be emitted on the output Observable.
 *
 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
 * delay-like operator since output emissions do not necessarily occur at the
 * same time as they did on the source Observable.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the timeout
 * duration for each source value, returned as an Observable or a Promise.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified duration Observable returned by
 * `durationSelector`, and may drop some values if they occur too frequently.
 * @method debounce
 * @owner Observable
 */ function $ee2c4b312bcc6775$var$debounce(durationSelector) {
    return function(source) {
        return source.lift(new $ee2c4b312bcc6775$var$DebounceOperator(durationSelector));
    };
}
module.exports.debounce = $ee2c4b312bcc6775$var$debounce;
var $ee2c4b312bcc6775$var$DebounceOperator = function() {
    function DebounceOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    DebounceOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $ee2c4b312bcc6775$var$DebounceSubscriber(subscriber, this.durationSelector));
    };
    return DebounceOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ee2c4b312bcc6775$var$DebounceSubscriber = function(_super) {
    $ee2c4b312bcc6775$var$__extends(DebounceSubscriber, _super);
    function DebounceSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.durationSelector = durationSelector;
        this.hasValue = false;
        this.durationSubscription = null;
    }
    DebounceSubscriber.prototype._next = function(value) {
        try {
            var result = this.durationSelector.call(this, value);
            if (result) this._tryNext(value, result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    DebounceSubscriber.prototype._complete = function() {
        this.emitValue();
        this.destination.complete();
    };
    DebounceSubscriber.prototype._tryNext = function(value, duration) {
        var subscription = this.durationSubscription;
        this.value = value;
        this.hasValue = true;
        if (subscription) {
            subscription.unsubscribe();
            this.remove(subscription);
        }
        subscription = $863V0.subscribeToResult(this, duration);
        if (!subscription.closed) this.add(this.durationSubscription = subscription);
    };
    DebounceSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    DebounceSubscriber.prototype.notifyComplete = function() {
        this.emitValue();
    };
    DebounceSubscriber.prototype.emitValue = function() {
        if (this.hasValue) {
            var value = this.value;
            var subscription = this.durationSubscription;
            if (subscription) {
                this.durationSubscription = null;
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.value = null;
            this.hasValue = false;
            _super.prototype._next.call(this, value);
        }
    };
    return DebounceSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=debounce.js.map

});

parcelRegister("5CHAu", function(module, exports) {
"use strict";
var $41824ff6ed50911a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $1pK8e = parcelRequire("1pK8e");


var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */ function $41824ff6ed50911a$var$delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return new $41824ff6ed50911a$var$SubscriptionDelayObservable(source, subscriptionDelay).lift(new $41824ff6ed50911a$var$DelayWhenOperator(delayDurationSelector));
    };
    return function(source) {
        return source.lift(new $41824ff6ed50911a$var$DelayWhenOperator(delayDurationSelector));
    };
}
module.exports.delayWhen = $41824ff6ed50911a$var$delayWhen;
var $41824ff6ed50911a$var$DelayWhenOperator = function() {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $41824ff6ed50911a$var$DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $41824ff6ed50911a$var$DelayWhenSubscriber = function(_super) {
    $41824ff6ed50911a$var$__extends(DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        _super.call(this, destination);
        this.delayDurationSelector = delayDurationSelector;
        this.completed = false;
        this.delayNotifierSubscriptions = [];
        this.values = [];
    }
    DelayWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) this.destination.next(value);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function(value) {
        try {
            var delayNotifier = this.delayDurationSelector(value);
            if (delayNotifier) this.tryDelay(delayNotifier, value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function() {
        this.completed = true;
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function(subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        var value = null;
        if (subscriptionIdx !== -1) {
            value = this.values[subscriptionIdx];
            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
            this.values.splice(subscriptionIdx, 1);
        }
        return value;
    };
    DelayWhenSubscriber.prototype.tryDelay = function(delayNotifier, value) {
        var notifierSubscription = $863V0.subscribeToResult(this, delayNotifier, value);
        if (notifierSubscription && !notifierSubscription.closed) {
            this.add(notifierSubscription);
            this.delayNotifierSubscriptions.push(notifierSubscription);
        }
        this.values.push(value);
    };
    DelayWhenSubscriber.prototype.tryComplete = function() {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) this.destination.complete();
    };
    return DelayWhenSubscriber;
}($hmcLb.OuterSubscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $41824ff6ed50911a$var$SubscriptionDelayObservable = function(_super) {
    $41824ff6ed50911a$var$__extends(SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(/** @deprecated internal use only */ source, subscriptionDelay) {
        _super.call(this);
        this.source = source;
        this.subscriptionDelay = subscriptionDelay;
    }
    /** @deprecated internal use only */ SubscriptionDelayObservable.prototype._subscribe = function(subscriber) {
        this.subscriptionDelay.subscribe(new $41824ff6ed50911a$var$SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}($1pK8e.Observable);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $41824ff6ed50911a$var$SubscriptionDelaySubscriber = function(_super) {
    $41824ff6ed50911a$var$__extends(SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        _super.call(this);
        this.parent = parent;
        this.source = source;
        this.sourceSubscribed = false;
    }
    SubscriptionDelaySubscriber.prototype._next = function(unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function(err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function() {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function() {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=delayWhen.js.map

});

parcelRegister("lbCzi", function(module, exports) {
"use strict";
var $f6c88aed6503c579$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/**
 * Converts an Observable of {@link Notification} objects into the emissions
 * that they represent.
 *
 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
 *
 * <img src="./img/dematerialize.png" width="100%">
 *
 * `dematerialize` is assumed to operate an Observable that only emits
 * {@link Notification} objects as `next` emissions, and does not emit any
 * `error`. Such Observable is the output of a `materialize` operation. Those
 * notifications are then unwrapped using the metadata they contain, and emitted
 * as `next`, `error`, and `complete` on the output Observable.
 *
 * Use this operator in conjunction with {@link materialize}.
 *
 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
 * var notifA = new Rx.Notification('N', 'A');
 * var notifB = new Rx.Notification('N', 'B');
 * var notifE = new Rx.Notification('E', void 0,
 *   new TypeError('x.toUpperCase is not a function')
 * );
 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
 * var upperCase = materialized.dematerialize();
 * upperCase.subscribe(x => console.log(x), e => console.error(e));
 *
 * // Results in:
 * // A
 * // B
 * // TypeError: x.toUpperCase is not a function
 *
 * @see {@link Notification}
 * @see {@link materialize}
 *
 * @return {Observable} An Observable that emits items and notifications
 * embedded in Notification objects emitted by the source Observable.
 * @method dematerialize
 * @owner Observable
 */ function $f6c88aed6503c579$var$dematerialize() {
    return function dematerializeOperatorFunction(source) {
        return source.lift(new $f6c88aed6503c579$var$DeMaterializeOperator());
    };
}
module.exports.dematerialize = $f6c88aed6503c579$var$dematerialize;
var $f6c88aed6503c579$var$DeMaterializeOperator = function() {
    function DeMaterializeOperator() {}
    DeMaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $f6c88aed6503c579$var$DeMaterializeSubscriber(subscriber));
    };
    return DeMaterializeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $f6c88aed6503c579$var$DeMaterializeSubscriber = function(_super) {
    $f6c88aed6503c579$var$__extends(DeMaterializeSubscriber, _super);
    function DeMaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    DeMaterializeSubscriber.prototype._next = function(value) {
        value.observe(this.destination);
    };
    return DeMaterializeSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=dematerialize.js.map

});

parcelRegister("8NmrP", function(module, exports) {
"use strict";
var $6674500762e96fb9$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

var $2e08b9bf86d2ca0a$export$ac57f2e66ff143c0;
var $2e08b9bf86d2ca0a$export$bdf4ff5a442cbbc5;
"use strict";

var $1pGyo = parcelRequire("1pGyo");

function $2e08b9bf86d2ca0a$var$minimalSetImpl() {
    // THIS IS NOT a full impl of Set, this is just the minimum
    // bits of functionality we need for this library.
    return function() {
        function MinimalSet() {
            this._values = [];
        }
        MinimalSet.prototype.add = function(value) {
            if (!this.has(value)) this._values.push(value);
        };
        MinimalSet.prototype.has = function(value) {
            return this._values.indexOf(value) !== -1;
        };
        Object.defineProperty(MinimalSet.prototype, "size", {
            get: function() {
                return this._values.length;
            },
            enumerable: true,
            configurable: true
        });
        MinimalSet.prototype.clear = function() {
            this._values.length = 0;
        };
        return MinimalSet;
    }();
}
$2e08b9bf86d2ca0a$export$ac57f2e66ff143c0 = $2e08b9bf86d2ca0a$var$minimalSetImpl;
$2e08b9bf86d2ca0a$export$bdf4ff5a442cbbc5 = $1pGyo.root.Set || $2e08b9bf86d2ca0a$var$minimalSetImpl(); //# sourceMappingURL=Set.js.map


/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
 *
 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
 * source observable directly with an equality check against previous values.
 *
 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
 *
 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
 * that the internal `Set` can be "flushed", basically clearing it of values.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
 *   .distinct()
 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
 *
 * @example <caption>An example using a keySelector function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     .distinct((p: Person) => p.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 *
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinct
 * @owner Observable
 */ function $6674500762e96fb9$var$distinct(keySelector, flushes) {
    return function(source) {
        return source.lift(new $6674500762e96fb9$var$DistinctOperator(keySelector, flushes));
    };
}
module.exports.distinct = $6674500762e96fb9$var$distinct;
var $6674500762e96fb9$var$DistinctOperator = function() {
    function DistinctOperator(keySelector, flushes) {
        this.keySelector = keySelector;
        this.flushes = flushes;
    }
    DistinctOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $6674500762e96fb9$var$DistinctSubscriber(subscriber, this.keySelector, this.flushes));
    };
    return DistinctOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $6674500762e96fb9$var$DistinctSubscriber = function(_super) {
    $6674500762e96fb9$var$__extends(DistinctSubscriber, _super);
    function DistinctSubscriber(destination, keySelector, flushes) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.values = new $2e08b9bf86d2ca0a$export$bdf4ff5a442cbbc5();
        if (flushes) this.add($863V0.subscribeToResult(this, flushes));
    }
    DistinctSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values.clear();
    };
    DistinctSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DistinctSubscriber.prototype._next = function(value) {
        if (this.keySelector) this._useKeySelector(value);
        else this._finalizeNext(value, value);
    };
    DistinctSubscriber.prototype._useKeySelector = function(value) {
        var key;
        var destination = this.destination;
        try {
            key = this.keySelector(value);
        } catch (err) {
            destination.error(err);
            return;
        }
        this._finalizeNext(key, value);
    };
    DistinctSubscriber.prototype._finalizeNext = function(key, value) {
        var values = this.values;
        if (!values.has(key)) {
            values.add(key);
            this.destination.next(value);
        }
    };
    return DistinctSubscriber;
}($hmcLb.OuterSubscriber);
module.exports.DistinctSubscriber = $6674500762e96fb9$var$DistinctSubscriber; //# sourceMappingURL=distinct.js.map

});

parcelRegister("fKoPv", function(module, exports) {
"use strict";
var $b76e6996330d7173$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $atSr0 = parcelRequire("atSr0");

/**
 * Emits the single value at the specified `index` in a sequence of emissions
 * from the source Observable.
 *
 * <span class="informal">Emits only the i-th value, then completes.</span>
 *
 * <img src="./img/elementAt.png" width="100%">
 *
 * `elementAt` returns an Observable that emits the item at the specified
 * `index` in the source Observable, or a default value if that `index` is out
 * of range and the `default` argument is provided. If the `default` argument is
 * not given and the `index` is out of range, the output Observable will emit an
 * `ArgumentOutOfRangeError` error.
 *
 * @example <caption>Emit only the third click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.elementAt(2);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // click 1 = nothing
 * // click 2 = nothing
 * // click 3 = MouseEvent object logged to console
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link skip}
 * @see {@link single}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
 * Observable has completed before emitting the i-th `next` notification.
 *
 * @param {number} index Is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {T} [defaultValue] The default value returned for missing indices.
 * @return {Observable} An Observable that emits a single item, if it is found.
 * Otherwise, will emit the default value if given. If not, then emits an error.
 * @method elementAt
 * @owner Observable
 */ function $b76e6996330d7173$var$elementAt(index, defaultValue) {
    return function(source) {
        return source.lift(new $b76e6996330d7173$var$ElementAtOperator(index, defaultValue));
    };
}
module.exports.elementAt = $b76e6996330d7173$var$elementAt;
var $b76e6996330d7173$var$ElementAtOperator = function() {
    function ElementAtOperator(index, defaultValue) {
        this.index = index;
        this.defaultValue = defaultValue;
        if (index < 0) throw new $atSr0.ArgumentOutOfRangeError;
    }
    ElementAtOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $b76e6996330d7173$var$ElementAtSubscriber(subscriber, this.index, this.defaultValue));
    };
    return ElementAtOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $b76e6996330d7173$var$ElementAtSubscriber = function(_super) {
    $b76e6996330d7173$var$__extends(ElementAtSubscriber, _super);
    function ElementAtSubscriber(destination, index, defaultValue) {
        _super.call(this, destination);
        this.index = index;
        this.defaultValue = defaultValue;
    }
    ElementAtSubscriber.prototype._next = function(x) {
        if (this.index-- === 0) {
            this.destination.next(x);
            this.destination.complete();
        }
    };
    ElementAtSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.index >= 0) {
            if (typeof this.defaultValue !== 'undefined') destination.next(this.defaultValue);
            else destination.error(new $atSr0.ArgumentOutOfRangeError);
        }
        destination.complete();
    };
    return ElementAtSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=elementAt.js.map

});

parcelRegister("9tnen", function(module, exports) {
"use strict";
var $6e58d7acea5ce63a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/**
 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
 *
 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
 *  Observable.of(1, 2, 3, 4, 5, 6)
 *     .every(x => x < 5)
 *     .subscribe(x => console.log(x)); // -> false
 *
 * @param {function} predicate A function for determining if an item meets a specified condition.
 * @param {any} [thisArg] Optional object to use for `this` in the callback.
 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
 * @method every
 * @owner Observable
 */ function $6e58d7acea5ce63a$var$every(predicate, thisArg) {
    return function(source) {
        return source.lift(new $6e58d7acea5ce63a$var$EveryOperator(predicate, thisArg, source));
    };
}
module.exports.every = $6e58d7acea5ce63a$var$every;
var $6e58d7acea5ce63a$var$EveryOperator = function() {
    function EveryOperator(predicate, thisArg, source) {
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
    }
    EveryOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $6e58d7acea5ce63a$var$EverySubscriber(observer, this.predicate, this.thisArg, this.source));
    };
    return EveryOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $6e58d7acea5ce63a$var$EverySubscriber = function(_super) {
    $6e58d7acea5ce63a$var$__extends(EverySubscriber, _super);
    function EverySubscriber(destination, predicate, thisArg, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
        this.index = 0;
        this.thisArg = thisArg || this;
    }
    EverySubscriber.prototype.notifyComplete = function(everyValueMatch) {
        this.destination.next(everyValueMatch);
        this.destination.complete();
    };
    EverySubscriber.prototype._next = function(value) {
        var result = false;
        try {
            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (!result) this.notifyComplete(false);
    };
    EverySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return EverySubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=every.js.map

});

parcelRegister("ajXCP", function(module, exports) {
"use strict";
var $7839ee133c359c2f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/**
 * Converts a higher-order Observable into a first-order Observable by dropping
 * inner Observables while the previous inner Observable has not yet completed.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * next inner Observables while the current inner is still executing.</span>
 *
 * <img src="./img/exhaust.png" width="100%">
 *
 * `exhaust` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable begins emitting the items emitted by that
 * inner Observable. So far, it behaves like {@link mergeAll}. However,
 * `exhaust` ignores every new inner Observable if the previous Observable has
 * not yet completed. Once that one completes, it will accept and flatten the
 * next inner Observable and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
 * var result = higherOrder.exhaust();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link switch}
 * @see {@link mergeAll}
 * @see {@link exhaustMap}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
 * exclusively until it completes before subscribing to the next.
 * @method exhaust
 * @owner Observable
 */ function $7839ee133c359c2f$var$exhaust() {
    return function(source) {
        return source.lift(new $7839ee133c359c2f$var$SwitchFirstOperator());
    };
}
module.exports.exhaust = $7839ee133c359c2f$var$exhaust;
var $7839ee133c359c2f$var$SwitchFirstOperator = function() {
    function SwitchFirstOperator() {}
    SwitchFirstOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7839ee133c359c2f$var$SwitchFirstSubscriber(subscriber));
    };
    return SwitchFirstOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7839ee133c359c2f$var$SwitchFirstSubscriber = function(_super) {
    $7839ee133c359c2f$var$__extends(SwitchFirstSubscriber, _super);
    function SwitchFirstSubscriber(destination) {
        _super.call(this, destination);
        this.hasCompleted = false;
        this.hasSubscription = false;
    }
    SwitchFirstSubscriber.prototype._next = function(value) {
        if (!this.hasSubscription) {
            this.hasSubscription = true;
            this.add($863V0.subscribeToResult(this, value));
        }
    };
    SwitchFirstSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (!this.hasSubscription) this.destination.complete();
    };
    SwitchFirstSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) this.destination.complete();
    };
    return SwitchFirstSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=exhaust.js.map

});

parcelRegister("4LCEp", function(module, exports) {
"use strict";
var $3789886ee1df175e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable only if the previous projected Observable has completed.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link exhaust}.</span>
 *
 * <img src="./img/exhaustMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. When it projects a source value to
 * an Observable, the output Observable begins emitting the items emitted by
 * that projected Observable. However, `exhaustMap` ignores every new projected
 * Observable if the previous projected Observable has not yet completed. Once
 * that one completes, it will accept and flatten the next projected Observable
 * and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaust}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable containing projected Observables
 * of each item of the source, ignoring projected Observables that start before
 * their preceding Observable has completed.
 * @method exhaustMap
 * @owner Observable
 */ function $3789886ee1df175e$var$exhaustMap(project, resultSelector) {
    return function(source) {
        return source.lift(new $3789886ee1df175e$var$SwitchFirstMapOperator(project, resultSelector));
    };
}
module.exports.exhaustMap = $3789886ee1df175e$var$exhaustMap;
var $3789886ee1df175e$var$SwitchFirstMapOperator = function() {
    function SwitchFirstMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchFirstMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $3789886ee1df175e$var$SwitchFirstMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchFirstMapOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3789886ee1df175e$var$SwitchFirstMapSubscriber = function(_super) {
    $3789886ee1df175e$var$__extends(SwitchFirstMapSubscriber, _super);
    function SwitchFirstMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.hasSubscription = false;
        this.hasCompleted = false;
        this.index = 0;
    }
    SwitchFirstMapSubscriber.prototype._next = function(value) {
        if (!this.hasSubscription) this.tryNext(value);
    };
    SwitchFirstMapSubscriber.prototype.tryNext = function(value) {
        var index = this.index++;
        var destination = this.destination;
        try {
            var result = this.project(value, index);
            this.hasSubscription = true;
            this.add($863V0.subscribeToResult(this, result, value, index));
        } catch (err) {
            destination.error(err);
        }
    };
    SwitchFirstMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (!this.hasSubscription) this.destination.complete();
    };
    SwitchFirstMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
        else destination.next(innerValue);
    };
    SwitchFirstMapSubscriber.prototype.trySelectResult = function(outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        try {
            var result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
            destination.next(result);
        } catch (err) {
            destination.error(err);
        }
    };
    SwitchFirstMapSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    SwitchFirstMapSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) this.destination.complete();
    };
    return SwitchFirstMapSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=exhaustMap.js.map

});

parcelRegister("cWC1J", function(module, exports) {
"use strict";
var $96c8662f7d76ccf8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aRdp2 = parcelRequire("aRdp2");


var $iMtch = parcelRequire("iMtch");


var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/* tslint:enable:max-line-length */ /**
 * Recursively projects each source value to an Observable which is merged in
 * the output Observable.
 *
 * <span class="informal">It's similar to {@link mergeMap}, but applies the
 * projection function to every source value as well as every output value.
 * It's recursive.</span>
 *
 * <img src="./img/expand.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger. *Expand* will re-emit on the output
 * Observable every source value. Then, each output value is given to the
 * `project` function which returns an inner Observable to be merged on the
 * output Observable. Those output values resulting from the projection are also
 * given to the `project` function to produce new output values. This is how
 * *expand* behaves recursively.
 *
 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var powersOfTwo = clicks
 *   .mapTo(1)
 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
 *   .take(10);
 * powersOfTwo.subscribe(x => console.log(x));
 *
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 *
 * @param {function(value: T, index: number) => Observable} project A function
 * that, when applied to an item emitted by the source or the output Observable,
 * returns an Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each projected inner Observable.
 * @return {Observable} An Observable that emits the source values and also
 * result of applying the projection function to each value emitted on the
 * output Observable and and merging the results of the Observables obtained
 * from this transformation.
 * @method expand
 * @owner Observable
 */ function $96c8662f7d76ccf8$var$expand(project, concurrent, scheduler) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (scheduler === void 0) scheduler = undefined;
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return function(source) {
        return source.lift(new $96c8662f7d76ccf8$var$ExpandOperator(project, concurrent, scheduler));
    };
}
module.exports.expand = $96c8662f7d76ccf8$var$expand;
var $96c8662f7d76ccf8$var$ExpandOperator = function() {
    function ExpandOperator(project, concurrent, scheduler) {
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
    }
    ExpandOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $96c8662f7d76ccf8$var$ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
    };
    return ExpandOperator;
}();
module.exports.ExpandOperator = $96c8662f7d76ccf8$var$ExpandOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $96c8662f7d76ccf8$var$ExpandSubscriber = function(_super) {
    $96c8662f7d76ccf8$var$__extends(ExpandSubscriber, _super);
    function ExpandSubscriber(destination, project, concurrent, scheduler) {
        _super.call(this, destination);
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
        this.index = 0;
        this.active = 0;
        this.hasCompleted = false;
        if (concurrent < Number.POSITIVE_INFINITY) this.buffer = [];
    }
    ExpandSubscriber.dispatch = function(arg) {
        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
        subscriber.subscribeToProjection(result, value, index);
    };
    ExpandSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (destination.closed) {
            this._complete();
            return;
        }
        var index = this.index++;
        if (this.active < this.concurrent) {
            destination.next(value);
            var result = $aRdp2.tryCatch(this.project)(value, index);
            if (result === $iMtch.errorObject) destination.error($iMtch.errorObject.e);
            else if (!this.scheduler) this.subscribeToProjection(result, value, index);
            else {
                var state = {
                    subscriber: this,
                    result: result,
                    value: value,
                    index: index
                };
                this.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
            }
        } else this.buffer.push(value);
    };
    ExpandSubscriber.prototype.subscribeToProjection = function(result, value, index) {
        this.active++;
        this.add($863V0.subscribeToResult(this, result, value, index));
    };
    ExpandSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.hasCompleted && this.active === 0) this.destination.complete();
    };
    ExpandSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._next(innerValue);
    };
    ExpandSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer && buffer.length > 0) this._next(buffer.shift());
        if (this.hasCompleted && this.active === 0) this.destination.complete();
    };
    return ExpandSubscriber;
}($hmcLb.OuterSubscriber);
module.exports.ExpandSubscriber = $96c8662f7d76ccf8$var$ExpandSubscriber; //# sourceMappingURL=expand.js.map

});

parcelRegister("2FoNr", function(module, exports) {
"use strict";
var $1f12a5236175921b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $9P4lO = parcelRequire("9P4lO");

/**
 * Returns an Observable that mirrors the source Observable, but will call a specified function when
 * the source terminates on complete or error.
 * @param {function} callback Function to be called when source terminates.
 * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
 * @method finally
 * @owner Observable
 */ function $1f12a5236175921b$var$finalize(callback) {
    return function(source) {
        return source.lift(new $1f12a5236175921b$var$FinallyOperator(callback));
    };
}
module.exports.finalize = $1f12a5236175921b$var$finalize;
var $1f12a5236175921b$var$FinallyOperator = function() {
    function FinallyOperator(callback) {
        this.callback = callback;
    }
    FinallyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $1f12a5236175921b$var$FinallySubscriber(subscriber, this.callback));
    };
    return FinallyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1f12a5236175921b$var$FinallySubscriber = function(_super) {
    $1f12a5236175921b$var$__extends(FinallySubscriber, _super);
    function FinallySubscriber(destination, callback) {
        _super.call(this, destination);
        this.add(new $9P4lO.Subscription(callback));
    }
    return FinallySubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=finalize.js.map

});

parcelRegister("gCYzh", function(module, exports) {
"use strict";
var $c1af2d7c28d91e2d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/**
 * Emits only the first value emitted by the source Observable that meets some
 * condition.
 *
 * <span class="informal">Finds the first value that passes some test and emits
 * that.</span>
 *
 * <img src="./img/find.png" width="100%">
 *
 * `find` searches for the first item in the source Observable that matches the
 * specified condition embodied by the `predicate`, and returns the first
 * occurrence in the source. Unlike {@link first}, the `predicate` is required
 * in `find`, and does not emit an error if a valid value is not found.
 *
 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link first}
 * @see {@link findIndex}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable<T>} An Observable of the first item that matches the
 * condition.
 * @method find
 * @owner Observable
 */ function $c1af2d7c28d91e2d$var$find(predicate, thisArg) {
    if (typeof predicate !== 'function') throw new TypeError('predicate is not a function');
    return function(source) {
        return source.lift(new $c1af2d7c28d91e2d$var$FindValueOperator(predicate, source, false, thisArg));
    };
}
module.exports.find = $c1af2d7c28d91e2d$var$find;
var $c1af2d7c28d91e2d$var$FindValueOperator = function() {
    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
    }
    FindValueOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $c1af2d7c28d91e2d$var$FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
    };
    return FindValueOperator;
}();
module.exports.FindValueOperator = $c1af2d7c28d91e2d$var$FindValueOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $c1af2d7c28d91e2d$var$FindValueSubscriber = function(_super) {
    $c1af2d7c28d91e2d$var$__extends(FindValueSubscriber, _super);
    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
        this.index = 0;
    }
    FindValueSubscriber.prototype.notifyComplete = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    FindValueSubscriber.prototype._next = function(value) {
        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
        var index = this.index++;
        try {
            var result = predicate.call(thisArg || this, value, index, this.source);
            if (result) this.notifyComplete(this.yieldIndex ? index : value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    FindValueSubscriber.prototype._complete = function() {
        this.notifyComplete(this.yieldIndex ? -1 : undefined);
    };
    return FindValueSubscriber;
}($fNVRJ.Subscriber);
module.exports.FindValueSubscriber = $c1af2d7c28d91e2d$var$FindValueSubscriber; //# sourceMappingURL=find.js.map

});

parcelRegister("imhbM", function(module, exports) {
"use strict";
var $d5d79d70fed69444$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $7NVBc = parcelRequire("7NVBc");

/**
 * Emits only the first value (or the first value that meets some condition)
 * emitted by the source Observable.
 *
 * <span class="informal">Emits only the first value. Or emits only the first
 * value that passes some test.</span>
 *
 * <img src="./img/first.png" width="100%">
 *
 * If called with no arguments, `first` emits the first value of the source
 * Observable, then completes. If called with a `predicate` function, `first`
 * emits the first value of the source that matches the specified condition. It
 * may also take a `resultSelector` function to produce the output value from
 * the input value, and a `defaultValue` to emit in case the source completes
 * before it is able to emit a valid value. Throws an error if `defaultValue`
 * was not provided and a matching element is not found.
 *
 * @example <caption>Emit only the first click that happens on the DOM</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Emits the first click that happens on a DIV</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link take}
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
 * An optional function called with each item to test for condition matching.
 * @param {function(value: T, index: number): R} [resultSelector] A function to
 * produce the value on the output Observable based on the values
 * and the indices of the source Observable. The arguments passed to this
 * function are:
 * - `value`: the value that was emitted on the source.
 * - `index`: the "index" of the value from the source.
 * @param {R} [defaultValue] The default value emitted in case no valid value
 * was found on the source.
 * @return {Observable<T|R>} An Observable of the first item that matches the
 * condition.
 * @method first
 * @owner Observable
 */ function $d5d79d70fed69444$var$first(predicate, resultSelector, defaultValue) {
    return function(source) {
        return source.lift(new $d5d79d70fed69444$var$FirstOperator(predicate, resultSelector, defaultValue, source));
    };
}
module.exports.first = $d5d79d70fed69444$var$first;
var $d5d79d70fed69444$var$FirstOperator = function() {
    function FirstOperator(predicate, resultSelector, defaultValue, source) {
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
    }
    FirstOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $d5d79d70fed69444$var$FirstSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
    };
    return FirstOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d5d79d70fed69444$var$FirstSubscriber = function(_super) {
    $d5d79d70fed69444$var$__extends(FirstSubscriber, _super);
    function FirstSubscriber(destination, predicate, resultSelector, defaultValue, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
        this.index = 0;
        this.hasCompleted = false;
        this._emitted = false;
    }
    FirstSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this._tryPredicate(value, index);
        else this._emit(value, index);
    };
    FirstSubscriber.prototype._tryPredicate = function(value, index) {
        var result;
        try {
            result = this.predicate(value, index, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this._emit(value, index);
    };
    FirstSubscriber.prototype._emit = function(value, index) {
        if (this.resultSelector) {
            this._tryResultSelector(value, index);
            return;
        }
        this._emitFinal(value);
    };
    FirstSubscriber.prototype._tryResultSelector = function(value, index) {
        var result;
        try {
            result = this.resultSelector(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this._emitFinal(result);
    };
    FirstSubscriber.prototype._emitFinal = function(value) {
        var destination = this.destination;
        if (!this._emitted) {
            this._emitted = true;
            destination.next(value);
            destination.complete();
            this.hasCompleted = true;
        }
    };
    FirstSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (!this.hasCompleted && typeof this.defaultValue !== 'undefined') {
            destination.next(this.defaultValue);
            destination.complete();
        } else if (!this.hasCompleted) destination.error(new $7NVBc.EmptyError);
    };
    return FirstSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=first.js.map

});

parcelRegister("lPY1W", function(module, exports) {
"use strict";
var $fe5ced25851f3f16$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $9P4lO = parcelRequire("9P4lO");


var $1pK8e = parcelRequire("1pK8e");


var $gGP9M = parcelRequire("gGP9M");

var $cf1481cccbf6c845$export$a5c7b93649eaf8f8;
"use strict";

var $1pGyo = parcelRequire("1pGyo");

var $c997d283c93864b4$export$dd450425f6b4a07;
"use strict";
var $c997d283c93864b4$var$MapPolyfill = function() {
    function MapPolyfill() {
        this.size = 0;
        this._values = [];
        this._keys = [];
    }
    MapPolyfill.prototype.get = function(key) {
        var i = this._keys.indexOf(key);
        return i === -1 ? undefined : this._values[i];
    };
    MapPolyfill.prototype.set = function(key, value) {
        var i = this._keys.indexOf(key);
        if (i === -1) {
            this._keys.push(key);
            this._values.push(value);
            this.size++;
        } else this._values[i] = value;
        return this;
    };
    MapPolyfill.prototype.delete = function(key) {
        var i = this._keys.indexOf(key);
        if (i === -1) return false;
        this._values.splice(i, 1);
        this._keys.splice(i, 1);
        this.size--;
        return true;
    };
    MapPolyfill.prototype.clear = function() {
        this._keys.length = 0;
        this._values.length = 0;
        this.size = 0;
    };
    MapPolyfill.prototype.forEach = function(cb, thisArg) {
        for(var i = 0; i < this.size; i++)cb.call(thisArg, this._values[i], this._keys[i]);
    };
    return MapPolyfill;
}();
$c997d283c93864b4$export$dd450425f6b4a07 = $c997d283c93864b4$var$MapPolyfill; //# sourceMappingURL=MapPolyfill.js.map


$cf1481cccbf6c845$export$a5c7b93649eaf8f8 = $1pGyo.root.Map || function() {
    return $c997d283c93864b4$export$dd450425f6b4a07;
}(); //# sourceMappingURL=Map.js.map


var $f922551a0c052090$export$d3f0a24774bb4055;
"use strict";
var $f922551a0c052090$var$FastMap = function() {
    function FastMap() {
        this.values = {};
    }
    FastMap.prototype.delete = function(key) {
        this.values[key] = null;
        return true;
    };
    FastMap.prototype.set = function(key, value) {
        this.values[key] = value;
        return this;
    };
    FastMap.prototype.get = function(key) {
        return this.values[key];
    };
    FastMap.prototype.forEach = function(cb, thisArg) {
        var values = this.values;
        for(var key in values)if (values.hasOwnProperty(key) && values[key] !== null) cb.call(thisArg, values[key], key);
    };
    FastMap.prototype.clear = function() {
        this.values = {};
    };
    return FastMap;
}();
$f922551a0c052090$export$d3f0a24774bb4055 = $f922551a0c052090$var$FastMap; //# sourceMappingURL=FastMap.js.map


/* tslint:enable:max-line-length */ /**
 * Groups the items emitted by an Observable according to a specified criterion,
 * and emits these grouped items as `GroupedObservables`, one
 * {@link GroupedObservable} per group.
 *
 * <img src="./img/groupBy.png" width="100%">
 *
 * @example <caption>Group objects by id and return as array</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs3'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *     )
 *     .groupBy(p => p.id)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // [ { id: 1, name: 'aze1' },
 * //   { id: 1, name: 'erg1' },
 * //   { id: 1, name: 'df1' } ]
 * //
 * // [ { id: 2, name: 'sf2' },
 * //   { id: 2, name: 'dg2' },
 * //   { id: 2, name: 'sfqfb2' },
 * //   { id: 2, name: 'qsgqsfg2' } ]
 * //
 * // [ { id: 3, name: 'qfs3' } ]
 *
 * @example <caption>Pivot data on the id field</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs1'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *                   )
 *     .groupBy(p => p.id, p => p.name)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
 *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
 * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
 * // { id: 3, values: [ 'qfs1' ] }
 *
 * @param {function(value: T): K} keySelector A function that extracts the key
 * for each item.
 * @param {function(value: T): R} [elementSelector] A function that extracts the
 * return element for each item.
 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
 * A function that returns an Observable to determine how long each group should
 * exist.
 * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
 * GroupedObservables, each of which corresponds to a unique key value and each
 * of which emits those items from the source Observable that share that key
 * value.
 * @method groupBy
 * @owner Observable
 */ function $fe5ced25851f3f16$var$groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return function(source) {
        return source.lift(new $fe5ced25851f3f16$var$GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
    };
}
module.exports.groupBy = $fe5ced25851f3f16$var$groupBy;
var $fe5ced25851f3f16$var$GroupByOperator = function() {
    function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
    }
    GroupByOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $fe5ced25851f3f16$var$GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
    };
    return GroupByOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $fe5ced25851f3f16$var$GroupBySubscriber = function(_super) {
    $fe5ced25851f3f16$var$__extends(GroupBySubscriber, _super);
    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
        this.groups = null;
        this.attemptedToUnsubscribe = false;
        this.count = 0;
    }
    GroupBySubscriber.prototype._next = function(value) {
        var key;
        try {
            key = this.keySelector(value);
        } catch (err) {
            this.error(err);
            return;
        }
        this._group(value, key);
    };
    GroupBySubscriber.prototype._group = function(value, key) {
        var groups = this.groups;
        if (!groups) groups = this.groups = typeof key === 'string' ? new $f922551a0c052090$export$d3f0a24774bb4055() : new $cf1481cccbf6c845$export$a5c7b93649eaf8f8();
        var group = groups.get(key);
        var element;
        if (this.elementSelector) try {
            element = this.elementSelector(value);
        } catch (err) {
            this.error(err);
        }
        else element = value;
        if (!group) {
            group = this.subjectSelector ? this.subjectSelector() : new $gGP9M.Subject();
            groups.set(key, group);
            var groupedObservable = new $fe5ced25851f3f16$var$GroupedObservable(key, group, this);
            this.destination.next(groupedObservable);
            if (this.durationSelector) {
                var duration = void 0;
                try {
                    duration = this.durationSelector(new $fe5ced25851f3f16$var$GroupedObservable(key, group));
                } catch (err) {
                    this.error(err);
                    return;
                }
                this.add(duration.subscribe(new $fe5ced25851f3f16$var$GroupDurationSubscriber(key, group, this)));
            }
        }
        if (!group.closed) group.next(element);
    };
    GroupBySubscriber.prototype._error = function(err) {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function(group, key) {
                group.error(err);
            });
            groups.clear();
        }
        this.destination.error(err);
    };
    GroupBySubscriber.prototype._complete = function() {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function(group, key) {
                group.complete();
            });
            groups.clear();
        }
        this.destination.complete();
    };
    GroupBySubscriber.prototype.removeGroup = function(key) {
        this.groups.delete(key);
    };
    GroupBySubscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.attemptedToUnsubscribe = true;
            if (this.count === 0) _super.prototype.unsubscribe.call(this);
        }
    };
    return GroupBySubscriber;
}($fNVRJ.Subscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $fe5ced25851f3f16$var$GroupDurationSubscriber = function(_super) {
    $fe5ced25851f3f16$var$__extends(GroupDurationSubscriber, _super);
    function GroupDurationSubscriber(key, group, parent) {
        _super.call(this, group);
        this.key = key;
        this.group = group;
        this.parent = parent;
    }
    GroupDurationSubscriber.prototype._next = function(value) {
        this.complete();
    };
    /** @deprecated internal use only */ GroupDurationSubscriber.prototype._unsubscribe = function() {
        var _a = this, parent = _a.parent, key = _a.key;
        this.key = this.parent = null;
        if (parent) parent.removeGroup(key);
    };
    return GroupDurationSubscriber;
}($fNVRJ.Subscriber);
/**
 * An Observable representing values belonging to the same group represented by
 * a common key. The values emitted by a GroupedObservable come from the source
 * Observable. The common key is available as the field `key` on a
 * GroupedObservable instance.
 *
 * @class GroupedObservable<K, T>
 */ var $fe5ced25851f3f16$var$GroupedObservable = function(_super) {
    $fe5ced25851f3f16$var$__extends(GroupedObservable, _super);
    function GroupedObservable(key, groupSubject, refCountSubscription) {
        _super.call(this);
        this.key = key;
        this.groupSubject = groupSubject;
        this.refCountSubscription = refCountSubscription;
    }
    /** @deprecated internal use only */ GroupedObservable.prototype._subscribe = function(subscriber) {
        var subscription = new $9P4lO.Subscription();
        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
        if (refCountSubscription && !refCountSubscription.closed) subscription.add(new $fe5ced25851f3f16$var$InnerRefCountSubscription(refCountSubscription));
        subscription.add(groupSubject.subscribe(subscriber));
        return subscription;
    };
    return GroupedObservable;
}($1pK8e.Observable);
module.exports.GroupedObservable = $fe5ced25851f3f16$var$GroupedObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $fe5ced25851f3f16$var$InnerRefCountSubscription = function(_super) {
    $fe5ced25851f3f16$var$__extends(InnerRefCountSubscription, _super);
    function InnerRefCountSubscription(parent) {
        _super.call(this);
        this.parent = parent;
        parent.count++;
    }
    InnerRefCountSubscription.prototype.unsubscribe = function() {
        var parent = this.parent;
        if (!parent.closed && !this.closed) {
            _super.prototype.unsubscribe.call(this);
            parent.count -= 1;
            if (parent.count === 0 && parent.attemptedToUnsubscribe) parent.unsubscribe();
        }
    };
    return InnerRefCountSubscription;
}($9P4lO.Subscription); //# sourceMappingURL=groupBy.js.map

});

parcelRegister("9ZC39", function(module, exports) {
"use strict";
var $74675372646974bd$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $bGEdw = parcelRequire("bGEdw");

/**
 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
 *
 * <img src="./img/ignoreElements.png" width="100%">
 *
 * @return {Observable} An empty Observable that only calls `complete`
 * or `error`, based on which one is called by the source Observable.
 * @method ignoreElements
 * @owner Observable
 */ function $74675372646974bd$var$ignoreElements() {
    return function ignoreElementsOperatorFunction(source) {
        return source.lift(new $74675372646974bd$var$IgnoreElementsOperator());
    };
}
module.exports.ignoreElements = $74675372646974bd$var$ignoreElements;
var $74675372646974bd$var$IgnoreElementsOperator = function() {
    function IgnoreElementsOperator() {}
    IgnoreElementsOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $74675372646974bd$var$IgnoreElementsSubscriber(subscriber));
    };
    return IgnoreElementsOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $74675372646974bd$var$IgnoreElementsSubscriber = function(_super) {
    $74675372646974bd$var$__extends(IgnoreElementsSubscriber, _super);
    function IgnoreElementsSubscriber() {
        _super.apply(this, arguments);
    }
    IgnoreElementsSubscriber.prototype._next = function(unused) {
        $bGEdw.noop();
    };
    return IgnoreElementsSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=ignoreElements.js.map

});

parcelRegister("8ubGV", function(module, exports) {
"use strict";
var $62da31bb1ac67010$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

function $62da31bb1ac67010$var$isEmpty() {
    return function(source) {
        return source.lift(new $62da31bb1ac67010$var$IsEmptyOperator());
    };
}
module.exports.isEmpty = $62da31bb1ac67010$var$isEmpty;
var $62da31bb1ac67010$var$IsEmptyOperator = function() {
    function IsEmptyOperator() {}
    IsEmptyOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $62da31bb1ac67010$var$IsEmptySubscriber(observer));
    };
    return IsEmptyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $62da31bb1ac67010$var$IsEmptySubscriber = function(_super) {
    $62da31bb1ac67010$var$__extends(IsEmptySubscriber, _super);
    function IsEmptySubscriber(destination) {
        _super.call(this, destination);
    }
    IsEmptySubscriber.prototype.notifyComplete = function(isEmpty) {
        var destination = this.destination;
        destination.next(isEmpty);
        destination.complete();
    };
    IsEmptySubscriber.prototype._next = function(value) {
        this.notifyComplete(false);
    };
    IsEmptySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return IsEmptySubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=isEmpty.js.map

});

parcelRegister("696yK", function(module, exports) {
"use strict";
var $4798abefa3b7b846$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $7NVBc = parcelRequire("7NVBc");

/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits only the last item emitted by the source Observable.
 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
 * the last item from the source Observable, the resulting Observable will emit the last item
 * from the source Observable that satisfies the predicate.
 *
 * <img src="./img/last.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {function} predicate - The condition any source emitted item has to satisfy.
 * @return {Observable} An Observable that emits only the last item satisfying the given condition
 * from the source, or an NoSuchElementException if no such items are emitted.
 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
 * @method last
 * @owner Observable
 */ function $4798abefa3b7b846$var$last(predicate, resultSelector, defaultValue) {
    return function(source) {
        return source.lift(new $4798abefa3b7b846$var$LastOperator(predicate, resultSelector, defaultValue, source));
    };
}
module.exports.last = $4798abefa3b7b846$var$last;
var $4798abefa3b7b846$var$LastOperator = function() {
    function LastOperator(predicate, resultSelector, defaultValue, source) {
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
    }
    LastOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $4798abefa3b7b846$var$LastSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
    };
    return LastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $4798abefa3b7b846$var$LastSubscriber = function(_super) {
    $4798abefa3b7b846$var$__extends(LastSubscriber, _super);
    function LastSubscriber(destination, predicate, resultSelector, defaultValue, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
        this.hasValue = false;
        this.index = 0;
        if (typeof defaultValue !== 'undefined') {
            this.lastValue = defaultValue;
            this.hasValue = true;
        }
    }
    LastSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this._tryPredicate(value, index);
        else {
            if (this.resultSelector) {
                this._tryResultSelector(value, index);
                return;
            }
            this.lastValue = value;
            this.hasValue = true;
        }
    };
    LastSubscriber.prototype._tryPredicate = function(value, index) {
        var result;
        try {
            result = this.predicate(value, index, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            if (this.resultSelector) {
                this._tryResultSelector(value, index);
                return;
            }
            this.lastValue = value;
            this.hasValue = true;
        }
    };
    LastSubscriber.prototype._tryResultSelector = function(value, index) {
        var result;
        try {
            result = this.resultSelector(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.lastValue = result;
        this.hasValue = true;
    };
    LastSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.hasValue) {
            destination.next(this.lastValue);
            destination.complete();
        } else destination.error(new $7NVBc.EmptyError);
    };
    return LastSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=last.js.map

});

parcelRegister("lzXbg", function(module, exports) {
"use strict";
var $fb5ac5edc4cdb62d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/**
 * Emits the given constant value on the output Observable every time the source
 * Observable emits a value.
 *
 * <span class="informal">Like {@link map}, but it maps every source value to
 * the same output value every time.</span>
 *
 * <img src="./img/mapTo.png" width="100%">
 *
 * Takes a constant `value` as argument, and emits that whenever the source
 * Observable emits a value. In other words, ignores the actual source value,
 * and simply uses the emission moment to know when to emit the given `value`.
 *
 * @example <caption>Map every click to the string 'Hi'</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var greetings = clicks.mapTo('Hi');
 * greetings.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {any} value The value to map each source value to.
 * @return {Observable} An Observable that emits the given `value` every time
 * the source Observable emits something.
 * @method mapTo
 * @owner Observable
 */ function $fb5ac5edc4cdb62d$var$mapTo(value) {
    return function(source) {
        return source.lift(new $fb5ac5edc4cdb62d$var$MapToOperator(value));
    };
}
module.exports.mapTo = $fb5ac5edc4cdb62d$var$mapTo;
var $fb5ac5edc4cdb62d$var$MapToOperator = function() {
    function MapToOperator(value) {
        this.value = value;
    }
    MapToOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $fb5ac5edc4cdb62d$var$MapToSubscriber(subscriber, this.value));
    };
    return MapToOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $fb5ac5edc4cdb62d$var$MapToSubscriber = function(_super) {
    $fb5ac5edc4cdb62d$var$__extends(MapToSubscriber, _super);
    function MapToSubscriber(destination, value) {
        _super.call(this, destination);
        this.value = value;
    }
    MapToSubscriber.prototype._next = function(x) {
        this.destination.next(this.value);
    };
    return MapToSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=mapTo.js.map

});

parcelRegister("baU6e", function(module, exports) {
"use strict";
var $822c2515a693f343$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $1XTds = parcelRequire("1XTds");

/**
 * Represents all of the notifications from the source Observable as `next`
 * emissions marked with their original types within {@link Notification}
 * objects.
 *
 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
 * {@link Notification} objects, emitted as `next` on the output Observable.
 * </span>
 *
 * <img src="./img/materialize.png" width="100%">
 *
 * `materialize` returns an Observable that emits a `next` notification for each
 * `next`, `error`, or `complete` emission of the source Observable. When the
 * source Observable emits `complete`, the output Observable will emit `next` as
 * a Notification of type "complete", and then it will emit `complete` as well.
 * When the source Observable emits `error`, the output will emit `next` as a
 * Notification of type "error", and then `complete`.
 *
 * This operator is useful for producing metadata of the source Observable, to
 * be consumed as `next` emissions. Use it in conjunction with
 * {@link dematerialize}.
 *
 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
 * var upperCase = letters.map(x => x.toUpperCase());
 * var materialized = upperCase.materialize();
 * materialized.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
 * // - Notification {kind: "E", value: undefined, error: TypeError:
 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
 * //   [as project] (http://1…, hasValue: false}
 *
 * @see {@link Notification}
 * @see {@link dematerialize}
 *
 * @return {Observable<Notification<T>>} An Observable that emits
 * {@link Notification} objects that wrap the original emissions from the source
 * Observable with metadata.
 * @method materialize
 * @owner Observable
 */ function $822c2515a693f343$var$materialize() {
    return function materializeOperatorFunction(source) {
        return source.lift(new $822c2515a693f343$var$MaterializeOperator());
    };
}
module.exports.materialize = $822c2515a693f343$var$materialize;
var $822c2515a693f343$var$MaterializeOperator = function() {
    function MaterializeOperator() {}
    MaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $822c2515a693f343$var$MaterializeSubscriber(subscriber));
    };
    return MaterializeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $822c2515a693f343$var$MaterializeSubscriber = function(_super) {
    $822c2515a693f343$var$__extends(MaterializeSubscriber, _super);
    function MaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    MaterializeSubscriber.prototype._next = function(value) {
        this.destination.next($1XTds.Notification.createNext(value));
    };
    MaterializeSubscriber.prototype._error = function(err) {
        var destination = this.destination;
        destination.next($1XTds.Notification.createError(err));
        destination.complete();
    };
    MaterializeSubscriber.prototype._complete = function() {
        var destination = this.destination;
        destination.next($1XTds.Notification.createComplete());
        destination.complete();
    };
    return MaterializeSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=materialize.js.map

});

parcelRegister("6k8sk", function(module, exports) {
"use strict";
var $49ab2b7c9c29c8fb$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in the output Observable.
 *
 * <span class="informal">It's like {@link mergeMap}, but maps each value always
 * to the same inner Observable.</span>
 *
 * <img src="./img/mergeMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then merges those resulting Observables into one
 * single Observable, which is the output Observable.
 *
 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable.
 * @method mergeMapTo
 * @owner Observable
 */ function $49ab2b7c9c29c8fb$var$mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
        resultSelector = null;
    }
    return function(source) {
        return source.lift(new $49ab2b7c9c29c8fb$var$MergeMapToOperator(innerObservable, resultSelector, concurrent));
    };
}
module.exports.mergeMapTo = $49ab2b7c9c29c8fb$var$mergeMapTo;
// TODO: Figure out correct signature here: an Operator<Observable<T>, R>
//       needs to implement call(observer: Subscriber<R>): Subscriber<Observable<T>>
var $49ab2b7c9c29c8fb$var$MergeMapToOperator = function() {
    function MergeMapToOperator(ish, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapToOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $49ab2b7c9c29c8fb$var$MergeMapToSubscriber(observer, this.ish, this.resultSelector, this.concurrent));
    };
    return MergeMapToOperator;
}();
module.exports.MergeMapToOperator = $49ab2b7c9c29c8fb$var$MergeMapToOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $49ab2b7c9c29c8fb$var$MergeMapToSubscriber = function(_super) {
    $49ab2b7c9c29c8fb$var$__extends(MergeMapToSubscriber, _super);
    function MergeMapToSubscriber(destination, ish, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        _super.call(this, destination);
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapToSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) {
            var resultSelector = this.resultSelector;
            var index = this.index++;
            var ish = this.ish;
            var destination = this.destination;
            this.active++;
            this._innerSub(ish, destination, resultSelector, value, index);
        } else this.buffer.push(value);
    };
    MergeMapToSubscriber.prototype._innerSub = function(ish, destination, resultSelector, value, index) {
        this.add($863V0.subscribeToResult(this, ish, value, index));
    };
    MergeMapToSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
    };
    MergeMapToSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
        else destination.next(innerValue);
    };
    MergeMapToSubscriber.prototype.trySelectResult = function(outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        var result;
        try {
            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            destination.error(err);
            return;
        }
        destination.next(result);
    };
    MergeMapToSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    MergeMapToSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapToSubscriber;
}($hmcLb.OuterSubscriber);
module.exports.MergeMapToSubscriber = $49ab2b7c9c29c8fb$var$MergeMapToSubscriber; //# sourceMappingURL=mergeMapTo.js.map

});

parcelRegister("b0JAN", function(module, exports) {
"use strict";
var $80430f80981c548e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $aRdp2 = parcelRequire("aRdp2");


var $iMtch = parcelRequire("iMtch");


var $863V0 = parcelRequire("863V0");


var $hmcLb = parcelRequire("hmcLb");

/**
 * Applies an accumulator function over the source Observable where the
 * accumulator function itself returns an Observable, then each intermediate
 * Observable returned is merged into the output Observable.
 *
 * <span class="informal">It's like {@link scan}, but the Observables returned
 * by the accumulator are merged into the outer Observable.</span>
 *
 * @example <caption>Count the number of click events</caption>
 * const click$ = Rx.Observable.fromEvent(document, 'click');
 * const one$ = click$.mapTo(1);
 * const seed = 0;
 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
 * count$.subscribe(x => console.log(x));
 *
 * // Results:
 * 1
 * 2
 * 3
 * 4
 * // ...and so on for each click
 *
 * @param {function(acc: R, value: T): Observable<R>} accumulator
 * The accumulator function called on each source value.
 * @param seed The initial accumulation value.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
 * input Observables being subscribed to concurrently.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method mergeScan
 * @owner Observable
 */ function $80430f80981c548e$var$mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return function(source) {
        return source.lift(new $80430f80981c548e$var$MergeScanOperator(accumulator, seed, concurrent));
    };
}
module.exports.mergeScan = $80430f80981c548e$var$mergeScan;
var $80430f80981c548e$var$MergeScanOperator = function() {
    function MergeScanOperator(accumulator, seed, concurrent) {
        this.accumulator = accumulator;
        this.seed = seed;
        this.concurrent = concurrent;
    }
    MergeScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $80430f80981c548e$var$MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
    };
    return MergeScanOperator;
}();
module.exports.MergeScanOperator = $80430f80981c548e$var$MergeScanOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $80430f80981c548e$var$MergeScanSubscriber = function(_super) {
    $80430f80981c548e$var$__extends(MergeScanSubscriber, _super);
    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this.acc = acc;
        this.concurrent = concurrent;
        this.hasValue = false;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeScanSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) {
            var index = this.index++;
            var ish = $aRdp2.tryCatch(this.accumulator)(this.acc, value);
            var destination = this.destination;
            if (ish === $iMtch.errorObject) destination.error($iMtch.errorObject.e);
            else {
                this.active++;
                this._innerSub(ish, value, index);
            }
        } else this.buffer.push(value);
    };
    MergeScanSubscriber.prototype._innerSub = function(ish, value, index) {
        this.add($863V0.subscribeToResult(this, ish, value, index));
    };
    MergeScanSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
    };
    MergeScanSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var destination = this.destination;
        this.acc = innerValue;
        this.hasValue = true;
        destination.next(innerValue);
    };
    MergeScanSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
    };
    return MergeScanSubscriber;
}($hmcLb.OuterSubscriber);
module.exports.MergeScanSubscriber = $80430f80981c548e$var$MergeScanSubscriber; //# sourceMappingURL=mergeScan.js.map

});

parcelRegister("dtFo6", function(module, exports) {
"use strict";
var $9cfe168f2dfad987$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gGP9M = parcelRequire("gGP9M");


var $1pK8e = parcelRequire("1pK8e");


var $fNVRJ = parcelRequire("fNVRJ");


var $9P4lO = parcelRequire("9P4lO");


var $8nouZ = parcelRequire("8nouZ");

/**
 * @class ConnectableObservable<T>
 */ var $9cfe168f2dfad987$var$ConnectableObservable = function(_super) {
    $9cfe168f2dfad987$var$__extends(ConnectableObservable, _super);
    function ConnectableObservable(/** @deprecated internal use only */ source, /** @deprecated internal use only */ subjectFactory) {
        _super.call(this);
        this.source = source;
        this.subjectFactory = subjectFactory;
        /** @deprecated internal use only */ this._refCount = 0;
        this._isComplete = false;
    }
    /** @deprecated internal use only */ ConnectableObservable.prototype._subscribe = function(subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    /** @deprecated internal use only */ ConnectableObservable.prototype.getSubject = function() {
        var subject = this._subject;
        if (!subject || subject.isStopped) this._subject = this.subjectFactory();
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function() {
        var connection = this._connection;
        if (!connection) {
            this._isComplete = false;
            connection = this._connection = new $9P4lO.Subscription();
            connection.add(this.source.subscribe(new $9cfe168f2dfad987$var$ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = $9P4lO.Subscription.EMPTY;
            } else this._connection = connection;
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function() {
        return $8nouZ.refCount()(this);
    };
    return ConnectableObservable;
}($1pK8e.Observable);
module.exports.ConnectableObservable = $9cfe168f2dfad987$var$ConnectableObservable;
var $9cfe168f2dfad987$var$connectableProto = $9cfe168f2dfad987$var$ConnectableObservable.prototype;
module.exports.connectableObservableDescriptor = {
    operator: {
        value: null
    },
    _refCount: {
        value: 0,
        writable: true
    },
    _subject: {
        value: null,
        writable: true
    },
    _connection: {
        value: null,
        writable: true
    },
    _subscribe: {
        value: $9cfe168f2dfad987$var$connectableProto._subscribe
    },
    _isComplete: {
        value: $9cfe168f2dfad987$var$connectableProto._isComplete,
        writable: true
    },
    getSubject: {
        value: $9cfe168f2dfad987$var$connectableProto.getSubject
    },
    connect: {
        value: $9cfe168f2dfad987$var$connectableProto.connect
    },
    refCount: {
        value: $9cfe168f2dfad987$var$connectableProto.refCount
    }
};
var $9cfe168f2dfad987$var$ConnectableSubscriber = function(_super) {
    $9cfe168f2dfad987$var$__extends(ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    ConnectableSubscriber.prototype._error = function(err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function() {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ ConnectableSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) connection.unsubscribe();
        }
    };
    return ConnectableSubscriber;
}($gGP9M.SubjectSubscriber);
var $9cfe168f2dfad987$var$RefCountOperator = function() {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new $9cfe168f2dfad987$var$RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) refCounter.connection = connectable.connect();
        return subscription;
    };
    return RefCountOperator;
}();
var $9cfe168f2dfad987$var$RefCountSubscriber = function(_super) {
    $9cfe168f2dfad987$var$__extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) sharedConnection.unsubscribe();
    };
    return RefCountSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=ConnectableObservable.js.map

});

parcelRegister("kkbhK", function(module, exports) {
"use strict";
var $ecbe6ded00783f44$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8dG7b = parcelRequire("8dG7b");


var $cH4eu = parcelRequire("cH4eu");


var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/* tslint:enable:max-line-length */ /**
 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
 * that was passed.
 *
 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
 *
 * <img src="./img/onErrorResumeNext.png" width="100%">
 *
 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
 * as the source.
 *
 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
 * be happening until there is no more Observables left in the series, at which point returned Observable will
 * complete - even if the last subscribed stream ended with an error.
 *
 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
 * an error.
 *
 * Note that you do not get any access to errors emitted by the Observables. In particular do not
 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
 *
 *
 * @example <caption>Subscribe to the next Observable after map fails</caption>
 * Rx.Observable.of(1, 2, 3, 0)
 *   .map(x => {
 *       if (x === 0) { throw Error(); }
         return 10 / x;
 *   })
 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
 *   .subscribe(
 *     val => console.log(val),
 *     err => console.log(err),          // Will never be called.
 *     () => console.log('that\'s it!')
 *   );
 *
 * // Logs:
 * // 10
 * // 5
 * // 3.3333333333333335
 * // 1
 * // 2
 * // 3
 * // "that's it!"
 *
 * @see {@link concat}
 * @see {@link catch}
 *
 * @param {...ObservableInput} observables Observables passed either directly or as an array.
 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
 * to the next passed Observable and so on, until it completes or runs out of Observables.
 * @method onErrorResumeNext
 * @owner Observable
 */ function $ecbe6ded00783f44$var$onErrorResumeNext() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i - 0] = arguments[_i];
    if (nextSources.length === 1 && $cH4eu.isArray(nextSources[0])) nextSources = nextSources[0];
    return function(source) {
        return source.lift(new $ecbe6ded00783f44$var$OnErrorResumeNextOperator(nextSources));
    };
}
module.exports.onErrorResumeNext = $ecbe6ded00783f44$var$onErrorResumeNext;
/* tslint:enable:max-line-length */ function $ecbe6ded00783f44$var$onErrorResumeNextStatic() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i - 0] = arguments[_i];
    var source = null;
    if (nextSources.length === 1 && $cH4eu.isArray(nextSources[0])) nextSources = nextSources[0];
    source = nextSources.shift();
    return new $8dG7b.FromObservable(source, null).lift(new $ecbe6ded00783f44$var$OnErrorResumeNextOperator(nextSources));
}
module.exports.onErrorResumeNextStatic = $ecbe6ded00783f44$var$onErrorResumeNextStatic;
var $ecbe6ded00783f44$var$OnErrorResumeNextOperator = function() {
    function OnErrorResumeNextOperator(nextSources) {
        this.nextSources = nextSources;
    }
    OnErrorResumeNextOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $ecbe6ded00783f44$var$OnErrorResumeNextSubscriber(subscriber, this.nextSources));
    };
    return OnErrorResumeNextOperator;
}();
var $ecbe6ded00783f44$var$OnErrorResumeNextSubscriber = function(_super) {
    $ecbe6ded00783f44$var$__extends(OnErrorResumeNextSubscriber, _super);
    function OnErrorResumeNextSubscriber(destination, nextSources) {
        _super.call(this, destination);
        this.destination = destination;
        this.nextSources = nextSources;
    }
    OnErrorResumeNextSubscriber.prototype.notifyError = function(error, innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.notifyComplete = function(innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._error = function(err) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._complete = function() {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function() {
        var next = this.nextSources.shift();
        if (next) this.add($863V0.subscribeToResult(this, next));
        else this.destination.complete();
    };
    return OnErrorResumeNextSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=onErrorResumeNext.js.map

});

parcelRegister("3jLcS", function(module, exports) {
"use strict";
var $26a7c3b9c157c433$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/**
 * Groups pairs of consecutive emissions together and emits them as an array of
 * two values.
 *
 * <span class="informal">Puts the current value and previous value together as
 * an array, and emits that.</span>
 *
 * <img src="./img/pairwise.png" width="100%">
 *
 * The Nth emission from the source Observable will cause the output Observable
 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
 * pair. For this reason, `pairwise` emits on the second and subsequent
 * emissions from the source Observable, but not on the first emission, because
 * there is no previous value in that case.
 *
 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var pairs = clicks.pairwise();
 * var distance = pairs.map(pair => {
 *   var x0 = pair[0].clientX;
 *   var y0 = pair[0].clientY;
 *   var x1 = pair[1].clientX;
 *   var y1 = pair[1].clientY;
 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
 * });
 * distance.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 *
 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
 * consecutive values from the source Observable.
 * @method pairwise
 * @owner Observable
 */ function $26a7c3b9c157c433$var$pairwise() {
    return function(source) {
        return source.lift(new $26a7c3b9c157c433$var$PairwiseOperator());
    };
}
module.exports.pairwise = $26a7c3b9c157c433$var$pairwise;
var $26a7c3b9c157c433$var$PairwiseOperator = function() {
    function PairwiseOperator() {}
    PairwiseOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $26a7c3b9c157c433$var$PairwiseSubscriber(subscriber));
    };
    return PairwiseOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $26a7c3b9c157c433$var$PairwiseSubscriber = function(_super) {
    $26a7c3b9c157c433$var$__extends(PairwiseSubscriber, _super);
    function PairwiseSubscriber(destination) {
        _super.call(this, destination);
        this.hasPrev = false;
    }
    PairwiseSubscriber.prototype._next = function(value) {
        if (this.hasPrev) this.destination.next([
            this.prev,
            value
        ]);
        else this.hasPrev = true;
        this.prev = value;
    };
    return PairwiseSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=pairwise.js.map

});

parcelRegister("Uz5yd", function(module, exports) {
"use strict";
var $0aa072edad5895e1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gGP9M = parcelRequire("gGP9M");


var $9P4lO = parcelRequire("9P4lO");

/**
 * @class AsyncSubject<T>
 */ var $0aa072edad5895e1$var$AsyncSubject = function(_super) {
    $0aa072edad5895e1$var$__extends(AsyncSubject, _super);
    function AsyncSubject() {
        _super.apply(this, arguments);
        this.value = null;
        this.hasNext = false;
        this.hasCompleted = false;
    }
    /** @deprecated internal use only */ AsyncSubject.prototype._subscribe = function(subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return $9P4lO.Subscription.EMPTY;
        } else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return $9P4lO.Subscription.EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function(value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function(error) {
        if (!this.hasCompleted) _super.prototype.error.call(this, error);
    };
    AsyncSubject.prototype.complete = function() {
        this.hasCompleted = true;
        if (this.hasNext) _super.prototype.next.call(this, this.value);
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}($gGP9M.Subject);
module.exports.AsyncSubject = $0aa072edad5895e1$var$AsyncSubject; //# sourceMappingURL=AsyncSubject.js.map

});

parcelRegister("4Elvw", function(module, exports) {
"use strict";
var $362b94cd3ac5693e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cH4eu = parcelRequire("cH4eu");


var $hmT2x = parcelRequire("hmT2x");


var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

function $362b94cd3ac5693e$var$race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    // if the only argument is an array, it was most likely called with
    // `race([obs1, obs2, ...])`
    if (observables.length === 1) {
        if ($cH4eu.isArray(observables[0])) observables = observables[0];
        else return observables[0];
    }
    return new $hmT2x.ArrayObservable(observables).lift(new $362b94cd3ac5693e$var$RaceOperator());
}
module.exports.race = $362b94cd3ac5693e$var$race;
var $362b94cd3ac5693e$var$RaceOperator = function() {
    function RaceOperator() {}
    RaceOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $362b94cd3ac5693e$var$RaceSubscriber(subscriber));
    };
    return RaceOperator;
}();
module.exports.RaceOperator = $362b94cd3ac5693e$var$RaceOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $362b94cd3ac5693e$var$RaceSubscriber = function(_super) {
    $362b94cd3ac5693e$var$__extends(RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        _super.call(this, destination);
        this.hasFirst = false;
        this.observables = [];
        this.subscriptions = [];
    }
    RaceSubscriber.prototype._next = function(observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            for(var i = 0; i < len && !this.hasFirst; i++){
                var observable = observables[i];
                var subscription = $863V0.subscribeToResult(this, observable, observable, i);
                if (this.subscriptions) this.subscriptions.push(subscription);
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for(var i = 0; i < this.subscriptions.length; i++)if (i !== outerIndex) {
                var subscription = this.subscriptions[i];
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}($hmcLb.OuterSubscriber);
module.exports.RaceSubscriber = $362b94cd3ac5693e$var$RaceSubscriber; //# sourceMappingURL=race.js.map

});

parcelRegister("2yT9v", function(module, exports) {
"use strict";
var $1dd989dff1b0efd2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $kjYch = parcelRequire("kjYch");

/**
 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
 *
 * <img src="./img/repeat.png" width="100%">
 *
 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
 * an empty Observable.
 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
 * count times.
 * @method repeat
 * @owner Observable
 */ function $1dd989dff1b0efd2$var$repeat(count) {
    if (count === void 0) count = -1;
    return function(source) {
        if (count === 0) return new $kjYch.EmptyObservable();
        else if (count < 0) return source.lift(new $1dd989dff1b0efd2$var$RepeatOperator(-1, source));
        else return source.lift(new $1dd989dff1b0efd2$var$RepeatOperator(count - 1, source));
    };
}
module.exports.repeat = $1dd989dff1b0efd2$var$repeat;
var $1dd989dff1b0efd2$var$RepeatOperator = function() {
    function RepeatOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RepeatOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $1dd989dff1b0efd2$var$RepeatSubscriber(subscriber, this.count, this.source));
    };
    return RepeatOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1dd989dff1b0efd2$var$RepeatSubscriber = function(_super) {
    $1dd989dff1b0efd2$var$__extends(RepeatSubscriber, _super);
    function RepeatSubscriber(destination, count, source) {
        _super.call(this, destination);
        this.count = count;
        this.source = source;
    }
    RepeatSubscriber.prototype.complete = function() {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) return _super.prototype.complete.call(this);
            else if (count > -1) this.count = count - 1;
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RepeatSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=repeat.js.map

});

parcelRegister("4E7OW", function(module, exports) {
"use strict";
var $3620f6d757e45d74$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gGP9M = parcelRequire("gGP9M");


var $aRdp2 = parcelRequire("aRdp2");


var $iMtch = parcelRequire("iMtch");


var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/**
 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
 * this method will resubscribe to the source Observable.
 *
 * <img src="./img/repeatWhen.png" width="100%">
 *
 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
 * which a user can `complete` or `error`, aborting the repetition.
 * @return {Observable} The source Observable modified with repeat logic.
 * @method repeatWhen
 * @owner Observable
 */ function $3620f6d757e45d74$var$repeatWhen(notifier) {
    return function(source) {
        return source.lift(new $3620f6d757e45d74$var$RepeatWhenOperator(notifier));
    };
}
module.exports.repeatWhen = $3620f6d757e45d74$var$repeatWhen;
var $3620f6d757e45d74$var$RepeatWhenOperator = function() {
    function RepeatWhenOperator(notifier) {
        this.notifier = notifier;
    }
    RepeatWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $3620f6d757e45d74$var$RepeatWhenSubscriber(subscriber, this.notifier, source));
    };
    return RepeatWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3620f6d757e45d74$var$RepeatWhenSubscriber = function(_super) {
    $3620f6d757e45d74$var$__extends(RepeatWhenSubscriber, _super);
    function RepeatWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
        this.sourceIsBeingSubscribedTo = true;
    }
    RepeatWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.sourceIsBeingSubscribedTo = true;
        this.source.subscribe(this);
    };
    RepeatWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        if (this.sourceIsBeingSubscribedTo === false) return _super.prototype.complete.call(this);
    };
    RepeatWhenSubscriber.prototype.complete = function() {
        this.sourceIsBeingSubscribedTo = false;
        if (!this.isStopped) {
            if (!this.retries) this.subscribeToRetries();
            if (!this.retriesSubscription || this.retriesSubscription.closed) return _super.prototype.complete.call(this);
            this._unsubscribeAndRecycle();
            this.notifications.next();
        }
    };
    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
        if (notifications) {
            notifications.unsubscribe();
            this.notifications = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function() {
        var _a = this, notifications = _a.notifications, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.notifications = null;
        this.retries = null;
        this.retriesSubscription = null;
        _super.prototype._unsubscribeAndRecycle.call(this);
        this.notifications = notifications;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        return this;
    };
    RepeatWhenSubscriber.prototype.subscribeToRetries = function() {
        this.notifications = new $gGP9M.Subject();
        var retries = $aRdp2.tryCatch(this.notifier)(this.notifications);
        if (retries === $iMtch.errorObject) return _super.prototype.complete.call(this);
        this.retries = retries;
        this.retriesSubscription = $863V0.subscribeToResult(this, retries);
    };
    return RepeatWhenSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=repeatWhen.js.map

});

parcelRegister("9BXI4", function(module, exports) {
"use strict";
var $6ff5e2e472476edb$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
 * as a number parameter) rather than propagating the `error` call.
 *
 * <img src="./img/retry.png" width="100%">
 *
 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
 * @param {number} count - Number of retry attempts before failing.
 * @return {Observable} The source Observable modified with the retry logic.
 * @method retry
 * @owner Observable
 */ function $6ff5e2e472476edb$var$retry(count) {
    if (count === void 0) count = -1;
    return function(source) {
        return source.lift(new $6ff5e2e472476edb$var$RetryOperator(count, source));
    };
}
module.exports.retry = $6ff5e2e472476edb$var$retry;
var $6ff5e2e472476edb$var$RetryOperator = function() {
    function RetryOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RetryOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $6ff5e2e472476edb$var$RetrySubscriber(subscriber, this.count, this.source));
    };
    return RetryOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $6ff5e2e472476edb$var$RetrySubscriber = function(_super) {
    $6ff5e2e472476edb$var$__extends(RetrySubscriber, _super);
    function RetrySubscriber(destination, count, source) {
        _super.call(this, destination);
        this.count = count;
        this.source = source;
    }
    RetrySubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) return _super.prototype.error.call(this, err);
            else if (count > -1) this.count = count - 1;
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RetrySubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=retry.js.map

});

parcelRegister("jcaZc", function(module, exports) {
"use strict";
var $df97a8e9dee3c880$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gGP9M = parcelRequire("gGP9M");


var $aRdp2 = parcelRequire("aRdp2");


var $iMtch = parcelRequire("iMtch");


var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
 * subscription. Otherwise this method will resubscribe to the source Observable.
 *
 * <img src="./img/retryWhen.png" width="100%">
 *
 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
 * user can `complete` or `error`, aborting the retry.
 * @return {Observable} The source Observable modified with retry logic.
 * @method retryWhen
 * @owner Observable
 */ function $df97a8e9dee3c880$var$retryWhen(notifier) {
    return function(source) {
        return source.lift(new $df97a8e9dee3c880$var$RetryWhenOperator(notifier, source));
    };
}
module.exports.retryWhen = $df97a8e9dee3c880$var$retryWhen;
var $df97a8e9dee3c880$var$RetryWhenOperator = function() {
    function RetryWhenOperator(notifier, source) {
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $df97a8e9dee3c880$var$RetryWhenSubscriber(subscriber, this.notifier, this.source));
    };
    return RetryWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $df97a8e9dee3c880$var$RetryWhenSubscriber = function(_super) {
    $df97a8e9dee3c880$var$__extends(RetryWhenSubscriber, _super);
    function RetryWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var errors = this.errors;
            var retries = this.retries;
            var retriesSubscription = this.retriesSubscription;
            if (!retries) {
                errors = new $gGP9M.Subject();
                retries = $aRdp2.tryCatch(this.notifier)(errors);
                if (retries === $iMtch.errorObject) return _super.prototype.error.call(this, $iMtch.errorObject.e);
                retriesSubscription = $863V0.subscribeToResult(this, retries);
            } else {
                this.errors = null;
                this.retriesSubscription = null;
            }
            this._unsubscribeAndRecycle();
            this.errors = errors;
            this.retries = retries;
            this.retriesSubscription = retriesSubscription;
            errors.next(err);
        }
    };
    /** @deprecated internal use only */ RetryWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
        if (errors) {
            errors.unsubscribe();
            this.errors = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    RetryWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, errors = _a.errors, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.errors = null;
        this.retries = null;
        this.retriesSubscription = null;
        this._unsubscribeAndRecycle();
        this.errors = errors;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        this.source.subscribe(this);
    };
    return RetryWhenSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=retryWhen.js.map

});

parcelRegister("8nouZ", function(module, exports) {
"use strict";
var $619379b19f681437$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

function $619379b19f681437$var$refCount() {
    return function refCountOperatorFunction(source) {
        return source.lift(new $619379b19f681437$var$RefCountOperator(source));
    };
}
module.exports.refCount = $619379b19f681437$var$refCount;
var $619379b19f681437$var$RefCountOperator = function() {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new $619379b19f681437$var$RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) refCounter.connection = connectable.connect();
        return subscription;
    };
    return RefCountOperator;
}();
var $619379b19f681437$var$RefCountSubscriber = function(_super) {
    $619379b19f681437$var$__extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) sharedConnection.unsubscribe();
    };
    return RefCountSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=refCount.js.map

});

parcelRegister("lyDF3", function(module, exports) {
"use strict";
var $fb1b89da5c53e3f8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/**
 * Emits the most recently emitted value from the source Observable whenever
 * another Observable, the `notifier`, emits.
 *
 * <span class="informal">It's like {@link sampleTime}, but samples whenever
 * the `notifier` Observable emits something.</span>
 *
 * <img src="./img/sample.png" width="100%">
 *
 * Whenever the `notifier` Observable emits a value or completes, `sample`
 * looks at the source Observable and emits whichever value it has most recently
 * emitted since the previous sampling, unless the source has not emitted
 * anything since the previous sampling. The `notifier` is subscribed to as soon
 * as the output Observable is subscribed.
 *
 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = seconds.sample(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {Observable<any>} notifier The Observable to use for sampling the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable whenever the notifier Observable
 * emits value or completes.
 * @method sample
 * @owner Observable
 */ function $fb1b89da5c53e3f8$var$sample(notifier) {
    return function(source) {
        return source.lift(new $fb1b89da5c53e3f8$var$SampleOperator(notifier));
    };
}
module.exports.sample = $fb1b89da5c53e3f8$var$sample;
var $fb1b89da5c53e3f8$var$SampleOperator = function() {
    function SampleOperator(notifier) {
        this.notifier = notifier;
    }
    SampleOperator.prototype.call = function(subscriber, source) {
        var sampleSubscriber = new $fb1b89da5c53e3f8$var$SampleSubscriber(subscriber);
        var subscription = source.subscribe(sampleSubscriber);
        subscription.add($863V0.subscribeToResult(sampleSubscriber, this.notifier));
        return subscription;
    };
    return SampleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $fb1b89da5c53e3f8$var$SampleSubscriber = function(_super) {
    $fb1b89da5c53e3f8$var$__extends(SampleSubscriber, _super);
    function SampleSubscriber() {
        _super.apply(this, arguments);
        this.hasValue = false;
    }
    SampleSubscriber.prototype._next = function(value) {
        this.value = value;
        this.hasValue = true;
    };
    SampleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    SampleSubscriber.prototype.notifyComplete = function() {
        this.emitValue();
    };
    SampleSubscriber.prototype.emitValue = function() {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.value);
        }
    };
    return SampleSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=sample.js.map

});

parcelRegister("kNoLt", function(module, exports) {
"use strict";
var $f23b97faba03d2ba$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $zAMIg = parcelRequire("zAMIg");

/**
 * Emits the most recently emitted value from the source Observable within
 * periodic time intervals.
 *
 * <span class="informal">Samples the source Observable at periodic time
 * intervals, emitting what it samples.</span>
 *
 * <img src="./img/sampleTime.png" width="100%">
 *
 * `sampleTime` periodically looks at the source Observable and emits whichever
 * value it has most recently emitted since the previous sampling, unless the
 * source has not emitted anything since the previous sampling. The sampling
 * happens periodically in time every `period` milliseconds (or the time unit
 * defined by the optional `scheduler` argument). The sampling starts as soon as
 * the output Observable is subscribed.
 *
 * @example <caption>Every second, emit the most recent click at most once</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.sampleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {number} period The sampling period expressed in milliseconds or the
 * time unit determined internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the sampling.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable at the specified time interval.
 * @method sampleTime
 * @owner Observable
 */ function $f23b97faba03d2ba$var$sampleTime(period, scheduler) {
    if (scheduler === void 0) scheduler = $zAMIg.async;
    return function(source) {
        return source.lift(new $f23b97faba03d2ba$var$SampleTimeOperator(period, scheduler));
    };
}
module.exports.sampleTime = $f23b97faba03d2ba$var$sampleTime;
var $f23b97faba03d2ba$var$SampleTimeOperator = function() {
    function SampleTimeOperator(period, scheduler) {
        this.period = period;
        this.scheduler = scheduler;
    }
    SampleTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $f23b97faba03d2ba$var$SampleTimeSubscriber(subscriber, this.period, this.scheduler));
    };
    return SampleTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $f23b97faba03d2ba$var$SampleTimeSubscriber = function(_super) {
    $f23b97faba03d2ba$var$__extends(SampleTimeSubscriber, _super);
    function SampleTimeSubscriber(destination, period, scheduler) {
        _super.call(this, destination);
        this.period = period;
        this.scheduler = scheduler;
        this.hasValue = false;
        this.add(scheduler.schedule($f23b97faba03d2ba$var$dispatchNotification, period, {
            subscriber: this,
            period: period
        }));
    }
    SampleTimeSubscriber.prototype._next = function(value) {
        this.lastValue = value;
        this.hasValue = true;
    };
    SampleTimeSubscriber.prototype.notifyNext = function() {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.lastValue);
        }
    };
    return SampleTimeSubscriber;
}($fNVRJ.Subscriber);
function $f23b97faba03d2ba$var$dispatchNotification(state) {
    var subscriber = state.subscriber, period = state.period;
    subscriber.notifyNext();
    this.schedule(state, period);
} //# sourceMappingURL=sampleTime.js.map

});

parcelRegister("i3T1u", function(module, exports) {
"use strict";
var $d2633035aaeb7cda$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $aRdp2 = parcelRequire("aRdp2");


var $iMtch = parcelRequire("iMtch");

/**
 * Compares all values of two observables in sequence using an optional comparor function
 * and returns an observable of a single boolean value representing whether or not the two sequences
 * are equal.
 *
 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
 *
 * <img src="./img/sequenceEqual.png" width="100%">
 *
 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
 * observables completes, the operator will wait for the other observable to complete; If the other
 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
 * completes or emits after the other complets, the returned observable will never complete.
 *
 * @example <caption>figure out if the Konami code matches</caption>
 * var code = Rx.Observable.from([
 *  "ArrowUp",
 *  "ArrowUp",
 *  "ArrowDown",
 *  "ArrowDown",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "KeyB",
 *  "KeyA",
 *  "Enter" // no start key, clearly.
 * ]);
 *
 * var keys = Rx.Observable.fromEvent(document, 'keyup')
 *  .map(e => e.code);
 * var matches = keys.bufferCount(11, 1)
 *  .mergeMap(
 *    last11 =>
 *      Rx.Observable.from(last11)
 *        .sequenceEqual(code)
 *   );
 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
 *
 * @see {@link combineLatest}
 * @see {@link zip}
 * @see {@link withLatestFrom}
 *
 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
 * @param {function} [comparor] An optional function to compare each value pair
 * @return {Observable} An Observable of a single boolean value representing whether or not
 * the values emitted by both observables were equal in sequence.
 * @method sequenceEqual
 * @owner Observable
 */ function $d2633035aaeb7cda$var$sequenceEqual(compareTo, comparor) {
    return function(source) {
        return source.lift(new $d2633035aaeb7cda$var$SequenceEqualOperator(compareTo, comparor));
    };
}
module.exports.sequenceEqual = $d2633035aaeb7cda$var$sequenceEqual;
var $d2633035aaeb7cda$var$SequenceEqualOperator = function() {
    function SequenceEqualOperator(compareTo, comparor) {
        this.compareTo = compareTo;
        this.comparor = comparor;
    }
    SequenceEqualOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d2633035aaeb7cda$var$SequenceEqualSubscriber(subscriber, this.compareTo, this.comparor));
    };
    return SequenceEqualOperator;
}();
module.exports.SequenceEqualOperator = $d2633035aaeb7cda$var$SequenceEqualOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d2633035aaeb7cda$var$SequenceEqualSubscriber = function(_super) {
    $d2633035aaeb7cda$var$__extends(SequenceEqualSubscriber, _super);
    function SequenceEqualSubscriber(destination, compareTo, comparor) {
        _super.call(this, destination);
        this.compareTo = compareTo;
        this.comparor = comparor;
        this._a = [];
        this._b = [];
        this._oneComplete = false;
        this.add(compareTo.subscribe(new $d2633035aaeb7cda$var$SequenceEqualCompareToSubscriber(destination, this)));
    }
    SequenceEqualSubscriber.prototype._next = function(value) {
        if (this._oneComplete && this._b.length === 0) this.emit(false);
        else {
            this._a.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype._complete = function() {
        if (this._oneComplete) this.emit(this._a.length === 0 && this._b.length === 0);
        else this._oneComplete = true;
    };
    SequenceEqualSubscriber.prototype.checkValues = function() {
        var _c = this, _a = _c._a, _b = _c._b, comparor = _c.comparor;
        while(_a.length > 0 && _b.length > 0){
            var a = _a.shift();
            var b = _b.shift();
            var areEqual = false;
            if (comparor) {
                areEqual = $aRdp2.tryCatch(comparor)(a, b);
                if (areEqual === $iMtch.errorObject) this.destination.error($iMtch.errorObject.e);
            } else areEqual = a === b;
            if (!areEqual) this.emit(false);
        }
    };
    SequenceEqualSubscriber.prototype.emit = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    SequenceEqualSubscriber.prototype.nextB = function(value) {
        if (this._oneComplete && this._a.length === 0) this.emit(false);
        else {
            this._b.push(value);
            this.checkValues();
        }
    };
    return SequenceEqualSubscriber;
}($fNVRJ.Subscriber);
module.exports.SequenceEqualSubscriber = $d2633035aaeb7cda$var$SequenceEqualSubscriber;
var $d2633035aaeb7cda$var$SequenceEqualCompareToSubscriber = function(_super) {
    $d2633035aaeb7cda$var$__extends(SequenceEqualCompareToSubscriber, _super);
    function SequenceEqualCompareToSubscriber(destination, parent) {
        _super.call(this, destination);
        this.parent = parent;
    }
    SequenceEqualCompareToSubscriber.prototype._next = function(value) {
        this.parent.nextB(value);
    };
    SequenceEqualCompareToSubscriber.prototype._error = function(err) {
        this.parent.error(err);
    };
    SequenceEqualCompareToSubscriber.prototype._complete = function() {
        this.parent._complete();
    };
    return SequenceEqualCompareToSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=sequenceEqual.js.map

});

parcelRegister("16fIO", function(module, exports) {
"use strict";
var $0cd28bfcda4ef342$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $7NVBc = parcelRequire("7NVBc");

/**
 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
 *
 * <img src="./img/single.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
 * the predicate.
 .
 * @method single
 * @owner Observable
 */ function $0cd28bfcda4ef342$var$single(predicate) {
    return function(source) {
        return source.lift(new $0cd28bfcda4ef342$var$SingleOperator(predicate, source));
    };
}
module.exports.single = $0cd28bfcda4ef342$var$single;
var $0cd28bfcda4ef342$var$SingleOperator = function() {
    function SingleOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    SingleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $0cd28bfcda4ef342$var$SingleSubscriber(subscriber, this.predicate, this.source));
    };
    return SingleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0cd28bfcda4ef342$var$SingleSubscriber = function(_super) {
    $0cd28bfcda4ef342$var$__extends(SingleSubscriber, _super);
    function SingleSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.seenValue = false;
        this.index = 0;
    }
    SingleSubscriber.prototype.applySingleValue = function(value) {
        if (this.seenValue) this.destination.error('Sequence contains more than one element');
        else {
            this.seenValue = true;
            this.singleValue = value;
        }
    };
    SingleSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this.tryNext(value, index);
        else this.applySingleValue(value);
    };
    SingleSubscriber.prototype.tryNext = function(value, index) {
        try {
            if (this.predicate(value, index, this.source)) this.applySingleValue(value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    SingleSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.index > 0) {
            destination.next(this.seenValue ? this.singleValue : undefined);
            destination.complete();
        } else destination.error(new $7NVBc.EmptyError);
    };
    return SingleSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=single.js.map

});

parcelRegister("68JyP", function(module, exports) {
"use strict";
var $4786d4d7f8197f2b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */ function $4786d4d7f8197f2b$var$skip(count) {
    return function(source) {
        return source.lift(new $4786d4d7f8197f2b$var$SkipOperator(count));
    };
}
module.exports.skip = $4786d4d7f8197f2b$var$skip;
var $4786d4d7f8197f2b$var$SkipOperator = function() {
    function SkipOperator(total) {
        this.total = total;
    }
    SkipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $4786d4d7f8197f2b$var$SkipSubscriber(subscriber, this.total));
    };
    return SkipOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $4786d4d7f8197f2b$var$SkipSubscriber = function(_super) {
    $4786d4d7f8197f2b$var$__extends(SkipSubscriber, _super);
    function SkipSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    SkipSubscriber.prototype._next = function(x) {
        if (++this.count > this.total) this.destination.next(x);
    };
    return SkipSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=skip.js.map

});

parcelRegister("3jZqE", function(module, exports) {
"use strict";
var $26b2cbec2101a9b5$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $atSr0 = parcelRequire("atSr0");

/**
 * Skip the last `count` values emitted by the source Observable.
 *
 * <img src="./img/skipLast.png" width="100%">
 *
 * `skipLast` returns an Observable that accumulates a queue with a length
 * enough to store the first `count` values. As more values are received,
 * values are taken from the front of the queue and produced on the result
 * sequence. This causes values to be delayed.
 *
 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 5);
 * var skipLastTwo = many.skipLast(2);
 * skipLastTwo.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 1 2 3
 *
 * @see {@link skip}
 * @see {@link skipUntil}
 * @see {@link skipWhile}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
 * ArgumentOutOrRangeError if `i < 0`.
 *
 * @param {number} count Number of elements to skip from the end of the source Observable.
 * @returns {Observable<T>} An Observable that skips the last count values
 * emitted by the source Observable.
 * @method skipLast
 * @owner Observable
 */ function $26b2cbec2101a9b5$var$skipLast(count) {
    return function(source) {
        return source.lift(new $26b2cbec2101a9b5$var$SkipLastOperator(count));
    };
}
module.exports.skipLast = $26b2cbec2101a9b5$var$skipLast;
var $26b2cbec2101a9b5$var$SkipLastOperator = function() {
    function SkipLastOperator(_skipCount) {
        this._skipCount = _skipCount;
        if (this._skipCount < 0) throw new $atSr0.ArgumentOutOfRangeError;
    }
    SkipLastOperator.prototype.call = function(subscriber, source) {
        if (this._skipCount === 0) // If we don't want to skip any values then just subscribe
        // to Subscriber without any further logic.
        return source.subscribe(new $fNVRJ.Subscriber(subscriber));
        else return source.subscribe(new $26b2cbec2101a9b5$var$SkipLastSubscriber(subscriber, this._skipCount));
    };
    return SkipLastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $26b2cbec2101a9b5$var$SkipLastSubscriber = function(_super) {
    $26b2cbec2101a9b5$var$__extends(SkipLastSubscriber, _super);
    function SkipLastSubscriber(destination, _skipCount) {
        _super.call(this, destination);
        this._skipCount = _skipCount;
        this._count = 0;
        this._ring = new Array(_skipCount);
    }
    SkipLastSubscriber.prototype._next = function(value) {
        var skipCount = this._skipCount;
        var count = this._count++;
        if (count < skipCount) this._ring[count] = value;
        else {
            var currentIndex = count % skipCount;
            var ring = this._ring;
            var oldValue = ring[currentIndex];
            ring[currentIndex] = value;
            this.destination.next(oldValue);
        }
    };
    return SkipLastSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=skipLast.js.map

});

parcelRegister("1bcQU", function(module, exports) {
"use strict";
var $0dc0c9c17e8212db$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */ function $0dc0c9c17e8212db$var$skipUntil(notifier) {
    return function(source) {
        return source.lift(new $0dc0c9c17e8212db$var$SkipUntilOperator(notifier));
    };
}
module.exports.skipUntil = $0dc0c9c17e8212db$var$skipUntil;
var $0dc0c9c17e8212db$var$SkipUntilOperator = function() {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $0dc0c9c17e8212db$var$SkipUntilSubscriber(subscriber, this.notifier));
    };
    return SkipUntilOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0dc0c9c17e8212db$var$SkipUntilSubscriber = function(_super) {
    $0dc0c9c17e8212db$var$__extends(SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.hasValue = false;
        this.isInnerStopped = false;
        this.add($863V0.subscribeToResult(this, notifier));
    }
    SkipUntilSubscriber.prototype._next = function(value) {
        if (this.hasValue) _super.prototype._next.call(this, value);
    };
    SkipUntilSubscriber.prototype._complete = function() {
        if (this.isInnerStopped) _super.prototype._complete.call(this);
        else this.unsubscribe();
    };
    SkipUntilSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.hasValue = true;
    };
    SkipUntilSubscriber.prototype.notifyComplete = function() {
        this.isInnerStopped = true;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    return SkipUntilSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=skipUntil.js.map

});

parcelRegister("15FKI", function(module, exports) {
"use strict";
var $0cb6a53cb976cca8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is flattened multiple
 * times with {@link switch} in the output Observable.
 *
 * <span class="informal">It's like {@link switchMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/switchMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. The output Observables
 * emits values only from the most recently emitted instance of
 * `innerObservable`.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link switch}
 * @see {@link switchMap}
 * @see {@link mergeMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable, and taking only the values
 * from the most recently projected inner Observable.
 * @method switchMapTo
 * @owner Observable
 */ function $0cb6a53cb976cca8$var$switchMapTo(innerObservable, resultSelector) {
    return function(source) {
        return source.lift(new $0cb6a53cb976cca8$var$SwitchMapToOperator(innerObservable, resultSelector));
    };
}
module.exports.switchMapTo = $0cb6a53cb976cca8$var$switchMapTo;
var $0cb6a53cb976cca8$var$SwitchMapToOperator = function() {
    function SwitchMapToOperator(observable, resultSelector) {
        this.observable = observable;
        this.resultSelector = resultSelector;
    }
    SwitchMapToOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $0cb6a53cb976cca8$var$SwitchMapToSubscriber(subscriber, this.observable, this.resultSelector));
    };
    return SwitchMapToOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0cb6a53cb976cca8$var$SwitchMapToSubscriber = function(_super) {
    $0cb6a53cb976cca8$var$__extends(SwitchMapToSubscriber, _super);
    function SwitchMapToSubscriber(destination, inner, resultSelector) {
        _super.call(this, destination);
        this.inner = inner;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapToSubscriber.prototype._next = function(value) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        this.add(this.innerSubscription = $863V0.subscribeToResult(this, this.inner, value, this.index++));
    };
    SwitchMapToSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ SwitchMapToSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = null;
    };
    SwitchMapToSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapToSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) this.tryResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        else destination.next(innerValue);
    };
    SwitchMapToSubscriber.prototype.tryResultSelector = function(outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        var result;
        try {
            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            destination.error(err);
            return;
        }
        destination.next(result);
    };
    return SwitchMapToSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=switchMapTo.js.map

});

parcelRegister("fYICX", function(module, exports) {
"use strict";
var $ba1f13a5c9caf3cd$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/**
 * Emits the values emitted by the source Observable until a `notifier`
 * Observable emits a value.
 *
 * <span class="informal">Lets values pass until a second Observable,
 * `notifier`, emits something. Then, it completes.</span>
 *
 * <img src="./img/takeUntil.png" width="100%">
 *
 * `takeUntil` subscribes and begins mirroring the source Observable. It also
 * monitors a second Observable, `notifier` that you provide. If the `notifier`
 * emits a value or a complete notification, the output Observable stops
 * mirroring the source Observable and completes.
 *
 * @example <caption>Tick every second until the first click happens</caption>
 * var interval = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = interval.takeUntil(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @param {Observable} notifier The Observable whose first emitted value will
 * cause the output Observable of `takeUntil` to stop emitting values from the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable until such time as `notifier` emits its first value.
 * @method takeUntil
 * @owner Observable
 */ function $ba1f13a5c9caf3cd$var$takeUntil(notifier) {
    return function(source) {
        return source.lift(new $ba1f13a5c9caf3cd$var$TakeUntilOperator(notifier));
    };
}
module.exports.takeUntil = $ba1f13a5c9caf3cd$var$takeUntil;
var $ba1f13a5c9caf3cd$var$TakeUntilOperator = function() {
    function TakeUntilOperator(notifier) {
        this.notifier = notifier;
    }
    TakeUntilOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $ba1f13a5c9caf3cd$var$TakeUntilSubscriber(subscriber, this.notifier));
    };
    return TakeUntilOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ba1f13a5c9caf3cd$var$TakeUntilSubscriber = function(_super) {
    $ba1f13a5c9caf3cd$var$__extends(TakeUntilSubscriber, _super);
    function TakeUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.add($863V0.subscribeToResult(this, notifier));
    }
    TakeUntilSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.complete();
    };
    TakeUntilSubscriber.prototype.notifyComplete = function() {
    // noop
    };
    return TakeUntilSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=takeUntil.js.map

});

parcelRegister("9xhQL", function(module, exports) {
"use strict";
var $6f150ac21195b221$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/**
 * Emits values emitted by the source Observable so long as each value satisfies
 * the given `predicate`, and then completes as soon as this `predicate` is not
 * satisfied.
 *
 * <span class="informal">Takes values from the source only while they pass the
 * condition given. When the first value does not satisfy, it completes.</span>
 *
 * <img src="./img/takeWhile.png" width="100%">
 *
 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
 * emitted on the source is given to the `predicate` function which returns a
 * boolean, representing a condition to be satisfied by the source values. The
 * output Observable emits the source values until such time as the `predicate`
 * returns false, at which point `takeWhile` stops mirroring the source
 * Observable and completes the output Observable.
 *
 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.takeWhile(ev => ev.clientX > 200);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates a value emitted by the source Observable and returns a boolean.
 * Also takes the (zero-based) index as the second argument.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable so long as each value satisfies the condition defined by the
 * `predicate`, then completes.
 * @method takeWhile
 * @owner Observable
 */ function $6f150ac21195b221$var$takeWhile(predicate) {
    return function(source) {
        return source.lift(new $6f150ac21195b221$var$TakeWhileOperator(predicate));
    };
}
module.exports.takeWhile = $6f150ac21195b221$var$takeWhile;
var $6f150ac21195b221$var$TakeWhileOperator = function() {
    function TakeWhileOperator(predicate) {
        this.predicate = predicate;
    }
    TakeWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $6f150ac21195b221$var$TakeWhileSubscriber(subscriber, this.predicate));
    };
    return TakeWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $6f150ac21195b221$var$TakeWhileSubscriber = function(_super) {
    $6f150ac21195b221$var$__extends(TakeWhileSubscriber, _super);
    function TakeWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.index = 0;
    }
    TakeWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        var result;
        try {
            result = this.predicate(value, this.index++);
        } catch (err) {
            destination.error(err);
            return;
        }
        this.nextOrComplete(value, result);
    };
    TakeWhileSubscriber.prototype.nextOrComplete = function(value, predicateResult) {
        var destination = this.destination;
        if (Boolean(predicateResult)) destination.next(value);
        else destination.complete();
    };
    return TakeWhileSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=takeWhile.js.map

});

parcelRegister("1WunK", function(module, exports) {
"use strict";
var $16a2c6794cec3b64$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

module.exports.defaultThrottleConfig = {
    leading: true,
    trailing: false
};
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for a duration determined by another Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link throttleTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/throttle.png" width="100%">
 *
 * `throttle` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled by calling the `durationSelector` function with the source value,
 * which returns the "duration" Observable. When the duration Observable emits a
 * value or completes, the timer is disabled, and this process repeats for the
 * next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration for each source value, returned as an Observable or a Promise.
 * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
 * to `{ leading: true, trailing: false }`.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttle
 * @owner Observable
 */ function $16a2c6794cec3b64$var$throttle(durationSelector, config) {
    if (config === void 0) config = module.exports.defaultThrottleConfig;
    return function(source) {
        return source.lift(new $16a2c6794cec3b64$var$ThrottleOperator(durationSelector, config.leading, config.trailing));
    };
}
module.exports.throttle = $16a2c6794cec3b64$var$throttle;
var $16a2c6794cec3b64$var$ThrottleOperator = function() {
    function ThrottleOperator(durationSelector, leading, trailing) {
        this.durationSelector = durationSelector;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $16a2c6794cec3b64$var$ThrottleSubscriber(subscriber, this.durationSelector, this.leading, this.trailing));
    };
    return ThrottleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc
 * @ignore
 * @extends {Ignored}
 */ var $16a2c6794cec3b64$var$ThrottleSubscriber = function(_super) {
    $16a2c6794cec3b64$var$__extends(ThrottleSubscriber, _super);
    function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
        _super.call(this, destination);
        this.destination = destination;
        this.durationSelector = durationSelector;
        this._leading = _leading;
        this._trailing = _trailing;
        this._hasTrailingValue = false;
    }
    ThrottleSubscriber.prototype._next = function(value) {
        if (this.throttled) {
            if (this._trailing) {
                this._hasTrailingValue = true;
                this._trailingValue = value;
            }
        } else {
            var duration = this.tryDurationSelector(value);
            if (duration) this.add(this.throttled = $863V0.subscribeToResult(this, duration));
            if (this._leading) {
                this.destination.next(value);
                if (this._trailing) {
                    this._hasTrailingValue = true;
                    this._trailingValue = value;
                }
            }
        }
    };
    ThrottleSubscriber.prototype.tryDurationSelector = function(value) {
        try {
            return this.durationSelector(value);
        } catch (err) {
            this.destination.error(err);
            return null;
        }
    };
    /** @deprecated internal use only */ ThrottleSubscriber.prototype._unsubscribe = function() {
        var _a = this, throttled = _a.throttled, _trailingValue = _a._trailingValue, _hasTrailingValue = _a._hasTrailingValue, _trailing = _a._trailing;
        this._trailingValue = null;
        this._hasTrailingValue = false;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
    };
    ThrottleSubscriber.prototype._sendTrailing = function() {
        var _a = this, destination = _a.destination, throttled = _a.throttled, _trailing = _a._trailing, _trailingValue = _a._trailingValue, _hasTrailingValue = _a._hasTrailingValue;
        if (throttled && _trailing && _hasTrailingValue) {
            destination.next(_trailingValue);
            this._trailingValue = null;
            this._hasTrailingValue = false;
        }
    };
    ThrottleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._sendTrailing();
        this._unsubscribe();
    };
    ThrottleSubscriber.prototype.notifyComplete = function() {
        this._sendTrailing();
        this._unsubscribe();
    };
    return ThrottleSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=throttle.js.map

});

parcelRegister("dtjlM", function(module, exports) {
"use strict";
var $9cecfe5c0350a73b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $zAMIg = parcelRequire("zAMIg");


var $1WunK = parcelRequire("1WunK");

/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for `duration` milliseconds, then repeats this process.
 *
 * <span class="informal">Lets a value pass, then ignores source values for the
 * next `duration` milliseconds.</span>
 *
 * <img src="./img/throttleTime.png" width="100%">
 *
 * `throttleTime` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled. After `duration` milliseconds (or the time unit determined
 * internally by the optional `scheduler`) has passed, the timer is disabled,
 * and this process repeats for the next source value. Optionally takes a
 * {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {number} duration Time to wait before emitting another value after
 * emitting the last value, measured in milliseconds or the time unit determined
 * internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the throttling.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttleTime
 * @owner Observable
 */ function $9cecfe5c0350a73b$var$throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) scheduler = $zAMIg.async;
    if (config === void 0) config = $1WunK.defaultThrottleConfig;
    return function(source) {
        return source.lift(new $9cecfe5c0350a73b$var$ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing));
    };
}
module.exports.throttleTime = $9cecfe5c0350a73b$var$throttleTime;
var $9cecfe5c0350a73b$var$ThrottleTimeOperator = function() {
    function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $9cecfe5c0350a73b$var$ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
    };
    return ThrottleTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9cecfe5c0350a73b$var$ThrottleTimeSubscriber = function(_super) {
    $9cecfe5c0350a73b$var$__extends(ThrottleTimeSubscriber, _super);
    function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
        _super.call(this, destination);
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
        this._hasTrailingValue = false;
        this._trailingValue = null;
    }
    ThrottleTimeSubscriber.prototype._next = function(value) {
        if (this.throttled) {
            if (this.trailing) {
                this._trailingValue = value;
                this._hasTrailingValue = true;
            }
        } else {
            this.add(this.throttled = this.scheduler.schedule($9cecfe5c0350a73b$var$dispatchNext, this.duration, {
                subscriber: this
            }));
            if (this.leading) this.destination.next(value);
        }
    };
    ThrottleTimeSubscriber.prototype.clearThrottle = function() {
        var throttled = this.throttled;
        if (throttled) {
            if (this.trailing && this._hasTrailingValue) {
                this.destination.next(this._trailingValue);
                this._trailingValue = null;
                this._hasTrailingValue = false;
            }
            throttled.unsubscribe();
            this.remove(throttled);
            this.throttled = null;
        }
    };
    return ThrottleTimeSubscriber;
}($fNVRJ.Subscriber);
function $9cecfe5c0350a73b$var$dispatchNext(arg) {
    var subscriber = arg.subscriber;
    subscriber.clearThrottle();
} //# sourceMappingURL=throttleTime.js.map

});

parcelRegister("4YU6O", function(module, exports) {
"use strict";
var $3a084a1818807618$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $zAMIg = parcelRequire("zAMIg");


var $fEWBj = parcelRequire("fEWBj");


var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/* tslint:enable:max-line-length */ /**
 *
 * Errors if Observable does not emit a value in given time span, in case of which
 * subscribes to the second Observable.
 *
 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
 *
 * <img src="./img/timeoutWith.png" width="100%">
 *
 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
 * still accepting as a first argument either a number or a Date, which control - respectively -
 * when values of source Observable should be emitted or when it should complete.
 *
 * The only difference is that it accepts a second, required parameter. This parameter
 * should be an Observable which will be subscribed when source Observable fails any timeout check.
 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
 * values from second Observable. Note that this fallback Observable is not checked for timeouts
 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
 * stream completes, it completes as well.
 *
 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
 * as a consequence - when second Observable will be subscribed, since subscription happens
 * immediately after failing check.
 *
 * @example <caption>Add fallback observable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const minutes = Rx.Observable.interval(60 * 1000);
 *
 * seconds.timeoutWith(900, minutes)
 *     .subscribe(
 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
 *                                      // since first value of `seconds` will not arrive fast enough.
 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
 *                                 // but here will never be called.
 *     );
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
 *                          passed as a second parameter.
 * @method timeoutWith
 * @owner Observable
 */ function $3a084a1818807618$var$timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) scheduler = $zAMIg.async;
    return function(source) {
        var absoluteTimeout = $fEWBj.isDate(due);
        var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
        return source.lift(new $3a084a1818807618$var$TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
    };
}
module.exports.timeoutWith = $3a084a1818807618$var$timeoutWith;
var $3a084a1818807618$var$TimeoutWithOperator = function() {
    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
    }
    TimeoutWithOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $3a084a1818807618$var$TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
    };
    return TimeoutWithOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3a084a1818807618$var$TimeoutWithSubscriber = function(_super) {
    $3a084a1818807618$var$__extends(TimeoutWithSubscriber, _super);
    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutWithSubscriber.dispatchTimeout = function(subscriber) {
        var withObservable = subscriber.withObservable;
        subscriber._unsubscribeAndRecycle();
        subscriber.add($863V0.subscribeToResult(subscriber, withObservable));
    };
    TimeoutWithSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutWithSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutWithSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.withObservable = null;
    };
    return TimeoutWithSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=timeoutWith.js.map

});

parcelRegister("cey0E", function(module, exports) {
"use strict";
var $8e812c655c682790$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $gGP9M = parcelRequire("gGP9M");

/**
 * Branch out the source Observable values as a nested Observable with each
 * nested Observable emitting at most `windowSize` values.
 *
 * <span class="informal">It's like {@link bufferCount}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowCount.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows every `startWindowEvery`
 * items, each containing no more than `windowSize` items. When the source
 * Observable completes or encounters an error, the output Observable emits
 * the current window and propagates the notification from the source
 * Observable. If `startWindowEvery` is not provided, then new windows are
 * started immediately at the start of the source and when each window completes
 * with size `windowSize`.
 *
 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(3)
 *   .map(win => win.skip(1)) // skip first of every 3 clicks
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(2, 3)
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link bufferCount}
 *
 * @param {number} windowSize The maximum number of values emitted by each
 * window.
 * @param {number} [startWindowEvery] Interval at which to start a new window.
 * For example if `startWindowEvery` is `2`, then a new window will be started
 * on every other value from the source. A new window is started at the
 * beginning of the source by default.
 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
 * are Observable of values.
 * @method windowCount
 * @owner Observable
 */ function $8e812c655c682790$var$windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) startWindowEvery = 0;
    return function windowCountOperatorFunction(source) {
        return source.lift(new $8e812c655c682790$var$WindowCountOperator(windowSize, startWindowEvery));
    };
}
module.exports.windowCount = $8e812c655c682790$var$windowCount;
var $8e812c655c682790$var$WindowCountOperator = function() {
    function WindowCountOperator(windowSize, startWindowEvery) {
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
    }
    WindowCountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $8e812c655c682790$var$WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
    };
    return WindowCountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $8e812c655c682790$var$WindowCountSubscriber = function(_super) {
    $8e812c655c682790$var$__extends(WindowCountSubscriber, _super);
    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
        this.windows = [
            new $gGP9M.Subject()
        ];
        this.count = 0;
        destination.next(this.windows[0]);
    }
    WindowCountSubscriber.prototype._next = function(value) {
        var startWindowEvery = this.startWindowEvery > 0 ? this.startWindowEvery : this.windowSize;
        var destination = this.destination;
        var windowSize = this.windowSize;
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len && !this.closed; i++)windows[i].next(value);
        var c = this.count - windowSize + 1;
        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) windows.shift().complete();
        if (++this.count % startWindowEvery === 0 && !this.closed) {
            var window_1 = new $gGP9M.Subject();
            windows.push(window_1);
            destination.next(window_1);
        }
    };
    WindowCountSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowCountSubscriber.prototype._complete = function() {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().complete();
        this.destination.complete();
    };
    /** @deprecated internal use only */ WindowCountSubscriber.prototype._unsubscribe = function() {
        this.count = 0;
        this.windows = null;
    };
    return WindowCountSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=windowCount.js.map

});

parcelRegister("3FVta", function(module, exports) {
"use strict";
var $2ad1c7aa869d5b30$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gGP9M = parcelRequire("gGP9M");


var $zAMIg = parcelRequire("zAMIg");


var $fNVRJ = parcelRequire("fNVRJ");


var $3l2mn = parcelRequire("3l2mn");


var $lRrDg = parcelRequire("lRrDg");

function $2ad1c7aa869d5b30$var$windowTime(windowTimeSpan) {
    var scheduler = $zAMIg.async;
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if ($lRrDg.isScheduler(arguments[3])) scheduler = arguments[3];
    if ($lRrDg.isScheduler(arguments[2])) scheduler = arguments[2];
    else if ($3l2mn.isNumeric(arguments[2])) maxWindowSize = arguments[2];
    if ($lRrDg.isScheduler(arguments[1])) scheduler = arguments[1];
    else if ($3l2mn.isNumeric(arguments[1])) windowCreationInterval = arguments[1];
    return function windowTimeOperatorFunction(source) {
        return source.lift(new $2ad1c7aa869d5b30$var$WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
    };
}
module.exports.windowTime = $2ad1c7aa869d5b30$var$windowTime;
var $2ad1c7aa869d5b30$var$WindowTimeOperator = function() {
    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
    }
    WindowTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2ad1c7aa869d5b30$var$WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
    };
    return WindowTimeOperator;
}();
var $2ad1c7aa869d5b30$var$CountedSubject = function(_super) {
    $2ad1c7aa869d5b30$var$__extends(CountedSubject, _super);
    function CountedSubject() {
        _super.apply(this, arguments);
        this._numberOfNextedValues = 0;
    }
    CountedSubject.prototype.next = function(value) {
        this._numberOfNextedValues++;
        _super.prototype.next.call(this, value);
    };
    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
        get: function() {
            return this._numberOfNextedValues;
        },
        enumerable: true,
        configurable: true
    });
    return CountedSubject;
}($gGP9M.Subject);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2ad1c7aa869d5b30$var$WindowTimeSubscriber = function(_super) {
    $2ad1c7aa869d5b30$var$__extends(WindowTimeSubscriber, _super);
    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
        this.windows = [];
        var window = this.openWindow();
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
            var closeState = {
                subscriber: this,
                window: window,
                context: null
            };
            var creationState = {
                windowTimeSpan: windowTimeSpan,
                windowCreationInterval: windowCreationInterval,
                subscriber: this,
                scheduler: scheduler
            };
            this.add(scheduler.schedule($2ad1c7aa869d5b30$var$dispatchWindowClose, windowTimeSpan, closeState));
            this.add(scheduler.schedule($2ad1c7aa869d5b30$var$dispatchWindowCreation, windowCreationInterval, creationState));
        } else {
            var timeSpanOnlyState = {
                subscriber: this,
                window: window,
                windowTimeSpan: windowTimeSpan
            };
            this.add(scheduler.schedule($2ad1c7aa869d5b30$var$dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
        }
    }
    WindowTimeSubscriber.prototype._next = function(value) {
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len; i++){
            var window_1 = windows[i];
            if (!window_1.closed) {
                window_1.next(value);
                if (window_1.numberOfNextedValues >= this.maxWindowSize) this.closeWindow(window_1);
            }
        }
    };
    WindowTimeSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        while(windows.length > 0)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowTimeSubscriber.prototype._complete = function() {
        var windows = this.windows;
        while(windows.length > 0){
            var window_2 = windows.shift();
            if (!window_2.closed) window_2.complete();
        }
        this.destination.complete();
    };
    WindowTimeSubscriber.prototype.openWindow = function() {
        var window = new $2ad1c7aa869d5b30$var$CountedSubject();
        this.windows.push(window);
        var destination = this.destination;
        destination.next(window);
        return window;
    };
    WindowTimeSubscriber.prototype.closeWindow = function(window) {
        window.complete();
        var windows = this.windows;
        windows.splice(windows.indexOf(window), 1);
    };
    return WindowTimeSubscriber;
}($fNVRJ.Subscriber);
function $2ad1c7aa869d5b30$var$dispatchWindowTimeSpanOnly(state) {
    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
    if (window) subscriber.closeWindow(window);
    state.window = subscriber.openWindow();
    this.schedule(state, windowTimeSpan);
}
function $2ad1c7aa869d5b30$var$dispatchWindowCreation(state) {
    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
    var window = subscriber.openWindow();
    var action = this;
    var context = {
        action: action,
        subscription: null
    };
    var timeSpanState = {
        subscriber: subscriber,
        window: window,
        context: context
    };
    context.subscription = scheduler.schedule($2ad1c7aa869d5b30$var$dispatchWindowClose, windowTimeSpan, timeSpanState);
    action.add(context.subscription);
    action.schedule(state, windowCreationInterval);
}
function $2ad1c7aa869d5b30$var$dispatchWindowClose(state) {
    var subscriber = state.subscriber, window = state.window, context = state.context;
    if (context && context.action && context.subscription) context.action.remove(context.subscription);
    subscriber.closeWindow(window);
} //# sourceMappingURL=windowTime.js.map

});

parcelRegister("468GZ", function(module, exports) {
"use strict";
var $2fbe7712c172b9bb$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gGP9M = parcelRequire("gGP9M");


var $9P4lO = parcelRequire("9P4lO");


var $aRdp2 = parcelRequire("aRdp2");


var $iMtch = parcelRequire("iMtch");


var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/**
 * Branch out the source Observable values as a nested Observable starting from
 * an emission from `openings` and ending when the output of `closingSelector`
 * emits.
 *
 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowToggle.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows that contain those items
 * emitted by the source Observable between the time when the `openings`
 * Observable emits an item and when the Observable returned by
 * `closingSelector` emits an item.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var result = clicks.windowToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * ).mergeAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowWhen}
 * @see {@link bufferToggle}
 *
 * @param {Observable<O>} openings An observable of notifications to start new
 * windows.
 * @param {function(value: O): Observable} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns an Observable,
 * which, when it emits (either `next` or `complete`), signals that the
 * associated window should complete.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowToggle
 * @owner Observable
 */ function $2fbe7712c172b9bb$var$windowToggle(openings, closingSelector) {
    return function(source) {
        return source.lift(new $2fbe7712c172b9bb$var$WindowToggleOperator(openings, closingSelector));
    };
}
module.exports.windowToggle = $2fbe7712c172b9bb$var$windowToggle;
var $2fbe7712c172b9bb$var$WindowToggleOperator = function() {
    function WindowToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    WindowToggleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2fbe7712c172b9bb$var$WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return WindowToggleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2fbe7712c172b9bb$var$WindowToggleSubscriber = function(_super) {
    $2fbe7712c172b9bb$var$__extends(WindowToggleSubscriber, _super);
    function WindowToggleSubscriber(destination, openings, closingSelector) {
        _super.call(this, destination);
        this.openings = openings;
        this.closingSelector = closingSelector;
        this.contexts = [];
        this.add(this.openSubscription = $863V0.subscribeToResult(this, openings, openings));
    }
    WindowToggleSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        if (contexts) {
            var len = contexts.length;
            for(var i = 0; i < len; i++)contexts[i].window.next(value);
        }
    };
    WindowToggleSubscriber.prototype._error = function(err) {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.error(err);
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._error.call(this, err);
    };
    WindowToggleSubscriber.prototype._complete = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.complete();
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ WindowToggleSubscriber.prototype._unsubscribe = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.unsubscribe();
                context.subscription.unsubscribe();
            }
        }
    };
    WindowToggleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (outerValue === this.openings) {
            var closingSelector = this.closingSelector;
            var closingNotifier = $aRdp2.tryCatch(closingSelector)(innerValue);
            if (closingNotifier === $iMtch.errorObject) return this.error($iMtch.errorObject.e);
            else {
                var window_1 = new $gGP9M.Subject();
                var subscription = new $9P4lO.Subscription();
                var context = {
                    window: window_1,
                    subscription: subscription
                };
                this.contexts.push(context);
                var innerSubscription = $863V0.subscribeToResult(this, closingNotifier, context);
                if (innerSubscription.closed) this.closeWindow(this.contexts.length - 1);
                else {
                    innerSubscription.context = context;
                    subscription.add(innerSubscription);
                }
                this.destination.next(window_1);
            }
        } else this.closeWindow(this.contexts.indexOf(outerValue));
    };
    WindowToggleSubscriber.prototype.notifyError = function(err) {
        this.error(err);
    };
    WindowToggleSubscriber.prototype.notifyComplete = function(inner) {
        if (inner !== this.openSubscription) this.closeWindow(this.contexts.indexOf(inner.context));
    };
    WindowToggleSubscriber.prototype.closeWindow = function(index) {
        if (index === -1) return;
        var contexts = this.contexts;
        var context = contexts[index];
        var window = context.window, subscription = context.subscription;
        contexts.splice(index, 1);
        window.complete();
        subscription.unsubscribe();
    };
    return WindowToggleSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=windowToggle.js.map

});

parcelRegister("a659n", function(module, exports) {
"use strict";
var $759e75aa39e29267$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gGP9M = parcelRequire("gGP9M");


var $aRdp2 = parcelRequire("aRdp2");


var $iMtch = parcelRequire("iMtch");


var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/**
 * Branch out the source Observable values as a nested Observable using a
 * factory function of closing Observables to determine when to start a new
 * window.
 *
 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowWhen.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping windows.
 * It emits the current window and opens a new one whenever the Observable
 * produced by the specified `closingSelector` function emits an item. The first
 * window is opened immediately when subscribing to the output Observable.
 *
 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks
 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link bufferWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals (on either `next` or
 * `complete`) when to close the previous window and start a new one.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowWhen
 * @owner Observable
 */ function $759e75aa39e29267$var$windowWhen(closingSelector) {
    return function windowWhenOperatorFunction(source) {
        return source.lift(new $759e75aa39e29267$var$WindowOperator(closingSelector));
    };
}
module.exports.windowWhen = $759e75aa39e29267$var$windowWhen;
var $759e75aa39e29267$var$WindowOperator = function() {
    function WindowOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    WindowOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $759e75aa39e29267$var$WindowSubscriber(subscriber, this.closingSelector));
    };
    return WindowOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $759e75aa39e29267$var$WindowSubscriber = function(_super) {
    $759e75aa39e29267$var$__extends(WindowSubscriber, _super);
    function WindowSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.destination = destination;
        this.closingSelector = closingSelector;
        this.openWindow();
    }
    WindowSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function(innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype._next = function(value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function(err) {
        this.window.error(err);
        this.destination.error(err);
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype._complete = function() {
        this.window.complete();
        this.destination.complete();
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype.unsubscribeClosingNotification = function() {
        if (this.closingNotification) this.closingNotification.unsubscribe();
    };
    WindowSubscriber.prototype.openWindow = function(innerSub) {
        if (innerSub === void 0) innerSub = null;
        if (innerSub) {
            this.remove(innerSub);
            innerSub.unsubscribe();
        }
        var prevWindow = this.window;
        if (prevWindow) prevWindow.complete();
        var window = this.window = new $gGP9M.Subject();
        this.destination.next(window);
        var closingNotifier = $aRdp2.tryCatch(this.closingSelector)();
        if (closingNotifier === $iMtch.errorObject) {
            var err = $iMtch.errorObject.e;
            this.destination.error(err);
            this.window.error(err);
        } else this.add(this.closingNotification = $863V0.subscribeToResult(this, closingNotifier));
    };
    return WindowSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=windowWhen.js.map

});

parcelRegister("2PecL", function(module, exports) {
"use strict";
var $20eb5cfa33e8c7df$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/* tslint:enable:max-line-length */ /**
 * Combines the source Observable with other Observables to create an Observable
 * whose values are calculated from the latest values of each, only when the
 * source emits.
 *
 * <span class="informal">Whenever the source Observable emits a value, it
 * computes a formula using that value plus the latest values from other input
 * Observables, then emits the output of that formula.</span>
 *
 * <img src="./img/withLatestFrom.png" width="100%">
 *
 * `withLatestFrom` combines each value from the source Observable (the
 * instance) with the latest values from the other input Observables only when
 * the source emits a value, optionally using a `project` function to determine
 * the value to be emitted on the output Observable. All input Observables must
 * emit at least one value before the output Observable will emit a value.
 *
 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var result = clicks.withLatestFrom(timer);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Function} [project] Projection function for combining values
 * together. Receives all values in order of the Observables passed, where the
 * first parameter is a value from the source Observable. (e.g.
 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
 * passed, arrays will be emitted on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method withLatestFrom
 * @owner Observable
 */ function $20eb5cfa33e8c7df$var$withLatestFrom() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
    return function(source) {
        var project;
        if (typeof args[args.length - 1] === 'function') project = args.pop();
        var observables = args;
        return source.lift(new $20eb5cfa33e8c7df$var$WithLatestFromOperator(observables, project));
    };
}
module.exports.withLatestFrom = $20eb5cfa33e8c7df$var$withLatestFrom;
var $20eb5cfa33e8c7df$var$WithLatestFromOperator = function() {
    function WithLatestFromOperator(observables, project) {
        this.observables = observables;
        this.project = project;
    }
    WithLatestFromOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $20eb5cfa33e8c7df$var$WithLatestFromSubscriber(subscriber, this.observables, this.project));
    };
    return WithLatestFromOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $20eb5cfa33e8c7df$var$WithLatestFromSubscriber = function(_super) {
    $20eb5cfa33e8c7df$var$__extends(WithLatestFromSubscriber, _super);
    function WithLatestFromSubscriber(destination, observables, project) {
        _super.call(this, destination);
        this.observables = observables;
        this.project = project;
        this.toRespond = [];
        var len = observables.length;
        this.values = new Array(len);
        for(var i = 0; i < len; i++)this.toRespond.push(i);
        for(var i = 0; i < len; i++){
            var observable = observables[i];
            this.add($863V0.subscribeToResult(this, observable, observable, i));
        }
    }
    WithLatestFromSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values[outerIndex] = innerValue;
        var toRespond = this.toRespond;
        if (toRespond.length > 0) {
            var found = toRespond.indexOf(outerIndex);
            if (found !== -1) toRespond.splice(found, 1);
        }
    };
    WithLatestFromSubscriber.prototype.notifyComplete = function() {
    // noop
    };
    WithLatestFromSubscriber.prototype._next = function(value) {
        if (this.toRespond.length === 0) {
            var args = [
                value
            ].concat(this.values);
            if (this.project) this._tryProject(args);
            else this.destination.next(args);
        }
    };
    WithLatestFromSubscriber.prototype._tryProject = function(args) {
        var result;
        try {
            result = this.project.apply(this, args);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return WithLatestFromSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=withLatestFrom.js.map

});

parcelRegister("7y0YZ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $683eb32df0243bcb$export$698db23c85ab60f9 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "skFyW",
    name: "InvalidExtensionLoader",
    loader: async ()=>(await (parcelRequire("gMz8j"))).InvalidExtension
});
module.exports["InvalidExtensionLoader"] = $683eb32df0243bcb$export$698db23c85ab60f9;

});

parcelRegister("1d1K5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $03a716fd1062a156$export$bd0ca5575b89f75a = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wzX_D",
    name: "InlineImage",
    loader: async ()=>(await (parcelRequire("c7Q3h"))).InlineImage
});
module.exports["InlineImage"] = $03a716fd1062a156$export$bd0ca5575b89f75a;

});

parcelRegister("cbr0D", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8pcS0 = parcelRequire("8pcS0");


var $3JqyB = parcelRequire("3JqyB");


var $2igSQ = parcelRequire("2igSQ");

const $aaaff26cb260a96a$export$fb67b4c81279b22e = (extension)=>{
    if (!extension) return null;
    const { extensionKey: extensionKey, parameters: parameters } = extension;
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).TEMPLATE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3JqyB.TemplateVariableComponent), {
        parameters: parameters
    });
    return null;
};
const $aaaff26cb260a96a$export$14d3630cd94f43d4 = (extension)=>{
    if (!extension) return null;
    const { extensionKey: extensionKey, parameters: parameters } = extension;
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).TEMPLATE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2igSQ.TemplateVariableInput), {
        parameters: parameters
    });
    return null;
};
module.exports["getTemplateExtensionHandler"] = $aaaff26cb260a96a$export$fb67b4c81279b22e;
module.exports["getTemplateVariableInputExtensionHandler"] = $aaaff26cb260a96a$export$14d3630cd94f43d4;

});

parcelRegister("5bak6", function(module, exports) {

var $bLswh = parcelRequire("bLswh");

const $3d0eafc518daabc9$export$f774d7302af8e99b = ({ contentId: contentId, contentType: contentType, contentVersion: contentVersion, contentStatus: contentStatus, spaceKey: spaceKey, spaceId: spaceId, isLivePage: isLivePage, templateId: templateId })=>({
        type: 'macro',
        content: {
            id: contentId,
            type: contentType,
            subtype: isLivePage ? 'live' : null,
            version: contentVersion,
            status: contentStatus
        },
        space: {
            key: spaceKey,
            id: spaceId
        },
        ...templateId && {
            template: {
                id: templateId
            }
        }
    });
function $3d0eafc518daabc9$export$fd8e92520f3c0007({ objectId: objectId, objectType: objectType, containerId: containerId, containerType: containerType }) {
    return {
        objectId: objectId,
        objectType: objectType || undefined,
        containerId: containerId || undefined,
        containerType: containerType
    };
}
function $3d0eafc518daabc9$export$7cb0da5f4e919dd7(environment) {
    return(// In dev, proxying to a site will give that site's environment,
    // which is not what we want
    window.location.hostname === 'localhost' ? (0, $bLswh.ProductEnvironment).DEVELOPMENT : environment === 'STAGING' ? (0, $bLswh.ProductEnvironment).STAGING : environment === 'PRODUCTION' ? (0, $bLswh.ProductEnvironment).PRODUCTION : (0, $bLswh.ProductEnvironment).DEVELOPMENT);
}
module.exports["createForgeMacroExtensionData"] = $3d0eafc518daabc9$export$f774d7302af8e99b;
module.exports["createForgeUIAnalyticsContext"] = $3d0eafc518daabc9$export$fd8e92520f3c0007;
module.exports["environmentToForgeProductEnvironment"] = $3d0eafc518daabc9$export$7cb0da5f4e919dd7;

});

parcelRegister("2oer2", function(module, exports) {
$parcel$export(module.exports, "getTemplateExtensionHandler", () => (parcelRequire("cbr0D")).getTemplateExtensionHandler);
$parcel$export(module.exports, "getTemplateVariableInputExtensionHandler", () => (parcelRequire("cbr0D")).getTemplateVariableInputExtensionHandler);

var $iol5P = parcelRequire("iol5P");


var $j2dS3 = parcelRequire("j2dS3");


var $8pcS0 = parcelRequire("8pcS0");


var $cbr0D = parcelRequire("cbr0D");

const $653189039caa12b3$export$ae3b897442224943 = 'text';
const $653189039caa12b3$export$a43e313f04be91d7 = 'textarea';
const $653189039caa12b3$export$22c50a44ec8aa5dd = 'select';
const $653189039caa12b3$export$178c63c1bbc65458 = 'variable_name';
function $653189039caa12b3$export$166100f9abd52166(name = $653189039caa12b3$export$178c63c1bbc65458) {
    return {
        type: (0, $8pcS0.INLINE_EXTENSION_TYPE),
        attrs: {
            extensionType: (0, $8pcS0.EXTENSION_TYPE).TEMPLATE,
            extensionKey: (0, $8pcS0.EXTENSION_KEY).TEMPLATE,
            parameters: {
                type: $653189039caa12b3$export$ae3b897442224943,
                name: name
            }
        }
    };
}
function $653189039caa12b3$export$fd5152d3cbf54f5f(node) {
    return node.attrs && node.attrs.extensionType === (0, $8pcS0.EXTENSION_TYPE).TEMPLATE;
}
function $653189039caa12b3$export$9d5f42c8c61fd9fc(selectedNode, config) {
    return new Promise((resolve, reject)=>{
        if (!selectedNode.attrs || !config.setActiveModal) {
            reject(new Error('Cannot open editing template variable dialog'));
            return;
        }
        const params = selectedNode.attrs.parameters;
        config.setActiveModal((0, $iol5P.TemplateVariableDialogLoader), {
            defaultVariableType: params.type,
            defaultVariableName: params.name,
            defaultRows: params.params && params.params.rows,
            defaultColumns: params.params && params.params.columns,
            defaultListOptions: params.params && params.params.options,
            onSave: (updatedParams)=>{
                const adf = (0, $j2dS3.updateParams)(selectedNode, updatedParams);
                // MacroAttributes and ADNode are pretty much the same type, but
                // MacroAttributes requires either "extension", "bodiedExtension", or
                // "inlineExtension". This check is so we can pass the ADNode as a
                // MacroAttributes, but will default to "extension" if given an
                // unexpected value.
                let extensionType = (0, $8pcS0.REGULAR_EXTENSION_TYPE);
                if (adf.type === (0, $8pcS0.BODIED_EXTENSION_TYPE)) extensionType = (0, $8pcS0.BODIED_EXTENSION_TYPE);
                else if (adf.type === (0, $8pcS0.INLINE_EXTENSION_TYPE)) extensionType = (0, $8pcS0.INLINE_EXTENSION_TYPE);
                resolve({
                    ...adf,
                    type: extensionType,
                    attrs: adf.attrs || {}
                });
            },
            onClose: ()=>{
                if (config.closeActiveModal) config.closeActiveModal();
            }
        });
    });
}
module.exports["TEXT_TYPE"] = $653189039caa12b3$export$ae3b897442224943;
module.exports["defaultVariableName"] = $653189039caa12b3$export$178c63c1bbc65458;
module.exports["openTemplateVariableDialog"] = $653189039caa12b3$export$9d5f42c8c61fd9fc;

});

parcelRegister("bQCqI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hRnS5 = parcelRequire("hRnS5");


var $eS4Za = parcelRequire("eS4Za");


var $8pcS0 = parcelRequire("8pcS0");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $aJPUt = parcelRequire("aJPUt");


var $lrmHr = parcelRequire("lrmHr");


var $7y0YZ = parcelRequire("7y0YZ");


var $1d1K5 = parcelRequire("1d1K5");


var $79lDc = parcelRequire("79lDc");

const $1e9e777543fb9510$export$112339158948d5ae = ({ contentId: contentId, contextProviders: contextProviders })=>(0, $eS4Za.createMacroExtensionHandler)((extension)=>{
        if (!extension) return null;
        const { extensionKey: extensionKey, parameters: parameters } = extension;
        const { ClassicEditorContextProvider: ClassicEditorContextProvider = ({ children: children })=>children } = contextProviders;
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extension);
        const defaultProps = {
            contentId: contentId,
            mode: (0, $5kjCz.RENDERER),
            extensionKey: extensionKey,
            attributes: attributes,
            node: extension
        };
        let implementation;
        switch(extensionKey){
            case (0, $8pcS0.EXTENSION_KEY).INVALID:
                // extension is rendered outside of React DOM tree and require access to the ClassicEditorContext
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ClassicEditorContextProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7y0YZ.InvalidExtensionLoader), {
                    parameters: parameters,
                    ...defaultProps
                }));
                break;
            case (0, $8pcS0.EXTENSION_KEY).INLINE_EXTERNAL_IMAGE:
                const inlineExternalImageProps = parameters;
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lrmHr.InlineExternalImage), {
                    ...inlineExternalImageProps,
                    ...defaultProps
                });
                break;
            case (0, $8pcS0.EXTENSION_KEY).INLINE_MEDIA_IMAGE:
                const inlineMediaImageProps = parameters;
                const { link: link } = parameters;
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1d1K5.InlineImage), {
                    ...inlineMediaImageProps,
                    ...defaultProps,
                    link: link
                });
                break;
            case (0, $8pcS0.EXTENSION_KEY).LEGACY_CONTENT:
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $79lDc.LegacyContentExtensionHandler), defaultProps);
                break;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: (0, $5kjCz.getExperienceName)((0, $5kjCz.RENDERER), extension),
            mode: (0, $5kjCz.RENDERER),
            extensionKey: extensionKey,
            attributes: attributes,
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
            contentId: contentId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRnS5.RendererActionsContext), null, implementation));
    });
module.exports["getMigrationExtHandlerForRenderer"] = $1e9e777543fb9510$export$112339158948d5ae;

});

parcelRegister("fUN4A", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $3c6a1291ddf1a836$export$5fc4d24c17f7a720 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "3123e",
    name: 'ClassicEditorContextProviderLazyLoader',
    loader: ()=>(parcelRequire("lF2in"))
});
module.exports["ClassicEditorContextProviderLazyLoader"] = $3c6a1291ddf1a836$export$5fc4d24c17f7a720;

});

parcelRegister("7NVBc", function(module, exports) {
"use strict";
var $5ae9c9f5c9200e54$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an Observable or a sequence was queried but has no
 * elements.
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link single}
 *
 * @class EmptyError
 */ var $5ae9c9f5c9200e54$var$EmptyError = function(_super) {
    $5ae9c9f5c9200e54$var$__extends(EmptyError, _super);
    function EmptyError() {
        var err = _super.call(this, 'no elements in sequence');
        this.name = err.name = 'EmptyError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return EmptyError;
}(Error);
module.exports.EmptyError = $5ae9c9f5c9200e54$var$EmptyError; //# sourceMappingURL=EmptyError.js.map

});

parcelRegister("3l2mn", function(module, exports) {
$parcel$export(module.exports, "isNumeric", () => $26e529e052ebd39b$export$e90fb89750dba83f, (v) => $26e529e052ebd39b$export$e90fb89750dba83f = v);
var $26e529e052ebd39b$export$e90fb89750dba83f;
"use strict";

var $cH4eu = parcelRequire("cH4eu");

function $26e529e052ebd39b$var$isNumeric(val) {
    // parseFloat NaNs numeric-cast false positives (null|true|false|"")
    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
    // subtraction forces infinities to NaN
    // adding 1 corrects loss of precision from parseFloat (#15100)
    return !$cH4eu.isArray(val) && val - parseFloat(val) + 1 >= 0;
}
$26e529e052ebd39b$export$e90fb89750dba83f = $26e529e052ebd39b$var$isNumeric;
 //# sourceMappingURL=isNumeric.js.map

});


$parcel$global.rlb("8MaGw")
//# sourceMappingURL=FullPageEditorComponent.b279bc14.js.map
